var ge = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Te = {}, J;
function Dr(s) {
  var e = 0;
  return function() {
    return e < s.length ? { done: !1, value: s[e++] } : { done: !0 };
  };
}
var Lo = typeof Object.defineProperties == "function" ? Object.defineProperty : function(s, e, p) {
  s != Array.prototype && s != Object.prototype && (s[e] = p.value);
};
function pa(s) {
  s = [typeof window == "object" && window, typeof self == "object" && self, typeof ge == "object" && ge, s];
  for (var e = 0; e < s.length; ++e) {
    var p = s[e];
    if (p && p.Math == Math)
      return p;
  }
  throw Error("Cannot find global object");
}
var Ee = pa(ge);
function Me() {
  Me = function() {
  }, Ee.Symbol || (Ee.Symbol = sa);
}
function Ir(s, e) {
  this.a = s, Lo(this, "description", { configurable: !0, writable: !0, value: e });
}
Ir.prototype.toString = function() {
  return this.a;
};
var sa = function() {
  function s(p) {
    if (this instanceof s)
      throw new TypeError("Symbol is not a constructor");
    return new Ir("jscomp_symbol_" + (p || "") + "_" + e++, p);
  }
  var e = 0;
  return s;
}();
function fe() {
  Me();
  var s = Ee.Symbol.iterator;
  s || (s = Ee.Symbol.iterator = Ee.Symbol("Symbol.iterator")), typeof Array.prototype[s] != "function" && Lo(Array.prototype, s, { configurable: !0, writable: !0, value: function() {
    return la(Dr(this));
  } }), fe = function() {
  };
}
function la(s) {
  return fe(), s = { next: s }, s[Ee.Symbol.iterator] = function() {
    return this;
  }, s;
}
function yo(s) {
  var e = typeof Symbol < "u" && Symbol.iterator && s[Symbol.iterator];
  return e ? e.call(s) : { next: Dr(s) };
}
var ua = typeof Object.create == "function" ? Object.create : function(s) {
  function e() {
  }
  return e.prototype = s, new e();
}, ho;
if (typeof Object.setPrototypeOf == "function")
  ho = Object.setPrototypeOf;
else {
  var no;
  e: {
    var ga = { V: !0 }, ji = {};
    try {
      ji.__proto__ = ga, no = ji.V;
      break e;
    } catch {
    }
    no = !1;
  }
  ho = no ? function(s, e) {
    if (s.__proto__ = e, s.__proto__ !== e)
      throw new TypeError(s + " is not extensible");
    return s;
  } : null;
}
var qi = ho;
function Wo(s, e) {
  if (s.prototype = ua(e.prototype), s.prototype.constructor = s, qi)
    qi(s, e);
  else
    for (var p in e)
      if (p != "prototype")
        if (Object.defineProperties) {
          var c = Object.getOwnPropertyDescriptor(e, p);
          c && Object.defineProperty(s, p, c);
        } else
          s[p] = e[p];
  s.O = e.prototype;
}
function da(s, e) {
  fe(), s instanceof String && (s += "");
  var p = 0, c = { next: function() {
    if (p < s.length) {
      var o = p++;
      return { value: e(o, s[o]), done: !1 };
    }
    return c.next = function() {
      return { done: !0, value: void 0 };
    }, c.next();
  } };
  return c[Symbol.iterator] = function() {
    return c;
  }, c;
}
function ct(s, e) {
  if (e) {
    var p = Ee;
    s = s.split(".");
    for (var c = 0; c < s.length - 1; c++) {
      var o = s[c];
      o in p || (p[o] = {}), p = p[o];
    }
    s = s[s.length - 1], c = p[s], e = e(c), e != c && e != null && Lo(p, s, { configurable: !0, writable: !0, value: e });
  }
}
ct("Array.prototype.keys", function(s) {
  return s || function() {
    return da(this, function(e) {
      return e;
    });
  };
});
ct("Array.prototype.find", function(s) {
  return s || function(e, p) {
    e: {
      var c = this;
      c instanceof String && (c = String(c));
      for (var o = c.length, a = 0; a < o; a++) {
        var i = c[a];
        if (e.call(p, i, a, c)) {
          e = i;
          break e;
        }
      }
      e = void 0;
    }
    return e;
  };
});
ct("Object.is", function(s) {
  return s || function(e, p) {
    return e === p ? e !== 0 || 1 / e === 1 / p : e !== e && p !== p;
  };
});
ct("Array.prototype.includes", function(s) {
  return s || function(e, p) {
    var c = this;
    c instanceof String && (c = String(c));
    var o = c.length;
    for (p = p || 0, 0 > p && (p = Math.max(p + o, 0)); p < o; p++) {
      var a = c[p];
      if (a === e || Object.is(a, e))
        return !0;
    }
    return !1;
  };
});
ct("Promise", function(s) {
  function e(i) {
    this.b = 0, this.c = void 0, this.a = [];
    var u = this.f();
    try {
      i(u.resolve, u.reject);
    } catch (y) {
      u.reject(y);
    }
  }
  function p() {
    this.a = null;
  }
  function c(i) {
    return i instanceof e ? i : new e(function(u) {
      u(i);
    });
  }
  if (s)
    return s;
  p.prototype.b = function(i) {
    if (this.a == null) {
      this.a = [];
      var u = this;
      this.c(function() {
        u.g();
      });
    }
    this.a.push(i);
  };
  var o = Ee.setTimeout;
  p.prototype.c = function(i) {
    o(i, 0);
  }, p.prototype.g = function() {
    for (; this.a && this.a.length; ) {
      var i = this.a;
      this.a = [];
      for (var u = 0; u < i.length; ++u) {
        var y = i[u];
        i[u] = null;
        try {
          y();
        } catch (h) {
          this.f(h);
        }
      }
    }
    this.a = null;
  }, p.prototype.f = function(i) {
    this.c(function() {
      throw i;
    });
  }, e.prototype.f = function() {
    function i(h) {
      return function(B) {
        y || (y = !0, h.call(u, B));
      };
    }
    var u = this, y = !1;
    return { resolve: i(this.s), reject: i(this.g) };
  }, e.prototype.s = function(i) {
    if (i === this)
      this.g(new TypeError("A Promise cannot resolve to itself"));
    else if (i instanceof e)
      this.v(i);
    else {
      e:
        switch (typeof i) {
          case "object":
            var u = i != null;
            break e;
          case "function":
            u = !0;
            break e;
          default:
            u = !1;
        }
      u ? this.m(i) : this.h(i);
    }
  }, e.prototype.m = function(i) {
    var u = void 0;
    try {
      u = i.then;
    } catch (y) {
      this.g(y);
      return;
    }
    typeof u == "function" ? this.w(u, i) : this.h(i);
  }, e.prototype.g = function(i) {
    this.i(2, i);
  }, e.prototype.h = function(i) {
    this.i(1, i);
  }, e.prototype.i = function(i, u) {
    if (this.b != 0)
      throw Error("Cannot settle(" + i + ", " + u + "): Promise already settled in state" + this.b);
    this.b = i, this.c = u, this.l();
  }, e.prototype.l = function() {
    if (this.a != null) {
      for (var i = 0; i < this.a.length; ++i)
        a.b(this.a[i]);
      this.a = null;
    }
  };
  var a = new p();
  return e.prototype.v = function(i) {
    var u = this.f();
    i.F(u.resolve, u.reject);
  }, e.prototype.w = function(i, u) {
    var y = this.f();
    try {
      i.call(u, y.resolve, y.reject);
    } catch (h) {
      y.reject(h);
    }
  }, e.prototype.then = function(i, u) {
    function y(M, I) {
      return typeof M == "function" ? function($) {
        try {
          h(M($));
        } catch (t) {
          B(t);
        }
      } : I;
    }
    var h, B, C = new e(function(M, I) {
      h = M, B = I;
    });
    return this.F(y(i, h), y(u, B)), C;
  }, e.prototype.catch = function(i) {
    return this.then(void 0, i);
  }, e.prototype.F = function(i, u) {
    function y() {
      switch (h.b) {
        case 1:
          i(h.c);
          break;
        case 2:
          u(h.c);
          break;
        default:
          throw Error("Unexpected state: " + h.b);
      }
    }
    var h = this;
    this.a == null ? a.b(y) : this.a.push(y);
  }, e.resolve = c, e.reject = function(i) {
    return new e(function(u, y) {
      y(i);
    });
  }, e.race = function(i) {
    return new e(function(u, y) {
      for (var h = yo(i), B = h.next(); !B.done; B = h.next())
        c(B.value).F(u, y);
    });
  }, e.all = function(i) {
    var u = yo(i), y = u.next();
    return y.done ? c([]) : new e(function(h, B) {
      function C($) {
        return function(t) {
          M[$] = t, I--, I == 0 && h(M);
        };
      }
      var M = [], I = 0;
      do
        M.push(void 0), I++, c(y.value).F(C(M.length - 1), B), y = u.next();
      while (!y.done);
    });
  }, e;
});
var zo = zo || {}, ee = ge || self;
function nt(s, e) {
  s = s.split("."), e = e || ee;
  for (var p = 0; p < s.length; p++)
    if (e = e[s[p]], e == null)
      return null;
  return e;
}
function It() {
}
function xt(s) {
  var e = typeof s;
  return e == "object" && s != null || e == "function";
}
function ca(s, e, p) {
  return s.call.apply(s.bind, arguments);
}
function fa(s, e, p) {
  if (!s)
    throw Error();
  if (2 < arguments.length) {
    var c = Array.prototype.slice.call(arguments, 2);
    return function() {
      var o = Array.prototype.slice.call(arguments);
      return Array.prototype.unshift.apply(o, c), s.apply(e, o);
    };
  }
  return function() {
    return s.apply(e, arguments);
  };
}
function De(s, e, p) {
  return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? De = ca : De = fa, De.apply(null, arguments);
}
function Ue(s, e) {
  function p() {
  }
  p.prototype = e.prototype, s.O = e.prototype, s.prototype = new p(), s.prototype.constructor = s;
}
function Gt(s) {
  this.a = s || {};
}
Gt.prototype.get = function(s) {
  return this.a[s];
};
Gt.prototype.G = function() {
  return Object.keys(this.a);
};
function ft(s, e, p, c) {
  this.f = s, this.c = e, this.b = p, this.a = c;
}
ft.prototype.getRequestMessage = function() {
  return this.f;
};
ft.prototype.getMethodDescriptor = function() {
  return this.c;
};
ft.prototype.getMetadata = function() {
  return this.b;
};
ft.prototype.getCallOptions = function() {
  return this.a;
};
function yt(s, e, p, c) {
  p = p === void 0 ? {} : p, this.c = s, this.a = p, this.b = e, this.f = c === void 0 ? null : c;
}
yt.prototype.getResponseMessage = function() {
  return this.c;
};
yt.prototype.getMetadata = function() {
  return this.a;
};
yt.prototype.getMethodDescriptor = function() {
  return this.b;
};
yt.prototype.getStatus = function() {
  return this.f;
};
function $t(s, e, p, c, o, a) {
  this.name = s, this.a = o, this.b = a;
}
function No(s, e, p) {
  p = p === void 0 ? {} : p;
  var c = c === void 0 ? new Gt() : c;
  return new ft(e, s, p, c);
}
$t.prototype.getName = function() {
  return this.name;
};
$t.prototype.getName = $t.prototype.getName;
function ya(s) {
  switch (s) {
    case 200:
      return 0;
    case 400:
      return 3;
    case 401:
      return 16;
    case 403:
      return 7;
    case 404:
      return 5;
    case 409:
      return 10;
    case 412:
      return 9;
    case 429:
      return 8;
    case 499:
      return 1;
    case 500:
      return 2;
    case 501:
      return 12;
    case 503:
      return 14;
    case 504:
      return 4;
    default:
      return 2;
  }
}
function ha(s) {
  switch (s) {
    case 0:
      return "OK";
    case 1:
      return "CANCELLED";
    case 2:
      return "UNKNOWN";
    case 3:
      return "INVALID_ARGUMENT";
    case 4:
      return "DEADLINE_EXCEEDED";
    case 5:
      return "NOT_FOUND";
    case 6:
      return "ALREADY_EXISTS";
    case 7:
      return "PERMISSION_DENIED";
    case 16:
      return "UNAUTHENTICATED";
    case 8:
      return "RESOURCE_EXHAUSTED";
    case 9:
      return "FAILED_PRECONDITION";
    case 10:
      return "ABORTED";
    case 11:
      return "OUT_OF_RANGE";
    case 12:
      return "UNIMPLEMENTED";
    case 13:
      return "INTERNAL";
    case 14:
      return "UNAVAILABLE";
    case 15:
      return "DATA_LOSS";
    default:
      return "";
  }
}
function de(s, e, p) {
  p = p === void 0 ? {} : p, e = Error.call(this, e), this.message = e.message, "stack" in e && (this.stack = e.stack), this.code = s, this.metadata = p;
}
Wo(de, Error);
de.prototype.toString = function() {
  var s = "RpcError(" + (ha(this.code) || String(this.code)) + ")";
  return this.message && (s += ": " + this.message), s;
};
de.prototype.name = "RpcError";
function _t(s) {
  this.a = s;
}
_t.prototype.on = function(s, e) {
  return s == "data" || s == "error" ? this : this.a.on(s, e);
};
_t.prototype.removeListener = function(s, e) {
  return this.a.removeListener(s, e);
};
_t.prototype.cancel = function() {
  this.a.cancel();
};
function va(s) {
  switch (s) {
    case 0:
      return "No Error";
    case 1:
      return "Access denied to content document";
    case 2:
      return "File not found";
    case 3:
      return "Firefox silently errored";
    case 4:
      return "Application custom error";
    case 5:
      return "An exception occurred";
    case 6:
      return "Http response at 400 or 500 level";
    case 7:
      return "Request was aborted";
    case 8:
      return "Request timed out";
    case 9:
      return "The resource is not available offline";
    default:
      return "Unrecognized error code";
  }
}
function ht(s) {
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ht);
  else {
    var e = Error().stack;
    e && (this.stack = e);
  }
  s && (this.message = String(s));
}
Ue(ht, Error);
ht.prototype.name = "CustomError";
function Ao(s, e) {
  s = s.split("%s");
  for (var p = "", c = s.length - 1, o = 0; o < c; o++)
    p += s[o] + (o < e.length ? e[o] : "%s");
  ht.call(this, p + s[c]);
}
Ue(Ao, ht);
Ao.prototype.name = "AssertionError";
function Fa(s, e) {
  throw new Ao("Failure" + (s ? ": " + s : ""), Array.prototype.slice.call(arguments, 1));
}
function Ra() {
  this.l = null, this.i = [], this.m = 0, this.b = vo, this.f = this.a = this.h = 0, this.c = null, this.g = 0;
}
function ba(s, e) {
  function p(h) {
    h == Fo || h == pt ? i.h = h : Hi(i, u, y, "invalid frame byte"), i.b = Vi, i.a = 0, i.f = 0;
  }
  function c(h) {
    i.f++, i.a = (i.a << 8) + h, i.f == 4 && (i.b = Ui, i.g = 0, typeof Uint8Array < "u" ? i.c = new Uint8Array(i.a) : i.c = Array(i.a), i.a == 0 && a());
  }
  function o(h) {
    i.c[i.g++] = h, i.g == i.a && a();
  }
  function a() {
    var h = {};
    h[i.h] = i.c, i.i.push(h), i.b = vo;
  }
  var i = s, u, y = 0;
  for (e instanceof Uint8Array || e instanceof Array ? u = e : u = new Uint8Array(e); y < u.length; ) {
    switch (i.b) {
      case $r:
        Hi(i, u, y, "stream already broken");
        break;
      case vo:
        p(u[y]);
        break;
      case Vi:
        c(u[y]);
        break;
      case Ui:
        o(u[y]);
        break;
      default:
        throw Error("unexpected parser state: " + i.b);
    }
    i.m++, y++;
  }
  return s = i.i, i.i = [], 0 < s.length ? s : null;
}
var vo = 0, Vi = 1, Ui = 2, $r = 3, Fo = 0, pt = 128;
function Hi(s, e, p, c) {
  throw s.b = $r, s.l = "The stream is broken @" + s.m + "/" + p + ". Error: " + c + `. With input:
` + e, Error(s.l);
}
var Lr = Array.prototype.indexOf ? function(s, e) {
  return Array.prototype.indexOf.call(s, e, void 0);
} : function(s, e) {
  if (typeof s == "string")
    return typeof e != "string" || e.length != 1 ? -1 : s.indexOf(e, 0);
  for (var p = 0; p < s.length; p++)
    if (p in s && s[p] === e)
      return p;
  return -1;
}, Ji = String.prototype.trim ? function(s) {
  return s.trim();
} : function(s) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(s)[1];
};
function oe(s, e) {
  return s.indexOf(e) != -1;
}
function ao(s, e) {
  return s < e ? -1 : s > e ? 1 : 0;
}
var Q;
e: {
  var Yi = ee.navigator;
  if (Yi) {
    var Ki = Yi.userAgent;
    if (Ki) {
      Q = Ki;
      break e;
    }
  }
  Q = "";
}
function Ba(s, e) {
  for (var p in s)
    e.call(void 0, s[p], p, s);
}
function Ma(s, e) {
  var p = {}, c;
  for (c in s)
    p[c] = e.call(void 0, s[c], c, s);
  return p;
}
var Zi = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Ca(s, e) {
  for (var p, c, o = 1; o < arguments.length; o++) {
    c = arguments[o];
    for (p in c)
      s[p] = c[p];
    for (var a = 0; a < Zi.length; a++)
      p = Zi[a], Object.prototype.hasOwnProperty.call(c, p) && (s[p] = c[p]);
  }
}
function Ta(s) {
  var e = 1;
  s = s.split(":");
  for (var p = []; 0 < e && s.length; )
    p.push(s.shift()), e--;
  return s.length && p.push(s.join(":")), p;
}
function xo(s) {
  return xo[" "](s), s;
}
xo[" "] = It;
function ma(s) {
  var e = Sa;
  return Object.prototype.hasOwnProperty.call(e, 9) ? e[9] : e[9] = s(9);
}
var wa = oe(Q, "Opera"), Ro = oe(Q, "Trident") || oe(Q, "MSIE"), Ea = oe(Q, "Edge"), Wr = oe(Q, "Gecko") && !(oe(Q.toLowerCase(), "webkit") && !oe(Q, "Edge")) && !(oe(Q, "Trident") || oe(Q, "MSIE")) && !oe(Q, "Edge"), Pa = oe(Q.toLowerCase(), "webkit") && !oe(Q, "Edge"), bo;
e: {
  var po = "", so = function() {
    var s = Q;
    if (Wr)
      return /rv:([^\);]+)(\)|;)/.exec(s);
    if (Ea)
      return /Edge\/([\d\.]+)/.exec(s);
    if (Ro)
      return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(s);
    if (Pa)
      return /WebKit\/(\S+)/.exec(s);
    if (wa)
      return /(?:Version)[ \/]?(\S+)/.exec(s);
  }();
  if (so && (po = so ? so[1] : ""), Ro) {
    var kt, Xi = ee.document;
    if (kt = Xi ? Xi.documentMode : void 0, kt != null && kt > parseFloat(po)) {
      bo = String(kt);
      break e;
    }
  }
  bo = po;
}
var Sa = {};
function Oa() {
  return ma(function() {
    for (var s = 0, e = Ji(String(bo)).split("."), p = Ji("9").split("."), c = Math.max(e.length, p.length), o = 0; s == 0 && o < c; o++) {
      var a = e[o] || "", i = p[o] || "";
      do {
        if (a = /(\d*)(\D*)(.*)/.exec(a) || ["", "", "", ""], i = /(\d*)(\D*)(.*)/.exec(i) || ["", "", "", ""], a[0].length == 0 && i[0].length == 0)
          break;
        s = ao(a[1].length == 0 ? 0 : parseInt(a[1], 10), i[1].length == 0 ? 0 : parseInt(i[1], 10)) || ao(a[2].length == 0, i[2].length == 0) || ao(a[2], i[2]), a = a[3], i = i[3];
      } while (s == 0);
    }
    return 0 <= s;
  });
}
function Go() {
  this.K = this.K;
}
Go.prototype.K = !1;
var ka = Object.freeze || function(s) {
  return s;
};
function je(s, e) {
  this.type = s, this.a = this.target = e, this.defaultPrevented = !1;
}
je.prototype.b = function() {
  this.defaultPrevented = !0;
};
var Da = function() {
  if (!ee.addEventListener || !Object.defineProperty)
    return !1;
  var s = !1, e = Object.defineProperty({}, "passive", { get: function() {
    s = !0;
  } });
  try {
    ee.addEventListener("test", It, e), ee.removeEventListener("test", It, e);
  } catch {
  }
  return s;
}();
function lt(s, e) {
  if (je.call(this, s ? s.type : ""), this.relatedTarget = this.a = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.pointerId = 0, this.pointerType = "", this.c = null, s) {
    var p = this.type = s.type, c = s.changedTouches && s.changedTouches.length ? s.changedTouches[0] : null;
    if (this.target = s.target || s.srcElement, this.a = e, e = s.relatedTarget) {
      if (Wr) {
        e: {
          try {
            xo(e.nodeName);
            var o = !0;
            break e;
          } catch {
          }
          o = !1;
        }
        o || (e = null);
      }
    } else
      p == "mouseover" ? e = s.fromElement : p == "mouseout" && (e = s.toElement);
    this.relatedTarget = e, c ? (this.clientX = c.clientX !== void 0 ? c.clientX : c.pageX, this.clientY = c.clientY !== void 0 ? c.clientY : c.pageY, this.screenX = c.screenX || 0, this.screenY = c.screenY || 0) : (this.clientX = s.clientX !== void 0 ? s.clientX : s.pageX, this.clientY = s.clientY !== void 0 ? s.clientY : s.pageY, this.screenX = s.screenX || 0, this.screenY = s.screenY || 0), this.button = s.button, this.key = s.key || "", this.ctrlKey = s.ctrlKey, this.altKey = s.altKey, this.shiftKey = s.shiftKey, this.metaKey = s.metaKey, this.pointerId = s.pointerId || 0, this.pointerType = typeof s.pointerType == "string" ? s.pointerType : Ia[s.pointerType] || "", this.c = s, s.defaultPrevented && lt.O.b.call(this);
  }
}
Ue(lt, je);
var Ia = ka({ 2: "touch", 3: "pen", 4: "mouse" });
lt.prototype.b = function() {
  lt.O.b.call(this);
  var s = this.c;
  s.preventDefault ? s.preventDefault() : s.returnValue = !1;
};
var vt = "closure_listenable_" + (1e6 * Math.random() | 0), $a = 0;
function La(s, e, p, c, o) {
  this.listener = s, this.proxy = null, this.src = e, this.type = p, this.capture = !!c, this.H = o, this.key = ++$a, this.A = this.D = !1;
}
function _o(s) {
  s.A = !0, s.listener = null, s.proxy = null, s.src = null, s.H = null;
}
function Ft(s) {
  this.src = s, this.a = {}, this.b = 0;
}
Ft.prototype.add = function(s, e, p, c, o) {
  var a = s.toString();
  s = this.a[a], s || (s = this.a[a] = [], this.b++);
  var i = jo(s, e, c, o);
  return -1 < i ? (e = s[i], p || (e.D = !1)) : (e = new La(e, this.src, a, !!c, o), e.D = p, s.push(e)), e;
};
Ft.prototype.remove = function(s, e, p, c) {
  if (s = s.toString(), !(s in this.a))
    return !1;
  var o = this.a[s];
  return e = jo(o, e, p, c), -1 < e ? (_o(o[e]), Array.prototype.splice.call(o, e, 1), o.length == 0 && (delete this.a[s], this.b--), !0) : !1;
};
function Bo(s, e) {
  var p = e.type;
  if (p in s.a) {
    var c = s.a[p], o = Lr(c, e), a;
    (a = 0 <= o) && Array.prototype.splice.call(c, o, 1), a && (_o(e), s.a[p].length == 0 && (delete s.a[p], s.b--));
  }
}
function jo(s, e, p, c) {
  for (var o = 0; o < s.length; ++o) {
    var a = s[o];
    if (!a.A && a.listener == e && a.capture == !!p && a.H == c)
      return o;
  }
  return -1;
}
var qo = "closure_lm_" + (1e6 * Math.random() | 0), lo = {};
function Lt(s, e, p, c, o) {
  if (c && c.once)
    Nr(s, e, p, c, o);
  else if (Array.isArray(e))
    for (var a = 0; a < e.length; a++)
      Lt(s, e[a], p, c, o);
  else
    p = Uo(p), s && s[vt] ? s.f.add(String(e), p, !1, xt(c) ? !!c.capture : !!c, o) : zr(s, e, p, !1, c, o);
}
function zr(s, e, p, c, o, a) {
  if (!e)
    throw Error("Invalid event type");
  var i = xt(o) ? !!o.capture : !!o, u = Vo(s);
  if (u || (s[qo] = u = new Ft(s)), p = u.add(e, p, c, i, a), !p.proxy)
    if (c = Wa(), p.proxy = c, c.src = s, c.listener = p, s.addEventListener)
      Da || (o = i), o === void 0 && (o = !1), s.addEventListener(e.toString(), c, o);
    else if (s.attachEvent)
      s.attachEvent(Gr(e.toString()), c);
    else if (s.addListener && s.removeListener)
      s.addListener(c);
    else
      throw Error("addEventListener and attachEvent are unavailable.");
}
function Wa() {
  function s(p) {
    return e.call(s.src, s.listener, p);
  }
  var e = za;
  return s;
}
function Nr(s, e, p, c, o) {
  if (Array.isArray(e))
    for (var a = 0; a < e.length; a++)
      Nr(s, e[a], p, c, o);
  else
    p = Uo(p), s && s[vt] ? s.f.add(String(e), p, !0, xt(c) ? !!c.capture : !!c, o) : zr(s, e, p, !0, c, o);
}
function Ar(s, e, p, c, o) {
  if (Array.isArray(e))
    for (var a = 0; a < e.length; a++)
      Ar(s, e[a], p, c, o);
  else
    c = xt(c) ? !!c.capture : !!c, p = Uo(p), s && s[vt] ? s.f.remove(String(e), p, c, o) : s && (s = Vo(s)) && (e = s.a[e.toString()], s = -1, e && (s = jo(e, p, c, o)), (p = -1 < s ? e[s] : null) && xr(p));
}
function xr(s) {
  if (typeof s != "number" && s && !s.A) {
    var e = s.src;
    if (e && e[vt])
      Bo(e.f, s);
    else {
      var p = s.type, c = s.proxy;
      e.removeEventListener ? e.removeEventListener(p, c, s.capture) : e.detachEvent ? e.detachEvent(Gr(p), c) : e.addListener && e.removeListener && e.removeListener(c), (p = Vo(e)) ? (Bo(p, s), p.b == 0 && (p.src = null, e[qo] = null)) : _o(s);
    }
  }
}
function Gr(s) {
  return s in lo ? lo[s] : lo[s] = "on" + s;
}
function za(s, e) {
  if (s.A)
    s = !0;
  else {
    e = new lt(e, this);
    var p = s.listener, c = s.H || s.src;
    s.D && xr(s), s = p.call(c, e);
  }
  return s;
}
function Vo(s) {
  return s = s[qo], s instanceof Ft ? s : null;
}
var uo = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
function Uo(s) {
  return typeof s == "function" ? s : (s[uo] || (s[uo] = function(e) {
    return s.handleEvent(e);
  }), s[uo]);
}
function He() {
  Go.call(this), this.f = new Ft(this), this.U = this;
}
Ue(He, Go);
He.prototype[vt] = !0;
He.prototype.addEventListener = function(s, e, p, c) {
  Lt(this, s, e, p, c);
};
He.prototype.removeEventListener = function(s, e, p, c) {
  Ar(this, s, e, p, c);
};
function Be(s, e) {
  s = s.U;
  var p = e.type || e;
  if (typeof e == "string")
    e = new je(e, s);
  else if (e instanceof je)
    e.target = e.target || s;
  else {
    var c = e;
    e = new je(p, s), Ca(e, c);
  }
  s = e.a = s, Qi(s, p, !0, e), Qi(s, p, !1, e);
}
function Qi(s, e, p, c) {
  if (e = s.f.a[String(e)]) {
    e = e.concat();
    for (var o = !0, a = 0; a < e.length; ++a) {
      var i = e[a];
      if (i && !i.A && i.capture == p) {
        var u = i.listener, y = i.H || i.src;
        i.D && Bo(s.f, i), o = u.call(y, c) !== !1 && o;
      }
    }
  }
}
var Ho = ee;
function _r(s, e, p) {
  if (typeof s == "function")
    p && (s = De(s, p));
  else if (s && typeof s.handleEvent == "function")
    s = De(s.handleEvent, s);
  else
    throw Error("Invalid listener argument");
  return 2147483647 < Number(e) ? -1 : Ho.setTimeout(s, e || 0);
}
function Rt(s, e) {
  this.name = s, this.value = e;
}
Rt.prototype.toString = function() {
  return this.name;
};
var Wt = new Rt("OFF", 1 / 0), jr = new Rt("SEVERE", 1e3), Na = new Rt("CONFIG", 700), Aa = new Rt("FINE", 500);
function qr() {
  this.clear();
}
var er;
qr.prototype.clear = function() {
};
function Vr(s, e, p) {
  this.reset(s || Wt, e, p, void 0, void 0);
}
Vr.prototype.reset = function() {
};
function Ur(s, e) {
  this.a = null, this.f = [], this.b = (e === void 0 ? null : e) || null, this.c = [], this.g = { getName: function() {
    return s;
  } };
}
function Hr(s) {
  return s.a ? s.a : s.b ? Hr(s.b) : (Fa("Root logger has no level set."), Wt);
}
function xa(s, e) {
  for (; s; )
    s.f.forEach(function(p) {
      p(e);
    }), s = s.b;
}
function Ga() {
  this.entries = {};
  var s = new Ur("");
  s.a = Na, this.entries[""] = s;
}
var go;
function zt(s, e, p) {
  var c = s.entries[e];
  if (c)
    return p !== void 0 && (c.a = p), c;
  c = zt(s, e.substr(0, e.lastIndexOf(".")));
  var o = new Ur(e, c);
  return s.entries[e] = o, c.c.push(o), p !== void 0 && (o.a = p), o;
}
function Mo() {
  return go || (go = new Ga()), go;
}
function Jo(s, e, p) {
  var c;
  if ((c = s) && (c = s && e)) {
    c = e.value;
    var o = s ? Hr(zt(Mo(), s.getName())) : Wt;
    c = c >= o.value;
  }
  c && (e = e || Wt, c = zt(Mo(), s.getName()), typeof p == "function" && (p = p()), er || (er = new qr()), s = s.getName(), s = new Vr(e, p, s), xa(c, s));
}
function ae(s, e) {
  s && Jo(s, Aa, e);
}
function Jr() {
}
Jr.prototype.a = null;
function tr(s) {
  var e;
  return (e = s.a) || (e = {}, Kr(s) && (e[0] = !0, e[1] = !0), e = s.a = e), e;
}
var Co;
function Yr() {
}
Ue(Yr, Jr);
function or(s) {
  return (s = Kr(s)) ? new ActiveXObject(s) : new XMLHttpRequest();
}
function Kr(s) {
  if (!s.b && typeof XMLHttpRequest > "u" && typeof ActiveXObject < "u") {
    for (var e = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], p = 0; p < e.length; p++) {
      var c = e[p];
      try {
        return new ActiveXObject(c), s.b = c;
      } catch {
      }
    }
    throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
  }
  return s.b;
}
Co = new Yr();
Me();
fe();
function Yo(s, e) {
  this.b = s[ee.Symbol.iterator](), this.c = e, this.f = 0;
}
Yo.prototype[Symbol.iterator] = function() {
  return this;
};
Yo.prototype.next = function() {
  var s = this.b.next();
  return { value: s.done ? void 0 : this.c.call(void 0, s.value, this.f++), done: s.done };
};
function _a(s, e) {
  return new Yo(s, e);
}
Me();
fe();
Me();
fe();
var jt = "StopIteration" in ee ? ee.StopIteration : { message: "StopIteration", stack: "" };
function Ie() {
}
Ie.prototype.next = function() {
  return Ie.prototype.a.call(this);
};
Ie.prototype.a = function() {
  throw jt;
};
Ie.prototype.u = function() {
  return this;
};
function Zr(s) {
  if (s instanceof be || s instanceof Pe || s instanceof Le)
    return s;
  if (typeof s.next == "function")
    return new be(function() {
      return ir(s);
    });
  if (Me(), fe(), typeof s[Symbol.iterator] == "function")
    return Me(), fe(), new be(function() {
      return s[Symbol.iterator]();
    });
  if (typeof s.u == "function")
    return new be(function() {
      return ir(s.u());
    });
  throw Error("Not an iterator or iterable.");
}
function ir(s) {
  if (!(s instanceof Ie))
    return s;
  var e = !1;
  return { next: function() {
    for (var p; !e; )
      try {
        p = s.a();
        break;
      } catch (c) {
        if (c !== jt)
          throw c;
        e = !0;
      }
    return { value: p, done: e };
  } };
}
Me();
fe();
function be(s) {
  this.b = s;
}
be.prototype.u = function() {
  return new Pe(this.b());
};
be.prototype[Symbol.iterator] = function() {
  return new Le(this.b());
};
be.prototype.c = function() {
  return new Le(this.b());
};
Me();
fe();
function Pe(s) {
  this.b = s;
}
Wo(Pe, Ie);
Pe.prototype.a = function() {
  var s = this.b.next();
  if (s.done)
    throw jt;
  return s.value;
};
Pe.prototype.next = function() {
  return Pe.prototype.a.call(this);
};
Pe.prototype[Symbol.iterator] = function() {
  return new Le(this.b);
};
Pe.prototype.c = function() {
  return new Le(this.b);
};
function Le(s) {
  be.call(this, function() {
    return s;
  }), this.f = s;
}
Wo(Le, be);
Le.prototype.next = function() {
  return this.f.next();
};
function qt(s, e) {
  this.o = {}, this.j = [], this.B = this.size = 0;
  var p = arguments.length;
  if (1 < p) {
    if (p % 2)
      throw Error("Uneven number of arguments");
    for (var c = 0; c < p; c += 2)
      this.set(arguments[c], arguments[c + 1]);
  } else
    s && this.addAll(s);
}
J = qt.prototype;
J.G = function() {
  return Ko(this), this.j.concat();
};
J.has = function(s) {
  return Ve(this.o, s);
};
J.clear = function() {
  this.o = {}, this.B = this.size = this.j.length = 0;
};
J.remove = function(s) {
  return this.delete(s);
};
J.delete = function(s) {
  return Ve(this.o, s) ? (delete this.o[s], --this.size, this.B++, this.j.length > 2 * this.size && Ko(this), !0) : !1;
};
function Ko(s) {
  if (s.size != s.j.length) {
    for (var e = 0, p = 0; e < s.j.length; ) {
      var c = s.j[e];
      Ve(s.o, c) && (s.j[p++] = c), e++;
    }
    s.j.length = p;
  }
  if (s.size != s.j.length) {
    var o = {};
    for (p = e = 0; e < s.j.length; )
      c = s.j[e], Ve(o, c) || (s.j[p++] = c, o[c] = 1), e++;
    s.j.length = p;
  }
}
J.get = function(s, e) {
  return Ve(this.o, s) ? this.o[s] : e;
};
J.set = function(s, e) {
  Ve(this.o, s) || (this.size += 1, this.j.push(s), this.B++), this.o[s] = e;
};
J.addAll = function(s) {
  if (s instanceof qt)
    for (var e = s.G(), p = 0; p < e.length; p++)
      this.set(e[p], s.get(e[p]));
  else
    for (e in s)
      this.set(e, s[e]);
};
J.forEach = function(s, e) {
  for (var p = this.G(), c = 0; c < p.length; c++) {
    var o = p[c], a = this.get(o);
    s.call(e, a, o, this);
  }
};
J.clone = function() {
  return new qt(this);
};
J.keys = function() {
  return Zr(this.u(!0)).c();
};
J.values = function() {
  return Zr(this.u(!1)).c();
};
J.entries = function() {
  var s = this;
  return _a(this.keys(), function(e) {
    return [e, s.get(e)];
  });
};
J.u = function(s) {
  Ko(this);
  var e = 0, p = this.B, c = this, o = new Ie();
  return o.a = function() {
    if (p != c.B)
      throw Error("The map has changed since the iterator was created");
    if (e >= c.j.length)
      throw jt;
    var a = c.j[e++];
    return s ? a : c.o[a];
  }, o.next = o.a.bind(o), o;
};
function Ve(s, e) {
  return Object.prototype.hasOwnProperty.call(s, e);
}
var ja = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function Vt(s) {
  He.call(this), this.headers = new qt(), this.C = s || null, this.c = !1, this.J = this.a = null, this.P = this.v = "", this.g = 0, this.l = "", this.i = this.N = this.s = this.L = !1, this.h = 0, this.w = null, this.m = Xr, this.I = this.M = !1;
}
Ue(Vt, He);
var Xr = "";
Vt.prototype.b = zt(Mo(), "goog.net.XhrIo", void 0).g;
var qa = /^https?$/i, Va = ["POST", "PUT"];
function Ua(s, e, p) {
  if (s.a)
    throw Error("[goog.net.XhrIo] Object is active with another request=" + s.v + "; newUri=" + e);
  s.v = e, s.l = "", s.g = 0, s.P = "POST", s.L = !1, s.c = !0, s.a = s.C ? or(s.C) : or(Co), s.J = s.C ? tr(s.C) : tr(Co), s.a.onreadystatechange = De(s.R, s);
  try {
    ae(s.b, Re(s, "Opening Xhr")), s.N = !0, s.a.open("POST", String(e), !0), s.N = !1;
  } catch (a) {
    ae(s.b, Re(s, "Error opening Xhr: " + a.message)), rr(s, a);
    return;
  }
  e = p || "", p = s.headers.clone();
  var c = p.G().find(function(a) {
    return a.toLowerCase() == "content-type";
  }), o = ee.FormData && e instanceof ee.FormData;
  !(0 <= Lr(Va, "POST")) || c || o || p.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"), p.forEach(function(a, i) {
    this.a.setRequestHeader(i, a);
  }, s), s.m && (s.a.responseType = s.m), "withCredentials" in s.a && s.a.withCredentials !== s.M && (s.a.withCredentials = s.M);
  try {
    tn(s), 0 < s.h && (s.I = Ha(s.a), ae(s.b, Re(s, "Will abort after " + s.h + "ms if incomplete, xhr2 " + s.I)), s.I ? (s.a.timeout = s.h, s.a.ontimeout = De(s.T, s)) : s.w = _r(s.T, s.h, s)), ae(s.b, Re(s, "Sending request")), s.s = !0, s.a.send(e), s.s = !1;
  } catch (a) {
    ae(
      s.b,
      Re(s, "Send error: " + a.message)
    ), rr(s, a);
  }
}
function Ha(s) {
  return Ro && Oa() && typeof s.timeout == "number" && s.ontimeout !== void 0;
}
J = Vt.prototype;
J.T = function() {
  typeof zo < "u" && this.a && (this.l = "Timed out after " + this.h + "ms, aborting", this.g = 8, ae(this.b, Re(this, this.l)), Be(this, "timeout"), this.abort(8));
};
function rr(s, e) {
  s.c = !1, s.a && (s.i = !0, s.a.abort(), s.i = !1), s.l = e, s.g = 5, Qr(s), Zo(s);
}
function Qr(s) {
  s.L || (s.L = !0, Be(s, "complete"), Be(s, "error"));
}
J.abort = function(s) {
  this.a && this.c && (ae(this.b, Re(this, "Aborting")), this.c = !1, this.i = !0, this.a.abort(), this.i = !1, this.g = s || 7, Be(this, "complete"), Be(this, "abort"), Zo(this));
};
J.R = function() {
  this.K || (this.N || this.s || this.i ? en(this) : this.W());
};
J.W = function() {
  en(this);
};
function en(s) {
  if (s.c && typeof zo < "u") {
    if (s.J[1] && _e(s) == 4 && s.getStatus() == 2)
      ae(s.b, Re(s, "Local request error detected and ignored"));
    else if (s.s && _e(s) == 4)
      _r(s.R, 0, s);
    else if (Be(s, "readystatechange"), _e(s) == 4) {
      ae(s.b, Re(s, "Request complete")), s.c = !1;
      try {
        var e = s.getStatus();
        e:
          switch (e) {
            case 200:
            case 201:
            case 202:
            case 204:
            case 206:
            case 304:
            case 1223:
              var p = !0;
              break e;
            default:
              p = !1;
          }
        var c;
        if (!(c = p)) {
          var o;
          if (o = e === 0) {
            var a = String(s.v).match(ja)[1] || null;
            if (!a && ee.self && ee.self.location) {
              var i = ee.self.location.protocol;
              a = i.substr(0, i.length - 1);
            }
            o = !qa.test(a ? a.toLowerCase() : "");
          }
          c = o;
        }
        if (c)
          Be(s, "complete"), Be(s, "success");
        else {
          s.g = 6;
          try {
            var u = 2 < _e(s) ? s.a.statusText : "";
          } catch (y) {
            ae(s.b, "Can not get status: " + y.message), u = "";
          }
          s.l = u + " [" + s.getStatus() + "]", Qr(s);
        }
      } finally {
        Zo(s);
      }
    }
  }
}
function Zo(s) {
  if (s.a) {
    tn(s);
    var e = s.a, p = s.J[0] ? It : null;
    s.a = null, s.J = null, Be(s, "ready");
    try {
      e.onreadystatechange = p;
    } catch (c) {
      (s = s.b) && Jo(s, jr, "Problem encountered resetting onreadystatechange: " + c.message);
    }
  }
}
function tn(s) {
  s.a && s.I && (s.a.ontimeout = null), s.w && (Ho.clearTimeout(s.w), s.w = null);
}
function _e(s) {
  return s.a ? s.a.readyState : 0;
}
J.getStatus = function() {
  try {
    return 2 < _e(this) ? this.a.status : -1;
  } catch {
    return -1;
  }
};
function Ja(s) {
  try {
    if (!s.a)
      return null;
    if ("response" in s.a)
      return s.a.response;
    switch (s.m) {
      case Xr:
      case "text":
        return s.a.responseText;
      case "arraybuffer":
        if ("mozResponseArrayBuffer" in s.a)
          return s.a.mozResponseArrayBuffer;
    }
    var e = s.b;
    return e && Jo(e, jr, "Response type " + s.m + " is not supported on this browser"), null;
  } catch (p) {
    return ae(s.b, "Can not get response: " + p.message), null;
  }
}
function Ya(s) {
  var e = {};
  s = (s.a && _e(s) == 4 && s.a.getAllResponseHeaders() || "").split(`\r
`);
  for (var p = 0; p < s.length; p++)
    if (!/^[\s\xa0]*$/.test(s[p])) {
      var c = Ta(s[p]), o = c[0];
      if (c = c[1], typeof c == "string") {
        c = c.trim();
        var a = e[o] || [];
        e[o] = a, a.push(c);
      }
    }
  return Ma(e, function(i) {
    return i.join(", ");
  });
}
function Re(s, e) {
  return e + " [" + s.P + " " + s.v + " " + s.getStatus() + "]";
}
var on = {}, st = null;
function Ka(s) {
  var e = s.length, p = 3 * e / 4;
  p % 3 ? p = Math.floor(p) : oe("=.", s[e - 1]) && (p = oe("=.", s[e - 2]) ? p - 2 : p - 1);
  var c = new Uint8Array(p), o = 0;
  return Za(s, function(a) {
    c[o++] = a;
  }), c.subarray(0, o);
}
function Za(s, e) {
  function p(y) {
    for (; c < s.length; ) {
      var h = s.charAt(c++), B = st[h];
      if (B != null)
        return B;
      if (!/^[\s\xa0]*$/.test(h))
        throw Error("Unknown base64 encoding at char: " + h);
    }
    return y;
  }
  rn();
  for (var c = 0; ; ) {
    var o = p(-1), a = p(0), i = p(64), u = p(64);
    if (u === 64 && o === -1)
      break;
    e(o << 2 | a >> 4), i != 64 && (e(a << 4 & 240 | i >> 2), u != 64 && e(i << 6 & 192 | u));
  }
}
function rn() {
  if (!st) {
    st = {};
    for (var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), e = ["+/=", "+/", "-_=", "-_.", "-_"], p = 0; 5 > p; p++) {
      var c = s.concat(e[p].split(""));
      on[p] = c;
      for (var o = 0; o < c.length; o++) {
        var a = c[o];
        st[a] === void 0 && (st[a] = o);
      }
    }
  }
}
var Xa = ["content-type", "grpc-status", "grpc-message"];
function ye(s) {
  this.a = s.Z, this.m = null, this.b = [], this.h = [], this.g = [], this.f = [], this.c = [], this.l = !1, this.i = 0, this.s = new Ra();
  var e = this;
  Lt(this.a, "readystatechange", function() {
    var p = e.a;
    if (p = p.a ? p.a.getResponseHeader("Content-Type") : null) {
      if (p = p.toLowerCase(), p.lastIndexOf("application/grpc-web-text", 0) == 0) {
        p = e.a;
        try {
          var c = p.a ? p.a.responseText : "";
        } catch (y) {
          ae(p.b, "Can not get responseText: " + y.message), c = "";
        }
        if (p = c || "", c = p.length - p.length % 4, p = p.substr(e.i, c - e.i), p.length == 0)
          return;
        e.i = c, p = Ka(p);
      } else if (p.lastIndexOf("application/grpc", 0) == 0)
        p = new Uint8Array(Ja(e.a));
      else {
        xe(e, new de(2, "Unknown Content-type received."));
        return;
      }
      c = null;
      try {
        c = ba(e.s, p);
      } catch {
        xe(e, new de(2, "Error in parsing response body"));
      }
      if (c)
        for (p = 0; p < c.length; p++) {
          if (Fo in c[p]) {
            var o = c[p][Fo];
            if (o) {
              var a = !1, i = void 0;
              try {
                i = e.m(o), a = !0;
              } catch (y) {
                xe(e, new de(13, "Error when deserializing response data; error: " + y + (", response: " + i)));
              }
              if (a)
                for (o = i, a = 0; a < e.b.length; a++)
                  e.b[a](o);
            }
          }
          if (pt in c[p] && 0 < c[p][pt].length) {
            for (o = "", a = 0; a < c[p][pt].length; a++)
              o += String.fromCharCode(c[p][pt][a]);
            for (o = o.trim().split(`\r
`), a = {}, i = 0; i < o.length; i++) {
              var u = o[i].indexOf(":");
              a[o[i].substring(0, u).trim()] = o[i].substring(u + 1).trim();
            }
            o = a, a = 0, i = "", "grpc-status" in o && (a = Number(o["grpc-status"]), delete o["grpc-status"]), "grpc-message" in o && (i = o["grpc-message"], delete o["grpc-message"]), xe(e, new de(a, i, o));
          }
        }
    }
  }), Lt(this.a, "complete", function() {
    var p = e.a.g, c = 2, o = "", a = {};
    c = Ya(e.a);
    var i = {};
    for (u in c)
      c.hasOwnProperty(u) && (i[u.toLowerCase()] = c[u]);
    Object.keys(i).forEach(function(y) {
      Xa.includes(y) || (a[y] = i[y]);
    }), Qa(e, a);
    var u = -1;
    if (p != 0) {
      switch (p) {
        case 7:
          c = 10;
          break;
        case 8:
          c = 4;
          break;
        case 6:
          u = e.a.getStatus(), c = ya(u);
          break;
        default:
          c = 14;
      }
      c == 10 && e.l || (o = va(p), u != -1 && (o += ", http status code: " + u), xe(e, new de(c, o)));
    } else
      p = !1, "grpc-status" in i && (c = Number(i["grpc-status"]), "grpc-message" in i && (o = i["grpc-message"]), c != 0 && (xe(e, new de(c, o || "", i)), p = !0)), p || ep(e);
  });
}
ye.prototype.on = function(s, e) {
  return s == "data" ? this.b.push(e) : s == "status" ? this.h.push(e) : s == "metadata" ? this.g.push(e) : s == "end" ? this.c.push(e) : s == "error" && this.f.push(e), this;
};
function at(s, e) {
  e = s.indexOf(e), -1 < e && s.splice(e, 1);
}
ye.prototype.removeListener = function(s, e) {
  return s == "data" ? at(this.b, e) : s == "status" ? at(this.h, e) : s == "metadata" ? at(this.g, e) : s == "end" ? at(this.c, e) : s == "error" && at(this.f, e), this;
};
ye.prototype.cancel = function() {
  this.l = !0, this.a.abort();
};
function xe(s, e) {
  if (e.code != 0)
    for (var p = new de(e.code, decodeURIComponent(e.message || ""), e.metadata), c = 0; c < s.f.length; c++)
      s.f[c](p);
  for (e = { code: e.code, details: decodeURIComponent(e.message || ""), metadata: e.metadata }, p = 0; p < s.h.length; p++)
    s.h[p](e);
}
function Qa(s, e) {
  for (var p = 0; p < s.g.length; p++)
    s.g[p](e);
}
function ep(s) {
  for (var e = 0; e < s.c.length; e++)
    s.c[e]();
}
ye.prototype.cancel = ye.prototype.cancel;
ye.prototype.removeListener = ye.prototype.removeListener;
ye.prototype.on = ye.prototype.on;
function tp(s) {
  var e = "";
  return Ba(s, function(p, c) {
    e += c, e += ":", e += p, e += `\r
`;
  }), e;
}
function re(s, e) {
  s = s === void 0 ? {} : s, this.a = s.format || nt("format", s) || "text", this.g = s.aa || nt("suppressCorsPreflight", s) || !1, this.f = s.withCredentials || nt("withCredentials", s) || !1, this.b = s.$ || nt("streamInterceptors", s) || [], this.h = s.ba || nt("unaryInterceptors", s) || [], this.c = e || null;
}
re.prototype.X = function(s, e, p, c, o) {
  var a = this, i = s.substr(0, s.length - c.name.length);
  return s = Qo(function(u) {
    return Xo(a, u, i);
  }, this.b).call(this, No(c, e, p)), nn(s, o, !1), new _t(s);
};
re.prototype.S = function(s, e, p, c) {
  var o = this, a = s.substr(0, s.length - c.name.length);
  return Qo(function(i) {
    return new Promise(function(u, y) {
      var h = Xo(o, i, a), B, C, M;
      nn(h, function(I, $, t, r, n) {
        I ? y(I) : n ? M = $ : t ? C = t : r ? B = r : (I = i.getMethodDescriptor(), $ = B, $ = $ === void 0 ? {} : $, u(new yt(M, I, $, C === void 0 ? null : C)));
      }, !0);
    });
  }, this.h).call(this, No(c, e, p)).then(function(i) {
    return i.getResponseMessage();
  });
};
re.prototype.unaryCall = function(s, e, p, c) {
  return this.S(s, e, p, c);
};
re.prototype.Y = function(s, e, p, c) {
  var o = this, a = s.substr(0, s.length - c.name.length);
  return Qo(function(i) {
    return Xo(o, i, a);
  }, this.b).call(this, No(c, e, p));
};
function Xo(s, e, p) {
  var c = e.getMethodDescriptor(), o = p + c.getName();
  p = s.c ? s.c : new Vt(), p.M = s.f;
  var a = new ye({ Z: p });
  a.m = c.b;
  var i = e.getMetadata();
  for (u in i)
    p.headers.set(u, i[u]);
  if (s.a == "text" ? (p.headers.set("Content-Type", "application/grpc-web-text"), p.headers.set("Accept", "application/grpc-web-text")) : p.headers.set("Content-Type", "application/grpc-web+proto"), p.headers.set("X-User-Agent", "grpc-web-javascript/0.1"), p.headers.set("X-Grpc-Web", "1"), p.headers.has("deadline")) {
    var u = Number(p.headers.get("deadline"));
    u = Math.ceil(u - (/* @__PURE__ */ new Date()).getTime()), p.headers.delete("deadline"), u === 1 / 0 && (u = 0), 0 < u && (p.headers.set("grpc-timeout", u + "m"), p.h = Math.max(0, Math.max(1e3, Math.ceil(1.1 * u))));
  }
  if (s.g) {
    i = p.headers, u = {};
    for (var y = yo(i.keys()), h = y.next(); !h.done; h = y.next())
      h = h.value, u[h] = i.get(h);
    p.headers.clear();
    e: {
      for (B in u) {
        var B = !1;
        break e;
      }
      B = !0;
    }
    B || (u = tp(u), typeof o == "string" ? (B = encodeURIComponent("$httpHeaders"), u = u != null ? "=" + encodeURIComponent(String(u)) : "", (B += u) && (u = o.indexOf("#"), 0 > u && (u = o.length), i = o.indexOf("?"), 0 > i || i > u ? (i = u, y = "") : y = o.substring(i + 1, u), o = [o.substr(0, i), y, o.substr(u)], u = o[1], o[1] = B ? u ? u + "&" + B : B : u, o = o[0] + (o[1] ? "?" + o[1] : "") + o[2])) : o.a("$httpHeaders", u));
  }
  for (e = (0, c.a)(e.getRequestMessage()), c = e.length, B = [0, 0, 0, 0], u = new Uint8Array(5 + c), i = 3; 0 <= i; i--)
    B[i] = c % 256, c >>>= 8;
  if (u.set(new Uint8Array(B), 1), u.set(e, 5), e = u, s.a == "text") {
    s = e;
    var C;
    for (C === void 0 && (C = 0), rn(), C = on[C], e = Array(Math.floor(s.length / 3)), c = C[64] || "", B = u = 0; u < s.length - 2; u += 3) {
      h = s[u];
      var M = s[u + 1];
      y = s[u + 2], i = C[h >> 2], h = C[(h & 3) << 4 | M >> 4], M = C[(M & 15) << 2 | y >> 6], y = C[y & 63], e[B++] = i + h + M + y;
    }
    switch (i = 0, y = c, s.length - u) {
      case 2:
        i = s[u + 1], y = C[(i & 15) << 2] || c;
      case 1:
        s = s[u], e[B] = C[s >> 2] + C[(s & 3) << 4 | i >> 4] + y + c;
    }
    e = e.join("");
  } else
    s.a == "binary" && (p.m = "arraybuffer");
  return Ua(p, o, e), a;
}
function nn(s, e, p) {
  var c = !1, o = null, a = !1;
  s.on("data", function(i) {
    c = !0, o = i;
  }), s.on("error", function(i) {
    i.code == 0 || a || (a = !0, e(i, null));
  }), s.on("status", function(i) {
    i.code == 0 || a ? p && e(null, null, i) : (a = !0, e({ code: i.code, message: i.details, metadata: i.metadata }, null));
  }), p && s.on("metadata", function(i) {
    e(null, null, null, i);
  }), s.on("end", function() {
    a || (c ? p ? e(null, o, null, null, !0) : e(null, o) : e({ code: 2, message: "Incomplete response" })), p && e(null, null);
  });
}
function Qo(s, e) {
  var p = s;
  return e.forEach(function(c) {
    var o = p;
    p = function(a) {
      return c.intercept(a, o);
    };
  }), p;
}
re.prototype.serverStreaming = re.prototype.Y;
re.prototype.unaryCall = re.prototype.unaryCall;
re.prototype.thenableCall = re.prototype.S;
re.prototype.rpcCall = re.prototype.X;
Te.CallOptions = Gt;
Te.MethodDescriptor = $t;
Te.GrpcWebClientBase = re;
Te.RpcError = de;
Te.StatusCode = { OK: 0, CANCELLED: 1, UNKNOWN: 2, INVALID_ARGUMENT: 3, DEADLINE_EXCEEDED: 4, NOT_FOUND: 5, ALREADY_EXISTS: 6, PERMISSION_DENIED: 7, UNAUTHENTICATED: 16, RESOURCE_EXHAUSTED: 8, FAILED_PRECONDITION: 9, ABORTED: 10, OUT_OF_RANGE: 11, UNIMPLEMENTED: 12, INTERNAL: 13, UNAVAILABLE: 14, DATA_LOSS: 15 };
Te.MethodType = { UNARY: "unary", SERVER_STREAMING: "server_streaming", BIDI_STREAMING: "bidi_streaming" };
Ho = typeof globalThis < "u" && globalThis || self;
var ei = {}, _ = {};
(function(s) {
  var e = typeof Object.defineProperties == "function" ? Object.defineProperty : function(l, g, f) {
    l != Array.prototype && l != Object.prototype && (l[g] = f.value);
  }, p = (typeof window < "u" && window === ge || typeof ge < "u" && ge != null, ge);
  function c(l, g) {
    if (g) {
      var f = p;
      l = l.split(".");
      for (var v = 0; v < l.length - 1; v++) {
        var R = l[v];
        R in f || (f[R] = {}), f = f[R];
      }
      l = l[l.length - 1], v = f[l], g = g(v), g != v && g != null && e(f, l, { configurable: !0, writable: !0, value: g });
    }
  }
  function o(l) {
    var g = 0;
    return function() {
      return g < l.length ? { done: !1, value: l[g++] } : { done: !0 };
    };
  }
  function a() {
    a = function() {
    }, p.Symbol || (p.Symbol = u);
  }
  function i(l, g) {
    this.a = l, e(this, "description", { configurable: !0, writable: !0, value: g });
  }
  i.prototype.toString = function() {
    return this.a;
  };
  var u = function() {
    function l(f) {
      if (this instanceof l)
        throw new TypeError("Symbol is not a constructor");
      return new i("jscomp_symbol_" + (f || "") + "_" + g++, f);
    }
    var g = 0;
    return l;
  }();
  function y() {
    a();
    var l = p.Symbol.iterator;
    l || (l = p.Symbol.iterator = p.Symbol("Symbol.iterator")), typeof Array.prototype[l] != "function" && e(Array.prototype, l, { configurable: !0, writable: !0, value: function() {
      return h(o(this));
    } }), y = function() {
    };
  }
  function h(l) {
    return y(), l = { next: l }, l[p.Symbol.iterator] = function() {
      return this;
    }, l;
  }
  function B(l, g) {
    y(), l instanceof String && (l += "");
    var f = 0, v = { next: function() {
      if (f < l.length) {
        var R = f++;
        return { value: g(R, l[R]), done: !1 };
      }
      return v.next = function() {
        return { done: !0, value: void 0 };
      }, v.next();
    } };
    return v[Symbol.iterator] = function() {
      return v;
    }, v;
  }
  c("Array.prototype.entries", function(l) {
    return l || function() {
      return B(this, function(g, f) {
        return [g, f];
      });
    };
  });
  var C = ge || self;
  function M(l, g, f) {
    l = l.split("."), f = f || C, l[0] in f || typeof f.execScript > "u" || f.execScript("var " + l[0]);
    for (var v; l.length && (v = l.shift()); )
      l.length || g === void 0 ? f[v] && f[v] !== Object.prototype[v] ? f = f[v] : f = f[v] = {} : f[v] = g;
  }
  function I(l) {
    var g = typeof l;
    if (g == "object")
      if (l) {
        if (l instanceof Array)
          return "array";
        if (l instanceof Object)
          return g;
        var f = Object.prototype.toString.call(l);
        if (f == "[object Window]")
          return "object";
        if (f == "[object Array]" || typeof l.length == "number" && typeof l.splice < "u" && typeof l.propertyIsEnumerable < "u" && !l.propertyIsEnumerable("splice"))
          return "array";
        if (f == "[object Function]" || typeof l.call < "u" && typeof l.propertyIsEnumerable < "u" && !l.propertyIsEnumerable("call"))
          return "function";
      } else
        return "null";
    else if (g == "function" && typeof l.call > "u")
      return "object";
    return g;
  }
  function $(l) {
    var g = typeof l;
    return g == "object" && l != null || g == "function";
  }
  function t(l, g, f) {
    M(l, g, f);
  }
  function r(l, g) {
    function f() {
    }
    f.prototype = g.prototype, l.prototype = new f(), l.prototype.constructor = l;
  }
  var n = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  function d(l, g) {
    for (var f, v, R = 1; R < arguments.length; R++) {
      v = arguments[R];
      for (f in v)
        l[f] = v[f];
      for (var T = 0; T < n.length; T++)
        f = n[T], Object.prototype.hasOwnProperty.call(v, f) && (l[f] = v[f]);
    }
  }
  var ne = Array.prototype.forEach ? function(l, g) {
    Array.prototype.forEach.call(l, g, void 0);
  } : function(l, g) {
    for (var f = l.length, v = typeof l == "string" ? l.split("") : l, R = 0; R < f; R++)
      R in v && g.call(void 0, v[R], R, l);
  }, O = Array.prototype.map ? function(l, g) {
    return Array.prototype.map.call(l, g, void 0);
  } : function(l, g) {
    for (var f = l.length, v = Array(f), R = typeof l == "string" ? l.split("") : l, T = 0; T < f; T++)
      T in R && (v[T] = g.call(void 0, R[T], T, l));
    return v;
  };
  function ia(l, g, f) {
    return 2 >= arguments.length ? Array.prototype.slice.call(l, g) : Array.prototype.slice.call(l, g, f);
  }
  function bt(l, g, f, v) {
    var R = "Assertion failed";
    if (f) {
      R += ": " + f;
      var T = v;
    } else
      l && (R += ": " + l, T = g);
    throw Error(R, T || []);
  }
  function w(l, g, f) {
    for (var v = [], R = 2; R < arguments.length; ++R)
      v[R - 2] = arguments[R];
    return l || bt("", null, g, v), l;
  }
  function ra(l, g, f) {
    for (var v = [], R = 2; R < arguments.length; ++R)
      v[R - 2] = arguments[R];
    typeof l != "string" && bt("Expected string but got %s: %s.", [I(l), l], g, v);
  }
  function na(l, g, f) {
    for (var v = [], R = 2; R < arguments.length; ++R)
      v[R - 2] = arguments[R];
    Array.isArray(l) || bt("Expected array but got %s: %s.", [I(l), l], g, v);
  }
  function K(l, g) {
    for (var f = [], v = 1; v < arguments.length; ++v)
      f[v - 1] = arguments[v];
    throw Error("Failure" + (l ? ": " + l : ""), f);
  }
  function le(l, g, f, v) {
    for (var R = [], T = 3; T < arguments.length; ++T)
      R[T - 3] = arguments[T];
    l instanceof g || bt("Expected instanceof %s but got %s.", [di(g), di(l)], f, R);
  }
  function di(l) {
    return l instanceof Function ? l.displayName || l.name || "unknown type name" : l instanceof Object ? l.constructor.displayName || l.constructor.name || Object.prototype.toString.call(l) : l === null ? "null" : typeof l;
  }
  function N(l, g) {
    if (this.c = l, this.b = g, this.a = {}, this.arrClean = !0, 0 < this.c.length) {
      for (l = 0; l < this.c.length; l++) {
        g = this.c[l];
        var f = g[0];
        this.a[f.toString()] = new ci(f, g[1]);
      }
      this.arrClean = !0;
    }
  }
  M("jspb.Map", N, void 0), N.prototype.g = function() {
    if (this.arrClean) {
      if (this.b) {
        var l = this.a, g;
        for (g in l)
          if (Object.prototype.hasOwnProperty.call(l, g)) {
            var f = l[g].a;
            f && f.g();
          }
      }
    } else {
      for (this.c.length = 0, l = me(this), l.sort(), g = 0; g < l.length; g++) {
        var v = this.a[l[g]];
        (f = v.a) && f.g(), this.c.push([v.key, v.value]);
      }
      this.arrClean = !0;
    }
    return this.c;
  }, N.prototype.toArray = N.prototype.g, N.prototype.Mc = function(l, g) {
    for (var f = this.g(), v = [], R = 0; R < f.length; R++) {
      var T = this.a[f[R][0].toString()];
      We(this, T);
      var P = T.a;
      P ? (w(g), v.push([T.key, g(l, P)])) : v.push([T.key, T.value]);
    }
    return v;
  }, N.prototype.toObject = N.prototype.Mc, N.fromObject = function(l, g, f) {
    g = new N([], g);
    for (var v = 0; v < l.length; v++) {
      var R = l[v][0], T = f(l[v][1]);
      g.set(R, T);
    }
    return g;
  };
  function Je(l) {
    this.a = 0, this.b = l;
  }
  Je.prototype.next = function() {
    return this.a < this.b.length ? { done: !1, value: this.b[this.a++] } : { done: !0, value: void 0 };
  }, typeof Symbol < "u" && (Je.prototype[Symbol.iterator] = function() {
    return this;
  }), N.prototype.Jb = function() {
    return me(this).length;
  }, N.prototype.getLength = N.prototype.Jb, N.prototype.clear = function() {
    this.a = {}, this.arrClean = !1;
  }, N.prototype.clear = N.prototype.clear, N.prototype.Cb = function(l) {
    l = l.toString();
    var g = this.a.hasOwnProperty(l);
    return delete this.a[l], this.arrClean = !1, g;
  }, N.prototype.del = N.prototype.Cb, N.prototype.Eb = function() {
    var l = [], g = me(this);
    g.sort();
    for (var f = 0; f < g.length; f++) {
      var v = this.a[g[f]];
      l.push([v.key, v.value]);
    }
    return l;
  }, N.prototype.getEntryList = N.prototype.Eb, N.prototype.entries = function() {
    var l = [], g = me(this);
    g.sort();
    for (var f = 0; f < g.length; f++) {
      var v = this.a[g[f]];
      l.push([v.key, We(this, v)]);
    }
    return new Je(l);
  }, N.prototype.entries = N.prototype.entries, N.prototype.keys = function() {
    var l = [], g = me(this);
    g.sort();
    for (var f = 0; f < g.length; f++)
      l.push(this.a[g[f]].key);
    return new Je(l);
  }, N.prototype.keys = N.prototype.keys, N.prototype.values = function() {
    var l = [], g = me(this);
    g.sort();
    for (var f = 0; f < g.length; f++)
      l.push(We(this, this.a[g[f]]));
    return new Je(l);
  }, N.prototype.values = N.prototype.values, N.prototype.forEach = function(l, g) {
    var f = me(this);
    f.sort();
    for (var v = 0; v < f.length; v++) {
      var R = this.a[f[v]];
      l.call(g, We(this, R), R.key, this);
    }
  }, N.prototype.forEach = N.prototype.forEach, N.prototype.set = function(l, g) {
    var f = new ci(l);
    return this.b ? (f.a = g, f.value = g.g()) : f.value = g, this.a[l.toString()] = f, this.arrClean = !1, this;
  }, N.prototype.set = N.prototype.set;
  function We(l, g) {
    return l.b ? (g.a || (g.a = new l.b(g.value)), g.a) : g.value;
  }
  N.prototype.get = function(l) {
    if (l = this.a[l.toString()])
      return We(this, l);
  }, N.prototype.get = N.prototype.get, N.prototype.has = function(l) {
    return l.toString() in this.a;
  }, N.prototype.has = N.prototype.has, N.prototype.Jc = function(l, g, f, v, R) {
    var T = me(this);
    T.sort();
    for (var P = 0; P < T.length; P++) {
      var W = this.a[T[P]];
      g.Va(l), f.call(g, 1, W.key), this.b ? v.call(g, 2, We(this, W), R) : v.call(g, 2, W.value), g.Ya();
    }
  }, N.prototype.serializeBinary = N.prototype.Jc, N.deserializeBinary = function(l, g, f, v, R, T, P) {
    for (; g.oa() && !g.bb(); ) {
      var W = g.c;
      W == 1 ? T = f.call(g) : W == 2 && (l.b ? (w(R), P || (P = new l.b()), v.call(g, P, R)) : P = v.call(g));
    }
    w(T != null), w(P != null), l.set(T, P);
  };
  function me(l) {
    l = l.a;
    var g = [], f;
    for (f in l)
      Object.prototype.hasOwnProperty.call(l, f) && g.push(f);
    return g;
  }
  function ci(l, g) {
    this.key = l, this.value = g, this.a = void 0;
  }
  function fi(l) {
    if (8192 >= l.length)
      return String.fromCharCode.apply(null, l);
    for (var g = "", f = 0; f < l.length; f += 8192)
      g += String.fromCharCode.apply(null, ia(l, f, f + 8192));
    return g;
  }
  var Zt = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" }, Bt = { "'": "\\'" }, yi = {}, Ye = null;
  function hi(l, g) {
    g === void 0 && (g = 0), Fi(), g = yi[g];
    for (var f = [], v = 0; v < l.length; v += 3) {
      var R = l[v], T = v + 1 < l.length, P = T ? l[v + 1] : 0, W = v + 2 < l.length, U = W ? l[v + 2] : 0, ke = R >> 2;
      R = (R & 3) << 4 | P >> 4, P = (P & 15) << 2 | U >> 6, U &= 63, W || (U = 64, T || (P = 64)), f.push(g[ke], g[R], g[P] || "", g[U] || "");
    }
    return f.join("");
  }
  function vi(l) {
    var g = l.length, f = 3 * g / 4;
    f % 3 ? f = Math.floor(f) : "=.".indexOf(l[g - 1]) != -1 && (f = "=.".indexOf(l[g - 2]) != -1 ? f - 2 : f - 1);
    var v = new Uint8Array(f), R = 0;
    return aa(l, function(T) {
      v[R++] = T;
    }), v.subarray(0, R);
  }
  function aa(l, g) {
    function f(U) {
      for (; v < l.length; ) {
        var ke = l.charAt(v++), _i = Ye[ke];
        if (_i != null)
          return _i;
        if (!/^[\s\xa0]*$/.test(ke))
          throw Error("Unknown base64 encoding at char: " + ke);
      }
      return U;
    }
    Fi();
    for (var v = 0; ; ) {
      var R = f(-1), T = f(0), P = f(64), W = f(64);
      if (W === 64 && R === -1)
        break;
      g(R << 2 | T >> 4), P != 64 && (g(T << 4 & 240 | P >> 2), W != 64 && g(P << 6 & 192 | W));
    }
  }
  function Fi() {
    if (!Ye) {
      Ye = {};
      for (var l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), g = ["+/=", "+/", "-_=", "-_.", "-_"], f = 0; 5 > f; f++) {
        var v = l.concat(g[f].split(""));
        yi[f] = v;
        for (var R = 0; R < v.length; R++) {
          var T = v[R];
          Ye[T] === void 0 && (Ye[T] = R);
        }
      }
    }
  }
  M("jspb.ConstBinaryMessage", function() {
  }, void 0), M("jspb.BinaryMessage", function() {
  }, void 0), M("jspb.BinaryConstants.FieldType", { yb: -1, ee: 1, FLOAT: 2, ke: 3, te: 4, je: 5, xb: 6, wb: 7, BOOL: 8, re: 9, ie: 10, le: 11, ce: 12, se: 13, ge: 14, me: 15, ne: 16, oe: 17, pe: 18, he: 30, ve: 31 }, void 0), M("jspb.BinaryConstants.WireType", { yb: -1, ue: 0, xb: 1, de: 2, qe: 3, fe: 4, wb: 5 }, void 0), M("jspb.BinaryConstants.FieldTypeToWireType", function(l) {
    switch (l) {
      case 5:
      case 3:
      case 13:
      case 4:
      case 17:
      case 18:
      case 8:
      case 14:
      case 31:
        return 0;
      case 1:
      case 6:
      case 16:
      case 30:
        return 1;
      case 9:
      case 11:
      case 12:
        return 2;
      case 2:
      case 7:
      case 15:
        return 5;
      default:
        return -1;
    }
  }, void 0), M("jspb.BinaryConstants.INVALID_FIELD_NUMBER", -1, void 0), M("jspb.BinaryConstants.FLOAT32_EPS", 1401298464324817e-60, void 0), M("jspb.BinaryConstants.FLOAT32_MIN", 11754943508222875e-54, void 0), M("jspb.BinaryConstants.FLOAT32_MAX", 34028234663852886e22, void 0), M("jspb.BinaryConstants.FLOAT64_EPS", 5e-324, void 0), M("jspb.BinaryConstants.FLOAT64_MIN", 22250738585072014e-324, void 0), M("jspb.BinaryConstants.FLOAT64_MAX", 17976931348623157e292, void 0), M("jspb.BinaryConstants.TWO_TO_20", 1048576, void 0), M("jspb.BinaryConstants.TWO_TO_23", 8388608, void 0), M("jspb.BinaryConstants.TWO_TO_31", 2147483648, void 0), M("jspb.BinaryConstants.TWO_TO_32", 4294967296, void 0), M("jspb.BinaryConstants.TWO_TO_52", 4503599627370496, void 0), M("jspb.BinaryConstants.TWO_TO_63", 9223372036854776e3, void 0), M("jspb.BinaryConstants.TWO_TO_64", 18446744073709552e3, void 0), M("jspb.BinaryConstants.ZERO_HASH", "\0\0\0\0\0\0\0\0", void 0);
  var x = 0, G = 0;
  M("jspb.utils.getSplit64Low", function() {
    return x;
  }, void 0), M("jspb.utils.getSplit64High", function() {
    return G;
  }, void 0);
  function Xt(l) {
    var g = l >>> 0;
    l = Math.floor((l - g) / 4294967296) >>> 0, x = g, G = l;
  }
  M("jspb.utils.splitUint64", Xt, void 0);
  function Ke(l) {
    var g = 0 > l;
    l = Math.abs(l);
    var f = l >>> 0;
    l = Math.floor((l - f) / 4294967296), l >>>= 0, g && (l = ~l >>> 0, f = (~f >>> 0) + 1, 4294967295 < f && (f = 0, l++, 4294967295 < l && (l = 0))), x = f, G = l;
  }
  M("jspb.utils.splitInt64", Ke, void 0);
  function Ri(l) {
    var g = 0 > l;
    l = 2 * Math.abs(l), Xt(l), l = x;
    var f = G;
    g && (l == 0 ? f == 0 ? f = l = 4294967295 : (f--, l = 4294967295) : l--), x = l, G = f;
  }
  M("jspb.utils.splitZigzag64", Ri, void 0);
  function bi(l) {
    var g = 0 > l ? 1 : 0;
    if (l = g ? -l : l, l === 0)
      0 < 1 / l ? x = G = 0 : (G = 0, x = 2147483648);
    else if (isNaN(l))
      G = 0, x = 2147483647;
    else if (34028234663852886e22 < l)
      G = 0, x = (g << 31 | 2139095040) >>> 0;
    else if (11754943508222875e-54 > l)
      l = Math.round(l / Math.pow(2, -149)), G = 0, x = (g << 31 | l) >>> 0;
    else {
      var f = Math.floor(Math.log(l) / Math.LN2);
      l *= Math.pow(2, -f), l = Math.round(8388608 * l), 16777216 <= l && ++f, G = 0, x = (g << 31 | f + 127 << 23 | l & 8388607) >>> 0;
    }
  }
  M("jspb.utils.splitFloat32", bi, void 0);
  function Bi(l) {
    var g = 0 > l ? 1 : 0;
    if (l = g ? -l : l, l === 0)
      G = 0 < 1 / l ? 0 : 2147483648, x = 0;
    else if (isNaN(l))
      G = 2147483647, x = 4294967295;
    else if (17976931348623157e292 < l)
      G = (g << 31 | 2146435072) >>> 0, x = 0;
    else if (22250738585072014e-324 > l)
      l /= Math.pow(2, -1074), G = (g << 31 | l / 4294967296) >>> 0, x = l >>> 0;
    else {
      var f = l, v = 0;
      if (2 <= f)
        for (; 2 <= f && 1023 > v; )
          v++, f /= 2;
      else
        for (; 1 > f && -1022 < v; )
          f *= 2, v--;
      l *= Math.pow(2, -v), G = (g << 31 | v + 1023 << 20 | 1048576 * l & 1048575) >>> 0, x = 4503599627370496 * l >>> 0;
    }
  }
  M("jspb.utils.splitFloat64", Bi, void 0);
  function we(l) {
    var g = l.charCodeAt(4), f = l.charCodeAt(5), v = l.charCodeAt(6), R = l.charCodeAt(7);
    x = l.charCodeAt(0) + (l.charCodeAt(1) << 8) + (l.charCodeAt(2) << 16) + (l.charCodeAt(3) << 24) >>> 0, G = g + (f << 8) + (v << 16) + (R << 24) >>> 0;
  }
  M("jspb.utils.splitHash64", we, void 0);
  function ze(l, g) {
    return 4294967296 * g + (l >>> 0);
  }
  M("jspb.utils.joinUint64", ze, void 0);
  function Ze(l, g) {
    var f = g & 2147483648;
    return f && (l = ~l + 1 >>> 0, g = ~g >>> 0, l == 0 && (g = g + 1 >>> 0)), l = ze(l, g), f ? -l : l;
  }
  M("jspb.utils.joinInt64", Ze, void 0);
  function Mt(l, g, f) {
    var v = g >> 31;
    return f(l << 1 ^ v, (g << 1 | l >>> 31) ^ v);
  }
  M("jspb.utils.toZigzag64", Mt, void 0);
  function Mi(l, g) {
    return Ct(l, g, Ze);
  }
  M("jspb.utils.joinZigzag64", Mi, void 0);
  function Ct(l, g, f) {
    var v = -(l & 1);
    return f((l >>> 1 | g << 31) ^ v, g >>> 1 ^ v);
  }
  M("jspb.utils.fromZigzag64", Ct, void 0);
  function Ci(l) {
    var g = 2 * (l >> 31) + 1, f = l >>> 23 & 255;
    return l &= 8388607, f == 255 ? l ? NaN : 1 / 0 * g : f == 0 ? g * Math.pow(2, -149) * l : g * Math.pow(2, f - 150) * (l + Math.pow(2, 23));
  }
  M("jspb.utils.joinFloat32", Ci, void 0);
  function Ti(l, g) {
    var f = 2 * (g >> 31) + 1, v = g >>> 20 & 2047;
    return l = 4294967296 * (g & 1048575) + l, v == 2047 ? l ? NaN : 1 / 0 * f : v == 0 ? f * Math.pow(2, -1074) * l : f * Math.pow(2, v - 1075) * (l + 4503599627370496);
  }
  M("jspb.utils.joinFloat64", Ti, void 0);
  function Tt(l, g) {
    return String.fromCharCode(l >>> 0 & 255, l >>> 8 & 255, l >>> 16 & 255, l >>> 24 & 255, g >>> 0 & 255, g >>> 8 & 255, g >>> 16 & 255, g >>> 24 & 255);
  }
  M("jspb.utils.joinHash64", Tt, void 0), M("jspb.utils.DIGITS", "0123456789abcdef".split(""), void 0);
  function Xe(l, g) {
    function f(R, T) {
      return R = R ? String(R) : "", T ? "0000000".slice(R.length) + R : R;
    }
    if (2097151 >= g)
      return "" + ze(l, g);
    var v = (l >>> 24 | g << 8) >>> 0 & 16777215;
    return g = g >> 16 & 65535, l = (l & 16777215) + 6777216 * v + 6710656 * g, v += 8147497 * g, g *= 2, 1e7 <= l && (v += Math.floor(l / 1e7), l %= 1e7), 1e7 <= v && (g += Math.floor(v / 1e7), v %= 1e7), f(g, 0) + f(v, g) + f(l, 1);
  }
  M("jspb.utils.joinUnsignedDecimalString", Xe, void 0);
  function Qe(l, g) {
    var f = g & 2147483648;
    return f && (l = ~l + 1 >>> 0, g = ~g + (l == 0 ? 1 : 0) >>> 0), l = Xe(l, g), f ? "-" + l : l;
  }
  M("jspb.utils.joinSignedDecimalString", Qe, void 0);
  function mi(l, g) {
    we(l), l = x;
    var f = G;
    return g ? Qe(l, f) : Xe(l, f);
  }
  M("jspb.utils.hash64ToDecimalString", mi, void 0), M("jspb.utils.hash64ArrayToDecimalStrings", function(l, g) {
    for (var f = Array(l.length), v = 0; v < l.length; v++)
      f[v] = mi(l[v], g);
    return f;
  }, void 0);
  function et(l) {
    function g(P, W) {
      for (var U = 0; 8 > U && (P !== 1 || 0 < W); U++)
        W = P * R[U] + W, R[U] = W & 255, W >>>= 8;
    }
    function f() {
      for (var P = 0; 8 > P; P++)
        R[P] = ~R[P] & 255;
    }
    w(0 < l.length);
    var v = !1;
    l[0] === "-" && (v = !0, l = l.slice(1));
    for (var R = [0, 0, 0, 0, 0, 0, 0, 0], T = 0; T < l.length; T++)
      g(10, l.charCodeAt(T) - 48);
    return v && (f(), g(1, 1)), fi(R);
  }
  M("jspb.utils.decimalStringToHash64", et, void 0), M("jspb.utils.splitDecimalString", function(l) {
    we(et(l));
  }, void 0);
  function wi(l) {
    return String.fromCharCode(10 > l ? 48 + l : 87 + l);
  }
  function Ei(l) {
    return 97 <= l ? l - 97 + 10 : l - 48;
  }
  M("jspb.utils.hash64ToHexString", function(l) {
    var g = Array(18);
    g[0] = "0", g[1] = "x";
    for (var f = 0; 8 > f; f++) {
      var v = l.charCodeAt(7 - f);
      g[2 * f + 2] = wi(v >> 4), g[2 * f + 3] = wi(v & 15);
    }
    return g.join("");
  }, void 0), M("jspb.utils.hexStringToHash64", function(l) {
    l = l.toLowerCase(), w(l.length == 18), w(l[0] == "0"), w(l[1] == "x");
    for (var g = "", f = 0; 8 > f; f++)
      g = String.fromCharCode(16 * Ei(l.charCodeAt(2 * f + 2)) + Ei(l.charCodeAt(2 * f + 3))) + g;
    return g;
  }, void 0), M("jspb.utils.hash64ToNumber", function(l, g) {
    we(l), l = x;
    var f = G;
    return g ? Ze(l, f) : ze(l, f);
  }, void 0), M("jspb.utils.numberToHash64", function(l) {
    return Ke(l), Tt(x, G);
  }, void 0), M("jspb.utils.countVarints", function(l, g, f) {
    for (var v = 0, R = g; R < f; R++)
      v += l[R] >> 7;
    return f - g - v;
  }, void 0), M("jspb.utils.countVarintFields", function(l, g, f, v) {
    var R = 0;
    if (v *= 8, 128 > v)
      for (; g < f && l[g++] == v; )
        for (R++; ; ) {
          var T = l[g++];
          if (!(T & 128))
            break;
        }
    else
      for (; g < f; ) {
        for (T = v; 128 < T; ) {
          if (l[g] != (T & 127 | 128))
            return R;
          g++, T >>= 7;
        }
        if (l[g++] != T)
          break;
        for (R++; T = l[g++], (T & 128) != 0; )
          ;
      }
    return R;
  }, void 0);
  function Pi(l, g, f, v, R) {
    var T = 0;
    if (128 > v)
      for (; g < f && l[g++] == v; )
        T++, g += R;
    else
      for (; g < f; ) {
        for (var P = v; 128 < P; ) {
          if (l[g++] != (P & 127 | 128))
            return T;
          P >>= 7;
        }
        if (l[g++] != P)
          break;
        T++, g += R;
      }
    return T;
  }
  M("jspb.utils.countFixed32Fields", function(l, g, f, v) {
    return Pi(l, g, f, 8 * v + 5, 4);
  }, void 0), M("jspb.utils.countFixed64Fields", function(l, g, f, v) {
    return Pi(l, g, f, 8 * v + 1, 8);
  }, void 0), M("jspb.utils.countDelimitedFields", function(l, g, f, v) {
    var R = 0;
    for (v = 8 * v + 2; g < f; ) {
      for (var T = v; 128 < T; ) {
        if (l[g++] != (T & 127 | 128))
          return R;
        T >>= 7;
      }
      if (l[g++] != T)
        break;
      R++;
      for (var P = 0, W = 1; T = l[g++], P += (T & 127) * W, W *= 128, (T & 128) != 0; )
        ;
      g += P;
    }
    return R;
  }, void 0), M("jspb.utils.debugBytesToTextFormat", function(l) {
    var g = '"';
    if (l) {
      l = mt(l);
      for (var f = 0; f < l.length; f++)
        g += "\\x", 16 > l[f] && (g += "0"), g += l[f].toString(16);
    }
    return g + '"';
  }, void 0), M("jspb.utils.debugScalarToTextFormat", function(l) {
    if (typeof l == "string") {
      l = String(l);
      for (var g = ['"'], f = 0; f < l.length; f++) {
        var v = l.charAt(f), R = v.charCodeAt(0), T = f + 1, P;
        (P = Zt[v]) || (31 < R && 127 > R || (R = v, R in Bt ? v = Bt[R] : R in Zt ? v = Bt[R] = Zt[R] : (P = R.charCodeAt(0), 31 < P && 127 > P ? v = R : (256 > P ? (v = "\\x", (16 > P || 256 < P) && (v += "0")) : (v = "\\u", 4096 > P && (v += "0")), v += P.toString(16).toUpperCase()), v = Bt[R] = v)), P = v), g[T] = P;
      }
      g.push('"'), l = g.join("");
    } else
      l = l.toString();
    return l;
  }, void 0), M("jspb.utils.stringToByteArray", function(l) {
    for (var g = new Uint8Array(l.length), f = 0; f < l.length; f++) {
      var v = l.charCodeAt(f);
      if (255 < v)
        throw Error("Conversion error: string contains codepoint outside of byte range");
      g[f] = v;
    }
    return g;
  }, void 0);
  function mt(l) {
    return l.constructor === Uint8Array ? l : l.constructor === ArrayBuffer ? new Uint8Array(l) : l.constructor === Array ? new Uint8Array(l) : l.constructor === String ? vi(l) : l instanceof Uint8Array ? new Uint8Array(l.buffer, l.byteOffset, l.byteLength) : (K("Type not convertible to Uint8Array."), new Uint8Array(0));
  }
  M("jspb.utils.byteSourceToUint8Array", mt, void 0);
  function m(l, g, f) {
    this.b = null, this.a = this.c = this.h = 0, this.v = !1, l && this.H(l, g, f);
  }
  M("jspb.BinaryDecoder", m, void 0);
  var tt = [];
  m.getInstanceCacheLength = function() {
    return tt.length;
  };
  function wt(l, g, f) {
    if (tt.length) {
      var v = tt.pop();
      return l && v.H(l, g, f), v;
    }
    return new m(l, g, f);
  }
  m.alloc = wt, m.prototype.Ca = function() {
    this.clear(), 100 > tt.length && tt.push(this);
  }, m.prototype.free = m.prototype.Ca, m.prototype.clone = function() {
    return wt(this.b, this.h, this.c - this.h);
  }, m.prototype.clone = m.prototype.clone, m.prototype.clear = function() {
    this.b = null, this.a = this.c = this.h = 0, this.v = !1;
  }, m.prototype.clear = m.prototype.clear, m.prototype.Y = function() {
    return this.b;
  }, m.prototype.getBuffer = m.prototype.Y, m.prototype.H = function(l, g, f) {
    this.b = mt(l), this.h = g !== void 0 ? g : 0, this.c = f !== void 0 ? this.h + f : this.b.length, this.a = this.h;
  }, m.prototype.setBlock = m.prototype.H, m.prototype.Db = function() {
    return this.c;
  }, m.prototype.getEnd = m.prototype.Db, m.prototype.setEnd = function(l) {
    this.c = l;
  }, m.prototype.setEnd = m.prototype.setEnd, m.prototype.reset = function() {
    this.a = this.h;
  }, m.prototype.reset = m.prototype.reset, m.prototype.B = function() {
    return this.a;
  }, m.prototype.getCursor = m.prototype.B, m.prototype.Ma = function(l) {
    this.a = l;
  }, m.prototype.setCursor = m.prototype.Ma, m.prototype.advance = function(l) {
    this.a += l, w(this.a <= this.c);
  }, m.prototype.advance = m.prototype.advance, m.prototype.ya = function() {
    return this.a == this.c;
  }, m.prototype.atEnd = m.prototype.ya, m.prototype.Qb = function() {
    return this.a > this.c;
  }, m.prototype.pastEnd = m.prototype.Qb, m.prototype.getError = function() {
    return this.v || 0 > this.a || this.a > this.c;
  }, m.prototype.getError = m.prototype.getError, m.prototype.w = function(l) {
    for (var g = 128, f = 0, v = 0, R = 0; 4 > R && 128 <= g; R++)
      g = this.b[this.a++], f |= (g & 127) << 7 * R;
    if (128 <= g && (g = this.b[this.a++], f |= (g & 127) << 28, v |= (g & 127) >> 4), 128 <= g)
      for (R = 0; 5 > R && 128 <= g; R++)
        g = this.b[this.a++], v |= (g & 127) << 7 * R + 3;
    if (128 > g)
      return l(f >>> 0, v >>> 0);
    K("Failed to read varint, encoding is invalid."), this.v = !0;
  }, m.prototype.readSplitVarint64 = m.prototype.w, m.prototype.ea = function(l) {
    return this.w(function(g, f) {
      return Ct(g, f, l);
    });
  }, m.prototype.readSplitZigzagVarint64 = m.prototype.ea, m.prototype.ta = function(l) {
    var g = this.b, f = this.a;
    this.a += 8;
    for (var v = 0, R = 0, T = f + 7; T >= f; T--)
      v = v << 8 | g[T], R = R << 8 | g[T + 4];
    return l(v, R);
  }, m.prototype.readSplitFixed64 = m.prototype.ta, m.prototype.kb = function() {
    for (; this.b[this.a] & 128; )
      this.a++;
    this.a++;
  }, m.prototype.skipVarint = m.prototype.kb, m.prototype.mb = function(l) {
    for (; 128 < l; )
      this.a--, l >>>= 7;
    this.a--;
  }, m.prototype.unskipVarint = m.prototype.mb, m.prototype.o = function() {
    var l = this.b, g = l[this.a], f = g & 127;
    return 128 > g ? (this.a += 1, w(this.a <= this.c), f) : (g = l[this.a + 1], f |= (g & 127) << 7, 128 > g ? (this.a += 2, w(this.a <= this.c), f) : (g = l[this.a + 2], f |= (g & 127) << 14, 128 > g ? (this.a += 3, w(this.a <= this.c), f) : (g = l[this.a + 3], f |= (g & 127) << 21, 128 > g ? (this.a += 4, w(this.a <= this.c), f) : (g = l[this.a + 4], f |= (g & 15) << 28, 128 > g ? (this.a += 5, w(this.a <= this.c), f >>> 0) : (this.a += 5, 128 <= l[this.a++] && 128 <= l[this.a++] && 128 <= l[this.a++] && 128 <= l[this.a++] && 128 <= l[this.a++] && w(!1), w(this.a <= this.c), f)))));
  }, m.prototype.readUnsignedVarint32 = m.prototype.o, m.prototype.da = function() {
    return ~~this.o();
  }, m.prototype.readSignedVarint32 = m.prototype.da, m.prototype.O = function() {
    return this.o().toString();
  }, m.prototype.Ea = function() {
    return this.da().toString();
  }, m.prototype.readSignedVarint32String = m.prototype.Ea, m.prototype.Ia = function() {
    var l = this.o();
    return l >>> 1 ^ -(l & 1);
  }, m.prototype.readZigzagVarint32 = m.prototype.Ia, m.prototype.Ga = function() {
    return this.w(ze);
  }, m.prototype.readUnsignedVarint64 = m.prototype.Ga, m.prototype.Ha = function() {
    return this.w(Xe);
  }, m.prototype.readUnsignedVarint64String = m.prototype.Ha, m.prototype.sa = function() {
    return this.w(Ze);
  }, m.prototype.readSignedVarint64 = m.prototype.sa, m.prototype.Fa = function() {
    return this.w(Qe);
  }, m.prototype.readSignedVarint64String = m.prototype.Fa, m.prototype.Ja = function() {
    return this.w(Mi);
  }, m.prototype.readZigzagVarint64 = m.prototype.Ja, m.prototype.fb = function() {
    return this.ea(Tt);
  }, m.prototype.readZigzagVarintHash64 = m.prototype.fb, m.prototype.Ka = function() {
    return this.ea(Qe);
  }, m.prototype.readZigzagVarint64String = m.prototype.Ka, m.prototype.Gc = function() {
    var l = this.b[this.a];
    return this.a += 1, w(this.a <= this.c), l;
  }, m.prototype.readUint8 = m.prototype.Gc, m.prototype.Ec = function() {
    var l = this.b[this.a], g = this.b[this.a + 1];
    return this.a += 2, w(this.a <= this.c), l << 0 | g << 8;
  }, m.prototype.readUint16 = m.prototype.Ec, m.prototype.m = function() {
    var l = this.b[this.a], g = this.b[this.a + 1], f = this.b[this.a + 2], v = this.b[this.a + 3];
    return this.a += 4, w(this.a <= this.c), (l << 0 | g << 8 | f << 16 | v << 24) >>> 0;
  }, m.prototype.readUint32 = m.prototype.m, m.prototype.ga = function() {
    var l = this.m(), g = this.m();
    return ze(l, g);
  }, m.prototype.readUint64 = m.prototype.ga, m.prototype.ha = function() {
    var l = this.m(), g = this.m();
    return Xe(l, g);
  }, m.prototype.readUint64String = m.prototype.ha, m.prototype.Xb = function() {
    var l = this.b[this.a];
    return this.a += 1, w(this.a <= this.c), l << 24 >> 24;
  }, m.prototype.readInt8 = m.prototype.Xb, m.prototype.Vb = function() {
    var l = this.b[this.a], g = this.b[this.a + 1];
    return this.a += 2, w(this.a <= this.c), (l << 0 | g << 8) << 16 >> 16;
  }, m.prototype.readInt16 = m.prototype.Vb, m.prototype.P = function() {
    var l = this.b[this.a], g = this.b[this.a + 1], f = this.b[this.a + 2], v = this.b[this.a + 3];
    return this.a += 4, w(this.a <= this.c), l << 0 | g << 8 | f << 16 | v << 24;
  }, m.prototype.readInt32 = m.prototype.P, m.prototype.ba = function() {
    var l = this.m(), g = this.m();
    return Ze(l, g);
  }, m.prototype.readInt64 = m.prototype.ba, m.prototype.ca = function() {
    var l = this.m(), g = this.m();
    return Qe(l, g);
  }, m.prototype.readInt64String = m.prototype.ca, m.prototype.aa = function() {
    var l = this.m();
    return Ci(l);
  }, m.prototype.readFloat = m.prototype.aa, m.prototype.Z = function() {
    var l = this.m(), g = this.m();
    return Ti(l, g);
  }, m.prototype.readDouble = m.prototype.Z, m.prototype.pa = function() {
    return !!this.b[this.a++];
  }, m.prototype.readBool = m.prototype.pa, m.prototype.ra = function() {
    return this.da();
  }, m.prototype.readEnum = m.prototype.ra, m.prototype.fa = function(l) {
    var g = this.b, f = this.a;
    l = f + l;
    for (var v = [], R = ""; f < l; ) {
      var T = g[f++];
      if (128 > T)
        v.push(T);
      else {
        if (192 > T)
          continue;
        if (224 > T) {
          var P = g[f++];
          v.push((T & 31) << 6 | P & 63);
        } else if (240 > T) {
          P = g[f++];
          var W = g[f++];
          v.push((T & 15) << 12 | (P & 63) << 6 | W & 63);
        } else if (248 > T) {
          P = g[f++], W = g[f++];
          var U = g[f++];
          T = (T & 7) << 18 | (P & 63) << 12 | (W & 63) << 6 | U & 63, T -= 65536, v.push((T >> 10 & 1023) + 55296, (T & 1023) + 56320);
        }
      }
      8192 <= v.length && (R += String.fromCharCode.apply(null, v), v.length = 0);
    }
    return R += fi(v), this.a = f, R;
  }, m.prototype.readString = m.prototype.fa, m.prototype.Dc = function() {
    var l = this.o();
    return this.fa(l);
  }, m.prototype.readStringWithLength = m.prototype.Dc, m.prototype.qa = function(l) {
    if (0 > l || this.a + l > this.b.length)
      return this.v = !0, K("Invalid byte length!"), new Uint8Array(0);
    var g = this.b.subarray(this.a, this.a + l);
    return this.a += l, w(this.a <= this.c), g;
  }, m.prototype.readBytes = m.prototype.qa, m.prototype.ia = function() {
    return this.w(Tt);
  }, m.prototype.readVarintHash64 = m.prototype.ia, m.prototype.$ = function() {
    var l = this.b, g = this.a, f = l[g], v = l[g + 1], R = l[g + 2], T = l[g + 3], P = l[g + 4], W = l[g + 5], U = l[g + 6];
    return l = l[g + 7], this.a += 8, String.fromCharCode(f, v, R, T, P, W, U, l);
  }, m.prototype.readFixedHash64 = m.prototype.$;
  function b(l, g, f) {
    this.a = wt(l, g, f), this.O = this.a.B(), this.b = this.c = -1, this.h = !1, this.v = null;
  }
  M("jspb.BinaryReader", b, void 0);
  var Ne = [];
  b.clearInstanceCache = function() {
    Ne = [];
  }, b.getInstanceCacheLength = function() {
    return Ne.length;
  };
  function Si(l, g, f) {
    if (Ne.length) {
      var v = Ne.pop();
      return l && v.a.H(l, g, f), v;
    }
    return new b(l, g, f);
  }
  b.alloc = Si, b.prototype.zb = Si, b.prototype.alloc = b.prototype.zb, b.prototype.Ca = function() {
    this.a.clear(), this.b = this.c = -1, this.h = !1, this.v = null, 100 > Ne.length && Ne.push(this);
  }, b.prototype.free = b.prototype.Ca, b.prototype.Fb = function() {
    return this.O;
  }, b.prototype.getFieldCursor = b.prototype.Fb, b.prototype.B = function() {
    return this.a.B();
  }, b.prototype.getCursor = b.prototype.B, b.prototype.Y = function() {
    return this.a.Y();
  }, b.prototype.getBuffer = b.prototype.Y, b.prototype.Hb = function() {
    return this.c;
  }, b.prototype.getFieldNumber = b.prototype.Hb, b.prototype.Lb = function() {
    return this.b;
  }, b.prototype.getWireType = b.prototype.Lb, b.prototype.Mb = function() {
    return this.b == 2;
  }, b.prototype.isDelimited = b.prototype.Mb, b.prototype.bb = function() {
    return this.b == 4;
  }, b.prototype.isEndGroup = b.prototype.bb, b.prototype.getError = function() {
    return this.h || this.a.getError();
  }, b.prototype.getError = b.prototype.getError, b.prototype.H = function(l, g, f) {
    this.a.H(l, g, f), this.b = this.c = -1;
  }, b.prototype.setBlock = b.prototype.H, b.prototype.reset = function() {
    this.a.reset(), this.b = this.c = -1;
  }, b.prototype.reset = b.prototype.reset, b.prototype.advance = function(l) {
    this.a.advance(l);
  }, b.prototype.advance = b.prototype.advance, b.prototype.oa = function() {
    if (this.a.ya())
      return !1;
    if (this.getError())
      return K("Decoder hit an error"), !1;
    this.O = this.a.B();
    var l = this.a.o(), g = l >>> 3;
    return l &= 7, l != 0 && l != 5 && l != 1 && l != 2 && l != 3 && l != 4 ? (K("Invalid wire type: %s (at position %s)", l, this.O), this.h = !0, !1) : (this.c = g, this.b = l, !0);
  }, b.prototype.nextField = b.prototype.oa, b.prototype.Oa = function() {
    this.a.mb(this.c << 3 | this.b);
  }, b.prototype.unskipHeader = b.prototype.Oa, b.prototype.Lc = function() {
    var l = this.c;
    for (this.Oa(); this.oa() && this.c == l; )
      this.C();
    this.a.ya() || this.Oa();
  }, b.prototype.skipMatchingFields = b.prototype.Lc, b.prototype.lb = function() {
    this.b != 0 ? (K("Invalid wire type for skipVarintField"), this.C()) : this.a.kb();
  }, b.prototype.skipVarintField = b.prototype.lb, b.prototype.gb = function() {
    if (this.b != 2)
      K("Invalid wire type for skipDelimitedField"), this.C();
    else {
      var l = this.a.o();
      this.a.advance(l);
    }
  }, b.prototype.skipDelimitedField = b.prototype.gb, b.prototype.hb = function() {
    this.b != 5 ? (K("Invalid wire type for skipFixed32Field"), this.C()) : this.a.advance(4);
  }, b.prototype.skipFixed32Field = b.prototype.hb, b.prototype.ib = function() {
    this.b != 1 ? (K("Invalid wire type for skipFixed64Field"), this.C()) : this.a.advance(8);
  }, b.prototype.skipFixed64Field = b.prototype.ib, b.prototype.jb = function() {
    var l = this.c;
    do {
      if (!this.oa()) {
        K("Unmatched start-group tag: stream EOF"), this.h = !0;
        break;
      }
      if (this.b == 4) {
        this.c != l && (K("Unmatched end-group tag"), this.h = !0);
        break;
      }
      this.C();
    } while (1);
  }, b.prototype.skipGroup = b.prototype.jb, b.prototype.C = function() {
    switch (this.b) {
      case 0:
        this.lb();
        break;
      case 1:
        this.ib();
        break;
      case 2:
        this.gb();
        break;
      case 5:
        this.hb();
        break;
      case 3:
        this.jb();
        break;
      default:
        K("Invalid wire encoding for field.");
    }
  }, b.prototype.skipField = b.prototype.C, b.prototype.Hc = function(l, g) {
    this.v === null && (this.v = {}), w(!this.v[l]), this.v[l] = g;
  }, b.prototype.registerReadCallback = b.prototype.Hc, b.prototype.Ic = function(l) {
    return w(this.v !== null), l = this.v[l], w(l), l(this);
  }, b.prototype.runReadCallback = b.prototype.Ic, b.prototype.Yb = function(l, g) {
    w(this.b == 2);
    var f = this.a.c, v = this.a.o();
    v = this.a.B() + v, this.a.setEnd(v), g(l, this), this.a.Ma(v), this.a.setEnd(f);
  }, b.prototype.readMessage = b.prototype.Yb, b.prototype.Ub = function(l, g, f) {
    w(this.b == 3), w(this.c == l), f(g, this), this.h || this.b == 4 || (K("Group submessage did not end with an END_GROUP tag"), this.h = !0);
  }, b.prototype.readGroup = b.prototype.Ub, b.prototype.Gb = function() {
    w(this.b == 2);
    var l = this.a.o(), g = this.a.B(), f = g + l;
    return l = wt(this.a.Y(), g, l), this.a.Ma(f), l;
  }, b.prototype.getFieldDecoder = b.prototype.Gb, b.prototype.P = function() {
    return w(this.b == 0), this.a.da();
  }, b.prototype.readInt32 = b.prototype.P, b.prototype.Wb = function() {
    return w(this.b == 0), this.a.Ea();
  }, b.prototype.readInt32String = b.prototype.Wb, b.prototype.ba = function() {
    return w(this.b == 0), this.a.sa();
  }, b.prototype.readInt64 = b.prototype.ba, b.prototype.ca = function() {
    return w(this.b == 0), this.a.Fa();
  }, b.prototype.readInt64String = b.prototype.ca, b.prototype.m = function() {
    return w(this.b == 0), this.a.o();
  }, b.prototype.readUint32 = b.prototype.m, b.prototype.Fc = function() {
    return w(this.b == 0), this.a.O();
  }, b.prototype.readUint32String = b.prototype.Fc, b.prototype.ga = function() {
    return w(this.b == 0), this.a.Ga();
  }, b.prototype.readUint64 = b.prototype.ga, b.prototype.ha = function() {
    return w(this.b == 0), this.a.Ha();
  }, b.prototype.readUint64String = b.prototype.ha, b.prototype.zc = function() {
    return w(this.b == 0), this.a.Ia();
  }, b.prototype.readSint32 = b.prototype.zc, b.prototype.Ac = function() {
    return w(this.b == 0), this.a.Ja();
  }, b.prototype.readSint64 = b.prototype.Ac, b.prototype.Bc = function() {
    return w(this.b == 0), this.a.Ka();
  }, b.prototype.readSint64String = b.prototype.Bc, b.prototype.Rb = function() {
    return w(this.b == 5), this.a.m();
  }, b.prototype.readFixed32 = b.prototype.Rb, b.prototype.Sb = function() {
    return w(this.b == 1), this.a.ga();
  }, b.prototype.readFixed64 = b.prototype.Sb, b.prototype.Tb = function() {
    return w(this.b == 1), this.a.ha();
  }, b.prototype.readFixed64String = b.prototype.Tb, b.prototype.vc = function() {
    return w(this.b == 5), this.a.P();
  }, b.prototype.readSfixed32 = b.prototype.vc, b.prototype.wc = function() {
    return w(this.b == 5), this.a.P().toString();
  }, b.prototype.readSfixed32String = b.prototype.wc, b.prototype.xc = function() {
    return w(this.b == 1), this.a.ba();
  }, b.prototype.readSfixed64 = b.prototype.xc, b.prototype.yc = function() {
    return w(this.b == 1), this.a.ca();
  }, b.prototype.readSfixed64String = b.prototype.yc, b.prototype.aa = function() {
    return w(this.b == 5), this.a.aa();
  }, b.prototype.readFloat = b.prototype.aa, b.prototype.Z = function() {
    return w(this.b == 1), this.a.Z();
  }, b.prototype.readDouble = b.prototype.Z, b.prototype.pa = function() {
    return w(this.b == 0), !!this.a.o();
  }, b.prototype.readBool = b.prototype.pa, b.prototype.ra = function() {
    return w(this.b == 0), this.a.sa();
  }, b.prototype.readEnum = b.prototype.ra, b.prototype.fa = function() {
    w(this.b == 2);
    var l = this.a.o();
    return this.a.fa(l);
  }, b.prototype.readString = b.prototype.fa, b.prototype.qa = function() {
    w(this.b == 2);
    var l = this.a.o();
    return this.a.qa(l);
  }, b.prototype.readBytes = b.prototype.qa, b.prototype.ia = function() {
    return w(this.b == 0), this.a.ia();
  }, b.prototype.readVarintHash64 = b.prototype.ia, b.prototype.Cc = function() {
    return w(this.b == 0), this.a.fb();
  }, b.prototype.readSintHash64 = b.prototype.Cc, b.prototype.w = function(l) {
    return w(this.b == 0), this.a.w(l);
  }, b.prototype.readSplitVarint64 = b.prototype.w, b.prototype.ea = function(l) {
    return w(this.b == 0), this.a.w(function(g, f) {
      return Ct(g, f, l);
    });
  }, b.prototype.readSplitZigzagVarint64 = b.prototype.ea, b.prototype.$ = function() {
    return w(this.b == 1), this.a.$();
  }, b.prototype.readFixedHash64 = b.prototype.$, b.prototype.ta = function(l) {
    return w(this.b == 1), this.a.ta(l);
  }, b.prototype.readSplitFixed64 = b.prototype.ta;
  function j(l, g) {
    w(l.b == 2);
    var f = l.a.o();
    f = l.a.B() + f;
    for (var v = []; l.a.B() < f; )
      v.push(g.call(l.a));
    return v;
  }
  b.prototype.gc = function() {
    return j(this, this.a.da);
  }, b.prototype.readPackedInt32 = b.prototype.gc, b.prototype.hc = function() {
    return j(this, this.a.Ea);
  }, b.prototype.readPackedInt32String = b.prototype.hc, b.prototype.ic = function() {
    return j(this, this.a.sa);
  }, b.prototype.readPackedInt64 = b.prototype.ic, b.prototype.jc = function() {
    return j(this, this.a.Fa);
  }, b.prototype.readPackedInt64String = b.prototype.jc, b.prototype.qc = function() {
    return j(this, this.a.o);
  }, b.prototype.readPackedUint32 = b.prototype.qc, b.prototype.rc = function() {
    return j(this, this.a.O);
  }, b.prototype.readPackedUint32String = b.prototype.rc, b.prototype.sc = function() {
    return j(this, this.a.Ga);
  }, b.prototype.readPackedUint64 = b.prototype.sc, b.prototype.tc = function() {
    return j(this, this.a.Ha);
  }, b.prototype.readPackedUint64String = b.prototype.tc, b.prototype.nc = function() {
    return j(this, this.a.Ia);
  }, b.prototype.readPackedSint32 = b.prototype.nc, b.prototype.oc = function() {
    return j(this, this.a.Ja);
  }, b.prototype.readPackedSint64 = b.prototype.oc, b.prototype.pc = function() {
    return j(this, this.a.Ka);
  }, b.prototype.readPackedSint64String = b.prototype.pc, b.prototype.bc = function() {
    return j(this, this.a.m);
  }, b.prototype.readPackedFixed32 = b.prototype.bc, b.prototype.cc = function() {
    return j(this, this.a.ga);
  }, b.prototype.readPackedFixed64 = b.prototype.cc, b.prototype.dc = function() {
    return j(this, this.a.ha);
  }, b.prototype.readPackedFixed64String = b.prototype.dc, b.prototype.kc = function() {
    return j(this, this.a.P);
  }, b.prototype.readPackedSfixed32 = b.prototype.kc, b.prototype.lc = function() {
    return j(this, this.a.ba);
  }, b.prototype.readPackedSfixed64 = b.prototype.lc, b.prototype.mc = function() {
    return j(this, this.a.ca);
  }, b.prototype.readPackedSfixed64String = b.prototype.mc, b.prototype.fc = function() {
    return j(this, this.a.aa);
  }, b.prototype.readPackedFloat = b.prototype.fc, b.prototype.$b = function() {
    return j(this, this.a.Z);
  }, b.prototype.readPackedDouble = b.prototype.$b, b.prototype.Zb = function() {
    return j(this, this.a.pa);
  }, b.prototype.readPackedBool = b.prototype.Zb, b.prototype.ac = function() {
    return j(this, this.a.ra);
  }, b.prototype.readPackedEnum = b.prototype.ac, b.prototype.uc = function() {
    return j(this, this.a.ia);
  }, b.prototype.readPackedVarintHash64 = b.prototype.uc, b.prototype.ec = function() {
    return j(this, this.a.$);
  }, b.prototype.readPackedFixedHash64 = b.prototype.ec;
  function ot(l, g, f, v, R) {
    this.ma = l, this.Ba = g, this.la = f, this.Na = v, this.na = R;
  }
  M("jspb.ExtensionFieldInfo", ot, void 0);
  function Oi(l, g, f, v, R, T) {
    this.Za = l, this.za = g, this.Aa = f, this.Wa = v, this.Ab = R, this.Nb = T;
  }
  M("jspb.ExtensionFieldBinaryInfo", Oi, void 0), ot.prototype.F = function() {
    return !!this.la;
  }, ot.prototype.isMessageType = ot.prototype.F;
  function k() {
  }
  M("jspb.Message", k, void 0), k.GENERATE_TO_OBJECT = !0, k.GENERATE_FROM_OBJECT = !0;
  var Et = typeof Uint8Array == "function";
  k.prototype.Ib = function() {
    return this.b;
  }, k.prototype.getJsPbMessageId = k.prototype.Ib, k.initialize = function(l, g, f, v, R, T) {
    l.f = null, g || (g = f ? [f] : []), l.b = f ? String(f) : void 0, l.D = f === 0 ? -1 : 0, l.u = g;
    e: {
      if (f = l.u.length, g = -1, f && (g = f - 1, f = l.u[g], !(f === null || typeof f != "object" || Array.isArray(f) || Et && f instanceof Uint8Array))) {
        l.G = g - l.D, l.i = f;
        break e;
      }
      -1 < v ? (l.G = Math.max(v, g + 1 - l.D), l.i = null) : l.G = Number.MAX_VALUE;
    }
    if (l.a = {}, R)
      for (v = 0; v < R.length; v++)
        g = R[v], g < l.G ? (g += l.D, l.u[g] = l.u[g] || it) : (Pt(l), l.i[g] = l.i[g] || it);
    if (T && T.length)
      for (v = 0; v < T.length; v++)
        Qt(l, T[v]);
  };
  var it = Object.freeze ? Object.freeze([]) : [];
  function Pt(l) {
    var g = l.G + l.D;
    l.u[g] || (l.i = l.u[g] = {});
  }
  function ki(l, g, f) {
    for (var v = [], R = 0; R < l.length; R++)
      v[R] = g.call(l[R], f, l[R]);
    return v;
  }
  k.toObjectList = ki, k.toObjectExtension = function(l, g, f, v, R) {
    for (var T in f) {
      var P = f[T], W = v.call(l, P);
      if (W != null) {
        for (var U in P.Ba)
          if (P.Ba.hasOwnProperty(U))
            break;
        g[U] = P.Na ? P.na ? ki(W, P.Na, R) : P.Na(R, W) : W;
      }
    }
  }, k.serializeBinaryExtensions = function(l, g, f, v) {
    for (var R in f) {
      var T = f[R], P = T.Za;
      if (!T.Aa)
        throw Error("Message extension present that was generated without binary serialization support");
      var W = v.call(l, P);
      if (W != null)
        if (P.F())
          if (T.Wa)
            T.Aa.call(g, P.ma, W, T.Wa);
          else
            throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
        else
          T.Aa.call(g, P.ma, W);
    }
  }, k.readBinaryExtension = function(l, g, f, v, R) {
    var T = f[g.c];
    if (T) {
      if (f = T.Za, !T.za)
        throw Error("Deserializing extension whose generated code does not support binary format");
      if (f.F()) {
        var P = new f.la();
        T.za.call(g, P, T.Ab);
      } else
        P = T.za.call(g);
      f.na && !T.Nb ? (g = v.call(l, f)) ? g.push(P) : R.call(l, f, [P]) : R.call(l, f, P);
    } else
      g.C();
  };
  function ie(l, g) {
    if (g < l.G) {
      g += l.D;
      var f = l.u[g];
      return f === it ? l.u[g] = [] : f;
    }
    if (l.i)
      return f = l.i[g], f === it ? l.i[g] = [] : f;
  }
  k.getField = ie, k.getRepeatedField = function(l, g) {
    return ie(l, g);
  };
  function Di(l, g) {
    return l = ie(l, g), l == null ? l : +l;
  }
  k.getOptionalFloatingPointField = Di;
  function Ii(l, g) {
    return l = ie(l, g), l == null ? l : !!l;
  }
  k.getBooleanField = Ii, k.getRepeatedFloatingPointField = function(l, g) {
    var f = ie(l, g);
    if (l.a || (l.a = {}), !l.a[g]) {
      for (var v = 0; v < f.length; v++)
        f[v] = +f[v];
      l.a[g] = !0;
    }
    return f;
  }, k.getRepeatedBooleanField = function(l, g) {
    var f = ie(l, g);
    if (l.a || (l.a = {}), !l.a[g]) {
      for (var v = 0; v < f.length; v++)
        f[v] = !!f[v];
      l.a[g] = !0;
    }
    return f;
  };
  function $i(l) {
    return l == null || typeof l == "string" ? l : Et && l instanceof Uint8Array ? hi(l) : (K("Cannot coerce to b64 string: " + I(l)), null);
  }
  k.bytesAsB64 = $i;
  function Li(l) {
    return l == null || l instanceof Uint8Array ? l : typeof l == "string" ? vi(l) : (K("Cannot coerce to Uint8Array: " + I(l)), null);
  }
  k.bytesAsU8 = Li, k.bytesListAsB64 = function(l) {
    return Wi(l), l.length && typeof l[0] != "string" ? O(l, $i) : l;
  }, k.bytesListAsU8 = function(l) {
    return Wi(l), !l.length || l[0] instanceof Uint8Array ? l : O(l, Li);
  };
  function Wi(l) {
    if (l && 1 < l.length) {
      var g = I(l[0]);
      ne(l, function(f) {
        I(f) != g && K("Inconsistent type in JSPB repeated field array. Got " + I(f) + " expected " + g);
      });
    }
  }
  function zi(l, g, f) {
    return l = ie(l, g), l ?? f;
  }
  k.getFieldWithDefault = zi, k.getBooleanFieldWithDefault = function(l, g, f) {
    return l = Ii(l, g), l ?? f;
  }, k.getFloatingPointFieldWithDefault = function(l, g, f) {
    return l = Di(l, g), l ?? f;
  }, k.getFieldProto3 = zi, k.getMapField = function(l, g, f, v) {
    if (l.f || (l.f = {}), g in l.f)
      return l.f[g];
    var R = ie(l, g);
    if (!R) {
      if (f)
        return;
      R = [], ve(l, g, R);
    }
    return l.f[g] = new N(R, v);
  };
  function ve(l, g, f) {
    return le(l, k), g < l.G ? l.u[g + l.D] = f : (Pt(l), l.i[g] = f), l;
  }
  k.setField = ve, k.setProto3IntField = function(l, g, f) {
    return Oe(l, g, f, 0);
  }, k.setProto3FloatField = function(l, g, f) {
    return Oe(l, g, f, 0);
  }, k.setProto3BooleanField = function(l, g, f) {
    return Oe(l, g, f, !1);
  }, k.setProto3StringField = function(l, g, f) {
    return Oe(l, g, f, "");
  }, k.setProto3BytesField = function(l, g, f) {
    return Oe(l, g, f, "");
  }, k.setProto3EnumField = function(l, g, f) {
    return Oe(l, g, f, 0);
  }, k.setProto3StringIntField = function(l, g, f) {
    return Oe(l, g, f, "0");
  };
  function Oe(l, g, f, v) {
    return le(l, k), f !== v ? ve(l, g, f) : g < l.G ? l.u[g + l.D] = null : (Pt(l), delete l.i[g]), l;
  }
  k.addToRepeatedField = function(l, g, f, v) {
    return le(l, k), g = ie(l, g), v != null ? g.splice(v, 0, f) : g.push(f), l;
  };
  function Ni(l, g, f, v) {
    return le(l, k), (f = Qt(l, f)) && f !== g && v !== void 0 && (l.f && f in l.f && (l.f[f] = void 0), ve(l, f, void 0)), ve(l, g, v);
  }
  k.setOneofField = Ni;
  function Qt(l, g) {
    for (var f, v, R = 0; R < g.length; R++) {
      var T = g[R], P = ie(l, T);
      P != null && (f = T, v = P, ve(l, T, void 0));
    }
    return f ? (ve(l, f, v), f) : 0;
  }
  k.computeOneofCase = Qt, k.getWrapperField = function(l, g, f, v) {
    if (l.f || (l.f = {}), !l.f[f]) {
      var R = ie(l, f);
      (v || R) && (l.f[f] = new g(R));
    }
    return l.f[f];
  }, k.getRepeatedWrapperField = function(l, g, f) {
    return Ai(l, g, f), g = l.f[f], g == it && (g = l.f[f] = []), g;
  };
  function Ai(l, g, f) {
    if (l.f || (l.f = {}), !l.f[f]) {
      for (var v = ie(l, f), R = [], T = 0; T < v.length; T++)
        R[T] = new g(v[T]);
      l.f[f] = R;
    }
  }
  k.setWrapperField = function(l, g, f) {
    le(l, k), l.f || (l.f = {});
    var v = f && f.g();
    return l.f[g] = f, ve(l, g, v);
  }, k.setOneofWrapperField = function(l, g, f, v) {
    le(l, k), l.f || (l.f = {});
    var R = v && v.g();
    return l.f[g] = v, Ni(l, g, f, R);
  }, k.setRepeatedWrapperField = function(l, g, f) {
    le(l, k), l.f || (l.f = {}), f = f || [];
    for (var v = [], R = 0; R < f.length; R++)
      v[R] = f[R].g();
    return l.f[g] = f, ve(l, g, v);
  }, k.addToRepeatedWrapperField = function(l, g, f, v, R) {
    Ai(l, v, g);
    var T = l.f[g];
    return T || (T = l.f[g] = []), f = f || new v(), l = ie(l, g), R != null ? (T.splice(R, 0, f), l.splice(R, 0, f.g())) : (T.push(f), l.push(f.g())), f;
  }, k.toMap = function(l, g, f, v) {
    for (var R = {}, T = 0; T < l.length; T++)
      R[g.call(l[T])] = f ? f.call(l[T], v, l[T]) : l[T];
    return R;
  };
  function xi(l) {
    if (l.f)
      for (var g in l.f) {
        var f = l.f[g];
        if (Array.isArray(f))
          for (var v = 0; v < f.length; v++)
            f[v] && f[v].g();
        else
          f && f.g();
      }
  }
  k.prototype.g = function() {
    return xi(this), this.u;
  }, k.prototype.toArray = k.prototype.g, k.prototype.toString = function() {
    return xi(this), this.u.toString();
  }, k.prototype.getExtension = function(l) {
    if (this.i) {
      this.f || (this.f = {});
      var g = l.ma;
      if (l.na) {
        if (l.F())
          return this.f[g] || (this.f[g] = O(this.i[g] || [], function(f) {
            return new l.la(f);
          })), this.f[g];
      } else if (l.F())
        return !this.f[g] && this.i[g] && (this.f[g] = new l.la(this.i[g])), this.f[g];
      return this.i[g];
    }
  }, k.prototype.getExtension = k.prototype.getExtension, k.prototype.Kc = function(l, g) {
    this.f || (this.f = {}), Pt(this);
    var f = l.ma;
    return l.na ? (g = g || [], l.F() ? (this.f[f] = g, this.i[f] = O(g, function(v) {
      return v.g();
    })) : this.i[f] = g) : l.F() ? (this.f[f] = g, this.i[f] = g && g.g()) : this.i[f] = g, this;
  }, k.prototype.setExtension = k.prototype.Kc, k.difference = function(l, g) {
    if (!(l instanceof g.constructor))
      throw Error("Messages have different types.");
    var f = l.g();
    g = g.g();
    var v = [], R = 0, T = f.length > g.length ? f.length : g.length;
    for (l.b && (v[0] = l.b, R = 1); R < T; R++)
      rt(f[R], g[R]) || (v[R] = g[R]);
    return new l.constructor(v);
  }, k.equals = function(l, g) {
    return l == g || !(!l || !g) && l instanceof g.constructor && rt(l.g(), g.g());
  };
  function eo(l, g) {
    l = l || {}, g = g || {};
    var f = {}, v;
    for (v in l)
      f[v] = 0;
    for (v in g)
      f[v] = 0;
    for (v in f)
      if (!rt(l[v], g[v]))
        return !1;
    return !0;
  }
  k.compareExtensions = eo;
  function rt(l, g) {
    if (l == g)
      return !0;
    if (!$(l) || !$(g))
      return typeof l == "number" && isNaN(l) || typeof g == "number" && isNaN(g) ? String(l) == String(g) : !1;
    if (l.constructor != g.constructor)
      return !1;
    if (Et && l.constructor === Uint8Array) {
      if (l.length != g.length)
        return !1;
      for (var f = 0; f < l.length; f++)
        if (l[f] != g[f])
          return !1;
      return !0;
    }
    if (l.constructor === Array) {
      var v = void 0, R = void 0, T = Math.max(l.length, g.length);
      for (f = 0; f < T; f++) {
        var P = l[f], W = g[f];
        if (P && P.constructor == Object && (w(v === void 0), w(f === l.length - 1), v = P, P = void 0), W && W.constructor == Object && (w(R === void 0), w(f === g.length - 1), R = W, W = void 0), !rt(P, W))
          return !1;
      }
      return v || R ? (v = v || {}, R = R || {}, eo(v, R)) : !0;
    }
    if (l.constructor === Object)
      return eo(l, g);
    throw Error("Invalid type in JSPB array");
  }
  k.compareFields = rt, k.prototype.Bb = function() {
    return St(this);
  }, k.prototype.cloneMessage = k.prototype.Bb, k.prototype.clone = function() {
    return St(this);
  }, k.prototype.clone = k.prototype.clone, k.clone = function(l) {
    return St(l);
  };
  function St(l) {
    return new l.constructor(to(l.g()));
  }
  k.copyInto = function(l, g) {
    le(l, k), le(g, k), w(l.constructor == g.constructor, "Copy source and target message should have the same type."), l = St(l);
    for (var f = g.g(), v = l.g(), R = f.length = 0; R < v.length; R++)
      f[R] = v[R];
    g.f = l.f, g.i = l.i;
  };
  function to(l) {
    if (Array.isArray(l)) {
      for (var g = Array(l.length), f = 0; f < l.length; f++) {
        var v = l[f];
        v != null && (g[f] = typeof v == "object" ? to(w(v)) : v);
      }
      return g;
    }
    if (Et && l instanceof Uint8Array)
      return new Uint8Array(l);
    g = {};
    for (f in l)
      v = l[f], v != null && (g[f] = typeof v == "object" ? to(w(v)) : v);
    return g;
  }
  k.registerMessageType = function(l, g) {
    g.we = l;
  };
  var ue = { dump: function(l) {
    return le(l, k, "jspb.Message instance expected"), w(l.getExtension, "Only unobfuscated and unoptimized compilation modes supported."), ue.X(l);
  } };
  M("jspb.debug.dump", ue.dump, void 0), ue.X = function(l) {
    var g = I(l);
    if (g == "number" || g == "string" || g == "boolean" || g == "null" || g == "undefined" || typeof Uint8Array < "u" && l instanceof Uint8Array)
      return l;
    if (g == "array")
      return na(l), O(l, ue.X);
    if (l instanceof N) {
      var f = {};
      l = l.entries();
      for (var v = l.next(); !v.done; v = l.next())
        f[v.value[0]] = ue.X(v.value[1]);
      return f;
    }
    le(l, k, "Only messages expected: " + l), g = l.constructor;
    var R = { $name: g.name || g.displayName };
    for (W in g.prototype) {
      var T = /^get([A-Z]\w*)/.exec(W);
      if (T && W != "getExtension" && W != "getJsPbMessageId") {
        var P = "has" + T[1];
        (!l[P] || l[P]()) && (P = l[W](), R[ue.$a(T[1])] = ue.X(P));
      }
    }
    if (l.extensionObject_)
      return R.$extensions = "Recursive dumping of extensions not supported in compiled code. Switch to uncompiled or dump extension object directly", R;
    for (v in g.extensions)
      if (/^\d+$/.test(v)) {
        P = g.extensions[v];
        var W = l.getExtension(P);
        T = void 0, P = P.Ba;
        var U = [], ke = 0;
        for (T in P)
          U[ke++] = T;
        T = U[0], W != null && (f || (f = R.$extensions = {}), f[ue.$a(T)] = ue.X(W));
      }
    return R;
  }, ue.$a = function(l) {
    return l.replace(/^[A-Z]/, function(g) {
      return g.toLowerCase();
    });
  };
  function S() {
    this.a = [];
  }
  M("jspb.BinaryEncoder", S, void 0), S.prototype.length = function() {
    return this.a.length;
  }, S.prototype.length = S.prototype.length, S.prototype.end = function() {
    var l = this.a;
    return this.a = [], l;
  }, S.prototype.end = S.prototype.end, S.prototype.l = function(l, g) {
    for (w(l == Math.floor(l)), w(g == Math.floor(g)), w(0 <= l && 4294967296 > l), w(0 <= g && 4294967296 > g); 0 < g || 127 < l; )
      this.a.push(l & 127 | 128), l = (l >>> 7 | g << 25) >>> 0, g >>>= 7;
    this.a.push(l);
  }, S.prototype.writeSplitVarint64 = S.prototype.l, S.prototype.A = function(l, g) {
    w(l == Math.floor(l)), w(g == Math.floor(g)), w(0 <= l && 4294967296 > l), w(0 <= g && 4294967296 > g), this.s(l), this.s(g);
  }, S.prototype.writeSplitFixed64 = S.prototype.A, S.prototype.j = function(l) {
    for (w(l == Math.floor(l)), w(0 <= l && 4294967296 > l); 127 < l; )
      this.a.push(l & 127 | 128), l >>>= 7;
    this.a.push(l);
  }, S.prototype.writeUnsignedVarint32 = S.prototype.j, S.prototype.M = function(l) {
    if (w(l == Math.floor(l)), w(-2147483648 <= l && 2147483648 > l), 0 <= l)
      this.j(l);
    else {
      for (var g = 0; 9 > g; g++)
        this.a.push(l & 127 | 128), l >>= 7;
      this.a.push(1);
    }
  }, S.prototype.writeSignedVarint32 = S.prototype.M, S.prototype.va = function(l) {
    w(l == Math.floor(l)), w(0 <= l && 18446744073709552e3 > l), Ke(l), this.l(x, G);
  }, S.prototype.writeUnsignedVarint64 = S.prototype.va, S.prototype.ua = function(l) {
    w(l == Math.floor(l)), w(-9223372036854776e3 <= l && 9223372036854776e3 > l), Ke(l), this.l(x, G);
  }, S.prototype.writeSignedVarint64 = S.prototype.ua, S.prototype.wa = function(l) {
    w(l == Math.floor(l)), w(-2147483648 <= l && 2147483648 > l), this.j((l << 1 ^ l >> 31) >>> 0);
  }, S.prototype.writeZigzagVarint32 = S.prototype.wa, S.prototype.xa = function(l) {
    w(l == Math.floor(l)), w(-9223372036854776e3 <= l && 9223372036854776e3 > l), Ri(l), this.l(x, G);
  }, S.prototype.writeZigzagVarint64 = S.prototype.xa, S.prototype.Ta = function(l) {
    this.W(et(l));
  }, S.prototype.writeZigzagVarint64String = S.prototype.Ta, S.prototype.W = function(l) {
    var g = this;
    we(l), Mt(x, G, function(f, v) {
      g.l(f >>> 0, v >>> 0);
    });
  }, S.prototype.writeZigzagVarintHash64 = S.prototype.W, S.prototype.be = function(l) {
    w(l == Math.floor(l)), w(0 <= l && 256 > l), this.a.push(l >>> 0 & 255);
  }, S.prototype.writeUint8 = S.prototype.be, S.prototype.ae = function(l) {
    w(l == Math.floor(l)), w(0 <= l && 65536 > l), this.a.push(l >>> 0 & 255), this.a.push(l >>> 8 & 255);
  }, S.prototype.writeUint16 = S.prototype.ae, S.prototype.s = function(l) {
    w(l == Math.floor(l)), w(0 <= l && 4294967296 > l), this.a.push(l >>> 0 & 255), this.a.push(l >>> 8 & 255), this.a.push(l >>> 16 & 255), this.a.push(l >>> 24 & 255);
  }, S.prototype.writeUint32 = S.prototype.s, S.prototype.V = function(l) {
    w(l == Math.floor(l)), w(0 <= l && 18446744073709552e3 > l), Xt(l), this.s(x), this.s(G);
  }, S.prototype.writeUint64 = S.prototype.V, S.prototype.Qc = function(l) {
    w(l == Math.floor(l)), w(-128 <= l && 128 > l), this.a.push(l >>> 0 & 255);
  }, S.prototype.writeInt8 = S.prototype.Qc, S.prototype.Pc = function(l) {
    w(l == Math.floor(l)), w(-32768 <= l && 32768 > l), this.a.push(l >>> 0 & 255), this.a.push(l >>> 8 & 255);
  }, S.prototype.writeInt16 = S.prototype.Pc, S.prototype.S = function(l) {
    w(l == Math.floor(l)), w(-2147483648 <= l && 2147483648 > l), this.a.push(l >>> 0 & 255), this.a.push(l >>> 8 & 255), this.a.push(l >>> 16 & 255), this.a.push(l >>> 24 & 255);
  }, S.prototype.writeInt32 = S.prototype.S, S.prototype.T = function(l) {
    w(l == Math.floor(l)), w(-9223372036854776e3 <= l && 9223372036854776e3 > l), Ke(l), this.A(x, G);
  }, S.prototype.writeInt64 = S.prototype.T, S.prototype.ka = function(l) {
    w(l == Math.floor(l)), w(-9223372036854776e3 <= +l && 9223372036854776e3 > +l), we(et(l)), this.A(x, G);
  }, S.prototype.writeInt64String = S.prototype.ka, S.prototype.L = function(l) {
    w(l === 1 / 0 || l === -1 / 0 || isNaN(l) || -34028234663852886e22 <= l && 34028234663852886e22 >= l), bi(l), this.s(x);
  }, S.prototype.writeFloat = S.prototype.L, S.prototype.J = function(l) {
    w(l === 1 / 0 || l === -1 / 0 || isNaN(l) || -17976931348623157e292 <= l && 17976931348623157e292 >= l), Bi(l), this.s(x), this.s(G);
  }, S.prototype.writeDouble = S.prototype.J, S.prototype.I = function(l) {
    w(typeof l == "boolean" || typeof l == "number"), this.a.push(l ? 1 : 0);
  }, S.prototype.writeBool = S.prototype.I, S.prototype.R = function(l) {
    w(l == Math.floor(l)), w(-2147483648 <= l && 2147483648 > l), this.M(l);
  }, S.prototype.writeEnum = S.prototype.R, S.prototype.ja = function(l) {
    this.a.push.apply(this.a, l);
  }, S.prototype.writeBytes = S.prototype.ja, S.prototype.N = function(l) {
    we(l), this.l(x, G);
  }, S.prototype.writeVarintHash64 = S.prototype.N, S.prototype.K = function(l) {
    we(l), this.s(x), this.s(G);
  }, S.prototype.writeFixedHash64 = S.prototype.K, S.prototype.U = function(l) {
    var g = this.a.length;
    ra(l);
    for (var f = 0; f < l.length; f++) {
      var v = l.charCodeAt(f);
      if (128 > v)
        this.a.push(v);
      else if (2048 > v)
        this.a.push(v >> 6 | 192), this.a.push(v & 63 | 128);
      else if (65536 > v)
        if (55296 <= v && 56319 >= v && f + 1 < l.length) {
          var R = l.charCodeAt(f + 1);
          56320 <= R && 57343 >= R && (v = 1024 * (v - 55296) + R - 56320 + 65536, this.a.push(v >> 18 | 240), this.a.push(v >> 12 & 63 | 128), this.a.push(v >> 6 & 63 | 128), this.a.push(v & 63 | 128), f++);
        } else
          this.a.push(v >> 12 | 224), this.a.push(v >> 6 & 63 | 128), this.a.push(v & 63 | 128);
    }
    return this.a.length - g;
  }, S.prototype.writeString = S.prototype.U;
  function L(l, g) {
    this.lo = l, this.hi = g;
  }
  M("jspb.arith.UInt64", L, void 0), L.prototype.cmp = function(l) {
    return this.hi < l.hi || this.hi == l.hi && this.lo < l.lo ? -1 : this.hi == l.hi && this.lo == l.lo ? 0 : 1;
  }, L.prototype.cmp = L.prototype.cmp, L.prototype.La = function() {
    return new L((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
  }, L.prototype.rightShift = L.prototype.La, L.prototype.Da = function() {
    return new L(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
  }, L.prototype.leftShift = L.prototype.Da, L.prototype.cb = function() {
    return !!(this.hi & 2147483648);
  }, L.prototype.msb = L.prototype.cb, L.prototype.Ob = function() {
    return !!(this.lo & 1);
  }, L.prototype.lsb = L.prototype.Ob, L.prototype.Ua = function() {
    return this.lo == 0 && this.hi == 0;
  }, L.prototype.zero = L.prototype.Ua, L.prototype.add = function(l) {
    return new L((this.lo + l.lo & 4294967295) >>> 0 >>> 0, ((this.hi + l.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + l.lo ? 1 : 0) >>> 0);
  }, L.prototype.add = L.prototype.add, L.prototype.sub = function(l) {
    return new L((this.lo - l.lo & 4294967295) >>> 0 >>> 0, ((this.hi - l.hi & 4294967295) >>> 0) - (0 > this.lo - l.lo ? 1 : 0) >>> 0);
  }, L.prototype.sub = L.prototype.sub;
  function oo(l, g) {
    var f = l & 65535;
    l >>>= 16;
    var v = g & 65535, R = g >>> 16;
    for (g = f * v + 65536 * (f * R & 65535) + 65536 * (l * v & 65535), f = l * R + (f * R >>> 16) + (l * v >>> 16); 4294967296 <= g; )
      g -= 4294967296, f += 1;
    return new L(g >>> 0, f >>> 0);
  }
  L.mul32x32 = oo, L.prototype.eb = function(l) {
    var g = oo(this.lo, l);
    return l = oo(this.hi, l), l.hi = l.lo, l.lo = 0, g.add(l);
  }, L.prototype.mul = L.prototype.eb, L.prototype.Xa = function(l) {
    if (l == 0)
      return [];
    var g = new L(0, 0), f = new L(this.lo, this.hi);
    l = new L(l, 0);
    for (var v = new L(1, 0); !l.cb(); )
      l = l.Da(), v = v.Da();
    for (; !v.Ua(); )
      0 >= l.cmp(f) && (g = g.add(v), f = f.sub(l)), l = l.La(), v = v.La();
    return [g, f];
  }, L.prototype.div = L.prototype.Xa, L.prototype.toString = function() {
    for (var l = "", g = this; !g.Ua(); ) {
      g = g.Xa(10);
      var f = g[0];
      l = g[1].lo + l, g = f;
    }
    return l == "" && (l = "0"), l;
  }, L.prototype.toString = L.prototype.toString;
  function Ae(l) {
    for (var g = new L(0, 0), f = new L(0, 0), v = 0; v < l.length; v++) {
      if ("0" > l[v] || "9" < l[v])
        return null;
      f.lo = parseInt(l[v], 10), g = g.eb(10).add(f);
    }
    return g;
  }
  L.fromString = Ae, L.prototype.clone = function() {
    return new L(this.lo, this.hi);
  }, L.prototype.clone = L.prototype.clone;
  function Z(l, g) {
    this.lo = l, this.hi = g;
  }
  M("jspb.arith.Int64", Z, void 0), Z.prototype.add = function(l) {
    return new Z((this.lo + l.lo & 4294967295) >>> 0 >>> 0, ((this.hi + l.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + l.lo ? 1 : 0) >>> 0);
  }, Z.prototype.add = Z.prototype.add, Z.prototype.sub = function(l) {
    return new Z((this.lo - l.lo & 4294967295) >>> 0 >>> 0, ((this.hi - l.hi & 4294967295) >>> 0) - (0 > this.lo - l.lo ? 1 : 0) >>> 0);
  }, Z.prototype.sub = Z.prototype.sub, Z.prototype.clone = function() {
    return new Z(this.lo, this.hi);
  }, Z.prototype.clone = Z.prototype.clone, Z.prototype.toString = function() {
    var l = (this.hi & 2147483648) != 0, g = new L(this.lo, this.hi);
    return l && (g = new L(0, 0).sub(g)), (l ? "-" : "") + g.toString();
  }, Z.prototype.toString = Z.prototype.toString;
  function Ot(l) {
    var g = 0 < l.length && l[0] == "-";
    return g && (l = l.substring(1)), l = Ae(l), l === null ? null : (g && (l = new L(0, 0).sub(l)), new Z(l.lo, l.hi));
  }
  Z.fromString = Ot;
  function F() {
    this.c = [], this.b = 0, this.a = new S(), this.h = [];
  }
  M("jspb.BinaryWriter", F, void 0);
  function Gi(l, g) {
    var f = l.a.end();
    l.c.push(f), l.c.push(g), l.b += f.length + g.length;
  }
  function q(l, g) {
    return z(l, g, 2), g = l.a.end(), l.c.push(g), l.b += g.length, g.push(l.b), g;
  }
  function V(l, g) {
    var f = g.pop();
    for (f = l.b + l.a.length() - f, w(0 <= f); 127 < f; )
      g.push(f & 127 | 128), f >>>= 7, l.b++;
    g.push(f), l.b++;
  }
  F.prototype.pb = function(l, g, f) {
    Gi(this, l.subarray(g, f));
  }, F.prototype.writeSerializedMessage = F.prototype.pb, F.prototype.Pb = function(l, g, f) {
    l != null && g != null && f != null && this.pb(l, g, f);
  }, F.prototype.maybeWriteSerializedMessage = F.prototype.Pb, F.prototype.reset = function() {
    this.c = [], this.a.end(), this.b = 0, this.h = [];
  }, F.prototype.reset = F.prototype.reset, F.prototype.ab = function() {
    w(this.h.length == 0);
    for (var l = new Uint8Array(this.b + this.a.length()), g = this.c, f = g.length, v = 0, R = 0; R < f; R++) {
      var T = g[R];
      l.set(T, v), v += T.length;
    }
    return g = this.a.end(), l.set(g, v), v += g.length, w(v == l.length), this.c = [l], l;
  }, F.prototype.getResultBuffer = F.prototype.ab, F.prototype.Kb = function(l) {
    return hi(this.ab(), l);
  }, F.prototype.getResultBase64String = F.prototype.Kb, F.prototype.Va = function(l) {
    this.h.push(q(this, l));
  }, F.prototype.beginSubMessage = F.prototype.Va, F.prototype.Ya = function() {
    w(0 <= this.h.length), V(this, this.h.pop());
  }, F.prototype.endSubMessage = F.prototype.Ya;
  function z(l, g, f) {
    w(1 <= g && g == Math.floor(g)), l.a.j(8 * g + f);
  }
  F.prototype.Nc = function(l, g, f) {
    switch (l) {
      case 1:
        this.J(g, f);
        break;
      case 2:
        this.L(g, f);
        break;
      case 3:
        this.T(g, f);
        break;
      case 4:
        this.V(g, f);
        break;
      case 5:
        this.S(g, f);
        break;
      case 6:
        this.Qa(g, f);
        break;
      case 7:
        this.Pa(g, f);
        break;
      case 8:
        this.I(g, f);
        break;
      case 9:
        this.U(g, f);
        break;
      case 10:
        K("Group field type not supported in writeAny()");
        break;
      case 11:
        K("Message field type not supported in writeAny()");
        break;
      case 12:
        this.ja(g, f);
        break;
      case 13:
        this.s(g, f);
        break;
      case 14:
        this.R(g, f);
        break;
      case 15:
        this.Ra(g, f);
        break;
      case 16:
        this.Sa(g, f);
        break;
      case 17:
        this.rb(g, f);
        break;
      case 18:
        this.sb(g, f);
        break;
      case 30:
        this.K(g, f);
        break;
      case 31:
        this.N(g, f);
        break;
      default:
        K("Invalid field type in writeAny()");
    }
  }, F.prototype.writeAny = F.prototype.Nc;
  function io(l, g, f) {
    f != null && (z(l, g, 0), l.a.j(f));
  }
  function ro(l, g, f) {
    f != null && (z(l, g, 0), l.a.M(f));
  }
  F.prototype.S = function(l, g) {
    g != null && (w(-2147483648 <= g && 2147483648 > g), ro(this, l, g));
  }, F.prototype.writeInt32 = F.prototype.S, F.prototype.ob = function(l, g) {
    g != null && (g = parseInt(g, 10), w(-2147483648 <= g && 2147483648 > g), ro(this, l, g));
  }, F.prototype.writeInt32String = F.prototype.ob, F.prototype.T = function(l, g) {
    g != null && (w(-9223372036854776e3 <= g && 9223372036854776e3 > g), g != null && (z(this, l, 0), this.a.ua(g)));
  }, F.prototype.writeInt64 = F.prototype.T, F.prototype.ka = function(l, g) {
    g != null && (g = Ot(g), z(this, l, 0), this.a.l(g.lo, g.hi));
  }, F.prototype.writeInt64String = F.prototype.ka, F.prototype.s = function(l, g) {
    g != null && (w(0 <= g && 4294967296 > g), io(this, l, g));
  }, F.prototype.writeUint32 = F.prototype.s, F.prototype.ub = function(l, g) {
    g != null && (g = parseInt(g, 10), w(0 <= g && 4294967296 > g), io(this, l, g));
  }, F.prototype.writeUint32String = F.prototype.ub, F.prototype.V = function(l, g) {
    g != null && (w(0 <= g && 18446744073709552e3 > g), g != null && (z(this, l, 0), this.a.va(g)));
  }, F.prototype.writeUint64 = F.prototype.V, F.prototype.vb = function(l, g) {
    g != null && (g = Ae(g), z(this, l, 0), this.a.l(g.lo, g.hi));
  }, F.prototype.writeUint64String = F.prototype.vb, F.prototype.rb = function(l, g) {
    g != null && (w(-2147483648 <= g && 2147483648 > g), g != null && (z(this, l, 0), this.a.wa(g)));
  }, F.prototype.writeSint32 = F.prototype.rb, F.prototype.sb = function(l, g) {
    g != null && (w(-9223372036854776e3 <= g && 9223372036854776e3 > g), g != null && (z(this, l, 0), this.a.xa(g)));
  }, F.prototype.writeSint64 = F.prototype.sb, F.prototype.$d = function(l, g) {
    g != null && g != null && (z(this, l, 0), this.a.W(g));
  }, F.prototype.writeSintHash64 = F.prototype.$d, F.prototype.Zd = function(l, g) {
    g != null && g != null && (z(this, l, 0), this.a.Ta(g));
  }, F.prototype.writeSint64String = F.prototype.Zd, F.prototype.Pa = function(l, g) {
    g != null && (w(0 <= g && 4294967296 > g), z(this, l, 5), this.a.s(g));
  }, F.prototype.writeFixed32 = F.prototype.Pa, F.prototype.Qa = function(l, g) {
    g != null && (w(0 <= g && 18446744073709552e3 > g), z(this, l, 1), this.a.V(g));
  }, F.prototype.writeFixed64 = F.prototype.Qa, F.prototype.nb = function(l, g) {
    g != null && (g = Ae(g), z(this, l, 1), this.a.A(g.lo, g.hi));
  }, F.prototype.writeFixed64String = F.prototype.nb, F.prototype.Ra = function(l, g) {
    g != null && (w(-2147483648 <= g && 2147483648 > g), z(this, l, 5), this.a.S(g));
  }, F.prototype.writeSfixed32 = F.prototype.Ra, F.prototype.Sa = function(l, g) {
    g != null && (w(-9223372036854776e3 <= g && 9223372036854776e3 > g), z(this, l, 1), this.a.T(g));
  }, F.prototype.writeSfixed64 = F.prototype.Sa, F.prototype.qb = function(l, g) {
    g != null && (g = Ot(g), z(this, l, 1), this.a.A(g.lo, g.hi));
  }, F.prototype.writeSfixed64String = F.prototype.qb, F.prototype.L = function(l, g) {
    g != null && (z(this, l, 5), this.a.L(g));
  }, F.prototype.writeFloat = F.prototype.L, F.prototype.J = function(l, g) {
    g != null && (z(this, l, 1), this.a.J(g));
  }, F.prototype.writeDouble = F.prototype.J, F.prototype.I = function(l, g) {
    g != null && (w(typeof g == "boolean" || typeof g == "number"), z(this, l, 0), this.a.I(g));
  }, F.prototype.writeBool = F.prototype.I, F.prototype.R = function(l, g) {
    g != null && (w(-2147483648 <= g && 2147483648 > g), z(this, l, 0), this.a.M(g));
  }, F.prototype.writeEnum = F.prototype.R, F.prototype.U = function(l, g) {
    g != null && (l = q(this, l), this.a.U(g), V(this, l));
  }, F.prototype.writeString = F.prototype.U, F.prototype.ja = function(l, g) {
    g != null && (g = mt(g), z(this, l, 2), this.a.j(g.length), Gi(this, g));
  }, F.prototype.writeBytes = F.prototype.ja, F.prototype.Rc = function(l, g, f) {
    g != null && (l = q(this, l), f(g, this), V(this, l));
  }, F.prototype.writeMessage = F.prototype.Rc, F.prototype.Sc = function(l, g, f) {
    g != null && (z(this, 1, 3), z(this, 2, 0), this.a.M(l), l = q(this, 3), f(g, this), V(this, l), z(this, 1, 4));
  }, F.prototype.writeMessageSet = F.prototype.Sc, F.prototype.Oc = function(l, g, f) {
    g != null && (z(this, l, 3), f(g, this), z(this, l, 4));
  }, F.prototype.writeGroup = F.prototype.Oc, F.prototype.K = function(l, g) {
    g != null && (w(g.length == 8), z(this, l, 1), this.a.K(g));
  }, F.prototype.writeFixedHash64 = F.prototype.K, F.prototype.N = function(l, g) {
    g != null && (w(g.length == 8), z(this, l, 0), this.a.N(g));
  }, F.prototype.writeVarintHash64 = F.prototype.N, F.prototype.A = function(l, g, f) {
    z(this, l, 1), this.a.A(g, f);
  }, F.prototype.writeSplitFixed64 = F.prototype.A, F.prototype.l = function(l, g, f) {
    z(this, l, 0), this.a.l(g, f);
  }, F.prototype.writeSplitVarint64 = F.prototype.l, F.prototype.tb = function(l, g, f) {
    z(this, l, 0);
    var v = this.a;
    Mt(g, f, function(R, T) {
      v.l(R >>> 0, T >>> 0);
    });
  }, F.prototype.writeSplitZigzagVarint64 = F.prototype.tb, F.prototype.Ed = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        ro(this, l, g[f]);
  }, F.prototype.writeRepeatedInt32 = F.prototype.Ed, F.prototype.Fd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.ob(l, g[f]);
  }, F.prototype.writeRepeatedInt32String = F.prototype.Fd, F.prototype.Gd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++) {
        var v = g[f];
        v != null && (z(this, l, 0), this.a.ua(v));
      }
  }, F.prototype.writeRepeatedInt64 = F.prototype.Gd, F.prototype.Qd = function(l, g, f, v) {
    if (g != null)
      for (var R = 0; R < g.length; R++)
        this.A(l, f(g[R]), v(g[R]));
  }, F.prototype.writeRepeatedSplitFixed64 = F.prototype.Qd, F.prototype.Rd = function(l, g, f, v) {
    if (g != null)
      for (var R = 0; R < g.length; R++)
        this.l(l, f(g[R]), v(g[R]));
  }, F.prototype.writeRepeatedSplitVarint64 = F.prototype.Rd, F.prototype.Sd = function(l, g, f, v) {
    if (g != null)
      for (var R = 0; R < g.length; R++)
        this.tb(l, f(g[R]), v(g[R]));
  }, F.prototype.writeRepeatedSplitZigzagVarint64 = F.prototype.Sd, F.prototype.Hd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.ka(l, g[f]);
  }, F.prototype.writeRepeatedInt64String = F.prototype.Hd, F.prototype.Ud = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        io(this, l, g[f]);
  }, F.prototype.writeRepeatedUint32 = F.prototype.Ud, F.prototype.Vd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.ub(l, g[f]);
  }, F.prototype.writeRepeatedUint32String = F.prototype.Vd, F.prototype.Wd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++) {
        var v = g[f];
        v != null && (z(this, l, 0), this.a.va(v));
      }
  }, F.prototype.writeRepeatedUint64 = F.prototype.Wd, F.prototype.Xd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.vb(l, g[f]);
  }, F.prototype.writeRepeatedUint64String = F.prototype.Xd, F.prototype.Md = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++) {
        var v = g[f];
        v != null && (z(this, l, 0), this.a.wa(v));
      }
  }, F.prototype.writeRepeatedSint32 = F.prototype.Md, F.prototype.Nd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++) {
        var v = g[f];
        v != null && (z(this, l, 0), this.a.xa(v));
      }
  }, F.prototype.writeRepeatedSint64 = F.prototype.Nd, F.prototype.Od = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++) {
        var v = g[f];
        v != null && (z(this, l, 0), this.a.Ta(v));
      }
  }, F.prototype.writeRepeatedSint64String = F.prototype.Od, F.prototype.Pd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++) {
        var v = g[f];
        v != null && (z(this, l, 0), this.a.W(v));
      }
  }, F.prototype.writeRepeatedSintHash64 = F.prototype.Pd, F.prototype.yd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.Pa(l, g[f]);
  }, F.prototype.writeRepeatedFixed32 = F.prototype.yd, F.prototype.zd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.Qa(l, g[f]);
  }, F.prototype.writeRepeatedFixed64 = F.prototype.zd, F.prototype.Ad = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.nb(l, g[f]);
  }, F.prototype.writeRepeatedFixed64String = F.prototype.Ad, F.prototype.Jd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.Ra(l, g[f]);
  }, F.prototype.writeRepeatedSfixed32 = F.prototype.Jd, F.prototype.Kd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.Sa(l, g[f]);
  }, F.prototype.writeRepeatedSfixed64 = F.prototype.Kd, F.prototype.Ld = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.qb(l, g[f]);
  }, F.prototype.writeRepeatedSfixed64String = F.prototype.Ld, F.prototype.Cd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.L(l, g[f]);
  }, F.prototype.writeRepeatedFloat = F.prototype.Cd, F.prototype.wd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.J(l, g[f]);
  }, F.prototype.writeRepeatedDouble = F.prototype.wd, F.prototype.ud = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.I(l, g[f]);
  }, F.prototype.writeRepeatedBool = F.prototype.ud, F.prototype.xd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.R(l, g[f]);
  }, F.prototype.writeRepeatedEnum = F.prototype.xd, F.prototype.Td = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.U(l, g[f]);
  }, F.prototype.writeRepeatedString = F.prototype.Td, F.prototype.vd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.ja(l, g[f]);
  }, F.prototype.writeRepeatedBytes = F.prototype.vd, F.prototype.Id = function(l, g, f) {
    if (g != null)
      for (var v = 0; v < g.length; v++) {
        var R = q(this, l);
        f(g[v], this), V(this, R);
      }
  }, F.prototype.writeRepeatedMessage = F.prototype.Id, F.prototype.Dd = function(l, g, f) {
    if (g != null)
      for (var v = 0; v < g.length; v++)
        z(this, l, 3), f(g[v], this), z(this, l, 4);
  }, F.prototype.writeRepeatedGroup = F.prototype.Dd, F.prototype.Bd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.K(l, g[f]);
  }, F.prototype.writeRepeatedFixedHash64 = F.prototype.Bd, F.prototype.Yd = function(l, g) {
    if (g != null)
      for (var f = 0; f < g.length; f++)
        this.N(l, g[f]);
  }, F.prototype.writeRepeatedVarintHash64 = F.prototype.Yd, F.prototype.ad = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.M(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedInt32 = F.prototype.ad, F.prototype.bd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.M(parseInt(g[f], 10));
      V(this, l);
    }
  }, F.prototype.writePackedInt32String = F.prototype.bd, F.prototype.cd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.ua(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedInt64 = F.prototype.cd, F.prototype.md = function(l, g, f, v) {
    if (g != null) {
      l = q(this, l);
      for (var R = 0; R < g.length; R++)
        this.a.A(f(g[R]), v(g[R]));
      V(this, l);
    }
  }, F.prototype.writePackedSplitFixed64 = F.prototype.md, F.prototype.nd = function(l, g, f, v) {
    if (g != null) {
      l = q(this, l);
      for (var R = 0; R < g.length; R++)
        this.a.l(f(g[R]), v(g[R]));
      V(this, l);
    }
  }, F.prototype.writePackedSplitVarint64 = F.prototype.nd, F.prototype.od = function(l, g, f, v) {
    if (g != null) {
      l = q(this, l);
      for (var R = this.a, T = 0; T < g.length; T++)
        Mt(f(g[T]), v(g[T]), function(P, W) {
          R.l(P >>> 0, W >>> 0);
        });
      V(this, l);
    }
  }, F.prototype.writePackedSplitZigzagVarint64 = F.prototype.od, F.prototype.dd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++) {
        var v = Ot(g[f]);
        this.a.l(v.lo, v.hi);
      }
      V(this, l);
    }
  }, F.prototype.writePackedInt64String = F.prototype.dd, F.prototype.pd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.j(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedUint32 = F.prototype.pd, F.prototype.qd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.j(parseInt(g[f], 10));
      V(this, l);
    }
  }, F.prototype.writePackedUint32String = F.prototype.qd, F.prototype.rd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.va(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedUint64 = F.prototype.rd, F.prototype.sd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++) {
        var v = Ae(g[f]);
        this.a.l(v.lo, v.hi);
      }
      V(this, l);
    }
  }, F.prototype.writePackedUint64String = F.prototype.sd, F.prototype.hd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.wa(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedSint32 = F.prototype.hd, F.prototype.jd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.xa(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedSint64 = F.prototype.jd, F.prototype.kd = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.W(et(g[f]));
      V(this, l);
    }
  }, F.prototype.writePackedSint64String = F.prototype.kd, F.prototype.ld = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.W(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedSintHash64 = F.prototype.ld, F.prototype.Wc = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(4 * g.length), l = 0; l < g.length; l++)
        this.a.s(g[l]);
  }, F.prototype.writePackedFixed32 = F.prototype.Wc, F.prototype.Xc = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(8 * g.length), l = 0; l < g.length; l++)
        this.a.V(g[l]);
  }, F.prototype.writePackedFixed64 = F.prototype.Xc, F.prototype.Yc = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(8 * g.length), l = 0; l < g.length; l++) {
        var f = Ae(g[l]);
        this.a.A(f.lo, f.hi);
      }
  }, F.prototype.writePackedFixed64String = F.prototype.Yc, F.prototype.ed = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(4 * g.length), l = 0; l < g.length; l++)
        this.a.S(g[l]);
  }, F.prototype.writePackedSfixed32 = F.prototype.ed, F.prototype.fd = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(8 * g.length), l = 0; l < g.length; l++)
        this.a.T(g[l]);
  }, F.prototype.writePackedSfixed64 = F.prototype.fd, F.prototype.gd = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(8 * g.length), l = 0; l < g.length; l++)
        this.a.ka(g[l]);
  }, F.prototype.writePackedSfixed64String = F.prototype.gd, F.prototype.$c = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(4 * g.length), l = 0; l < g.length; l++)
        this.a.L(g[l]);
  }, F.prototype.writePackedFloat = F.prototype.$c, F.prototype.Uc = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(8 * g.length), l = 0; l < g.length; l++)
        this.a.J(g[l]);
  }, F.prototype.writePackedDouble = F.prototype.Uc, F.prototype.Tc = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(g.length), l = 0; l < g.length; l++)
        this.a.I(g[l]);
  }, F.prototype.writePackedBool = F.prototype.Tc, F.prototype.Vc = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.R(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedEnum = F.prototype.Vc, F.prototype.Zc = function(l, g) {
    if (g != null && g.length)
      for (z(this, l, 2), this.a.j(8 * g.length), l = 0; l < g.length; l++)
        this.a.K(g[l]);
  }, F.prototype.writePackedFixedHash64 = F.prototype.Zc, F.prototype.td = function(l, g) {
    if (g != null && g.length) {
      l = q(this, l);
      for (var f = 0; f < g.length; f++)
        this.a.N(g[f]);
      V(this, l);
    }
  }, F.prototype.writePackedVarintHash64 = F.prototype.td, s.debug = ue, s.Map = N, s.Message = k, s.BinaryReader = b, s.BinaryWriter = F, s.ExtensionFieldInfo = ot, s.ExtensionFieldBinaryInfo = Oi, s.exportSymbol = t, s.inherits = r, s.object = { extend: d }, s.typeOf = I;
})(_);
var he = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.protobuf.BoolValue", null, c), p.exportSymbol("proto.google.protobuf.BytesValue", null, c), p.exportSymbol("proto.google.protobuf.DoubleValue", null, c), p.exportSymbol("proto.google.protobuf.FloatValue", null, c), p.exportSymbol("proto.google.protobuf.Int32Value", null, c), p.exportSymbol("proto.google.protobuf.Int64Value", null, c), p.exportSymbol("proto.google.protobuf.StringValue", null, c), p.exportSymbol("proto.google.protobuf.UInt32Value", null, c), p.exportSymbol("proto.google.protobuf.UInt64Value", null, c), proto.google.protobuf.DoubleValue = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.DoubleValue, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.DoubleValue.displayName = "proto.google.protobuf.DoubleValue"), proto.google.protobuf.FloatValue = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.FloatValue, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FloatValue.displayName = "proto.google.protobuf.FloatValue"), proto.google.protobuf.Int64Value = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.Int64Value, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.Int64Value.displayName = "proto.google.protobuf.Int64Value"), proto.google.protobuf.UInt64Value = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.UInt64Value, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.UInt64Value.displayName = "proto.google.protobuf.UInt64Value"), proto.google.protobuf.Int32Value = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.Int32Value, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.Int32Value.displayName = "proto.google.protobuf.Int32Value"), proto.google.protobuf.UInt32Value = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.UInt32Value, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.UInt32Value.displayName = "proto.google.protobuf.UInt32Value"), proto.google.protobuf.BoolValue = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.BoolValue, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.BoolValue.displayName = "proto.google.protobuf.BoolValue"), proto.google.protobuf.StringValue = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.StringValue, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.StringValue.displayName = "proto.google.protobuf.StringValue"), proto.google.protobuf.BytesValue = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.BytesValue, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.BytesValue.displayName = "proto.google.protobuf.BytesValue"), e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DoubleValue.prototype.toObject = function(o) {
    return proto.google.protobuf.DoubleValue.toObject(o, this);
  }, proto.google.protobuf.DoubleValue.toObject = function(o, a) {
    var i = {
      value: e.Message.getFloatingPointFieldWithDefault(a, 1, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.DoubleValue.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.DoubleValue();
    return proto.google.protobuf.DoubleValue.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.DoubleValue.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readDouble()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.DoubleValue.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.DoubleValue.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.DoubleValue.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i !== 0 && a.writeDouble(
      1,
      i
    );
  }, proto.google.protobuf.DoubleValue.prototype.getValue = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.DoubleValue.prototype.setValue = function(o) {
    return e.Message.setProto3FloatField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FloatValue.prototype.toObject = function(o) {
    return proto.google.protobuf.FloatValue.toObject(o, this);
  }, proto.google.protobuf.FloatValue.toObject = function(o, a) {
    var i = {
      value: e.Message.getFloatingPointFieldWithDefault(a, 1, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.FloatValue.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FloatValue();
    return proto.google.protobuf.FloatValue.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FloatValue.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readFloat()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FloatValue.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FloatValue.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FloatValue.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i !== 0 && a.writeFloat(
      1,
      i
    );
  }, proto.google.protobuf.FloatValue.prototype.getValue = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.FloatValue.prototype.setValue = function(o) {
    return e.Message.setProto3FloatField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.Int64Value.prototype.toObject = function(o) {
    return proto.google.protobuf.Int64Value.toObject(o, this);
  }, proto.google.protobuf.Int64Value.toObject = function(o, a) {
    var i = {
      value: e.Message.getFieldWithDefault(a, 1, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.Int64Value.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.Int64Value();
    return proto.google.protobuf.Int64Value.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.Int64Value.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt64()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.Int64Value.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.Int64Value.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.Int64Value.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i !== 0 && a.writeInt64(
      1,
      i
    );
  }, proto.google.protobuf.Int64Value.prototype.getValue = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.Int64Value.prototype.setValue = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UInt64Value.prototype.toObject = function(o) {
    return proto.google.protobuf.UInt64Value.toObject(o, this);
  }, proto.google.protobuf.UInt64Value.toObject = function(o, a) {
    var i = {
      value: e.Message.getFieldWithDefault(a, 1, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.UInt64Value.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.UInt64Value();
    return proto.google.protobuf.UInt64Value.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.UInt64Value.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readUint64()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.UInt64Value.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.UInt64Value.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.UInt64Value.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i !== 0 && a.writeUint64(
      1,
      i
    );
  }, proto.google.protobuf.UInt64Value.prototype.getValue = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.UInt64Value.prototype.setValue = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.Int32Value.prototype.toObject = function(o) {
    return proto.google.protobuf.Int32Value.toObject(o, this);
  }, proto.google.protobuf.Int32Value.toObject = function(o, a) {
    var i = {
      value: e.Message.getFieldWithDefault(a, 1, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.Int32Value.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.Int32Value();
    return proto.google.protobuf.Int32Value.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.Int32Value.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.Int32Value.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.Int32Value.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.Int32Value.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i !== 0 && a.writeInt32(
      1,
      i
    );
  }, proto.google.protobuf.Int32Value.prototype.getValue = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.Int32Value.prototype.setValue = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UInt32Value.prototype.toObject = function(o) {
    return proto.google.protobuf.UInt32Value.toObject(o, this);
  }, proto.google.protobuf.UInt32Value.toObject = function(o, a) {
    var i = {
      value: e.Message.getFieldWithDefault(a, 1, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.UInt32Value.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.UInt32Value();
    return proto.google.protobuf.UInt32Value.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.UInt32Value.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readUint32()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.UInt32Value.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.UInt32Value.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.UInt32Value.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i !== 0 && a.writeUint32(
      1,
      i
    );
  }, proto.google.protobuf.UInt32Value.prototype.getValue = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.UInt32Value.prototype.setValue = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.BoolValue.prototype.toObject = function(o) {
    return proto.google.protobuf.BoolValue.toObject(o, this);
  }, proto.google.protobuf.BoolValue.toObject = function(o, a) {
    var i = {
      value: e.Message.getBooleanFieldWithDefault(a, 1, !1)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.BoolValue.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.BoolValue();
    return proto.google.protobuf.BoolValue.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.BoolValue.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.BoolValue.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.BoolValue.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.BoolValue.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i && a.writeBool(
      1,
      i
    );
  }, proto.google.protobuf.BoolValue.prototype.getValue = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.google.protobuf.BoolValue.prototype.setValue = function(o) {
    return e.Message.setProto3BooleanField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.StringValue.prototype.toObject = function(o) {
    return proto.google.protobuf.StringValue.toObject(o, this);
  }, proto.google.protobuf.StringValue.toObject = function(o, a) {
    var i = {
      value: e.Message.getFieldWithDefault(a, 1, "")
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.StringValue.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.StringValue();
    return proto.google.protobuf.StringValue.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.StringValue.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.StringValue.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.StringValue.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.StringValue.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue(), i.length > 0 && a.writeString(
      1,
      i
    );
  }, proto.google.protobuf.StringValue.prototype.getValue = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.StringValue.prototype.setValue = function(o) {
    return e.Message.setProto3StringField(this, 1, o);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.BytesValue.prototype.toObject = function(o) {
    return proto.google.protobuf.BytesValue.toObject(o, this);
  }, proto.google.protobuf.BytesValue.toObject = function(o, a) {
    var i = {
      value: a.getValue_asB64()
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.BytesValue.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.BytesValue();
    return proto.google.protobuf.BytesValue.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.BytesValue.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {!Uint8Array} */
            a.readBytes()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.BytesValue.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.BytesValue.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.BytesValue.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getValue_asU8(), i.length > 0 && a.writeBytes(
      1,
      i
    );
  }, proto.google.protobuf.BytesValue.prototype.getValue = function() {
    return (
      /** @type {!(string|Uint8Array)} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.BytesValue.prototype.getValue_asB64 = function() {
    return (
      /** @type {string} */
      e.Message.bytesAsB64(
        this.getValue()
      )
    );
  }, proto.google.protobuf.BytesValue.prototype.getValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      e.Message.bytesAsU8(
        this.getValue()
      )
    );
  }, proto.google.protobuf.BytesValue.prototype.setValue = function(o) {
    return e.Message.setProto3BytesField(this, 1, o);
  }, p.object.extend(s, proto.google.protobuf);
})(he);
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = he;
  p.object.extend(proto, o), p.exportSymbol("proto.api.patient.v1.IntegrationError", null, c), p.exportSymbol("proto.api.patient.v1.PreconditionError", null, c), p.exportSymbol("proto.api.patient.v1.RequestFailure", null, c), p.exportSymbol("proto.api.patient.v1.RequestFailure.ErrorCase", null, c), proto.api.patient.v1.RequestFailure = function(a) {
    e.Message.initialize(this, a, 0, -1, null, proto.api.patient.v1.RequestFailure.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.RequestFailure, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.RequestFailure.displayName = "proto.api.patient.v1.RequestFailure"), proto.api.patient.v1.RequestFailure.oneofGroups_ = [[11, 12]], proto.api.patient.v1.RequestFailure.ErrorCase = {
    ERROR_NOT_SET: 0,
    PRECONDITION_ERROR: 11,
    INTEGRATION_ERROR: 12
  }, proto.api.patient.v1.RequestFailure.prototype.getErrorCase = function() {
    return (
      /** @type {proto.api.patient.v1.RequestFailure.ErrorCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.RequestFailure.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.RequestFailure.prototype.toObject = function(a) {
    return proto.api.patient.v1.RequestFailure.toObject(a, this);
  }, proto.api.patient.v1.RequestFailure.toObject = function(a, i) {
    var u, y = {
      message: (u = i.getMessage()) && o.StringValue.toObject(a, u),
      preconditionError: e.Message.getFieldWithDefault(i, 11, 0),
      integrationError: e.Message.getFieldWithDefault(i, 12, 0)
    };
    return a && (y.$jspbMessageInstance = i), y;
  }), proto.api.patient.v1.RequestFailure.deserializeBinary = function(a) {
    var i = new e.BinaryReader(a), u = new proto.api.patient.v1.RequestFailure();
    return proto.api.patient.v1.RequestFailure.deserializeBinaryFromReader(u, i);
  }, proto.api.patient.v1.RequestFailure.deserializeBinaryFromReader = function(a, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var u = i.getFieldNumber();
      switch (u) {
        case 1:
          var y = new o.StringValue();
          i.readMessage(y, o.StringValue.deserializeBinaryFromReader), a.setMessage(y);
          break;
        case 11:
          var y = (
            /** @type {!proto.api.patient.v1.PreconditionError} */
            i.readEnum()
          );
          a.setPreconditionError(y);
          break;
        case 12:
          var y = (
            /** @type {!proto.api.patient.v1.IntegrationError} */
            i.readEnum()
          );
          a.setIntegrationError(y);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return a;
  }, proto.api.patient.v1.RequestFailure.prototype.serializeBinary = function() {
    var a = new e.BinaryWriter();
    return proto.api.patient.v1.RequestFailure.serializeBinaryToWriter(this, a), a.getResultBuffer();
  }, proto.api.patient.v1.RequestFailure.serializeBinaryToWriter = function(a, i) {
    var u = void 0;
    u = a.getMessage(), u != null && i.writeMessage(
      1,
      u,
      o.StringValue.serializeBinaryToWriter
    ), u = /** @type {!proto.api.patient.v1.PreconditionError} */
    e.Message.getField(a, 11), u != null && i.writeEnum(
      11,
      u
    ), u = /** @type {!proto.api.patient.v1.IntegrationError} */
    e.Message.getField(a, 12), u != null && i.writeEnum(
      12,
      u
    );
  }, proto.api.patient.v1.RequestFailure.prototype.getMessage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 1)
    );
  }, proto.api.patient.v1.RequestFailure.prototype.setMessage = function(a) {
    return e.Message.setWrapperField(this, 1, a);
  }, proto.api.patient.v1.RequestFailure.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  }, proto.api.patient.v1.RequestFailure.prototype.hasMessage = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.RequestFailure.prototype.getPreconditionError = function() {
    return (
      /** @type {!proto.api.patient.v1.PreconditionError} */
      e.Message.getFieldWithDefault(this, 11, 0)
    );
  }, proto.api.patient.v1.RequestFailure.prototype.setPreconditionError = function(a) {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.RequestFailure.oneofGroups_[0], a);
  }, proto.api.patient.v1.RequestFailure.prototype.clearPreconditionError = function() {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.RequestFailure.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.RequestFailure.prototype.hasPreconditionError = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.RequestFailure.prototype.getIntegrationError = function() {
    return (
      /** @type {!proto.api.patient.v1.IntegrationError} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.RequestFailure.prototype.setIntegrationError = function(a) {
    return e.Message.setOneofField(this, 12, proto.api.patient.v1.RequestFailure.oneofGroups_[0], a);
  }, proto.api.patient.v1.RequestFailure.prototype.clearIntegrationError = function() {
    return e.Message.setOneofField(this, 12, proto.api.patient.v1.RequestFailure.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.RequestFailure.prototype.hasIntegrationError = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.PreconditionError = {
    PRECONDITION_ERROR_UNSPECIFIED: 0,
    PRECONDITION_ERROR_AGE_RESTRICTION: 1,
    PRECONDITION_ERROR_BOOKING_LIMIT_REACHED: 2,
    PRECONDITION_ERROR_LATE_CANCELLATION: 3,
    PRECONDITION_ERROR_ALREADY_CANCELLED: 4,
    PRECONDITION_ERROR_EMAIL_PHONE_CONFLICT: 5,
    PRECONDITION_ERROR_INVALID_PROMO_CODE: 7,
    PRECONDITION_ERROR_OTHER: 10
  }, proto.api.patient.v1.IntegrationError = {
    INTEGRATION_ERROR_UNSPECIFIED: 0,
    INTEGRATION_ERROR_INVALID_ARGUMENT: 1,
    INTEGRATION_ERROR_NOT_FOUND: 2,
    INTEGRATION_ERROR_CONFLICT: 3,
    INTEGRATION_ERROR_NOT_SUPPORTED: 4,
    INTEGRATION_ERROR_UNAUTHORIZED: 5,
    INTEGRATION_ERROR_INTERNAL: 6
  }, p.object.extend(s, proto.api.patient.v1);
})(ei);
var Ut = {}, an = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.api.CustomHttpPattern", null, c), p.exportSymbol("proto.google.api.Http", null, c), p.exportSymbol("proto.google.api.HttpRule", null, c), p.exportSymbol("proto.google.api.HttpRule.PatternCase", null, c), proto.google.api.Http = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.api.Http.repeatedFields_, null);
  }, p.inherits(proto.google.api.Http, e.Message), p.DEBUG && !COMPILED && (proto.google.api.Http.displayName = "proto.google.api.Http"), proto.google.api.HttpRule = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.api.HttpRule.repeatedFields_, proto.google.api.HttpRule.oneofGroups_);
  }, p.inherits(proto.google.api.HttpRule, e.Message), p.DEBUG && !COMPILED && (proto.google.api.HttpRule.displayName = "proto.google.api.HttpRule"), proto.google.api.CustomHttpPattern = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.api.CustomHttpPattern, e.Message), p.DEBUG && !COMPILED && (proto.google.api.CustomHttpPattern.displayName = "proto.google.api.CustomHttpPattern"), proto.google.api.Http.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.google.api.Http.prototype.toObject = function(o) {
    return proto.google.api.Http.toObject(o, this);
  }, proto.google.api.Http.toObject = function(o, a) {
    var i = {
      rulesList: e.Message.toObjectList(
        a.getRulesList(),
        proto.google.api.HttpRule.toObject,
        o
      ),
      fullyDecodeReservedExpansion: e.Message.getBooleanFieldWithDefault(a, 2, !1)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.api.Http.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.api.Http();
    return proto.google.api.Http.deserializeBinaryFromReader(i, a);
  }, proto.google.api.Http.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = new proto.google.api.HttpRule();
          a.readMessage(u, proto.google.api.HttpRule.deserializeBinaryFromReader), o.addRules(u);
          break;
        case 2:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setFullyDecodeReservedExpansion(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.api.Http.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.api.Http.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.api.Http.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getRulesList(), i.length > 0 && a.writeRepeatedMessage(
      1,
      i,
      proto.google.api.HttpRule.serializeBinaryToWriter
    ), i = o.getFullyDecodeReservedExpansion(), i && a.writeBool(
      2,
      i
    );
  }, proto.google.api.Http.prototype.getRulesList = function() {
    return (
      /** @type{!Array<!proto.google.api.HttpRule>} */
      e.Message.getRepeatedWrapperField(this, proto.google.api.HttpRule, 1)
    );
  }, proto.google.api.Http.prototype.setRulesList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 1, o);
  }, proto.google.api.Http.prototype.addRules = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 1, o, proto.google.api.HttpRule, a);
  }, proto.google.api.Http.prototype.clearRulesList = function() {
    return this.setRulesList([]);
  }, proto.google.api.Http.prototype.getFullyDecodeReservedExpansion = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.api.Http.prototype.setFullyDecodeReservedExpansion = function(o) {
    return e.Message.setProto3BooleanField(this, 2, o);
  }, proto.google.api.HttpRule.repeatedFields_ = [11], proto.google.api.HttpRule.oneofGroups_ = [[2, 3, 4, 5, 6, 8]], proto.google.api.HttpRule.PatternCase = {
    PATTERN_NOT_SET: 0,
    GET: 2,
    PUT: 3,
    POST: 4,
    DELETE: 5,
    PATCH: 6,
    CUSTOM: 8
  }, proto.google.api.HttpRule.prototype.getPatternCase = function() {
    return (
      /** @type {proto.google.api.HttpRule.PatternCase} */
      e.Message.computeOneofCase(this, proto.google.api.HttpRule.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.api.HttpRule.prototype.toObject = function(o) {
    return proto.google.api.HttpRule.toObject(o, this);
  }, proto.google.api.HttpRule.toObject = function(o, a) {
    var i, u = {
      selector: e.Message.getFieldWithDefault(a, 1, ""),
      get: e.Message.getFieldWithDefault(a, 2, ""),
      put: e.Message.getFieldWithDefault(a, 3, ""),
      post: e.Message.getFieldWithDefault(a, 4, ""),
      pb_delete: e.Message.getFieldWithDefault(a, 5, ""),
      patch: e.Message.getFieldWithDefault(a, 6, ""),
      custom: (i = a.getCustom()) && proto.google.api.CustomHttpPattern.toObject(o, i),
      body: e.Message.getFieldWithDefault(a, 7, ""),
      responseBody: e.Message.getFieldWithDefault(a, 12, ""),
      additionalBindingsList: e.Message.toObjectList(
        a.getAdditionalBindingsList(),
        proto.google.api.HttpRule.toObject,
        o
      )
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.api.HttpRule.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.api.HttpRule();
    return proto.google.api.HttpRule.deserializeBinaryFromReader(i, a);
  }, proto.google.api.HttpRule.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setSelector(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setGet(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPut(u);
          break;
        case 4:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPost(u);
          break;
        case 5:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setDelete(u);
          break;
        case 6:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPatch(u);
          break;
        case 8:
          var u = new proto.google.api.CustomHttpPattern();
          a.readMessage(u, proto.google.api.CustomHttpPattern.deserializeBinaryFromReader), o.setCustom(u);
          break;
        case 7:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setBody(u);
          break;
        case 12:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setResponseBody(u);
          break;
        case 11:
          var u = new proto.google.api.HttpRule();
          a.readMessage(u, proto.google.api.HttpRule.deserializeBinaryFromReader), o.addAdditionalBindings(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.api.HttpRule.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.api.HttpRule.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.api.HttpRule.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getSelector(), i.length > 0 && a.writeString(
      1,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 2), i != null && a.writeString(
      2,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 3), i != null && a.writeString(
      3,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 4), i != null && a.writeString(
      4,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 5), i != null && a.writeString(
      5,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 6), i != null && a.writeString(
      6,
      i
    ), i = o.getCustom(), i != null && a.writeMessage(
      8,
      i,
      proto.google.api.CustomHttpPattern.serializeBinaryToWriter
    ), i = o.getBody(), i.length > 0 && a.writeString(
      7,
      i
    ), i = o.getResponseBody(), i.length > 0 && a.writeString(
      12,
      i
    ), i = o.getAdditionalBindingsList(), i.length > 0 && a.writeRepeatedMessage(
      11,
      i,
      proto.google.api.HttpRule.serializeBinaryToWriter
    );
  }, proto.google.api.HttpRule.prototype.getSelector = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.api.HttpRule.prototype.setSelector = function(o) {
    return e.Message.setProto3StringField(this, 1, o);
  }, proto.google.api.HttpRule.prototype.getGet = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.api.HttpRule.prototype.setGet = function(o) {
    return e.Message.setOneofField(this, 2, proto.google.api.HttpRule.oneofGroups_[0], o);
  }, proto.google.api.HttpRule.prototype.clearGet = function() {
    return e.Message.setOneofField(this, 2, proto.google.api.HttpRule.oneofGroups_[0], void 0);
  }, proto.google.api.HttpRule.prototype.hasGet = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.api.HttpRule.prototype.getPut = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.api.HttpRule.prototype.setPut = function(o) {
    return e.Message.setOneofField(this, 3, proto.google.api.HttpRule.oneofGroups_[0], o);
  }, proto.google.api.HttpRule.prototype.clearPut = function() {
    return e.Message.setOneofField(this, 3, proto.google.api.HttpRule.oneofGroups_[0], void 0);
  }, proto.google.api.HttpRule.prototype.hasPut = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.api.HttpRule.prototype.getPost = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.google.api.HttpRule.prototype.setPost = function(o) {
    return e.Message.setOneofField(this, 4, proto.google.api.HttpRule.oneofGroups_[0], o);
  }, proto.google.api.HttpRule.prototype.clearPost = function() {
    return e.Message.setOneofField(this, 4, proto.google.api.HttpRule.oneofGroups_[0], void 0);
  }, proto.google.api.HttpRule.prototype.hasPost = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.api.HttpRule.prototype.getDelete = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.google.api.HttpRule.prototype.setDelete = function(o) {
    return e.Message.setOneofField(this, 5, proto.google.api.HttpRule.oneofGroups_[0], o);
  }, proto.google.api.HttpRule.prototype.clearDelete = function() {
    return e.Message.setOneofField(this, 5, proto.google.api.HttpRule.oneofGroups_[0], void 0);
  }, proto.google.api.HttpRule.prototype.hasDelete = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.api.HttpRule.prototype.getPatch = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.google.api.HttpRule.prototype.setPatch = function(o) {
    return e.Message.setOneofField(this, 6, proto.google.api.HttpRule.oneofGroups_[0], o);
  }, proto.google.api.HttpRule.prototype.clearPatch = function() {
    return e.Message.setOneofField(this, 6, proto.google.api.HttpRule.oneofGroups_[0], void 0);
  }, proto.google.api.HttpRule.prototype.hasPatch = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.api.HttpRule.prototype.getCustom = function() {
    return (
      /** @type{?proto.google.api.CustomHttpPattern} */
      e.Message.getWrapperField(this, proto.google.api.CustomHttpPattern, 8)
    );
  }, proto.google.api.HttpRule.prototype.setCustom = function(o) {
    return e.Message.setOneofWrapperField(this, 8, proto.google.api.HttpRule.oneofGroups_[0], o);
  }, proto.google.api.HttpRule.prototype.clearCustom = function() {
    return this.setCustom(void 0);
  }, proto.google.api.HttpRule.prototype.hasCustom = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.google.api.HttpRule.prototype.getBody = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.google.api.HttpRule.prototype.setBody = function(o) {
    return e.Message.setProto3StringField(this, 7, o);
  }, proto.google.api.HttpRule.prototype.getResponseBody = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 12, "")
    );
  }, proto.google.api.HttpRule.prototype.setResponseBody = function(o) {
    return e.Message.setProto3StringField(this, 12, o);
  }, proto.google.api.HttpRule.prototype.getAdditionalBindingsList = function() {
    return (
      /** @type{!Array<!proto.google.api.HttpRule>} */
      e.Message.getRepeatedWrapperField(this, proto.google.api.HttpRule, 11)
    );
  }, proto.google.api.HttpRule.prototype.setAdditionalBindingsList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 11, o);
  }, proto.google.api.HttpRule.prototype.addAdditionalBindings = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 11, o, proto.google.api.HttpRule, a);
  }, proto.google.api.HttpRule.prototype.clearAdditionalBindingsList = function() {
    return this.setAdditionalBindingsList([]);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.api.CustomHttpPattern.prototype.toObject = function(o) {
    return proto.google.api.CustomHttpPattern.toObject(o, this);
  }, proto.google.api.CustomHttpPattern.toObject = function(o, a) {
    var i = {
      kind: e.Message.getFieldWithDefault(a, 1, ""),
      path: e.Message.getFieldWithDefault(a, 2, "")
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.api.CustomHttpPattern.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.api.CustomHttpPattern();
    return proto.google.api.CustomHttpPattern.deserializeBinaryFromReader(i, a);
  }, proto.google.api.CustomHttpPattern.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setKind(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPath(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.api.CustomHttpPattern.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.api.CustomHttpPattern.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.api.CustomHttpPattern.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getKind(), i.length > 0 && a.writeString(
      1,
      i
    ), i = o.getPath(), i.length > 0 && a.writeString(
      2,
      i
    );
  }, proto.google.api.CustomHttpPattern.prototype.getKind = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.api.CustomHttpPattern.prototype.setKind = function(o) {
    return e.Message.setProto3StringField(this, 1, o);
  }, proto.google.api.CustomHttpPattern.prototype.getPath = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.api.CustomHttpPattern.prototype.setPath = function(o) {
    return e.Message.setProto3StringField(this, 2, o);
  }, p.object.extend(s, proto.google.api);
})(an);
var pn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.protobuf.DescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.DescriptorProto.ExtensionRange", null, c), p.exportSymbol("proto.google.protobuf.DescriptorProto.ReservedRange", null, c), p.exportSymbol("proto.google.protobuf.Edition", null, c), p.exportSymbol("proto.google.protobuf.EnumDescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.EnumDescriptorProto.EnumReservedRange", null, c), p.exportSymbol("proto.google.protobuf.EnumOptions", null, c), p.exportSymbol("proto.google.protobuf.EnumValueDescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.EnumValueOptions", null, c), p.exportSymbol("proto.google.protobuf.ExtensionRangeOptions", null, c), p.exportSymbol("proto.google.protobuf.ExtensionRangeOptions.Declaration", null, c), p.exportSymbol("proto.google.protobuf.ExtensionRangeOptions.VerificationState", null, c), p.exportSymbol("proto.google.protobuf.FeatureSet", null, c), p.exportSymbol("proto.google.protobuf.FeatureSet.EnumType", null, c), p.exportSymbol("proto.google.protobuf.FeatureSet.FieldPresence", null, c), p.exportSymbol("proto.google.protobuf.FeatureSet.JsonFormat", null, c), p.exportSymbol("proto.google.protobuf.FeatureSet.MessageEncoding", null, c), p.exportSymbol("proto.google.protobuf.FeatureSet.RepeatedFieldEncoding", null, c), p.exportSymbol("proto.google.protobuf.FeatureSet.Utf8Validation", null, c), p.exportSymbol("proto.google.protobuf.FeatureSetDefaults", null, c), p.exportSymbol("proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault", null, c), p.exportSymbol("proto.google.protobuf.FieldDescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.FieldDescriptorProto.Label", null, c), p.exportSymbol("proto.google.protobuf.FieldDescriptorProto.Type", null, c), p.exportSymbol("proto.google.protobuf.FieldOptions", null, c), p.exportSymbol("proto.google.protobuf.FieldOptions.CType", null, c), p.exportSymbol("proto.google.protobuf.FieldOptions.EditionDefault", null, c), p.exportSymbol("proto.google.protobuf.FieldOptions.FeatureSupport", null, c), p.exportSymbol("proto.google.protobuf.FieldOptions.JSType", null, c), p.exportSymbol("proto.google.protobuf.FieldOptions.OptionRetention", null, c), p.exportSymbol("proto.google.protobuf.FieldOptions.OptionTargetType", null, c), p.exportSymbol("proto.google.protobuf.FileDescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.FileDescriptorSet", null, c), p.exportSymbol("proto.google.protobuf.FileOptions", null, c), p.exportSymbol("proto.google.protobuf.FileOptions.OptimizeMode", null, c), p.exportSymbol("proto.google.protobuf.GeneratedCodeInfo", null, c), p.exportSymbol("proto.google.protobuf.GeneratedCodeInfo.Annotation", null, c), p.exportSymbol("proto.google.protobuf.GeneratedCodeInfo.Annotation.Semantic", null, c), p.exportSymbol("proto.google.protobuf.MessageOptions", null, c), p.exportSymbol("proto.google.protobuf.MethodDescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.MethodOptions", null, c), p.exportSymbol("proto.google.protobuf.MethodOptions.IdempotencyLevel", null, c), p.exportSymbol("proto.google.protobuf.OneofDescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.OneofOptions", null, c), p.exportSymbol("proto.google.protobuf.ServiceDescriptorProto", null, c), p.exportSymbol("proto.google.protobuf.ServiceOptions", null, c), p.exportSymbol("proto.google.protobuf.SourceCodeInfo", null, c), p.exportSymbol("proto.google.protobuf.SourceCodeInfo.Location", null, c), p.exportSymbol("proto.google.protobuf.UninterpretedOption", null, c), p.exportSymbol("proto.google.protobuf.UninterpretedOption.NamePart", null, c), proto.google.protobuf.FileDescriptorSet = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.FileDescriptorSet.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.FileDescriptorSet, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FileDescriptorSet.displayName = "proto.google.protobuf.FileDescriptorSet"), proto.google.protobuf.FileDescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.FileDescriptorProto.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.FileDescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FileDescriptorProto.displayName = "proto.google.protobuf.FileDescriptorProto"), proto.google.protobuf.DescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.DescriptorProto.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.DescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.DescriptorProto.displayName = "proto.google.protobuf.DescriptorProto"), proto.google.protobuf.DescriptorProto.ExtensionRange = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.DescriptorProto.ExtensionRange, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.DescriptorProto.ExtensionRange.displayName = "proto.google.protobuf.DescriptorProto.ExtensionRange"), proto.google.protobuf.DescriptorProto.ReservedRange = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.DescriptorProto.ReservedRange, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.DescriptorProto.ReservedRange.displayName = "proto.google.protobuf.DescriptorProto.ReservedRange"), proto.google.protobuf.ExtensionRangeOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.ExtensionRangeOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.ExtensionRangeOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.ExtensionRangeOptions.displayName = "proto.google.protobuf.ExtensionRangeOptions"), proto.google.protobuf.ExtensionRangeOptions.extensions = {}, proto.google.protobuf.ExtensionRangeOptions.extensionsBinary = {}, proto.google.protobuf.ExtensionRangeOptions.Declaration = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.ExtensionRangeOptions.Declaration, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.ExtensionRangeOptions.Declaration.displayName = "proto.google.protobuf.ExtensionRangeOptions.Declaration"), proto.google.protobuf.FieldDescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.FieldDescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FieldDescriptorProto.displayName = "proto.google.protobuf.FieldDescriptorProto"), proto.google.protobuf.OneofDescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.OneofDescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.OneofDescriptorProto.displayName = "proto.google.protobuf.OneofDescriptorProto"), proto.google.protobuf.EnumDescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.EnumDescriptorProto.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.EnumDescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.EnumDescriptorProto.displayName = "proto.google.protobuf.EnumDescriptorProto"), proto.google.protobuf.EnumDescriptorProto.EnumReservedRange = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.displayName = "proto.google.protobuf.EnumDescriptorProto.EnumReservedRange"), proto.google.protobuf.EnumValueDescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.EnumValueDescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.EnumValueDescriptorProto.displayName = "proto.google.protobuf.EnumValueDescriptorProto"), proto.google.protobuf.ServiceDescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.ServiceDescriptorProto.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.ServiceDescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.ServiceDescriptorProto.displayName = "proto.google.protobuf.ServiceDescriptorProto"), proto.google.protobuf.MethodDescriptorProto = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.MethodDescriptorProto, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.MethodDescriptorProto.displayName = "proto.google.protobuf.MethodDescriptorProto"), proto.google.protobuf.FileOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.FileOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.FileOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FileOptions.displayName = "proto.google.protobuf.FileOptions"), proto.google.protobuf.FileOptions.extensions = {}, proto.google.protobuf.FileOptions.extensionsBinary = {}, proto.google.protobuf.MessageOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.MessageOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.MessageOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.MessageOptions.displayName = "proto.google.protobuf.MessageOptions"), proto.google.protobuf.MessageOptions.extensions = {}, proto.google.protobuf.MessageOptions.extensionsBinary = {}, proto.google.protobuf.FieldOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.FieldOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.FieldOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FieldOptions.displayName = "proto.google.protobuf.FieldOptions"), proto.google.protobuf.FieldOptions.extensions = {}, proto.google.protobuf.FieldOptions.extensionsBinary = {}, proto.google.protobuf.FieldOptions.EditionDefault = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.FieldOptions.EditionDefault, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FieldOptions.EditionDefault.displayName = "proto.google.protobuf.FieldOptions.EditionDefault"), proto.google.protobuf.FieldOptions.FeatureSupport = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.FieldOptions.FeatureSupport, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FieldOptions.FeatureSupport.displayName = "proto.google.protobuf.FieldOptions.FeatureSupport"), proto.google.protobuf.OneofOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.OneofOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.OneofOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.OneofOptions.displayName = "proto.google.protobuf.OneofOptions"), proto.google.protobuf.OneofOptions.extensions = {}, proto.google.protobuf.OneofOptions.extensionsBinary = {}, proto.google.protobuf.EnumOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.EnumOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.EnumOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.EnumOptions.displayName = "proto.google.protobuf.EnumOptions"), proto.google.protobuf.EnumOptions.extensions = {}, proto.google.protobuf.EnumOptions.extensionsBinary = {}, proto.google.protobuf.EnumValueOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.EnumValueOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.EnumValueOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.EnumValueOptions.displayName = "proto.google.protobuf.EnumValueOptions"), proto.google.protobuf.EnumValueOptions.extensions = {}, proto.google.protobuf.EnumValueOptions.extensionsBinary = {}, proto.google.protobuf.ServiceOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.ServiceOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.ServiceOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.ServiceOptions.displayName = "proto.google.protobuf.ServiceOptions"), proto.google.protobuf.ServiceOptions.extensions = {}, proto.google.protobuf.ServiceOptions.extensionsBinary = {}, proto.google.protobuf.MethodOptions = function(o) {
    e.Message.initialize(this, o, 0, 500, proto.google.protobuf.MethodOptions.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.MethodOptions, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.MethodOptions.displayName = "proto.google.protobuf.MethodOptions"), proto.google.protobuf.MethodOptions.extensions = {}, proto.google.protobuf.MethodOptions.extensionsBinary = {}, proto.google.protobuf.UninterpretedOption = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.UninterpretedOption.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.UninterpretedOption, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.UninterpretedOption.displayName = "proto.google.protobuf.UninterpretedOption"), proto.google.protobuf.UninterpretedOption.NamePart = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.UninterpretedOption.NamePart, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.UninterpretedOption.NamePart.displayName = "proto.google.protobuf.UninterpretedOption.NamePart"), proto.google.protobuf.FeatureSet = function(o) {
    e.Message.initialize(this, o, 0, 7, null, null);
  }, p.inherits(proto.google.protobuf.FeatureSet, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FeatureSet.displayName = "proto.google.protobuf.FeatureSet"), proto.google.protobuf.FeatureSet.extensions = {}, proto.google.protobuf.FeatureSet.extensionsBinary = {}, proto.google.protobuf.FeatureSetDefaults = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.FeatureSetDefaults.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.FeatureSetDefaults, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FeatureSetDefaults.displayName = "proto.google.protobuf.FeatureSetDefaults"), proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.displayName = "proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault"), proto.google.protobuf.SourceCodeInfo = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.SourceCodeInfo.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.SourceCodeInfo, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.SourceCodeInfo.displayName = "proto.google.protobuf.SourceCodeInfo"), proto.google.protobuf.SourceCodeInfo.Location = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.SourceCodeInfo.Location, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.SourceCodeInfo.Location.displayName = "proto.google.protobuf.SourceCodeInfo.Location"), proto.google.protobuf.GeneratedCodeInfo = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.GeneratedCodeInfo.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.GeneratedCodeInfo, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.GeneratedCodeInfo.displayName = "proto.google.protobuf.GeneratedCodeInfo"), proto.google.protobuf.GeneratedCodeInfo.Annotation = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_, null);
  }, p.inherits(proto.google.protobuf.GeneratedCodeInfo.Annotation, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.GeneratedCodeInfo.Annotation.displayName = "proto.google.protobuf.GeneratedCodeInfo.Annotation"), proto.google.protobuf.FileDescriptorSet.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FileDescriptorSet.prototype.toObject = function(o) {
    return proto.google.protobuf.FileDescriptorSet.toObject(o, this);
  }, proto.google.protobuf.FileDescriptorSet.toObject = function(o, a) {
    var i = {
      fileList: e.Message.toObjectList(
        a.getFileList(),
        proto.google.protobuf.FileDescriptorProto.toObject,
        o
      )
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.FileDescriptorSet.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FileDescriptorSet();
    return proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = new proto.google.protobuf.FileDescriptorProto();
          a.readMessage(u, proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader), o.addFile(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FileDescriptorSet.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getFileList(), i.length > 0 && a.writeRepeatedMessage(
      1,
      i,
      proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter
    );
  }, proto.google.protobuf.FileDescriptorSet.prototype.getFileList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FileDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.FileDescriptorProto, 1)
    );
  }, proto.google.protobuf.FileDescriptorSet.prototype.setFileList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 1, o);
  }, proto.google.protobuf.FileDescriptorSet.prototype.addFile = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 1, o, proto.google.protobuf.FileDescriptorProto, a);
  }, proto.google.protobuf.FileDescriptorSet.prototype.clearFileList = function() {
    return this.setFileList([]);
  }, proto.google.protobuf.FileDescriptorProto.repeatedFields_ = [3, 10, 11, 4, 5, 6, 7], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FileDescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.FileDescriptorProto.toObject(o, this);
  }, proto.google.protobuf.FileDescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      pb_package: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      dependencyList: (i = e.Message.getRepeatedField(a, 3)) == null ? void 0 : i,
      publicDependencyList: (i = e.Message.getRepeatedField(a, 10)) == null ? void 0 : i,
      weakDependencyList: (i = e.Message.getRepeatedField(a, 11)) == null ? void 0 : i,
      messageTypeList: e.Message.toObjectList(
        a.getMessageTypeList(),
        proto.google.protobuf.DescriptorProto.toObject,
        o
      ),
      enumTypeList: e.Message.toObjectList(
        a.getEnumTypeList(),
        proto.google.protobuf.EnumDescriptorProto.toObject,
        o
      ),
      serviceList: e.Message.toObjectList(
        a.getServiceList(),
        proto.google.protobuf.ServiceDescriptorProto.toObject,
        o
      ),
      extensionList: e.Message.toObjectList(
        a.getExtensionList(),
        proto.google.protobuf.FieldDescriptorProto.toObject,
        o
      ),
      options: (i = a.getOptions()) && proto.google.protobuf.FileOptions.toObject(o, i),
      sourceCodeInfo: (i = a.getSourceCodeInfo()) && proto.google.protobuf.SourceCodeInfo.toObject(o, i),
      syntax: (i = e.Message.getField(a, 12)) == null ? void 0 : i,
      edition: (i = e.Message.getField(a, 14)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FileDescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FileDescriptorProto();
    return proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.setName(h);
          break;
        case 2:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.setPackage(h);
          break;
        case 3:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.addDependency(h);
          break;
        case 10:
          for (var y = (
            /** @type {!Array<number>} */
            a.isDelimited() ? a.readPackedInt32() : [a.readInt32()]
          ), u = 0; u < y.length; u++)
            o.addPublicDependency(y[u]);
          break;
        case 11:
          for (var y = (
            /** @type {!Array<number>} */
            a.isDelimited() ? a.readPackedInt32() : [a.readInt32()]
          ), u = 0; u < y.length; u++)
            o.addWeakDependency(y[u]);
          break;
        case 4:
          var h = new proto.google.protobuf.DescriptorProto();
          a.readMessage(h, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader), o.addMessageType(h);
          break;
        case 5:
          var h = new proto.google.protobuf.EnumDescriptorProto();
          a.readMessage(h, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader), o.addEnumType(h);
          break;
        case 6:
          var h = new proto.google.protobuf.ServiceDescriptorProto();
          a.readMessage(h, proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader), o.addService(h);
          break;
        case 7:
          var h = new proto.google.protobuf.FieldDescriptorProto();
          a.readMessage(h, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader), o.addExtension$(h);
          break;
        case 8:
          var h = new proto.google.protobuf.FileOptions();
          a.readMessage(h, proto.google.protobuf.FileOptions.deserializeBinaryFromReader), o.setOptions(h);
          break;
        case 9:
          var h = new proto.google.protobuf.SourceCodeInfo();
          a.readMessage(h, proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader), o.setSourceCodeInfo(h);
          break;
        case 12:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.setSyntax(h);
          break;
        case 14:
          var h = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setEdition(h);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FileDescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 2), i != null && a.writeString(
      2,
      i
    ), i = o.getDependencyList(), i.length > 0 && a.writeRepeatedString(
      3,
      i
    ), i = o.getPublicDependencyList(), i.length > 0 && a.writeRepeatedInt32(
      10,
      i
    ), i = o.getWeakDependencyList(), i.length > 0 && a.writeRepeatedInt32(
      11,
      i
    ), i = o.getMessageTypeList(), i.length > 0 && a.writeRepeatedMessage(
      4,
      i,
      proto.google.protobuf.DescriptorProto.serializeBinaryToWriter
    ), i = o.getEnumTypeList(), i.length > 0 && a.writeRepeatedMessage(
      5,
      i,
      proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter
    ), i = o.getServiceList(), i.length > 0 && a.writeRepeatedMessage(
      6,
      i,
      proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter
    ), i = o.getExtensionList(), i.length > 0 && a.writeRepeatedMessage(
      7,
      i,
      proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
    ), i = o.getOptions(), i != null && a.writeMessage(
      8,
      i,
      proto.google.protobuf.FileOptions.serializeBinaryToWriter
    ), i = o.getSourceCodeInfo(), i != null && a.writeMessage(
      9,
      i,
      proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter
    ), i = /** @type {string} */
    e.Message.getField(o, 12), i != null && a.writeString(
      12,
      i
    ), i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 14), i != null && a.writeEnum(
      14,
      i
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getPackage = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setPackage = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearPackage = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasPackage = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getDependencyList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 3)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setDependencyList = function(o) {
    return e.Message.setField(this, 3, o || []);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addDependency = function(o, a) {
    return e.Message.addToRepeatedField(this, 3, o, a);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearDependencyList = function() {
    return this.setDependencyList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getPublicDependencyList = function() {
    return (
      /** @type {!Array<number>} */
      e.Message.getRepeatedField(this, 10)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setPublicDependencyList = function(o) {
    return e.Message.setField(this, 10, o || []);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addPublicDependency = function(o, a) {
    return e.Message.addToRepeatedField(this, 10, o, a);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearPublicDependencyList = function() {
    return this.setPublicDependencyList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getWeakDependencyList = function() {
    return (
      /** @type {!Array<number>} */
      e.Message.getRepeatedField(this, 11)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setWeakDependencyList = function(o) {
    return e.Message.setField(this, 11, o || []);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addWeakDependency = function(o, a) {
    return e.Message.addToRepeatedField(this, 11, o, a);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearWeakDependencyList = function() {
    return this.setWeakDependencyList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getMessageTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 4)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setMessageTypeList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 4, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addMessageType = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 4, o, proto.google.protobuf.DescriptorProto, a);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearMessageTypeList = function() {
    return this.setMessageTypeList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getEnumTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 5)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setEnumTypeList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 5, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addEnumType = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 5, o, proto.google.protobuf.EnumDescriptorProto, a);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearEnumTypeList = function() {
    return this.setEnumTypeList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getServiceList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.ServiceDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.ServiceDescriptorProto, 6)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setServiceList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 6, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addService = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 6, o, proto.google.protobuf.ServiceDescriptorProto, a);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearServiceList = function() {
    return this.setServiceList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getExtensionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 7)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setExtensionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 7, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addExtension$ = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 7, o, proto.google.protobuf.FieldDescriptorProto, a);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearExtensionList = function() {
    return this.setExtensionList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.FileOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.FileOptions, 8)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 8, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getSourceCodeInfo = function() {
    return (
      /** @type{?proto.google.protobuf.SourceCodeInfo} */
      e.Message.getWrapperField(this, proto.google.protobuf.SourceCodeInfo, 9)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setSourceCodeInfo = function(o) {
    return e.Message.setWrapperField(this, 9, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearSourceCodeInfo = function() {
    return this.setSourceCodeInfo(void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasSourceCodeInfo = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getSyntax = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 12, "")
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setSyntax = function(o) {
    return e.Message.setField(this, 12, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearSyntax = function() {
    return e.Message.setField(this, 12, void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasSyntax = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getEdition = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 14, 0)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setEdition = function(o) {
    return e.Message.setField(this, 14, o);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearEdition = function() {
    return e.Message.setField(this, 14, void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasEdition = function() {
    return e.Message.getField(this, 14) != null;
  }, proto.google.protobuf.DescriptorProto.repeatedFields_ = [2, 6, 3, 4, 5, 8, 9, 10], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.DescriptorProto.toObject(o, this);
  }, proto.google.protobuf.DescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      fieldList: e.Message.toObjectList(
        a.getFieldList(),
        proto.google.protobuf.FieldDescriptorProto.toObject,
        o
      ),
      extensionList: e.Message.toObjectList(
        a.getExtensionList(),
        proto.google.protobuf.FieldDescriptorProto.toObject,
        o
      ),
      nestedTypeList: e.Message.toObjectList(
        a.getNestedTypeList(),
        proto.google.protobuf.DescriptorProto.toObject,
        o
      ),
      enumTypeList: e.Message.toObjectList(
        a.getEnumTypeList(),
        proto.google.protobuf.EnumDescriptorProto.toObject,
        o
      ),
      extensionRangeList: e.Message.toObjectList(
        a.getExtensionRangeList(),
        proto.google.protobuf.DescriptorProto.ExtensionRange.toObject,
        o
      ),
      oneofDeclList: e.Message.toObjectList(
        a.getOneofDeclList(),
        proto.google.protobuf.OneofDescriptorProto.toObject,
        o
      ),
      options: (i = a.getOptions()) && proto.google.protobuf.MessageOptions.toObject(o, i),
      reservedRangeList: e.Message.toObjectList(
        a.getReservedRangeList(),
        proto.google.protobuf.DescriptorProto.ReservedRange.toObject,
        o
      ),
      reservedNameList: (i = e.Message.getRepeatedField(a, 10)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.DescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.DescriptorProto();
    return proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setName(u);
          break;
        case 2:
          var u = new proto.google.protobuf.FieldDescriptorProto();
          a.readMessage(u, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader), o.addField(u);
          break;
        case 6:
          var u = new proto.google.protobuf.FieldDescriptorProto();
          a.readMessage(u, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader), o.addExtension$(u);
          break;
        case 3:
          var u = new proto.google.protobuf.DescriptorProto();
          a.readMessage(u, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader), o.addNestedType(u);
          break;
        case 4:
          var u = new proto.google.protobuf.EnumDescriptorProto();
          a.readMessage(u, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader), o.addEnumType(u);
          break;
        case 5:
          var u = new proto.google.protobuf.DescriptorProto.ExtensionRange();
          a.readMessage(u, proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader), o.addExtensionRange(u);
          break;
        case 8:
          var u = new proto.google.protobuf.OneofDescriptorProto();
          a.readMessage(u, proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader), o.addOneofDecl(u);
          break;
        case 7:
          var u = new proto.google.protobuf.MessageOptions();
          a.readMessage(u, proto.google.protobuf.MessageOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        case 9:
          var u = new proto.google.protobuf.DescriptorProto.ReservedRange();
          a.readMessage(u, proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader), o.addReservedRange(u);
          break;
        case 10:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.addReservedName(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.DescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.DescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.DescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = o.getFieldList(), i.length > 0 && a.writeRepeatedMessage(
      2,
      i,
      proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
    ), i = o.getExtensionList(), i.length > 0 && a.writeRepeatedMessage(
      6,
      i,
      proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
    ), i = o.getNestedTypeList(), i.length > 0 && a.writeRepeatedMessage(
      3,
      i,
      proto.google.protobuf.DescriptorProto.serializeBinaryToWriter
    ), i = o.getEnumTypeList(), i.length > 0 && a.writeRepeatedMessage(
      4,
      i,
      proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter
    ), i = o.getExtensionRangeList(), i.length > 0 && a.writeRepeatedMessage(
      5,
      i,
      proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter
    ), i = o.getOneofDeclList(), i.length > 0 && a.writeRepeatedMessage(
      8,
      i,
      proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter
    ), i = o.getOptions(), i != null && a.writeMessage(
      7,
      i,
      proto.google.protobuf.MessageOptions.serializeBinaryToWriter
    ), i = o.getReservedRangeList(), i.length > 0 && a.writeRepeatedMessage(
      9,
      i,
      proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter
    ), i = o.getReservedNameList(), i.length > 0 && a.writeRepeatedString(
      10,
      i
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.toObject = function(o) {
    return proto.google.protobuf.DescriptorProto.ExtensionRange.toObject(o, this);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.toObject = function(o, a) {
    var i, u = {
      start: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      end: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      options: (i = a.getOptions()) && proto.google.protobuf.ExtensionRangeOptions.toObject(o, i)
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.DescriptorProto.ExtensionRange();
    return proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setStart(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setEnd(u);
          break;
        case 3:
          var u = new proto.google.protobuf.ExtensionRangeOptions();
          a.readMessage(u, proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {number} */
    e.Message.getField(o, 1), i != null && a.writeInt32(
      1,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 2), i != null && a.writeInt32(
      2,
      i
    ), i = o.getOptions(), i != null && a.writeMessage(
      3,
      i,
      proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getStart = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setStart = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearStart = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasStart = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getEnd = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setEnd = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearEnd = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasEnd = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.ExtensionRangeOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.ExtensionRangeOptions, 3)
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 3, o);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasOptions = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DescriptorProto.ReservedRange.prototype.toObject = function(o) {
    return proto.google.protobuf.DescriptorProto.ReservedRange.toObject(o, this);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.toObject = function(o, a) {
    var i, u = {
      start: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      end: (i = e.Message.getField(a, 2)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.DescriptorProto.ReservedRange();
    return proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setStart(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setEnd(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {number} */
    e.Message.getField(o, 1), i != null && a.writeInt32(
      1,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 2), i != null && a.writeInt32(
      2,
      i
    );
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getStart = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setStart = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearStart = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasStart = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getEnd = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setEnd = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearEnd = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasEnd = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.DescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.DescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.DescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.DescriptorProto.prototype.getFieldList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 2)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setFieldList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 2, o);
  }, proto.google.protobuf.DescriptorProto.prototype.addField = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 2, o, proto.google.protobuf.FieldDescriptorProto, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearFieldList = function() {
    return this.setFieldList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getExtensionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 6)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setExtensionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 6, o);
  }, proto.google.protobuf.DescriptorProto.prototype.addExtension$ = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 6, o, proto.google.protobuf.FieldDescriptorProto, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearExtensionList = function() {
    return this.setExtensionList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getNestedTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 3)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setNestedTypeList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 3, o);
  }, proto.google.protobuf.DescriptorProto.prototype.addNestedType = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 3, o, proto.google.protobuf.DescriptorProto, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearNestedTypeList = function() {
    return this.setNestedTypeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getEnumTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 4)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setEnumTypeList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 4, o);
  }, proto.google.protobuf.DescriptorProto.prototype.addEnumType = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 4, o, proto.google.protobuf.EnumDescriptorProto, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearEnumTypeList = function() {
    return this.setEnumTypeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getExtensionRangeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ExtensionRange, 5)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setExtensionRangeList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 5, o);
  }, proto.google.protobuf.DescriptorProto.prototype.addExtensionRange = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 5, o, proto.google.protobuf.DescriptorProto.ExtensionRange, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearExtensionRangeList = function() {
    return this.setExtensionRangeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getOneofDeclList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.OneofDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.OneofDescriptorProto, 8)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setOneofDeclList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 8, o);
  }, proto.google.protobuf.DescriptorProto.prototype.addOneofDecl = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 8, o, proto.google.protobuf.OneofDescriptorProto, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearOneofDeclList = function() {
    return this.setOneofDeclList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.MessageOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.MessageOptions, 7)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 7, o);
  }, proto.google.protobuf.DescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.DescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.google.protobuf.DescriptorProto.prototype.getReservedRangeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ReservedRange, 9)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setReservedRangeList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 9, o);
  }, proto.google.protobuf.DescriptorProto.prototype.addReservedRange = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 9, o, proto.google.protobuf.DescriptorProto.ReservedRange, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearReservedRangeList = function() {
    return this.setReservedRangeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getReservedNameList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 10)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setReservedNameList = function(o) {
    return e.Message.setField(this, 10, o || []);
  }, proto.google.protobuf.DescriptorProto.prototype.addReservedName = function(o, a) {
    return e.Message.addToRepeatedField(this, 10, o, a);
  }, proto.google.protobuf.DescriptorProto.prototype.clearReservedNameList = function() {
    return this.setReservedNameList([]);
  }, proto.google.protobuf.ExtensionRangeOptions.repeatedFields_ = [999, 2], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.ExtensionRangeOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.ExtensionRangeOptions.toObject(o, this);
  }, proto.google.protobuf.ExtensionRangeOptions.toObject = function(o, a) {
    var i, u = {
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      ),
      declarationList: e.Message.toObjectList(
        a.getDeclarationList(),
        proto.google.protobuf.ExtensionRangeOptions.Declaration.toObject,
        o
      ),
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      verification: e.Message.getFieldWithDefault(a, 3, 1)
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.ExtensionRangeOptions.extensions,
      proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.ExtensionRangeOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.ExtensionRangeOptions();
    return proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        case 2:
          var u = new proto.google.protobuf.ExtensionRangeOptions.Declaration();
          a.readMessage(u, proto.google.protobuf.ExtensionRangeOptions.Declaration.deserializeBinaryFromReader), o.addDeclaration(u);
          break;
        case 50:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 3:
          var u = (
            /** @type {!proto.google.protobuf.ExtensionRangeOptions.VerificationState} */
            a.readEnum()
          );
          o.setVerification(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.ExtensionRangeOptions.extensionsBinary,
            proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension,
            proto.google.protobuf.ExtensionRangeOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), i = o.getDeclarationList(), i.length > 0 && a.writeRepeatedMessage(
      2,
      i,
      proto.google.protobuf.ExtensionRangeOptions.Declaration.serializeBinaryToWriter
    ), i = o.getFeatures(), i != null && a.writeMessage(
      50,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = /** @type {!proto.google.protobuf.ExtensionRangeOptions.VerificationState} */
    e.Message.getField(o, 3), i != null && a.writeEnum(
      3,
      i
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.ExtensionRangeOptions.extensionsBinary,
      proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension
    );
  }, proto.google.protobuf.ExtensionRangeOptions.VerificationState = {
    DECLARATION: 0,
    UNVERIFIED: 1
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.toObject = function(o) {
    return proto.google.protobuf.ExtensionRangeOptions.Declaration.toObject(o, this);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.toObject = function(o, a) {
    var i, u = {
      number: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      fullName: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      type: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      reserved: (i = e.Message.getBooleanField(a, 5)) == null ? void 0 : i,
      repeated: (i = e.Message.getBooleanField(a, 6)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.ExtensionRangeOptions.Declaration.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.ExtensionRangeOptions.Declaration();
    return proto.google.protobuf.ExtensionRangeOptions.Declaration.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNumber(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setFullName(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setType(u);
          break;
        case 5:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setReserved(u);
          break;
        case 6:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setRepeated(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.ExtensionRangeOptions.Declaration.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {number} */
    e.Message.getField(o, 1), i != null && a.writeInt32(
      1,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 2), i != null && a.writeString(
      2,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 3), i != null && a.writeString(
      3,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 5), i != null && a.writeBool(
      5,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 6), i != null && a.writeBool(
      6,
      i
    );
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.getNumber = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.setNumber = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.clearNumber = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.hasNumber = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.getFullName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.setFullName = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.clearFullName = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.hasFullName = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.getType = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.setType = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.clearType = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.hasType = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.getReserved = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.setReserved = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.clearReserved = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.hasReserved = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.getRepeated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 6, !1)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.setRepeated = function(o) {
    return e.Message.setField(this, 6, o);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.clearRepeated = function() {
    return e.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.ExtensionRangeOptions.Declaration.prototype.hasRepeated = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.getDeclarationList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.ExtensionRangeOptions.Declaration>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.ExtensionRangeOptions.Declaration, 2)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.setDeclarationList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 2, o);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.addDeclaration = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 2, o, proto.google.protobuf.ExtensionRangeOptions.Declaration, a);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.clearDeclarationList = function() {
    return this.setDeclarationList([]);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 50)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 50, o);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 50) != null;
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.getVerification = function() {
    return (
      /** @type {!proto.google.protobuf.ExtensionRangeOptions.VerificationState} */
      e.Message.getFieldWithDefault(this, 3, 1)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.setVerification = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.clearVerification = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.hasVerification = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FieldDescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.FieldDescriptorProto.toObject(o, this);
  }, proto.google.protobuf.FieldDescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      number: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      label: (i = e.Message.getField(a, 4)) == null ? void 0 : i,
      type: (i = e.Message.getField(a, 5)) == null ? void 0 : i,
      typeName: (i = e.Message.getField(a, 6)) == null ? void 0 : i,
      extendee: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      defaultValue: (i = e.Message.getField(a, 7)) == null ? void 0 : i,
      oneofIndex: (i = e.Message.getField(a, 9)) == null ? void 0 : i,
      jsonName: (i = e.Message.getField(a, 10)) == null ? void 0 : i,
      options: (i = a.getOptions()) && proto.google.protobuf.FieldOptions.toObject(o, i),
      proto3Optional: (i = e.Message.getBooleanField(a, 17)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FieldDescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FieldDescriptorProto();
    return proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setName(u);
          break;
        case 3:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNumber(u);
          break;
        case 4:
          var u = (
            /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */
            a.readEnum()
          );
          o.setLabel(u);
          break;
        case 5:
          var u = (
            /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */
            a.readEnum()
          );
          o.setType(u);
          break;
        case 6:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setTypeName(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setExtendee(u);
          break;
        case 7:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setDefaultValue(u);
          break;
        case 9:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setOneofIndex(u);
          break;
        case 10:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setJsonName(u);
          break;
        case 8:
          var u = new proto.google.protobuf.FieldOptions();
          a.readMessage(u, proto.google.protobuf.FieldOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        case 17:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setProto3Optional(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 3), i != null && a.writeInt32(
      3,
      i
    ), i = /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */
    e.Message.getField(o, 4), i != null && a.writeEnum(
      4,
      i
    ), i = /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */
    e.Message.getField(o, 5), i != null && a.writeEnum(
      5,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 6), i != null && a.writeString(
      6,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 2), i != null && a.writeString(
      2,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 7), i != null && a.writeString(
      7,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 9), i != null && a.writeInt32(
      9,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 10), i != null && a.writeString(
      10,
      i
    ), i = o.getOptions(), i != null && a.writeMessage(
      8,
      i,
      proto.google.protobuf.FieldOptions.serializeBinaryToWriter
    ), i = /** @type {boolean} */
    e.Message.getField(o, 17), i != null && a.writeBool(
      17,
      i
    );
  }, proto.google.protobuf.FieldDescriptorProto.Type = {
    TYPE_DOUBLE: 1,
    TYPE_FLOAT: 2,
    TYPE_INT64: 3,
    TYPE_UINT64: 4,
    TYPE_INT32: 5,
    TYPE_FIXED64: 6,
    TYPE_FIXED32: 7,
    TYPE_BOOL: 8,
    TYPE_STRING: 9,
    TYPE_GROUP: 10,
    TYPE_MESSAGE: 11,
    TYPE_BYTES: 12,
    TYPE_UINT32: 13,
    TYPE_ENUM: 14,
    TYPE_SFIXED32: 15,
    TYPE_SFIXED64: 16,
    TYPE_SINT32: 17,
    TYPE_SINT64: 18
  }, proto.google.protobuf.FieldDescriptorProto.Label = {
    LABEL_OPTIONAL: 1,
    LABEL_REPEATED: 3,
    LABEL_REQUIRED: 2
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getNumber = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setNumber = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearNumber = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasNumber = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getLabel = function() {
    return (
      /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */
      e.Message.getFieldWithDefault(this, 4, 1)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setLabel = function(o) {
    return e.Message.setField(this, 4, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearLabel = function() {
    return e.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasLabel = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getType = function() {
    return (
      /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */
      e.Message.getFieldWithDefault(this, 5, 1)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setType = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearType = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasType = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getTypeName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setTypeName = function(o) {
    return e.Message.setField(this, 6, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearTypeName = function() {
    return e.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasTypeName = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getExtendee = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setExtendee = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearExtendee = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasExtendee = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getDefaultValue = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setDefaultValue = function(o) {
    return e.Message.setField(this, 7, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearDefaultValue = function() {
    return e.Message.setField(this, 7, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasDefaultValue = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getOneofIndex = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 9, 0)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setOneofIndex = function(o) {
    return e.Message.setField(this, 9, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearOneofIndex = function() {
    return e.Message.setField(this, 9, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasOneofIndex = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getJsonName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 10, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setJsonName = function(o) {
    return e.Message.setField(this, 10, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearJsonName = function() {
    return e.Message.setField(this, 10, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasJsonName = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.FieldOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.FieldOptions, 8)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 8, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getProto3Optional = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 17, !1)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setProto3Optional = function(o) {
    return e.Message.setField(this, 17, o);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearProto3Optional = function() {
    return e.Message.setField(this, 17, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasProto3Optional = function() {
    return e.Message.getField(this, 17) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.OneofDescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.OneofDescriptorProto.toObject(o, this);
  }, proto.google.protobuf.OneofDescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      options: (i = a.getOptions()) && proto.google.protobuf.OneofOptions.toObject(o, i)
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.OneofDescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.OneofDescriptorProto();
    return proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setName(u);
          break;
        case 2:
          var u = new proto.google.protobuf.OneofOptions();
          a.readMessage(u, proto.google.protobuf.OneofOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.OneofDescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = o.getOptions(), i != null && a.writeMessage(
      2,
      i,
      proto.google.protobuf.OneofOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.OneofDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.OneofDescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.OneofDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.OneofOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.OneofOptions, 2)
    );
  }, proto.google.protobuf.OneofDescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 2, o);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumDescriptorProto.repeatedFields_ = [2, 4, 5], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumDescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.EnumDescriptorProto.toObject(o, this);
  }, proto.google.protobuf.EnumDescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      valueList: e.Message.toObjectList(
        a.getValueList(),
        proto.google.protobuf.EnumValueDescriptorProto.toObject,
        o
      ),
      options: (i = a.getOptions()) && proto.google.protobuf.EnumOptions.toObject(o, i),
      reservedRangeList: e.Message.toObjectList(
        a.getReservedRangeList(),
        proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject,
        o
      ),
      reservedNameList: (i = e.Message.getRepeatedField(a, 5)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.EnumDescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.EnumDescriptorProto();
    return proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setName(u);
          break;
        case 2:
          var u = new proto.google.protobuf.EnumValueDescriptorProto();
          a.readMessage(u, proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader), o.addValue(u);
          break;
        case 3:
          var u = new proto.google.protobuf.EnumOptions();
          a.readMessage(u, proto.google.protobuf.EnumOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        case 4:
          var u = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange();
          a.readMessage(u, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader), o.addReservedRange(u);
          break;
        case 5:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.addReservedName(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = o.getValueList(), i.length > 0 && a.writeRepeatedMessage(
      2,
      i,
      proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter
    ), i = o.getOptions(), i != null && a.writeMessage(
      3,
      i,
      proto.google.protobuf.EnumOptions.serializeBinaryToWriter
    ), i = o.getReservedRangeList(), i.length > 0 && a.writeRepeatedMessage(
      4,
      i,
      proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter
    ), i = o.getReservedNameList(), i.length > 0 && a.writeRepeatedString(
      5,
      i
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.toObject = function(o) {
    return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject(o, this);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject = function(o, a) {
    var i, u = {
      start: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      end: (i = e.Message.getField(a, 2)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange();
    return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setStart(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setEnd(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {number} */
    e.Message.getField(o, 1), i != null && a.writeInt32(
      1,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 2), i != null && a.writeInt32(
      2,
      i
    );
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getStart = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setStart = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearStart = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasStart = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getEnd = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setEnd = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearEnd = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasEnd = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getValueList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumValueDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumValueDescriptorProto, 2)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setValueList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 2, o);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.addValue = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 2, o, proto.google.protobuf.EnumValueDescriptorProto, a);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearValueList = function() {
    return this.setValueList([]);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.EnumOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.EnumOptions, 3)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 3, o);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getReservedRangeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, 4)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setReservedRangeList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 4, o);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.addReservedRange = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 4, o, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, a);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedRangeList = function() {
    return this.setReservedRangeList([]);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getReservedNameList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 5)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setReservedNameList = function(o) {
    return e.Message.setField(this, 5, o || []);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.addReservedName = function(o, a) {
    return e.Message.addToRepeatedField(this, 5, o, a);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedNameList = function() {
    return this.setReservedNameList([]);
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumValueDescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.EnumValueDescriptorProto.toObject(o, this);
  }, proto.google.protobuf.EnumValueDescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      number: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      options: (i = a.getOptions()) && proto.google.protobuf.EnumValueOptions.toObject(o, i)
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.EnumValueDescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.EnumValueDescriptorProto();
    return proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setName(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNumber(u);
          break;
        case 3:
          var u = new proto.google.protobuf.EnumValueOptions();
          a.readMessage(u, proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 2), i != null && a.writeInt32(
      2,
      i
    ), i = o.getOptions(), i != null && a.writeMessage(
      3,
      i,
      proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.getNumber = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.setNumber = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.clearNumber = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.hasNumber = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.EnumValueOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.EnumValueOptions, 3)
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 3, o);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.ServiceDescriptorProto.repeatedFields_ = [2], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.ServiceDescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.ServiceDescriptorProto.toObject(o, this);
  }, proto.google.protobuf.ServiceDescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      methodList: e.Message.toObjectList(
        a.getMethodList(),
        proto.google.protobuf.MethodDescriptorProto.toObject,
        o
      ),
      options: (i = a.getOptions()) && proto.google.protobuf.ServiceOptions.toObject(o, i)
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.ServiceDescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.ServiceDescriptorProto();
    return proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setName(u);
          break;
        case 2:
          var u = new proto.google.protobuf.MethodDescriptorProto();
          a.readMessage(u, proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader), o.addMethod(u);
          break;
        case 3:
          var u = new proto.google.protobuf.ServiceOptions();
          a.readMessage(u, proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = o.getMethodList(), i.length > 0 && a.writeRepeatedMessage(
      2,
      i,
      proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter
    ), i = o.getOptions(), i != null && a.writeMessage(
      3,
      i,
      proto.google.protobuf.ServiceOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.getMethodList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.MethodDescriptorProto>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.MethodDescriptorProto, 2)
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.setMethodList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 2, o);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.addMethod = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 2, o, proto.google.protobuf.MethodDescriptorProto, a);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.clearMethodList = function() {
    return this.setMethodList([]);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.ServiceOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.ServiceOptions, 3)
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 3, o);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.MethodDescriptorProto.prototype.toObject = function(o) {
    return proto.google.protobuf.MethodDescriptorProto.toObject(o, this);
  }, proto.google.protobuf.MethodDescriptorProto.toObject = function(o, a) {
    var i, u = {
      name: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      inputType: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      outputType: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      options: (i = a.getOptions()) && proto.google.protobuf.MethodOptions.toObject(o, i),
      clientStreaming: e.Message.getBooleanFieldWithDefault(a, 5, !1),
      serverStreaming: e.Message.getBooleanFieldWithDefault(a, 6, !1)
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.MethodDescriptorProto.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.MethodDescriptorProto();
    return proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setName(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setInputType(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setOutputType(u);
          break;
        case 4:
          var u = new proto.google.protobuf.MethodOptions();
          a.readMessage(u, proto.google.protobuf.MethodOptions.deserializeBinaryFromReader), o.setOptions(u);
          break;
        case 5:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setClientStreaming(u);
          break;
        case 6:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setServerStreaming(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 2), i != null && a.writeString(
      2,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 3), i != null && a.writeString(
      3,
      i
    ), i = o.getOptions(), i != null && a.writeMessage(
      4,
      i,
      proto.google.protobuf.MethodOptions.serializeBinaryToWriter
    ), i = /** @type {boolean} */
    e.Message.getField(o, 5), i != null && a.writeBool(
      5,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 6), i != null && a.writeBool(
      6,
      i
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setName = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearName = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getInputType = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setInputType = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearInputType = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasInputType = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getOutputType = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setOutputType = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearOutputType = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasOutputType = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.MethodOptions} */
      e.Message.getWrapperField(this, proto.google.protobuf.MethodOptions, 4)
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setOptions = function(o) {
    return e.Message.setWrapperField(this, 4, o);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasOptions = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getClientStreaming = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setClientStreaming = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearClientStreaming = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasClientStreaming = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getServerStreaming = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 6, !1)
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setServerStreaming = function(o) {
    return e.Message.setField(this, 6, o);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearServerStreaming = function() {
    return e.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasServerStreaming = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.protobuf.FileOptions.repeatedFields_ = [999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FileOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.FileOptions.toObject(o, this);
  }, proto.google.protobuf.FileOptions.toObject = function(o, a) {
    var i, u = {
      javaPackage: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      javaOuterClassname: (i = e.Message.getField(a, 8)) == null ? void 0 : i,
      javaMultipleFiles: e.Message.getBooleanFieldWithDefault(a, 10, !1),
      javaGenerateEqualsAndHash: (i = e.Message.getBooleanField(a, 20)) == null ? void 0 : i,
      javaStringCheckUtf8: e.Message.getBooleanFieldWithDefault(a, 27, !1),
      optimizeFor: e.Message.getFieldWithDefault(a, 9, 1),
      goPackage: (i = e.Message.getField(a, 11)) == null ? void 0 : i,
      ccGenericServices: e.Message.getBooleanFieldWithDefault(a, 16, !1),
      javaGenericServices: e.Message.getBooleanFieldWithDefault(a, 17, !1),
      pyGenericServices: e.Message.getBooleanFieldWithDefault(a, 18, !1),
      deprecated: e.Message.getBooleanFieldWithDefault(a, 23, !1),
      ccEnableArenas: e.Message.getBooleanFieldWithDefault(a, 31, !0),
      objcClassPrefix: (i = e.Message.getField(a, 36)) == null ? void 0 : i,
      csharpNamespace: (i = e.Message.getField(a, 37)) == null ? void 0 : i,
      swiftPrefix: (i = e.Message.getField(a, 39)) == null ? void 0 : i,
      phpClassPrefix: (i = e.Message.getField(a, 40)) == null ? void 0 : i,
      phpNamespace: (i = e.Message.getField(a, 41)) == null ? void 0 : i,
      phpMetadataNamespace: (i = e.Message.getField(a, 44)) == null ? void 0 : i,
      rubyPackage: (i = e.Message.getField(a, 45)) == null ? void 0 : i,
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.FileOptions.extensions,
      proto.google.protobuf.FileOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FileOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FileOptions();
    return proto.google.protobuf.FileOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FileOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setJavaPackage(u);
          break;
        case 8:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setJavaOuterClassname(u);
          break;
        case 10:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setJavaMultipleFiles(u);
          break;
        case 20:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setJavaGenerateEqualsAndHash(u);
          break;
        case 27:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setJavaStringCheckUtf8(u);
          break;
        case 9:
          var u = (
            /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */
            a.readEnum()
          );
          o.setOptimizeFor(u);
          break;
        case 11:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setGoPackage(u);
          break;
        case 16:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setCcGenericServices(u);
          break;
        case 17:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setJavaGenericServices(u);
          break;
        case 18:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setPyGenericServices(u);
          break;
        case 23:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecated(u);
          break;
        case 31:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setCcEnableArenas(u);
          break;
        case 36:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setObjcClassPrefix(u);
          break;
        case 37:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setCsharpNamespace(u);
          break;
        case 39:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setSwiftPrefix(u);
          break;
        case 40:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPhpClassPrefix(u);
          break;
        case 41:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPhpNamespace(u);
          break;
        case 44:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPhpMetadataNamespace(u);
          break;
        case 45:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setRubyPackage(u);
          break;
        case 50:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.FileOptions.extensionsBinary,
            proto.google.protobuf.FileOptions.prototype.getExtension,
            proto.google.protobuf.FileOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FileOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FileOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FileOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 8), i != null && a.writeString(
      8,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 10), i != null && a.writeBool(
      10,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 20), i != null && a.writeBool(
      20,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 27), i != null && a.writeBool(
      27,
      i
    ), i = /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */
    e.Message.getField(o, 9), i != null && a.writeEnum(
      9,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 11), i != null && a.writeString(
      11,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 16), i != null && a.writeBool(
      16,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 17), i != null && a.writeBool(
      17,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 18), i != null && a.writeBool(
      18,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 23), i != null && a.writeBool(
      23,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 31), i != null && a.writeBool(
      31,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 36), i != null && a.writeString(
      36,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 37), i != null && a.writeString(
      37,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 39), i != null && a.writeString(
      39,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 40), i != null && a.writeString(
      40,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 41), i != null && a.writeString(
      41,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 44), i != null && a.writeString(
      44,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 45), i != null && a.writeString(
      45,
      i
    ), i = o.getFeatures(), i != null && a.writeMessage(
      50,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.FileOptions.extensionsBinary,
      proto.google.protobuf.FileOptions.prototype.getExtension
    );
  }, proto.google.protobuf.FileOptions.OptimizeMode = {
    SPEED: 1,
    CODE_SIZE: 2,
    LITE_RUNTIME: 3
  }, proto.google.protobuf.FileOptions.prototype.getJavaPackage = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaPackage = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaPackage = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaPackage = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaOuterClassname = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 8, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaOuterClassname = function(o) {
    return e.Message.setField(this, 8, o);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaOuterClassname = function() {
    return e.Message.setField(this, 8, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaOuterClassname = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaMultipleFiles = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 10, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaMultipleFiles = function(o) {
    return e.Message.setField(this, 10, o);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaMultipleFiles = function() {
    return e.Message.setField(this, 10, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaMultipleFiles = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaGenerateEqualsAndHash = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 20, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaGenerateEqualsAndHash = function(o) {
    return e.Message.setField(this, 20, o);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaGenerateEqualsAndHash = function() {
    return e.Message.setField(this, 20, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaGenerateEqualsAndHash = function() {
    return e.Message.getField(this, 20) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaStringCheckUtf8 = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 27, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaStringCheckUtf8 = function(o) {
    return e.Message.setField(this, 27, o);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaStringCheckUtf8 = function() {
    return e.Message.setField(this, 27, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaStringCheckUtf8 = function() {
    return e.Message.getField(this, 27) != null;
  }, proto.google.protobuf.FileOptions.prototype.getOptimizeFor = function() {
    return (
      /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */
      e.Message.getFieldWithDefault(this, 9, 1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setOptimizeFor = function(o) {
    return e.Message.setField(this, 9, o);
  }, proto.google.protobuf.FileOptions.prototype.clearOptimizeFor = function() {
    return e.Message.setField(this, 9, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasOptimizeFor = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.google.protobuf.FileOptions.prototype.getGoPackage = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setGoPackage = function(o) {
    return e.Message.setField(this, 11, o);
  }, proto.google.protobuf.FileOptions.prototype.clearGoPackage = function() {
    return e.Message.setField(this, 11, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasGoPackage = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.google.protobuf.FileOptions.prototype.getCcGenericServices = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 16, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setCcGenericServices = function(o) {
    return e.Message.setField(this, 16, o);
  }, proto.google.protobuf.FileOptions.prototype.clearCcGenericServices = function() {
    return e.Message.setField(this, 16, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasCcGenericServices = function() {
    return e.Message.getField(this, 16) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaGenericServices = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 17, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaGenericServices = function(o) {
    return e.Message.setField(this, 17, o);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaGenericServices = function() {
    return e.Message.setField(this, 17, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaGenericServices = function() {
    return e.Message.getField(this, 17) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPyGenericServices = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 18, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setPyGenericServices = function(o) {
    return e.Message.setField(this, 18, o);
  }, proto.google.protobuf.FileOptions.prototype.clearPyGenericServices = function() {
    return e.Message.setField(this, 18, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPyGenericServices = function() {
    return e.Message.getField(this, 18) != null;
  }, proto.google.protobuf.FileOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 23, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setDeprecated = function(o) {
    return e.Message.setField(this, 23, o);
  }, proto.google.protobuf.FileOptions.prototype.clearDeprecated = function() {
    return e.Message.setField(this, 23, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasDeprecated = function() {
    return e.Message.getField(this, 23) != null;
  }, proto.google.protobuf.FileOptions.prototype.getCcEnableArenas = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 31, !0)
    );
  }, proto.google.protobuf.FileOptions.prototype.setCcEnableArenas = function(o) {
    return e.Message.setField(this, 31, o);
  }, proto.google.protobuf.FileOptions.prototype.clearCcEnableArenas = function() {
    return e.Message.setField(this, 31, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasCcEnableArenas = function() {
    return e.Message.getField(this, 31) != null;
  }, proto.google.protobuf.FileOptions.prototype.getObjcClassPrefix = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 36, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setObjcClassPrefix = function(o) {
    return e.Message.setField(this, 36, o);
  }, proto.google.protobuf.FileOptions.prototype.clearObjcClassPrefix = function() {
    return e.Message.setField(this, 36, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasObjcClassPrefix = function() {
    return e.Message.getField(this, 36) != null;
  }, proto.google.protobuf.FileOptions.prototype.getCsharpNamespace = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 37, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setCsharpNamespace = function(o) {
    return e.Message.setField(this, 37, o);
  }, proto.google.protobuf.FileOptions.prototype.clearCsharpNamespace = function() {
    return e.Message.setField(this, 37, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasCsharpNamespace = function() {
    return e.Message.getField(this, 37) != null;
  }, proto.google.protobuf.FileOptions.prototype.getSwiftPrefix = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 39, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setSwiftPrefix = function(o) {
    return e.Message.setField(this, 39, o);
  }, proto.google.protobuf.FileOptions.prototype.clearSwiftPrefix = function() {
    return e.Message.setField(this, 39, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasSwiftPrefix = function() {
    return e.Message.getField(this, 39) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPhpClassPrefix = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 40, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setPhpClassPrefix = function(o) {
    return e.Message.setField(this, 40, o);
  }, proto.google.protobuf.FileOptions.prototype.clearPhpClassPrefix = function() {
    return e.Message.setField(this, 40, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPhpClassPrefix = function() {
    return e.Message.getField(this, 40) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPhpNamespace = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 41, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setPhpNamespace = function(o) {
    return e.Message.setField(this, 41, o);
  }, proto.google.protobuf.FileOptions.prototype.clearPhpNamespace = function() {
    return e.Message.setField(this, 41, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPhpNamespace = function() {
    return e.Message.getField(this, 41) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPhpMetadataNamespace = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 44, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setPhpMetadataNamespace = function(o) {
    return e.Message.setField(this, 44, o);
  }, proto.google.protobuf.FileOptions.prototype.clearPhpMetadataNamespace = function() {
    return e.Message.setField(this, 44, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPhpMetadataNamespace = function() {
    return e.Message.getField(this, 44) != null;
  }, proto.google.protobuf.FileOptions.prototype.getRubyPackage = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 45, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setRubyPackage = function(o) {
    return e.Message.setField(this, 45, o);
  }, proto.google.protobuf.FileOptions.prototype.clearRubyPackage = function() {
    return e.Message.setField(this, 45, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasRubyPackage = function() {
    return e.Message.getField(this, 45) != null;
  }, proto.google.protobuf.FileOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 50)
    );
  }, proto.google.protobuf.FileOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 50, o);
  }, proto.google.protobuf.FileOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 50) != null;
  }, proto.google.protobuf.FileOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.FileOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.FileOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.FileOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.MessageOptions.repeatedFields_ = [999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.MessageOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.MessageOptions.toObject(o, this);
  }, proto.google.protobuf.MessageOptions.toObject = function(o, a) {
    var i, u = {
      messageSetWireFormat: e.Message.getBooleanFieldWithDefault(a, 1, !1),
      noStandardDescriptorAccessor: e.Message.getBooleanFieldWithDefault(a, 2, !1),
      deprecated: e.Message.getBooleanFieldWithDefault(a, 3, !1),
      mapEntry: (i = e.Message.getBooleanField(a, 7)) == null ? void 0 : i,
      deprecatedLegacyJsonFieldConflicts: (i = e.Message.getBooleanField(a, 11)) == null ? void 0 : i,
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.MessageOptions.extensions,
      proto.google.protobuf.MessageOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.MessageOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.MessageOptions();
    return proto.google.protobuf.MessageOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.MessageOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setMessageSetWireFormat(u);
          break;
        case 2:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setNoStandardDescriptorAccessor(u);
          break;
        case 3:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecated(u);
          break;
        case 7:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setMapEntry(u);
          break;
        case 11:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecatedLegacyJsonFieldConflicts(u);
          break;
        case 12:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.MessageOptions.extensionsBinary,
            proto.google.protobuf.MessageOptions.prototype.getExtension,
            proto.google.protobuf.MessageOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.MessageOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.MessageOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.MessageOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {boolean} */
    e.Message.getField(o, 1), i != null && a.writeBool(
      1,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 2), i != null && a.writeBool(
      2,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 3), i != null && a.writeBool(
      3,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 7), i != null && a.writeBool(
      7,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 11), i != null && a.writeBool(
      11,
      i
    ), i = o.getFeatures(), i != null && a.writeMessage(
      12,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.MessageOptions.extensionsBinary,
      proto.google.protobuf.MessageOptions.prototype.getExtension
    );
  }, proto.google.protobuf.MessageOptions.prototype.getMessageSetWireFormat = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setMessageSetWireFormat = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.MessageOptions.prototype.clearMessageSetWireFormat = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasMessageSetWireFormat = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getNoStandardDescriptorAccessor = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setNoStandardDescriptorAccessor = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.MessageOptions.prototype.clearNoStandardDescriptorAccessor = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasNoStandardDescriptorAccessor = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setDeprecated = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.MessageOptions.prototype.clearDeprecated = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasDeprecated = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getMapEntry = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 7, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setMapEntry = function(o) {
    return e.Message.setField(this, 7, o);
  }, proto.google.protobuf.MessageOptions.prototype.clearMapEntry = function() {
    return e.Message.setField(this, 7, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasMapEntry = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getDeprecatedLegacyJsonFieldConflicts = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 11, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setDeprecatedLegacyJsonFieldConflicts = function(o) {
    return e.Message.setField(this, 11, o);
  }, proto.google.protobuf.MessageOptions.prototype.clearDeprecatedLegacyJsonFieldConflicts = function() {
    return e.Message.setField(this, 11, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasDeprecatedLegacyJsonFieldConflicts = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 12)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 12, o);
  }, proto.google.protobuf.MessageOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.MessageOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.MessageOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.FieldOptions.repeatedFields_ = [19, 20, 999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FieldOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.FieldOptions.toObject(o, this);
  }, proto.google.protobuf.FieldOptions.toObject = function(o, a) {
    var i, u = {
      ctype: e.Message.getFieldWithDefault(a, 1, 0),
      packed: (i = e.Message.getBooleanField(a, 2)) == null ? void 0 : i,
      jstype: e.Message.getFieldWithDefault(a, 6, 0),
      lazy: e.Message.getBooleanFieldWithDefault(a, 5, !1),
      unverifiedLazy: e.Message.getBooleanFieldWithDefault(a, 15, !1),
      deprecated: e.Message.getBooleanFieldWithDefault(a, 3, !1),
      weak: e.Message.getBooleanFieldWithDefault(a, 10, !1),
      debugRedact: e.Message.getBooleanFieldWithDefault(a, 16, !1),
      retention: (i = e.Message.getField(a, 17)) == null ? void 0 : i,
      targetsList: (i = e.Message.getRepeatedField(a, 19)) == null ? void 0 : i,
      editionDefaultsList: e.Message.toObjectList(
        a.getEditionDefaultsList(),
        proto.google.protobuf.FieldOptions.EditionDefault.toObject,
        o
      ),
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      featureSupport: (i = a.getFeatureSupport()) && proto.google.protobuf.FieldOptions.FeatureSupport.toObject(o, i),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.FieldOptions.extensions,
      proto.google.protobuf.FieldOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FieldOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FieldOptions();
    return proto.google.protobuf.FieldOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FieldOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var h = (
            /** @type {!proto.google.protobuf.FieldOptions.CType} */
            a.readEnum()
          );
          o.setCtype(h);
          break;
        case 2:
          var h = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setPacked(h);
          break;
        case 6:
          var h = (
            /** @type {!proto.google.protobuf.FieldOptions.JSType} */
            a.readEnum()
          );
          o.setJstype(h);
          break;
        case 5:
          var h = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setLazy(h);
          break;
        case 15:
          var h = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setUnverifiedLazy(h);
          break;
        case 3:
          var h = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecated(h);
          break;
        case 10:
          var h = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setWeak(h);
          break;
        case 16:
          var h = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDebugRedact(h);
          break;
        case 17:
          var h = (
            /** @type {!proto.google.protobuf.FieldOptions.OptionRetention} */
            a.readEnum()
          );
          o.setRetention(h);
          break;
        case 19:
          for (var u = (
            /** @type {!Array<!proto.google.protobuf.FieldOptions.OptionTargetType>} */
            a.isDelimited() ? a.readPackedEnum() : [a.readEnum()]
          ), y = 0; y < u.length; y++)
            o.addTargets(u[y]);
          break;
        case 20:
          var h = new proto.google.protobuf.FieldOptions.EditionDefault();
          a.readMessage(h, proto.google.protobuf.FieldOptions.EditionDefault.deserializeBinaryFromReader), o.addEditionDefaults(h);
          break;
        case 21:
          var h = new proto.google.protobuf.FeatureSet();
          a.readMessage(h, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(h);
          break;
        case 22:
          var h = new proto.google.protobuf.FieldOptions.FeatureSupport();
          a.readMessage(h, proto.google.protobuf.FieldOptions.FeatureSupport.deserializeBinaryFromReader), o.setFeatureSupport(h);
          break;
        case 999:
          var h = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(h, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(h);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.FieldOptions.extensionsBinary,
            proto.google.protobuf.FieldOptions.prototype.getExtension,
            proto.google.protobuf.FieldOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FieldOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FieldOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FieldOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {!proto.google.protobuf.FieldOptions.CType} */
    e.Message.getField(o, 1), i != null && a.writeEnum(
      1,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 2), i != null && a.writeBool(
      2,
      i
    ), i = /** @type {!proto.google.protobuf.FieldOptions.JSType} */
    e.Message.getField(o, 6), i != null && a.writeEnum(
      6,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 5), i != null && a.writeBool(
      5,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 15), i != null && a.writeBool(
      15,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 3), i != null && a.writeBool(
      3,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 10), i != null && a.writeBool(
      10,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 16), i != null && a.writeBool(
      16,
      i
    ), i = /** @type {!proto.google.protobuf.FieldOptions.OptionRetention} */
    e.Message.getField(o, 17), i != null && a.writeEnum(
      17,
      i
    ), i = o.getTargetsList(), i.length > 0 && a.writeRepeatedEnum(
      19,
      i
    ), i = o.getEditionDefaultsList(), i.length > 0 && a.writeRepeatedMessage(
      20,
      i,
      proto.google.protobuf.FieldOptions.EditionDefault.serializeBinaryToWriter
    ), i = o.getFeatures(), i != null && a.writeMessage(
      21,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = o.getFeatureSupport(), i != null && a.writeMessage(
      22,
      i,
      proto.google.protobuf.FieldOptions.FeatureSupport.serializeBinaryToWriter
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.FieldOptions.extensionsBinary,
      proto.google.protobuf.FieldOptions.prototype.getExtension
    );
  }, proto.google.protobuf.FieldOptions.CType = {
    STRING: 0,
    CORD: 1,
    STRING_PIECE: 2
  }, proto.google.protobuf.FieldOptions.JSType = {
    JS_NORMAL: 0,
    JS_STRING: 1,
    JS_NUMBER: 2
  }, proto.google.protobuf.FieldOptions.OptionRetention = {
    RETENTION_UNKNOWN: 0,
    RETENTION_RUNTIME: 1,
    RETENTION_SOURCE: 2
  }, proto.google.protobuf.FieldOptions.OptionTargetType = {
    TARGET_TYPE_UNKNOWN: 0,
    TARGET_TYPE_FILE: 1,
    TARGET_TYPE_EXTENSION_RANGE: 2,
    TARGET_TYPE_MESSAGE: 3,
    TARGET_TYPE_FIELD: 4,
    TARGET_TYPE_ONEOF: 5,
    TARGET_TYPE_ENUM: 6,
    TARGET_TYPE_ENUM_ENTRY: 7,
    TARGET_TYPE_SERVICE: 8,
    TARGET_TYPE_METHOD: 9
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FieldOptions.EditionDefault.prototype.toObject = function(o) {
    return proto.google.protobuf.FieldOptions.EditionDefault.toObject(o, this);
  }, proto.google.protobuf.FieldOptions.EditionDefault.toObject = function(o, a) {
    var i, u = {
      edition: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      value: (i = e.Message.getField(a, 2)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FieldOptions.EditionDefault.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FieldOptions.EditionDefault();
    return proto.google.protobuf.FieldOptions.EditionDefault.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FieldOptions.EditionDefault.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 3:
          var u = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setEdition(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FieldOptions.EditionDefault.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FieldOptions.EditionDefault.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 3), i != null && a.writeEnum(
      3,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 2), i != null && a.writeString(
      2,
      i
    );
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.getEdition = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.setEdition = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.clearEdition = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.hasEdition = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.getValue = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.setValue = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.clearValue = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FieldOptions.EditionDefault.prototype.hasValue = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FieldOptions.FeatureSupport.prototype.toObject = function(o) {
    return proto.google.protobuf.FieldOptions.FeatureSupport.toObject(o, this);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.toObject = function(o, a) {
    var i, u = {
      editionIntroduced: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      editionDeprecated: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      deprecationWarning: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      editionRemoved: (i = e.Message.getField(a, 4)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FieldOptions.FeatureSupport.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FieldOptions.FeatureSupport();
    return proto.google.protobuf.FieldOptions.FeatureSupport.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setEditionIntroduced(u);
          break;
        case 2:
          var u = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setEditionDeprecated(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setDeprecationWarning(u);
          break;
        case 4:
          var u = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setEditionRemoved(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FieldOptions.FeatureSupport.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FieldOptions.FeatureSupport.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 1), i != null && a.writeEnum(
      1,
      i
    ), i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 2), i != null && a.writeEnum(
      2,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 3), i != null && a.writeString(
      3,
      i
    ), i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 4), i != null && a.writeEnum(
      4,
      i
    );
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.getEditionIntroduced = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.setEditionIntroduced = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.clearEditionIntroduced = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.hasEditionIntroduced = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.getEditionDeprecated = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.setEditionDeprecated = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.clearEditionDeprecated = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.hasEditionDeprecated = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.getDeprecationWarning = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.setDeprecationWarning = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.clearDeprecationWarning = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.hasDeprecationWarning = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.getEditionRemoved = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.setEditionRemoved = function(o) {
    return e.Message.setField(this, 4, o);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.clearEditionRemoved = function() {
    return e.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.FieldOptions.FeatureSupport.prototype.hasEditionRemoved = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getCtype = function() {
    return (
      /** @type {!proto.google.protobuf.FieldOptions.CType} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setCtype = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearCtype = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasCtype = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getPacked = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setPacked = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearPacked = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasPacked = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getJstype = function() {
    return (
      /** @type {!proto.google.protobuf.FieldOptions.JSType} */
      e.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setJstype = function(o) {
    return e.Message.setField(this, 6, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearJstype = function() {
    return e.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasJstype = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getLazy = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setLazy = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearLazy = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasLazy = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getUnverifiedLazy = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 15, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setUnverifiedLazy = function(o) {
    return e.Message.setField(this, 15, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearUnverifiedLazy = function() {
    return e.Message.setField(this, 15, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasUnverifiedLazy = function() {
    return e.Message.getField(this, 15) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setDeprecated = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearDeprecated = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasDeprecated = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getWeak = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 10, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setWeak = function(o) {
    return e.Message.setField(this, 10, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearWeak = function() {
    return e.Message.setField(this, 10, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasWeak = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getDebugRedact = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 16, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setDebugRedact = function(o) {
    return e.Message.setField(this, 16, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearDebugRedact = function() {
    return e.Message.setField(this, 16, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasDebugRedact = function() {
    return e.Message.getField(this, 16) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getRetention = function() {
    return (
      /** @type {!proto.google.protobuf.FieldOptions.OptionRetention} */
      e.Message.getFieldWithDefault(this, 17, 0)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setRetention = function(o) {
    return e.Message.setField(this, 17, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearRetention = function() {
    return e.Message.setField(this, 17, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasRetention = function() {
    return e.Message.getField(this, 17) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getTargetsList = function() {
    return (
      /** @type {!Array<!proto.google.protobuf.FieldOptions.OptionTargetType>} */
      e.Message.getRepeatedField(this, 19)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setTargetsList = function(o) {
    return e.Message.setField(this, 19, o || []);
  }, proto.google.protobuf.FieldOptions.prototype.addTargets = function(o, a) {
    return e.Message.addToRepeatedField(this, 19, o, a);
  }, proto.google.protobuf.FieldOptions.prototype.clearTargetsList = function() {
    return this.setTargetsList([]);
  }, proto.google.protobuf.FieldOptions.prototype.getEditionDefaultsList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FieldOptions.EditionDefault>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldOptions.EditionDefault, 20)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setEditionDefaultsList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 20, o);
  }, proto.google.protobuf.FieldOptions.prototype.addEditionDefaults = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 20, o, proto.google.protobuf.FieldOptions.EditionDefault, a);
  }, proto.google.protobuf.FieldOptions.prototype.clearEditionDefaultsList = function() {
    return this.setEditionDefaultsList([]);
  }, proto.google.protobuf.FieldOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 21)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 21, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 21) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getFeatureSupport = function() {
    return (
      /** @type{?proto.google.protobuf.FieldOptions.FeatureSupport} */
      e.Message.getWrapperField(this, proto.google.protobuf.FieldOptions.FeatureSupport, 22)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setFeatureSupport = function(o) {
    return e.Message.setWrapperField(this, 22, o);
  }, proto.google.protobuf.FieldOptions.prototype.clearFeatureSupport = function() {
    return this.setFeatureSupport(void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasFeatureSupport = function() {
    return e.Message.getField(this, 22) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.FieldOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.FieldOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.OneofOptions.repeatedFields_ = [999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.OneofOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.OneofOptions.toObject(o, this);
  }, proto.google.protobuf.OneofOptions.toObject = function(o, a) {
    var i, u = {
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.OneofOptions.extensions,
      proto.google.protobuf.OneofOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.OneofOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.OneofOptions();
    return proto.google.protobuf.OneofOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.OneofOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.OneofOptions.extensionsBinary,
            proto.google.protobuf.OneofOptions.prototype.getExtension,
            proto.google.protobuf.OneofOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.OneofOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.OneofOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.OneofOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getFeatures(), i != null && a.writeMessage(
      1,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.OneofOptions.extensionsBinary,
      proto.google.protobuf.OneofOptions.prototype.getExtension
    );
  }, proto.google.protobuf.OneofOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 1)
    );
  }, proto.google.protobuf.OneofOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 1, o);
  }, proto.google.protobuf.OneofOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.OneofOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.OneofOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.OneofOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.OneofOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.OneofOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.EnumOptions.repeatedFields_ = [999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.EnumOptions.toObject(o, this);
  }, proto.google.protobuf.EnumOptions.toObject = function(o, a) {
    var i, u = {
      allowAlias: (i = e.Message.getBooleanField(a, 2)) == null ? void 0 : i,
      deprecated: e.Message.getBooleanFieldWithDefault(a, 3, !1),
      deprecatedLegacyJsonFieldConflicts: (i = e.Message.getBooleanField(a, 6)) == null ? void 0 : i,
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.EnumOptions.extensions,
      proto.google.protobuf.EnumOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.EnumOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.EnumOptions();
    return proto.google.protobuf.EnumOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.EnumOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 2:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setAllowAlias(u);
          break;
        case 3:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecated(u);
          break;
        case 6:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecatedLegacyJsonFieldConflicts(u);
          break;
        case 7:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.EnumOptions.extensionsBinary,
            proto.google.protobuf.EnumOptions.prototype.getExtension,
            proto.google.protobuf.EnumOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.EnumOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.EnumOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.EnumOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {boolean} */
    e.Message.getField(o, 2), i != null && a.writeBool(
      2,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 3), i != null && a.writeBool(
      3,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 6), i != null && a.writeBool(
      6,
      i
    ), i = o.getFeatures(), i != null && a.writeMessage(
      7,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.EnumOptions.extensionsBinary,
      proto.google.protobuf.EnumOptions.prototype.getExtension
    );
  }, proto.google.protobuf.EnumOptions.prototype.getAllowAlias = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setAllowAlias = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.EnumOptions.prototype.clearAllowAlias = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.EnumOptions.prototype.hasAllowAlias = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setDeprecated = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.EnumOptions.prototype.clearDeprecated = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.EnumOptions.prototype.hasDeprecated = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.EnumOptions.prototype.getDeprecatedLegacyJsonFieldConflicts = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 6, !1)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setDeprecatedLegacyJsonFieldConflicts = function(o) {
    return e.Message.setField(this, 6, o);
  }, proto.google.protobuf.EnumOptions.prototype.clearDeprecatedLegacyJsonFieldConflicts = function() {
    return e.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.EnumOptions.prototype.hasDeprecatedLegacyJsonFieldConflicts = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.protobuf.EnumOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 7)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 7, o);
  }, proto.google.protobuf.EnumOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.EnumOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.google.protobuf.EnumOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.EnumOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.EnumOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.EnumValueOptions.repeatedFields_ = [999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumValueOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.EnumValueOptions.toObject(o, this);
  }, proto.google.protobuf.EnumValueOptions.toObject = function(o, a) {
    var i, u = {
      deprecated: e.Message.getBooleanFieldWithDefault(a, 1, !1),
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      debugRedact: e.Message.getBooleanFieldWithDefault(a, 3, !1),
      featureSupport: (i = a.getFeatureSupport()) && proto.google.protobuf.FieldOptions.FeatureSupport.toObject(o, i),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.EnumValueOptions.extensions,
      proto.google.protobuf.EnumValueOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.EnumValueOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.EnumValueOptions();
    return proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecated(u);
          break;
        case 2:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 3:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDebugRedact(u);
          break;
        case 4:
          var u = new proto.google.protobuf.FieldOptions.FeatureSupport();
          a.readMessage(u, proto.google.protobuf.FieldOptions.FeatureSupport.deserializeBinaryFromReader), o.setFeatureSupport(u);
          break;
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.EnumValueOptions.extensionsBinary,
            proto.google.protobuf.EnumValueOptions.prototype.getExtension,
            proto.google.protobuf.EnumValueOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.EnumValueOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {boolean} */
    e.Message.getField(o, 1), i != null && a.writeBool(
      1,
      i
    ), i = o.getFeatures(), i != null && a.writeMessage(
      2,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = /** @type {boolean} */
    e.Message.getField(o, 3), i != null && a.writeBool(
      3,
      i
    ), i = o.getFeatureSupport(), i != null && a.writeMessage(
      4,
      i,
      proto.google.protobuf.FieldOptions.FeatureSupport.serializeBinaryToWriter
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.EnumValueOptions.extensionsBinary,
      proto.google.protobuf.EnumValueOptions.prototype.getExtension
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.setDeprecated = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.EnumValueOptions.prototype.clearDeprecated = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumValueOptions.prototype.hasDeprecated = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumValueOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 2)
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 2, o);
  }, proto.google.protobuf.EnumValueOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.EnumValueOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumValueOptions.prototype.getDebugRedact = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.setDebugRedact = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.EnumValueOptions.prototype.clearDebugRedact = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.EnumValueOptions.prototype.hasDebugRedact = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.EnumValueOptions.prototype.getFeatureSupport = function() {
    return (
      /** @type{?proto.google.protobuf.FieldOptions.FeatureSupport} */
      e.Message.getWrapperField(this, proto.google.protobuf.FieldOptions.FeatureSupport, 4)
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.setFeatureSupport = function(o) {
    return e.Message.setWrapperField(this, 4, o);
  }, proto.google.protobuf.EnumValueOptions.prototype.clearFeatureSupport = function() {
    return this.setFeatureSupport(void 0);
  }, proto.google.protobuf.EnumValueOptions.prototype.hasFeatureSupport = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.EnumValueOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.EnumValueOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.EnumValueOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.ServiceOptions.repeatedFields_ = [999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.ServiceOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.ServiceOptions.toObject(o, this);
  }, proto.google.protobuf.ServiceOptions.toObject = function(o, a) {
    var i, u = {
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      deprecated: e.Message.getBooleanFieldWithDefault(a, 33, !1),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.ServiceOptions.extensions,
      proto.google.protobuf.ServiceOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.ServiceOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.ServiceOptions();
    return proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 34:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 33:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecated(u);
          break;
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.ServiceOptions.extensionsBinary,
            proto.google.protobuf.ServiceOptions.prototype.getExtension,
            proto.google.protobuf.ServiceOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.ServiceOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.ServiceOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.ServiceOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getFeatures(), i != null && a.writeMessage(
      34,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = /** @type {boolean} */
    e.Message.getField(o, 33), i != null && a.writeBool(
      33,
      i
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.ServiceOptions.extensionsBinary,
      proto.google.protobuf.ServiceOptions.prototype.getExtension
    );
  }, proto.google.protobuf.ServiceOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 34)
    );
  }, proto.google.protobuf.ServiceOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 34, o);
  }, proto.google.protobuf.ServiceOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.ServiceOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 34) != null;
  }, proto.google.protobuf.ServiceOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 33, !1)
    );
  }, proto.google.protobuf.ServiceOptions.prototype.setDeprecated = function(o) {
    return e.Message.setField(this, 33, o);
  }, proto.google.protobuf.ServiceOptions.prototype.clearDeprecated = function() {
    return e.Message.setField(this, 33, void 0);
  }, proto.google.protobuf.ServiceOptions.prototype.hasDeprecated = function() {
    return e.Message.getField(this, 33) != null;
  }, proto.google.protobuf.ServiceOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.ServiceOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.ServiceOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.ServiceOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.MethodOptions.repeatedFields_ = [999], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.MethodOptions.prototype.toObject = function(o) {
    return proto.google.protobuf.MethodOptions.toObject(o, this);
  }, proto.google.protobuf.MethodOptions.toObject = function(o, a) {
    var i, u = {
      deprecated: e.Message.getBooleanFieldWithDefault(a, 33, !1),
      idempotencyLevel: e.Message.getFieldWithDefault(a, 34, 0),
      features: (i = a.getFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      uninterpretedOptionList: e.Message.toObjectList(
        a.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        o
      )
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.MethodOptions.extensions,
      proto.google.protobuf.MethodOptions.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.MethodOptions.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.MethodOptions();
    return proto.google.protobuf.MethodOptions.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.MethodOptions.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 33:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setDeprecated(u);
          break;
        case 34:
          var u = (
            /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */
            a.readEnum()
          );
          o.setIdempotencyLevel(u);
          break;
        case 35:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFeatures(u);
          break;
        case 999:
          var u = new proto.google.protobuf.UninterpretedOption();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), o.addUninterpretedOption(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.MethodOptions.extensionsBinary,
            proto.google.protobuf.MethodOptions.prototype.getExtension,
            proto.google.protobuf.MethodOptions.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.MethodOptions.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.MethodOptions.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.MethodOptions.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {boolean} */
    e.Message.getField(o, 33), i != null && a.writeBool(
      33,
      i
    ), i = /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */
    e.Message.getField(o, 34), i != null && a.writeEnum(
      34,
      i
    ), i = o.getFeatures(), i != null && a.writeMessage(
      35,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = o.getUninterpretedOptionList(), i.length > 0 && a.writeRepeatedMessage(
      999,
      i,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.MethodOptions.extensionsBinary,
      proto.google.protobuf.MethodOptions.prototype.getExtension
    );
  }, proto.google.protobuf.MethodOptions.IdempotencyLevel = {
    IDEMPOTENCY_UNKNOWN: 0,
    NO_SIDE_EFFECTS: 1,
    IDEMPOTENT: 2
  }, proto.google.protobuf.MethodOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 33, !1)
    );
  }, proto.google.protobuf.MethodOptions.prototype.setDeprecated = function(o) {
    return e.Message.setField(this, 33, o);
  }, proto.google.protobuf.MethodOptions.prototype.clearDeprecated = function() {
    return e.Message.setField(this, 33, void 0);
  }, proto.google.protobuf.MethodOptions.prototype.hasDeprecated = function() {
    return e.Message.getField(this, 33) != null;
  }, proto.google.protobuf.MethodOptions.prototype.getIdempotencyLevel = function() {
    return (
      /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */
      e.Message.getFieldWithDefault(this, 34, 0)
    );
  }, proto.google.protobuf.MethodOptions.prototype.setIdempotencyLevel = function(o) {
    return e.Message.setField(this, 34, o);
  }, proto.google.protobuf.MethodOptions.prototype.clearIdempotencyLevel = function() {
    return e.Message.setField(this, 34, void 0);
  }, proto.google.protobuf.MethodOptions.prototype.hasIdempotencyLevel = function() {
    return e.Message.getField(this, 34) != null;
  }, proto.google.protobuf.MethodOptions.prototype.getFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 35)
    );
  }, proto.google.protobuf.MethodOptions.prototype.setFeatures = function(o) {
    return e.Message.setWrapperField(this, 35, o);
  }, proto.google.protobuf.MethodOptions.prototype.clearFeatures = function() {
    return this.setFeatures(void 0);
  }, proto.google.protobuf.MethodOptions.prototype.hasFeatures = function() {
    return e.Message.getField(this, 35) != null;
  }, proto.google.protobuf.MethodOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.MethodOptions.prototype.setUninterpretedOptionList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 999, o);
  }, proto.google.protobuf.MethodOptions.prototype.addUninterpretedOption = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 999, o, proto.google.protobuf.UninterpretedOption, a);
  }, proto.google.protobuf.MethodOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.UninterpretedOption.repeatedFields_ = [2], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UninterpretedOption.prototype.toObject = function(o) {
    return proto.google.protobuf.UninterpretedOption.toObject(o, this);
  }, proto.google.protobuf.UninterpretedOption.toObject = function(o, a) {
    var i, u = {
      nameList: e.Message.toObjectList(
        a.getNameList(),
        proto.google.protobuf.UninterpretedOption.NamePart.toObject,
        o
      ),
      identifierValue: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      positiveIntValue: (i = e.Message.getField(a, 4)) == null ? void 0 : i,
      negativeIntValue: (i = e.Message.getField(a, 5)) == null ? void 0 : i,
      doubleValue: (i = e.Message.getOptionalFloatingPointField(a, 6)) == null ? void 0 : i,
      stringValue: a.getStringValue_asB64(),
      aggregateValue: (i = e.Message.getField(a, 8)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.UninterpretedOption.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.UninterpretedOption();
    return proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 2:
          var u = new proto.google.protobuf.UninterpretedOption.NamePart();
          a.readMessage(u, proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader), o.addName(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setIdentifierValue(u);
          break;
        case 4:
          var u = (
            /** @type {number} */
            a.readUint64()
          );
          o.setPositiveIntValue(u);
          break;
        case 5:
          var u = (
            /** @type {number} */
            a.readInt64()
          );
          o.setNegativeIntValue(u);
          break;
        case 6:
          var u = (
            /** @type {number} */
            a.readDouble()
          );
          o.setDoubleValue(u);
          break;
        case 7:
          var u = (
            /** @type {!Uint8Array} */
            a.readBytes()
          );
          o.setStringValue(u);
          break;
        case 8:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setAggregateValue(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.UninterpretedOption.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getNameList(), i.length > 0 && a.writeRepeatedMessage(
      2,
      i,
      proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter
    ), i = /** @type {string} */
    e.Message.getField(o, 3), i != null && a.writeString(
      3,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 4), i != null && a.writeUint64(
      4,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 5), i != null && a.writeInt64(
      5,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 6), i != null && a.writeDouble(
      6,
      i
    ), i = /** @type {!(string|Uint8Array)} */
    e.Message.getField(o, 7), i != null && a.writeBytes(
      7,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 8), i != null && a.writeString(
      8,
      i
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UninterpretedOption.NamePart.prototype.toObject = function(o) {
    return proto.google.protobuf.UninterpretedOption.NamePart.toObject(o, this);
  }, proto.google.protobuf.UninterpretedOption.NamePart.toObject = function(o, a) {
    var i, u = {
      namePart: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      isExtension: (i = e.Message.getBooleanField(a, 2)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.UninterpretedOption.NamePart();
    return proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setNamePart(u);
          break;
        case 2:
          var u = (
            /** @type {boolean} */
            a.readBool()
          );
          o.setIsExtension(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = /** @type {boolean} */
    e.Message.getField(o, 2), i != null && a.writeBool(
      2,
      i
    );
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.getNamePart = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.setNamePart = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearNamePart = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasNamePart = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.getIsExtension = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.setIsExtension = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearIsExtension = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasIsExtension = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getNameList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption.NamePart>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption.NamePart, 2)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setNameList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 2, o);
  }, proto.google.protobuf.UninterpretedOption.prototype.addName = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 2, o, proto.google.protobuf.UninterpretedOption.NamePart, a);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearNameList = function() {
    return this.setNameList([]);
  }, proto.google.protobuf.UninterpretedOption.prototype.getIdentifierValue = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setIdentifierValue = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearIdentifierValue = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasIdentifierValue = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getPositiveIntValue = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setPositiveIntValue = function(o) {
    return e.Message.setField(this, 4, o);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearPositiveIntValue = function() {
    return e.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasPositiveIntValue = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getNegativeIntValue = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setNegativeIntValue = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearNegativeIntValue = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasNegativeIntValue = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getDoubleValue = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 6, 0)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setDoubleValue = function(o) {
    return e.Message.setField(this, 6, o);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearDoubleValue = function() {
    return e.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasDoubleValue = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getStringValue = function() {
    return (
      /** @type {!(string|Uint8Array)} */
      e.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asB64 = function() {
    return (
      /** @type {string} */
      e.Message.bytesAsB64(
        this.getStringValue()
      )
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      e.Message.bytesAsU8(
        this.getStringValue()
      )
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setStringValue = function(o) {
    return e.Message.setField(this, 7, o);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearStringValue = function() {
    return e.Message.setField(this, 7, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasStringValue = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getAggregateValue = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 8, "")
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setAggregateValue = function(o) {
    return e.Message.setField(this, 8, o);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearAggregateValue = function() {
    return e.Message.setField(this, 8, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasAggregateValue = function() {
    return e.Message.getField(this, 8) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FeatureSet.prototype.toObject = function(o) {
    return proto.google.protobuf.FeatureSet.toObject(o, this);
  }, proto.google.protobuf.FeatureSet.toObject = function(o, a) {
    var i, u = {
      fieldPresence: (i = e.Message.getField(a, 1)) == null ? void 0 : i,
      enumType: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      repeatedFieldEncoding: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      utf8Validation: (i = e.Message.getField(a, 4)) == null ? void 0 : i,
      messageEncoding: (i = e.Message.getField(a, 5)) == null ? void 0 : i,
      jsonFormat: (i = e.Message.getField(a, 6)) == null ? void 0 : i
    };
    return e.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      a,
      u,
      proto.google.protobuf.FeatureSet.extensions,
      proto.google.protobuf.FeatureSet.prototype.getExtension,
      o
    ), o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FeatureSet.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FeatureSet();
    return proto.google.protobuf.FeatureSet.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {!proto.google.protobuf.FeatureSet.FieldPresence} */
            a.readEnum()
          );
          o.setFieldPresence(u);
          break;
        case 2:
          var u = (
            /** @type {!proto.google.protobuf.FeatureSet.EnumType} */
            a.readEnum()
          );
          o.setEnumType(u);
          break;
        case 3:
          var u = (
            /** @type {!proto.google.protobuf.FeatureSet.RepeatedFieldEncoding} */
            a.readEnum()
          );
          o.setRepeatedFieldEncoding(u);
          break;
        case 4:
          var u = (
            /** @type {!proto.google.protobuf.FeatureSet.Utf8Validation} */
            a.readEnum()
          );
          o.setUtf8Validation(u);
          break;
        case 5:
          var u = (
            /** @type {!proto.google.protobuf.FeatureSet.MessageEncoding} */
            a.readEnum()
          );
          o.setMessageEncoding(u);
          break;
        case 6:
          var u = (
            /** @type {!proto.google.protobuf.FeatureSet.JsonFormat} */
            a.readEnum()
          );
          o.setJsonFormat(u);
          break;
        default:
          e.Message.readBinaryExtension(
            o,
            a,
            proto.google.protobuf.FeatureSet.extensionsBinary,
            proto.google.protobuf.FeatureSet.prototype.getExtension,
            proto.google.protobuf.FeatureSet.prototype.setExtension
          );
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FeatureSet.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FeatureSet.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FeatureSet.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {!proto.google.protobuf.FeatureSet.FieldPresence} */
    e.Message.getField(o, 1), i != null && a.writeEnum(
      1,
      i
    ), i = /** @type {!proto.google.protobuf.FeatureSet.EnumType} */
    e.Message.getField(o, 2), i != null && a.writeEnum(
      2,
      i
    ), i = /** @type {!proto.google.protobuf.FeatureSet.RepeatedFieldEncoding} */
    e.Message.getField(o, 3), i != null && a.writeEnum(
      3,
      i
    ), i = /** @type {!proto.google.protobuf.FeatureSet.Utf8Validation} */
    e.Message.getField(o, 4), i != null && a.writeEnum(
      4,
      i
    ), i = /** @type {!proto.google.protobuf.FeatureSet.MessageEncoding} */
    e.Message.getField(o, 5), i != null && a.writeEnum(
      5,
      i
    ), i = /** @type {!proto.google.protobuf.FeatureSet.JsonFormat} */
    e.Message.getField(o, 6), i != null && a.writeEnum(
      6,
      i
    ), e.Message.serializeBinaryExtensions(
      o,
      a,
      proto.google.protobuf.FeatureSet.extensionsBinary,
      proto.google.protobuf.FeatureSet.prototype.getExtension
    );
  }, proto.google.protobuf.FeatureSet.FieldPresence = {
    FIELD_PRESENCE_UNKNOWN: 0,
    EXPLICIT: 1,
    IMPLICIT: 2,
    LEGACY_REQUIRED: 3
  }, proto.google.protobuf.FeatureSet.EnumType = {
    ENUM_TYPE_UNKNOWN: 0,
    OPEN: 1,
    CLOSED: 2
  }, proto.google.protobuf.FeatureSet.RepeatedFieldEncoding = {
    REPEATED_FIELD_ENCODING_UNKNOWN: 0,
    PACKED: 1,
    EXPANDED: 2
  }, proto.google.protobuf.FeatureSet.Utf8Validation = {
    UTF8_VALIDATION_UNKNOWN: 0,
    VERIFY: 2,
    NONE: 3
  }, proto.google.protobuf.FeatureSet.MessageEncoding = {
    MESSAGE_ENCODING_UNKNOWN: 0,
    LENGTH_PREFIXED: 1,
    DELIMITED: 2
  }, proto.google.protobuf.FeatureSet.JsonFormat = {
    JSON_FORMAT_UNKNOWN: 0,
    ALLOW: 1,
    LEGACY_BEST_EFFORT: 2
  }, proto.google.protobuf.FeatureSet.prototype.getFieldPresence = function() {
    return (
      /** @type {!proto.google.protobuf.FeatureSet.FieldPresence} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.FeatureSet.prototype.setFieldPresence = function(o) {
    return e.Message.setField(this, 1, o);
  }, proto.google.protobuf.FeatureSet.prototype.clearFieldPresence = function() {
    return e.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FeatureSet.prototype.hasFieldPresence = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FeatureSet.prototype.getEnumType = function() {
    return (
      /** @type {!proto.google.protobuf.FeatureSet.EnumType} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.FeatureSet.prototype.setEnumType = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.FeatureSet.prototype.clearEnumType = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FeatureSet.prototype.hasEnumType = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FeatureSet.prototype.getRepeatedFieldEncoding = function() {
    return (
      /** @type {!proto.google.protobuf.FeatureSet.RepeatedFieldEncoding} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.protobuf.FeatureSet.prototype.setRepeatedFieldEncoding = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.FeatureSet.prototype.clearRepeatedFieldEncoding = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FeatureSet.prototype.hasRepeatedFieldEncoding = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FeatureSet.prototype.getUtf8Validation = function() {
    return (
      /** @type {!proto.google.protobuf.FeatureSet.Utf8Validation} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.protobuf.FeatureSet.prototype.setUtf8Validation = function(o) {
    return e.Message.setField(this, 4, o);
  }, proto.google.protobuf.FeatureSet.prototype.clearUtf8Validation = function() {
    return e.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.FeatureSet.prototype.hasUtf8Validation = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.FeatureSet.prototype.getMessageEncoding = function() {
    return (
      /** @type {!proto.google.protobuf.FeatureSet.MessageEncoding} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.google.protobuf.FeatureSet.prototype.setMessageEncoding = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.FeatureSet.prototype.clearMessageEncoding = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.FeatureSet.prototype.hasMessageEncoding = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.FeatureSet.prototype.getJsonFormat = function() {
    return (
      /** @type {!proto.google.protobuf.FeatureSet.JsonFormat} */
      e.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.google.protobuf.FeatureSet.prototype.setJsonFormat = function(o) {
    return e.Message.setField(this, 6, o);
  }, proto.google.protobuf.FeatureSet.prototype.clearJsonFormat = function() {
    return e.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.FeatureSet.prototype.hasJsonFormat = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.google.protobuf.FeatureSetDefaults.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FeatureSetDefaults.prototype.toObject = function(o) {
    return proto.google.protobuf.FeatureSetDefaults.toObject(o, this);
  }, proto.google.protobuf.FeatureSetDefaults.toObject = function(o, a) {
    var i, u = {
      defaultsList: e.Message.toObjectList(
        a.getDefaultsList(),
        proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.toObject,
        o
      ),
      minimumEdition: (i = e.Message.getField(a, 4)) == null ? void 0 : i,
      maximumEdition: (i = e.Message.getField(a, 5)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FeatureSetDefaults.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FeatureSetDefaults();
    return proto.google.protobuf.FeatureSetDefaults.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FeatureSetDefaults.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = new proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault();
          a.readMessage(u, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.deserializeBinaryFromReader), o.addDefaults(u);
          break;
        case 4:
          var u = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setMinimumEdition(u);
          break;
        case 5:
          var u = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setMaximumEdition(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FeatureSetDefaults.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FeatureSetDefaults.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FeatureSetDefaults.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getDefaultsList(), i.length > 0 && a.writeRepeatedMessage(
      1,
      i,
      proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.serializeBinaryToWriter
    ), i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 4), i != null && a.writeEnum(
      4,
      i
    ), i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 5), i != null && a.writeEnum(
      5,
      i
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.toObject = function(o) {
    return proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.toObject(o, this);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.toObject = function(o, a) {
    var i, u = {
      edition: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      overridableFeatures: (i = a.getOverridableFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i),
      fixedFeatures: (i = a.getFixedFeatures()) && proto.google.protobuf.FeatureSet.toObject(o, i)
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault();
    return proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 3:
          var u = (
            /** @type {!proto.google.protobuf.Edition} */
            a.readEnum()
          );
          o.setEdition(u);
          break;
        case 4:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setOverridableFeatures(u);
          break;
        case 5:
          var u = new proto.google.protobuf.FeatureSet();
          a.readMessage(u, proto.google.protobuf.FeatureSet.deserializeBinaryFromReader), o.setFixedFeatures(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {!proto.google.protobuf.Edition} */
    e.Message.getField(o, 3), i != null && a.writeEnum(
      3,
      i
    ), i = o.getOverridableFeatures(), i != null && a.writeMessage(
      4,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    ), i = o.getFixedFeatures(), i != null && a.writeMessage(
      5,
      i,
      proto.google.protobuf.FeatureSet.serializeBinaryToWriter
    );
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.getEdition = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.setEdition = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.clearEdition = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.hasEdition = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.getOverridableFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 4)
    );
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.setOverridableFeatures = function(o) {
    return e.Message.setWrapperField(this, 4, o);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.clearOverridableFeatures = function() {
    return this.setOverridableFeatures(void 0);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.hasOverridableFeatures = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.getFixedFeatures = function() {
    return (
      /** @type{?proto.google.protobuf.FeatureSet} */
      e.Message.getWrapperField(this, proto.google.protobuf.FeatureSet, 5)
    );
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.setFixedFeatures = function(o) {
    return e.Message.setWrapperField(this, 5, o);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.clearFixedFeatures = function() {
    return this.setFixedFeatures(void 0);
  }, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.prototype.hasFixedFeatures = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.FeatureSetDefaults.prototype.getDefaultsList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault, 1)
    );
  }, proto.google.protobuf.FeatureSetDefaults.prototype.setDefaultsList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 1, o);
  }, proto.google.protobuf.FeatureSetDefaults.prototype.addDefaults = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 1, o, proto.google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault, a);
  }, proto.google.protobuf.FeatureSetDefaults.prototype.clearDefaultsList = function() {
    return this.setDefaultsList([]);
  }, proto.google.protobuf.FeatureSetDefaults.prototype.getMinimumEdition = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.protobuf.FeatureSetDefaults.prototype.setMinimumEdition = function(o) {
    return e.Message.setField(this, 4, o);
  }, proto.google.protobuf.FeatureSetDefaults.prototype.clearMinimumEdition = function() {
    return e.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.FeatureSetDefaults.prototype.hasMinimumEdition = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.FeatureSetDefaults.prototype.getMaximumEdition = function() {
    return (
      /** @type {!proto.google.protobuf.Edition} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.google.protobuf.FeatureSetDefaults.prototype.setMaximumEdition = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.FeatureSetDefaults.prototype.clearMaximumEdition = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.FeatureSetDefaults.prototype.hasMaximumEdition = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.SourceCodeInfo.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.SourceCodeInfo.prototype.toObject = function(o) {
    return proto.google.protobuf.SourceCodeInfo.toObject(o, this);
  }, proto.google.protobuf.SourceCodeInfo.toObject = function(o, a) {
    var i = {
      locationList: e.Message.toObjectList(
        a.getLocationList(),
        proto.google.protobuf.SourceCodeInfo.Location.toObject,
        o
      )
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.SourceCodeInfo.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.SourceCodeInfo();
    return proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = new proto.google.protobuf.SourceCodeInfo.Location();
          a.readMessage(u, proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader), o.addLocation(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.SourceCodeInfo.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getLocationList(), i.length > 0 && a.writeRepeatedMessage(
      1,
      i,
      proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_ = [1, 2, 6], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.SourceCodeInfo.Location.prototype.toObject = function(o) {
    return proto.google.protobuf.SourceCodeInfo.Location.toObject(o, this);
  }, proto.google.protobuf.SourceCodeInfo.Location.toObject = function(o, a) {
    var i, u = {
      pathList: (i = e.Message.getRepeatedField(a, 1)) == null ? void 0 : i,
      spanList: (i = e.Message.getRepeatedField(a, 2)) == null ? void 0 : i,
      leadingComments: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      trailingComments: (i = e.Message.getField(a, 4)) == null ? void 0 : i,
      leadingDetachedCommentsList: (i = e.Message.getRepeatedField(a, 6)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.SourceCodeInfo.Location.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.SourceCodeInfo.Location();
    return proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          for (var y = (
            /** @type {!Array<number>} */
            a.isDelimited() ? a.readPackedInt32() : [a.readInt32()]
          ), u = 0; u < y.length; u++)
            o.addPath(y[u]);
          break;
        case 2:
          for (var y = (
            /** @type {!Array<number>} */
            a.isDelimited() ? a.readPackedInt32() : [a.readInt32()]
          ), u = 0; u < y.length; u++)
            o.addSpan(y[u]);
          break;
        case 3:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.setLeadingComments(h);
          break;
        case 4:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.setTrailingComments(h);
          break;
        case 6:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.addLeadingDetachedComments(h);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getPathList(), i.length > 0 && a.writePackedInt32(
      1,
      i
    ), i = o.getSpanList(), i.length > 0 && a.writePackedInt32(
      2,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 3), i != null && a.writeString(
      3,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 4), i != null && a.writeString(
      4,
      i
    ), i = o.getLeadingDetachedCommentsList(), i.length > 0 && a.writeRepeatedString(
      6,
      i
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getPathList = function() {
    return (
      /** @type {!Array<number>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setPathList = function(o) {
    return e.Message.setField(this, 1, o || []);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.addPath = function(o, a) {
    return e.Message.addToRepeatedField(this, 1, o, a);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearPathList = function() {
    return this.setPathList([]);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getSpanList = function() {
    return (
      /** @type {!Array<number>} */
      e.Message.getRepeatedField(this, 2)
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setSpanList = function(o) {
    return e.Message.setField(this, 2, o || []);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.addSpan = function(o, a) {
    return e.Message.addToRepeatedField(this, 2, o, a);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearSpanList = function() {
    return this.setSpanList([]);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingComments = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingComments = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingComments = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.hasLeadingComments = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getTrailingComments = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setTrailingComments = function(o) {
    return e.Message.setField(this, 4, o);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearTrailingComments = function() {
    return e.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.hasTrailingComments = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingDetachedCommentsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 6)
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingDetachedCommentsList = function(o) {
    return e.Message.setField(this, 6, o || []);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.addLeadingDetachedComments = function(o, a) {
    return e.Message.addToRepeatedField(this, 6, o, a);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingDetachedCommentsList = function() {
    return this.setLeadingDetachedCommentsList([]);
  }, proto.google.protobuf.SourceCodeInfo.prototype.getLocationList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.SourceCodeInfo.Location>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.SourceCodeInfo.Location, 1)
    );
  }, proto.google.protobuf.SourceCodeInfo.prototype.setLocationList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 1, o);
  }, proto.google.protobuf.SourceCodeInfo.prototype.addLocation = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 1, o, proto.google.protobuf.SourceCodeInfo.Location, a);
  }, proto.google.protobuf.SourceCodeInfo.prototype.clearLocationList = function() {
    return this.setLocationList([]);
  }, proto.google.protobuf.GeneratedCodeInfo.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.GeneratedCodeInfo.prototype.toObject = function(o) {
    return proto.google.protobuf.GeneratedCodeInfo.toObject(o, this);
  }, proto.google.protobuf.GeneratedCodeInfo.toObject = function(o, a) {
    var i = {
      annotationList: e.Message.toObjectList(
        a.getAnnotationList(),
        proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject,
        o
      )
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.GeneratedCodeInfo.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.GeneratedCodeInfo();
    return proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = new proto.google.protobuf.GeneratedCodeInfo.Annotation();
          a.readMessage(u, proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader), o.addAnnotation(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getAnnotationList(), i.length > 0 && a.writeRepeatedMessage(
      1,
      i,
      proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.toObject = function(o) {
    return proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject(o, this);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject = function(o, a) {
    var i, u = {
      pathList: (i = e.Message.getRepeatedField(a, 1)) == null ? void 0 : i,
      sourceFile: (i = e.Message.getField(a, 2)) == null ? void 0 : i,
      begin: (i = e.Message.getField(a, 3)) == null ? void 0 : i,
      end: (i = e.Message.getField(a, 4)) == null ? void 0 : i,
      semantic: (i = e.Message.getField(a, 5)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.GeneratedCodeInfo.Annotation();
    return proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          for (var u = (
            /** @type {!Array<number>} */
            a.isDelimited() ? a.readPackedInt32() : [a.readInt32()]
          ), y = 0; y < u.length; y++)
            o.addPath(u[y]);
          break;
        case 2:
          var h = (
            /** @type {string} */
            a.readString()
          );
          o.setSourceFile(h);
          break;
        case 3:
          var h = (
            /** @type {number} */
            a.readInt32()
          );
          o.setBegin(h);
          break;
        case 4:
          var h = (
            /** @type {number} */
            a.readInt32()
          );
          o.setEnd(h);
          break;
        case 5:
          var h = (
            /** @type {!proto.google.protobuf.GeneratedCodeInfo.Annotation.Semantic} */
            a.readEnum()
          );
          o.setSemantic(h);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getPathList(), i.length > 0 && a.writePackedInt32(
      1,
      i
    ), i = /** @type {string} */
    e.Message.getField(o, 2), i != null && a.writeString(
      2,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 3), i != null && a.writeInt32(
      3,
      i
    ), i = /** @type {number} */
    e.Message.getField(o, 4), i != null && a.writeInt32(
      4,
      i
    ), i = /** @type {!proto.google.protobuf.GeneratedCodeInfo.Annotation.Semantic} */
    e.Message.getField(o, 5), i != null && a.writeEnum(
      5,
      i
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.Semantic = {
    NONE: 0,
    SET: 1,
    ALIAS: 2
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getPathList = function() {
    return (
      /** @type {!Array<number>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setPathList = function(o) {
    return e.Message.setField(this, 1, o || []);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.addPath = function(o, a) {
    return e.Message.addToRepeatedField(this, 1, o, a);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearPathList = function() {
    return this.setPathList([]);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getSourceFile = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setSourceFile = function(o) {
    return e.Message.setField(this, 2, o);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearSourceFile = function() {
    return e.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasSourceFile = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getBegin = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setBegin = function(o) {
    return e.Message.setField(this, 3, o);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearBegin = function() {
    return e.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasBegin = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getEnd = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setEnd = function(o) {
    return e.Message.setField(this, 4, o);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearEnd = function() {
    return e.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasEnd = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getSemantic = function() {
    return (
      /** @type {!proto.google.protobuf.GeneratedCodeInfo.Annotation.Semantic} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setSemantic = function(o) {
    return e.Message.setField(this, 5, o);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearSemantic = function() {
    return e.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasSemantic = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.getAnnotationList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>} */
      e.Message.getRepeatedWrapperField(this, proto.google.protobuf.GeneratedCodeInfo.Annotation, 1)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.setAnnotationList = function(o) {
    return e.Message.setRepeatedWrapperField(this, 1, o);
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.addAnnotation = function(o, a) {
    return e.Message.addToRepeatedWrapperField(this, 1, o, proto.google.protobuf.GeneratedCodeInfo.Annotation, a);
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.clearAnnotationList = function() {
    return this.setAnnotationList([]);
  }, proto.google.protobuf.Edition = {
    EDITION_UNKNOWN: 0,
    EDITION_LEGACY: 900,
    EDITION_PROTO2: 998,
    EDITION_PROTO3: 999,
    EDITION_2023: 1e3,
    EDITION_2024: 1001,
    EDITION_1_TEST_ONLY: 1,
    EDITION_2_TEST_ONLY: 2,
    EDITION_99997_TEST_ONLY: 99997,
    EDITION_99998_TEST_ONLY: 99998,
    EDITION_99999_TEST_ONLY: 99999,
    EDITION_MAX: 2147483647
  }, p.object.extend(s, proto.google.protobuf);
})(pn);
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = an;
  p.object.extend(proto, o);
  var a = pn;
  p.object.extend(proto, a), p.exportSymbol("proto.google.api.http", null, c), proto.google.api.http = new e.ExtensionFieldInfo(
    72295728,
    { http: 0 },
    o.HttpRule,
    /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */
    o.HttpRule.toObject,
    0
  ), a.MethodOptions.extensionsBinary[72295728] = new e.ExtensionFieldBinaryInfo(
    proto.google.api.http,
    e.BinaryReader.prototype.readMessage,
    e.BinaryWriter.prototype.writeMessage,
    o.HttpRule.serializeBinaryToWriter,
    o.HttpRule.deserializeBinaryFromReader,
    !1
  ), a.MethodOptions.extensions[72295728] = proto.google.api.http, p.object.extend(s, proto.google.api);
})(Ut);
var ti = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.Date", null, c), proto.google.type.Date = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.Date, e.Message), p.DEBUG && !COMPILED && (proto.google.type.Date.displayName = "proto.google.type.Date"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.Date.prototype.toObject = function(o) {
    return proto.google.type.Date.toObject(o, this);
  }, proto.google.type.Date.toObject = function(o, a) {
    var i = {
      year: e.Message.getFieldWithDefault(a, 1, 0),
      month: e.Message.getFieldWithDefault(a, 2, 0),
      day: e.Message.getFieldWithDefault(a, 3, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.Date.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.Date();
    return proto.google.type.Date.deserializeBinaryFromReader(i, a);
  }, proto.google.type.Date.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setYear(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setMonth(u);
          break;
        case 3:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setDay(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.Date.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.Date.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.Date.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getYear(), i !== 0 && a.writeInt32(
      1,
      i
    ), i = o.getMonth(), i !== 0 && a.writeInt32(
      2,
      i
    ), i = o.getDay(), i !== 0 && a.writeInt32(
      3,
      i
    );
  }, proto.google.type.Date.prototype.getYear = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.Date.prototype.setYear = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, proto.google.type.Date.prototype.getMonth = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.Date.prototype.setMonth = function(o) {
    return e.Message.setProto3IntField(this, 2, o);
  }, proto.google.type.Date.prototype.getDay = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.Date.prototype.setDay = function(o) {
    return e.Message.setProto3IntField(this, 3, o);
  }, p.object.extend(s, proto.google.type);
})(ti);
var oi = {}, ii = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.protobuf.Duration", null, c), proto.google.protobuf.Duration = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.protobuf.Duration, e.Message), p.DEBUG && !COMPILED && (proto.google.protobuf.Duration.displayName = "proto.google.protobuf.Duration"), e.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.Duration.prototype.toObject = function(o) {
    return proto.google.protobuf.Duration.toObject(o, this);
  }, proto.google.protobuf.Duration.toObject = function(o, a) {
    var i = {
      seconds: e.Message.getFieldWithDefault(a, 1, 0),
      nanos: e.Message.getFieldWithDefault(a, 2, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.protobuf.Duration.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.protobuf.Duration();
    return proto.google.protobuf.Duration.deserializeBinaryFromReader(i, a);
  }, proto.google.protobuf.Duration.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt64()
          );
          o.setSeconds(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNanos(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.protobuf.Duration.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.protobuf.Duration.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.protobuf.Duration.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getSeconds(), i !== 0 && a.writeInt64(
      1,
      i
    ), i = o.getNanos(), i !== 0 && a.writeInt32(
      2,
      i
    );
  }, proto.google.protobuf.Duration.prototype.getSeconds = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.Duration.prototype.setSeconds = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, proto.google.protobuf.Duration.prototype.getNanos = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.Duration.prototype.setNanos = function(o) {
    return e.Message.setProto3IntField(this, 2, o);
  }, p.object.extend(s, proto.google.protobuf);
})(ii);
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = ii;
  p.object.extend(proto, o), p.exportSymbol("proto.google.type.DateTime", null, c), p.exportSymbol("proto.google.type.DateTime.TimeOffsetCase", null, c), p.exportSymbol("proto.google.type.TimeZone", null, c), proto.google.type.DateTime = function(a) {
    e.Message.initialize(this, a, 0, -1, null, proto.google.type.DateTime.oneofGroups_);
  }, p.inherits(proto.google.type.DateTime, e.Message), p.DEBUG && !COMPILED && (proto.google.type.DateTime.displayName = "proto.google.type.DateTime"), proto.google.type.TimeZone = function(a) {
    e.Message.initialize(this, a, 0, -1, null, null);
  }, p.inherits(proto.google.type.TimeZone, e.Message), p.DEBUG && !COMPILED && (proto.google.type.TimeZone.displayName = "proto.google.type.TimeZone"), proto.google.type.DateTime.oneofGroups_ = [[8, 9]], proto.google.type.DateTime.TimeOffsetCase = {
    TIME_OFFSET_NOT_SET: 0,
    UTC_OFFSET: 8,
    TIME_ZONE: 9
  }, proto.google.type.DateTime.prototype.getTimeOffsetCase = function() {
    return (
      /** @type {proto.google.type.DateTime.TimeOffsetCase} */
      e.Message.computeOneofCase(this, proto.google.type.DateTime.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.DateTime.prototype.toObject = function(a) {
    return proto.google.type.DateTime.toObject(a, this);
  }, proto.google.type.DateTime.toObject = function(a, i) {
    var u, y = {
      year: e.Message.getFieldWithDefault(i, 1, 0),
      month: e.Message.getFieldWithDefault(i, 2, 0),
      day: e.Message.getFieldWithDefault(i, 3, 0),
      hours: e.Message.getFieldWithDefault(i, 4, 0),
      minutes: e.Message.getFieldWithDefault(i, 5, 0),
      seconds: e.Message.getFieldWithDefault(i, 6, 0),
      nanos: e.Message.getFieldWithDefault(i, 7, 0),
      utcOffset: (u = i.getUtcOffset()) && o.Duration.toObject(a, u),
      timeZone: (u = i.getTimeZone()) && proto.google.type.TimeZone.toObject(a, u)
    };
    return a && (y.$jspbMessageInstance = i), y;
  }), proto.google.type.DateTime.deserializeBinary = function(a) {
    var i = new e.BinaryReader(a), u = new proto.google.type.DateTime();
    return proto.google.type.DateTime.deserializeBinaryFromReader(u, i);
  }, proto.google.type.DateTime.deserializeBinaryFromReader = function(a, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var u = i.getFieldNumber();
      switch (u) {
        case 1:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setYear(y);
          break;
        case 2:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setMonth(y);
          break;
        case 3:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setDay(y);
          break;
        case 4:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setHours(y);
          break;
        case 5:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setMinutes(y);
          break;
        case 6:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setSeconds(y);
          break;
        case 7:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setNanos(y);
          break;
        case 8:
          var y = new o.Duration();
          i.readMessage(y, o.Duration.deserializeBinaryFromReader), a.setUtcOffset(y);
          break;
        case 9:
          var y = new proto.google.type.TimeZone();
          i.readMessage(y, proto.google.type.TimeZone.deserializeBinaryFromReader), a.setTimeZone(y);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return a;
  }, proto.google.type.DateTime.prototype.serializeBinary = function() {
    var a = new e.BinaryWriter();
    return proto.google.type.DateTime.serializeBinaryToWriter(this, a), a.getResultBuffer();
  }, proto.google.type.DateTime.serializeBinaryToWriter = function(a, i) {
    var u = void 0;
    u = a.getYear(), u !== 0 && i.writeInt32(
      1,
      u
    ), u = a.getMonth(), u !== 0 && i.writeInt32(
      2,
      u
    ), u = a.getDay(), u !== 0 && i.writeInt32(
      3,
      u
    ), u = a.getHours(), u !== 0 && i.writeInt32(
      4,
      u
    ), u = a.getMinutes(), u !== 0 && i.writeInt32(
      5,
      u
    ), u = a.getSeconds(), u !== 0 && i.writeInt32(
      6,
      u
    ), u = a.getNanos(), u !== 0 && i.writeInt32(
      7,
      u
    ), u = a.getUtcOffset(), u != null && i.writeMessage(
      8,
      u,
      o.Duration.serializeBinaryToWriter
    ), u = a.getTimeZone(), u != null && i.writeMessage(
      9,
      u,
      proto.google.type.TimeZone.serializeBinaryToWriter
    );
  }, proto.google.type.DateTime.prototype.getYear = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.DateTime.prototype.setYear = function(a) {
    return e.Message.setProto3IntField(this, 1, a);
  }, proto.google.type.DateTime.prototype.getMonth = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.DateTime.prototype.setMonth = function(a) {
    return e.Message.setProto3IntField(this, 2, a);
  }, proto.google.type.DateTime.prototype.getDay = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.DateTime.prototype.setDay = function(a) {
    return e.Message.setProto3IntField(this, 3, a);
  }, proto.google.type.DateTime.prototype.getHours = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.type.DateTime.prototype.setHours = function(a) {
    return e.Message.setProto3IntField(this, 4, a);
  }, proto.google.type.DateTime.prototype.getMinutes = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.google.type.DateTime.prototype.setMinutes = function(a) {
    return e.Message.setProto3IntField(this, 5, a);
  }, proto.google.type.DateTime.prototype.getSeconds = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.google.type.DateTime.prototype.setSeconds = function(a) {
    return e.Message.setProto3IntField(this, 6, a);
  }, proto.google.type.DateTime.prototype.getNanos = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 7, 0)
    );
  }, proto.google.type.DateTime.prototype.setNanos = function(a) {
    return e.Message.setProto3IntField(this, 7, a);
  }, proto.google.type.DateTime.prototype.getUtcOffset = function() {
    return (
      /** @type{?proto.google.protobuf.Duration} */
      e.Message.getWrapperField(this, o.Duration, 8)
    );
  }, proto.google.type.DateTime.prototype.setUtcOffset = function(a) {
    return e.Message.setOneofWrapperField(this, 8, proto.google.type.DateTime.oneofGroups_[0], a);
  }, proto.google.type.DateTime.prototype.clearUtcOffset = function() {
    return this.setUtcOffset(void 0);
  }, proto.google.type.DateTime.prototype.hasUtcOffset = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.google.type.DateTime.prototype.getTimeZone = function() {
    return (
      /** @type{?proto.google.type.TimeZone} */
      e.Message.getWrapperField(this, proto.google.type.TimeZone, 9)
    );
  }, proto.google.type.DateTime.prototype.setTimeZone = function(a) {
    return e.Message.setOneofWrapperField(this, 9, proto.google.type.DateTime.oneofGroups_[0], a);
  }, proto.google.type.DateTime.prototype.clearTimeZone = function() {
    return this.setTimeZone(void 0);
  }, proto.google.type.DateTime.prototype.hasTimeZone = function() {
    return e.Message.getField(this, 9) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.TimeZone.prototype.toObject = function(a) {
    return proto.google.type.TimeZone.toObject(a, this);
  }, proto.google.type.TimeZone.toObject = function(a, i) {
    var u = {
      id: e.Message.getFieldWithDefault(i, 1, ""),
      version: e.Message.getFieldWithDefault(i, 2, "")
    };
    return a && (u.$jspbMessageInstance = i), u;
  }), proto.google.type.TimeZone.deserializeBinary = function(a) {
    var i = new e.BinaryReader(a), u = new proto.google.type.TimeZone();
    return proto.google.type.TimeZone.deserializeBinaryFromReader(u, i);
  }, proto.google.type.TimeZone.deserializeBinaryFromReader = function(a, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var u = i.getFieldNumber();
      switch (u) {
        case 1:
          var y = (
            /** @type {string} */
            i.readString()
          );
          a.setId(y);
          break;
        case 2:
          var y = (
            /** @type {string} */
            i.readString()
          );
          a.setVersion(y);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return a;
  }, proto.google.type.TimeZone.prototype.serializeBinary = function() {
    var a = new e.BinaryWriter();
    return proto.google.type.TimeZone.serializeBinaryToWriter(this, a), a.getResultBuffer();
  }, proto.google.type.TimeZone.serializeBinaryToWriter = function(a, i) {
    var u = void 0;
    u = a.getId(), u.length > 0 && i.writeString(
      1,
      u
    ), u = a.getVersion(), u.length > 0 && i.writeString(
      2,
      u
    );
  }, proto.google.type.TimeZone.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.TimeZone.prototype.setId = function(a) {
    return e.Message.setProto3StringField(this, 1, a);
  }, proto.google.type.TimeZone.prototype.getVersion = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.type.TimeZone.prototype.setVersion = function(a) {
    return e.Message.setProto3StringField(this, 2, a);
  }, p.object.extend(s, proto.google.type);
})(oi);
var sn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.DayOfWeek", null, c), proto.google.type.DayOfWeek = {
    DAY_OF_WEEK_UNSPECIFIED: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 7
  }, p.object.extend(s, proto.google.type);
})(sn);
var ln = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.LatLng", null, c), proto.google.type.LatLng = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.LatLng, e.Message), p.DEBUG && !COMPILED && (proto.google.type.LatLng.displayName = "proto.google.type.LatLng"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.LatLng.prototype.toObject = function(o) {
    return proto.google.type.LatLng.toObject(o, this);
  }, proto.google.type.LatLng.toObject = function(o, a) {
    var i = {
      latitude: e.Message.getFloatingPointFieldWithDefault(a, 1, 0),
      longitude: e.Message.getFloatingPointFieldWithDefault(a, 2, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.LatLng.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.LatLng();
    return proto.google.type.LatLng.deserializeBinaryFromReader(i, a);
  }, proto.google.type.LatLng.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readDouble()
          );
          o.setLatitude(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readDouble()
          );
          o.setLongitude(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.LatLng.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.LatLng.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.LatLng.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getLatitude(), i !== 0 && a.writeDouble(
      1,
      i
    ), i = o.getLongitude(), i !== 0 && a.writeDouble(
      2,
      i
    );
  }, proto.google.type.LatLng.prototype.getLatitude = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.LatLng.prototype.setLatitude = function(o) {
    return e.Message.setProto3FloatField(this, 1, o);
  }, proto.google.type.LatLng.prototype.getLongitude = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.LatLng.prototype.setLongitude = function(o) {
    return e.Message.setProto3FloatField(this, 2, o);
  }, p.object.extend(s, proto.google.type);
})(ln);
var un = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.Money", null, c), proto.google.type.Money = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.Money, e.Message), p.DEBUG && !COMPILED && (proto.google.type.Money.displayName = "proto.google.type.Money"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.Money.prototype.toObject = function(o) {
    return proto.google.type.Money.toObject(o, this);
  }, proto.google.type.Money.toObject = function(o, a) {
    var i = {
      currencyCode: e.Message.getFieldWithDefault(a, 1, ""),
      units: e.Message.getFieldWithDefault(a, 2, 0),
      nanos: e.Message.getFieldWithDefault(a, 3, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.Money.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.Money();
    return proto.google.type.Money.deserializeBinaryFromReader(i, a);
  }, proto.google.type.Money.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setCurrencyCode(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt64()
          );
          o.setUnits(u);
          break;
        case 3:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNanos(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.Money.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.Money.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.Money.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getCurrencyCode(), i.length > 0 && a.writeString(
      1,
      i
    ), i = o.getUnits(), i !== 0 && a.writeInt64(
      2,
      i
    ), i = o.getNanos(), i !== 0 && a.writeInt32(
      3,
      i
    );
  }, proto.google.type.Money.prototype.getCurrencyCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.Money.prototype.setCurrencyCode = function(o) {
    return e.Message.setProto3StringField(this, 1, o);
  }, proto.google.type.Money.prototype.getUnits = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.Money.prototype.setUnits = function(o) {
    return e.Message.setProto3IntField(this, 2, o);
  }, proto.google.type.Money.prototype.getNanos = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.Money.prototype.setNanos = function(o) {
    return e.Message.setProto3IntField(this, 3, o);
  }, p.object.extend(s, proto.google.type);
})(un);
var ri = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.PhoneNumber", null, c), p.exportSymbol("proto.google.type.PhoneNumber.KindCase", null, c), p.exportSymbol("proto.google.type.PhoneNumber.ShortCode", null, c), proto.google.type.PhoneNumber = function(o) {
    e.Message.initialize(this, o, 0, -1, null, proto.google.type.PhoneNumber.oneofGroups_);
  }, p.inherits(proto.google.type.PhoneNumber, e.Message), p.DEBUG && !COMPILED && (proto.google.type.PhoneNumber.displayName = "proto.google.type.PhoneNumber"), proto.google.type.PhoneNumber.ShortCode = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.PhoneNumber.ShortCode, e.Message), p.DEBUG && !COMPILED && (proto.google.type.PhoneNumber.ShortCode.displayName = "proto.google.type.PhoneNumber.ShortCode"), proto.google.type.PhoneNumber.oneofGroups_ = [[1, 2]], proto.google.type.PhoneNumber.KindCase = {
    KIND_NOT_SET: 0,
    E164_NUMBER: 1,
    SHORT_CODE: 2
  }, proto.google.type.PhoneNumber.prototype.getKindCase = function() {
    return (
      /** @type {proto.google.type.PhoneNumber.KindCase} */
      e.Message.computeOneofCase(this, proto.google.type.PhoneNumber.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.PhoneNumber.prototype.toObject = function(o) {
    return proto.google.type.PhoneNumber.toObject(o, this);
  }, proto.google.type.PhoneNumber.toObject = function(o, a) {
    var i, u = {
      e164Number: e.Message.getFieldWithDefault(a, 1, ""),
      shortCode: (i = a.getShortCode()) && proto.google.type.PhoneNumber.ShortCode.toObject(o, i),
      extension: e.Message.getFieldWithDefault(a, 3, "")
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.type.PhoneNumber.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.PhoneNumber();
    return proto.google.type.PhoneNumber.deserializeBinaryFromReader(i, a);
  }, proto.google.type.PhoneNumber.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setE164Number(u);
          break;
        case 2:
          var u = new proto.google.type.PhoneNumber.ShortCode();
          a.readMessage(u, proto.google.type.PhoneNumber.ShortCode.deserializeBinaryFromReader), o.setShortCode(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setExtension$(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.PhoneNumber.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.PhoneNumber.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.PhoneNumber.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = o.getShortCode(), i != null && a.writeMessage(
      2,
      i,
      proto.google.type.PhoneNumber.ShortCode.serializeBinaryToWriter
    ), i = o.getExtension$(), i.length > 0 && a.writeString(
      3,
      i
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.PhoneNumber.ShortCode.prototype.toObject = function(o) {
    return proto.google.type.PhoneNumber.ShortCode.toObject(o, this);
  }, proto.google.type.PhoneNumber.ShortCode.toObject = function(o, a) {
    var i = {
      regionCode: e.Message.getFieldWithDefault(a, 1, ""),
      number: e.Message.getFieldWithDefault(a, 2, "")
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.PhoneNumber.ShortCode.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.PhoneNumber.ShortCode();
    return proto.google.type.PhoneNumber.ShortCode.deserializeBinaryFromReader(i, a);
  }, proto.google.type.PhoneNumber.ShortCode.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setRegionCode(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setNumber(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.PhoneNumber.ShortCode.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.PhoneNumber.ShortCode.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.PhoneNumber.ShortCode.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getRegionCode(), i.length > 0 && a.writeString(
      1,
      i
    ), i = o.getNumber(), i.length > 0 && a.writeString(
      2,
      i
    );
  }, proto.google.type.PhoneNumber.ShortCode.prototype.getRegionCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.PhoneNumber.ShortCode.prototype.setRegionCode = function(o) {
    return e.Message.setProto3StringField(this, 1, o);
  }, proto.google.type.PhoneNumber.ShortCode.prototype.getNumber = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.type.PhoneNumber.ShortCode.prototype.setNumber = function(o) {
    return e.Message.setProto3StringField(this, 2, o);
  }, proto.google.type.PhoneNumber.prototype.getE164Number = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.PhoneNumber.prototype.setE164Number = function(o) {
    return e.Message.setOneofField(this, 1, proto.google.type.PhoneNumber.oneofGroups_[0], o);
  }, proto.google.type.PhoneNumber.prototype.clearE164Number = function() {
    return e.Message.setOneofField(this, 1, proto.google.type.PhoneNumber.oneofGroups_[0], void 0);
  }, proto.google.type.PhoneNumber.prototype.hasE164Number = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.type.PhoneNumber.prototype.getShortCode = function() {
    return (
      /** @type{?proto.google.type.PhoneNumber.ShortCode} */
      e.Message.getWrapperField(this, proto.google.type.PhoneNumber.ShortCode, 2)
    );
  }, proto.google.type.PhoneNumber.prototype.setShortCode = function(o) {
    return e.Message.setOneofWrapperField(this, 2, proto.google.type.PhoneNumber.oneofGroups_[0], o);
  }, proto.google.type.PhoneNumber.prototype.clearShortCode = function() {
    return this.setShortCode(void 0);
  }, proto.google.type.PhoneNumber.prototype.hasShortCode = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.type.PhoneNumber.prototype.getExtension$ = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.type.PhoneNumber.prototype.setExtension$ = function(o) {
    return e.Message.setProto3StringField(this, 3, o);
  }, p.object.extend(s, proto.google.type);
})(ri);
var gn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.PostalAddress", null, c), proto.google.type.PostalAddress = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.google.type.PostalAddress.repeatedFields_, null);
  }, p.inherits(proto.google.type.PostalAddress, e.Message), p.DEBUG && !COMPILED && (proto.google.type.PostalAddress.displayName = "proto.google.type.PostalAddress"), proto.google.type.PostalAddress.repeatedFields_ = [9, 10], e.Message.GENERATE_TO_OBJECT && (proto.google.type.PostalAddress.prototype.toObject = function(o) {
    return proto.google.type.PostalAddress.toObject(o, this);
  }, proto.google.type.PostalAddress.toObject = function(o, a) {
    var i, u = {
      revision: e.Message.getFieldWithDefault(a, 1, 0),
      regionCode: e.Message.getFieldWithDefault(a, 2, ""),
      languageCode: e.Message.getFieldWithDefault(a, 3, ""),
      postalCode: e.Message.getFieldWithDefault(a, 4, ""),
      sortingCode: e.Message.getFieldWithDefault(a, 5, ""),
      administrativeArea: e.Message.getFieldWithDefault(a, 6, ""),
      locality: e.Message.getFieldWithDefault(a, 7, ""),
      sublocality: e.Message.getFieldWithDefault(a, 8, ""),
      addressLinesList: (i = e.Message.getRepeatedField(a, 9)) == null ? void 0 : i,
      recipientsList: (i = e.Message.getRepeatedField(a, 10)) == null ? void 0 : i,
      organization: e.Message.getFieldWithDefault(a, 11, "")
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.type.PostalAddress.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.PostalAddress();
    return proto.google.type.PostalAddress.deserializeBinaryFromReader(i, a);
  }, proto.google.type.PostalAddress.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setRevision(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setRegionCode(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setLanguageCode(u);
          break;
        case 4:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setPostalCode(u);
          break;
        case 5:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setSortingCode(u);
          break;
        case 6:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setAdministrativeArea(u);
          break;
        case 7:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setLocality(u);
          break;
        case 8:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setSublocality(u);
          break;
        case 9:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.addAddressLines(u);
          break;
        case 10:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.addRecipients(u);
          break;
        case 11:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setOrganization(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.PostalAddress.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.PostalAddress.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.PostalAddress.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getRevision(), i !== 0 && a.writeInt32(
      1,
      i
    ), i = o.getRegionCode(), i.length > 0 && a.writeString(
      2,
      i
    ), i = o.getLanguageCode(), i.length > 0 && a.writeString(
      3,
      i
    ), i = o.getPostalCode(), i.length > 0 && a.writeString(
      4,
      i
    ), i = o.getSortingCode(), i.length > 0 && a.writeString(
      5,
      i
    ), i = o.getAdministrativeArea(), i.length > 0 && a.writeString(
      6,
      i
    ), i = o.getLocality(), i.length > 0 && a.writeString(
      7,
      i
    ), i = o.getSublocality(), i.length > 0 && a.writeString(
      8,
      i
    ), i = o.getAddressLinesList(), i.length > 0 && a.writeRepeatedString(
      9,
      i
    ), i = o.getRecipientsList(), i.length > 0 && a.writeRepeatedString(
      10,
      i
    ), i = o.getOrganization(), i.length > 0 && a.writeString(
      11,
      i
    );
  }, proto.google.type.PostalAddress.prototype.getRevision = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.PostalAddress.prototype.setRevision = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, proto.google.type.PostalAddress.prototype.getRegionCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.type.PostalAddress.prototype.setRegionCode = function(o) {
    return e.Message.setProto3StringField(this, 2, o);
  }, proto.google.type.PostalAddress.prototype.getLanguageCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.type.PostalAddress.prototype.setLanguageCode = function(o) {
    return e.Message.setProto3StringField(this, 3, o);
  }, proto.google.type.PostalAddress.prototype.getPostalCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.google.type.PostalAddress.prototype.setPostalCode = function(o) {
    return e.Message.setProto3StringField(this, 4, o);
  }, proto.google.type.PostalAddress.prototype.getSortingCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.google.type.PostalAddress.prototype.setSortingCode = function(o) {
    return e.Message.setProto3StringField(this, 5, o);
  }, proto.google.type.PostalAddress.prototype.getAdministrativeArea = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.google.type.PostalAddress.prototype.setAdministrativeArea = function(o) {
    return e.Message.setProto3StringField(this, 6, o);
  }, proto.google.type.PostalAddress.prototype.getLocality = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.google.type.PostalAddress.prototype.setLocality = function(o) {
    return e.Message.setProto3StringField(this, 7, o);
  }, proto.google.type.PostalAddress.prototype.getSublocality = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 8, "")
    );
  }, proto.google.type.PostalAddress.prototype.setSublocality = function(o) {
    return e.Message.setProto3StringField(this, 8, o);
  }, proto.google.type.PostalAddress.prototype.getAddressLinesList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 9)
    );
  }, proto.google.type.PostalAddress.prototype.setAddressLinesList = function(o) {
    return e.Message.setField(this, 9, o || []);
  }, proto.google.type.PostalAddress.prototype.addAddressLines = function(o, a) {
    return e.Message.addToRepeatedField(this, 9, o, a);
  }, proto.google.type.PostalAddress.prototype.clearAddressLinesList = function() {
    return this.setAddressLinesList([]);
  }, proto.google.type.PostalAddress.prototype.getRecipientsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 10)
    );
  }, proto.google.type.PostalAddress.prototype.setRecipientsList = function(o) {
    return e.Message.setField(this, 10, o || []);
  }, proto.google.type.PostalAddress.prototype.addRecipients = function(o, a) {
    return e.Message.addToRepeatedField(this, 10, o, a);
  }, proto.google.type.PostalAddress.prototype.clearRecipientsList = function() {
    return this.setRecipientsList([]);
  }, proto.google.type.PostalAddress.prototype.getOrganization = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.google.type.PostalAddress.prototype.setOrganization = function(o) {
    return e.Message.setProto3StringField(this, 11, o);
  }, p.object.extend(s, proto.google.type);
})(gn);
var dn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.TimeOfDay", null, c), proto.google.type.TimeOfDay = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.TimeOfDay, e.Message), p.DEBUG && !COMPILED && (proto.google.type.TimeOfDay.displayName = "proto.google.type.TimeOfDay"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.TimeOfDay.prototype.toObject = function(o) {
    return proto.google.type.TimeOfDay.toObject(o, this);
  }, proto.google.type.TimeOfDay.toObject = function(o, a) {
    var i = {
      hours: e.Message.getFieldWithDefault(a, 1, 0),
      minutes: e.Message.getFieldWithDefault(a, 2, 0),
      seconds: e.Message.getFieldWithDefault(a, 3, 0),
      nanos: e.Message.getFieldWithDefault(a, 4, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.TimeOfDay.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.TimeOfDay();
    return proto.google.type.TimeOfDay.deserializeBinaryFromReader(i, a);
  }, proto.google.type.TimeOfDay.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setHours(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setMinutes(u);
          break;
        case 3:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setSeconds(u);
          break;
        case 4:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNanos(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.TimeOfDay.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.TimeOfDay.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.TimeOfDay.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getHours(), i !== 0 && a.writeInt32(
      1,
      i
    ), i = o.getMinutes(), i !== 0 && a.writeInt32(
      2,
      i
    ), i = o.getSeconds(), i !== 0 && a.writeInt32(
      3,
      i
    ), i = o.getNanos(), i !== 0 && a.writeInt32(
      4,
      i
    );
  }, proto.google.type.TimeOfDay.prototype.getHours = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setHours = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, proto.google.type.TimeOfDay.prototype.getMinutes = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setMinutes = function(o) {
    return e.Message.setProto3IntField(this, 2, o);
  }, proto.google.type.TimeOfDay.prototype.getSeconds = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setSeconds = function(o) {
    return e.Message.setProto3IntField(this, 3, o);
  }, proto.google.type.TimeOfDay.prototype.getNanos = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setNanos = function(o) {
    return e.Message.setProto3IntField(this, 4, o);
  }, p.object.extend(s, proto.google.type);
})(dn);
var D = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = ei;
  p.object.extend(proto, o);
  var a = Ut;
  p.object.extend(proto, a);
  var i = he;
  p.object.extend(proto, i);
  var u = ti;
  p.object.extend(proto, u);
  var y = oi;
  p.object.extend(proto, y);
  var h = sn;
  p.object.extend(proto, h);
  var B = ln;
  p.object.extend(proto, B);
  var C = un;
  p.object.extend(proto, C);
  var M = ri;
  p.object.extend(proto, M);
  var I = gn;
  p.object.extend(proto, I);
  var $ = dn;
  p.object.extend(proto, $), p.exportSymbol("proto.api.patient.v1.Appointment", null, c), p.exportSymbol("proto.api.patient.v1.AppointmentClaim", null, c), p.exportSymbol("proto.api.patient.v1.BookingMeta", null, c), p.exportSymbol("proto.api.patient.v1.BookingStatus", null, c), p.exportSymbol("proto.api.patient.v1.CancelBookingRequest", null, c), p.exportSymbol("proto.api.patient.v1.CancelBookingResponse", null, c), p.exportSymbol("proto.api.patient.v1.CancelBookingResponse.Failure", null, c), p.exportSymbol("proto.api.patient.v1.CancelBookingResponse.Failure.ErrorCase", null, c), p.exportSymbol("proto.api.patient.v1.CancelBookingResponse.ResultCase", null, c), p.exportSymbol("proto.api.patient.v1.CancelBookingResponse.Success", null, c), p.exportSymbol("proto.api.patient.v1.Caregiver", null, c), p.exportSymbol("proto.api.patient.v1.Clinic", null, c), p.exportSymbol("proto.api.patient.v1.ClinicHours", null, c), p.exportSymbol("proto.api.patient.v1.ClinicImageCard", null, c), p.exportSymbol("proto.api.patient.v1.ClinicImages", null, c), p.exportSymbol("proto.api.patient.v1.ClinicKeyword", null, c), p.exportSymbol("proto.api.patient.v1.ClinicLanguage", null, c), p.exportSymbol("proto.api.patient.v1.ClinicLocation", null, c), p.exportSymbol("proto.api.patient.v1.ClinicLocation.Loc", null, c), p.exportSymbol("proto.api.patient.v1.ClinicMembership", null, c), p.exportSymbol("proto.api.patient.v1.ClinicMeta", null, c), p.exportSymbol("proto.api.patient.v1.ClinicOption", null, c), p.exportSymbol("proto.api.patient.v1.ClinicOptionType", null, c), p.exportSymbol("proto.api.patient.v1.ClinicOutofServicePeriods", null, c), p.exportSymbol("proto.api.patient.v1.ClinicPaymentOption", null, c), p.exportSymbol("proto.api.patient.v1.ClinicStaff", null, c), p.exportSymbol("proto.api.patient.v1.ClinicStatistics", null, c), p.exportSymbol("proto.api.patient.v1.ClinicSubscriptionType", null, c), p.exportSymbol("proto.api.patient.v1.ClinicTreatment", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingInquiryRequest", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingInquiryResponse", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingInquiryResponse.Failure", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingInquiryResponse.Failure.ErrorCase", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingInquiryResponse.ResultCase", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingInquiryResponse.Success", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingRequest", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingResponse", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingResponse.BookingAction", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingResponse.Failure", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingResponse.Failure.ErrorCase", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingResponse.PendingActions", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingResponse.ResultCase", null, c), p.exportSymbol("proto.api.patient.v1.CreateBookingResponse.Success", null, c), p.exportSymbol("proto.api.patient.v1.CreateReviewForClinicRequest", null, c), p.exportSymbol("proto.api.patient.v1.CreateReviewForClinicResponse", null, c), p.exportSymbol("proto.api.patient.v1.DeviceMeta", null, c), p.exportSymbol("proto.api.patient.v1.DeviceMeta.Type", null, c), p.exportSymbol("proto.api.patient.v1.FindAppointmentsPerClinicRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindAppointmentsPerClinicRequest.Sorting", null, c), p.exportSymbol("proto.api.patient.v1.FindAppointmentsPerClinicResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic", null, c), p.exportSymbol("proto.api.patient.v1.FindAppointmentsRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindAppointmentsRequest.Sorting", null, c), p.exportSymbol("proto.api.patient.v1.FindAppointmentsResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByIdsRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByIdsResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintCase", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationRequest.Sorting", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo", null, c), p.exportSymbol("proto.api.patient.v1.FindLocationsRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindLocationsResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindMyExternalBookingsRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindMyExternalBookingsResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking", null, c), p.exportSymbol("proto.api.patient.v1.FindReviewsForClinicRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindReviewsForClinicResponse", null, c), p.exportSymbol("proto.api.patient.v1.FindTreatmentsRequest", null, c), p.exportSymbol("proto.api.patient.v1.FindTreatmentsResponse", null, c), p.exportSymbol("proto.api.patient.v1.Gender", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodRequest", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodRequest.BookingCase", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodResponse", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodResponse.MethodCase", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.Provider", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodResponse.None", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodResponse.Payment", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.Provider", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingFlowTypeRequest", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingFlowTypeResponse", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingFlowTypeResponse.BookingFlowType", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingStatusRequest", null, c), p.exportSymbol("proto.api.patient.v1.GetBookingStatusResponse", null, c), p.exportSymbol("proto.api.patient.v1.GetClinicRequest", null, c), p.exportSymbol("proto.api.patient.v1.GetClinicRequest.IdentifierCase", null, c), p.exportSymbol("proto.api.patient.v1.GetClinicResponse", null, c), p.exportSymbol("proto.api.patient.v1.GetReviewRequestInfoRequest", null, c), p.exportSymbol("proto.api.patient.v1.GetReviewRequestInfoResponse", null, c), p.exportSymbol("proto.api.patient.v1.GetReviewsScoreForClinicRequest", null, c), p.exportSymbol("proto.api.patient.v1.GetReviewsScoreForClinicResponse", null, c), p.exportSymbol("proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore", null, c), p.exportSymbol("proto.api.patient.v1.Location", null, c), p.exportSymbol("proto.api.patient.v1.LocationType", null, c), p.exportSymbol("proto.api.patient.v1.LookupPatientRequest", null, c), p.exportSymbol("proto.api.patient.v1.LookupPatientRequest.IdentifierCase", null, c), p.exportSymbol("proto.api.patient.v1.LookupPatientResponse", null, c), p.exportSymbol("proto.api.patient.v1.LookupPatientResponse.Patient", null, c), p.exportSymbol("proto.api.patient.v1.PatientExistsRequest", null, c), p.exportSymbol("proto.api.patient.v1.PatientExistsResponse", null, c), p.exportSymbol("proto.api.patient.v1.PatientInfo", null, c), p.exportSymbol("proto.api.patient.v1.PatientInfo.PidCase", null, c), p.exportSymbol("proto.api.patient.v1.Price", null, c), p.exportSymbol("proto.api.patient.v1.Price.PriceCase", null, c), p.exportSymbol("proto.api.patient.v1.Price.ReducedPrice", null, c), p.exportSymbol("proto.api.patient.v1.Price.StandardPrice", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingRequest", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingRequest.ActionCase", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingResponse", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData", null, c), p.exportSymbol("proto.api.patient.v1.ProceedBookingResponse.SessionDataCase", null, c), p.exportSymbol("proto.api.patient.v1.Review", null, c), p.exportSymbol("proto.api.patient.v1.Review.Answer", null, c), p.exportSymbol("proto.api.patient.v1.Review.Origin", null, c), p.exportSymbol("proto.api.patient.v1.ReviewPrompt", null, c), p.exportSymbol("proto.api.patient.v1.ReviewPrompt.Type", null, c), p.exportSymbol("proto.api.patient.v1.ReviewRequest", null, c), p.exportSymbol("proto.api.patient.v1.SwedishPersonalIdentityNumber", null, c), p.exportSymbol("proto.api.patient.v1.Treatment", null, c), p.exportSymbol("proto.api.patient.v1.TreatmentInquiry", null, c), p.exportSymbol("proto.api.patient.v1.ValidatePromoCodeRequest", null, c), p.exportSymbol("proto.api.patient.v1.ValidatePromoCodeResponse", null, c), p.exportSymbol("proto.api.patient.v1.ValidatePromoCodeResponse.DiscountType", null, c), p.exportSymbol("proto.api.patient.v1.ValidatePromoCodeResponse.PatientRelationshipType", null, c), p.exportSymbol("proto.api.patient.v1.ValidatePromoCodeResponse.ResultCase", null, c), p.exportSymbol("proto.api.patient.v1.ValidatePromoCodeResponse.Success", null, c), proto.api.patient.v1.Price = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.Price.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.Price, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Price.displayName = "proto.api.patient.v1.Price"), proto.api.patient.v1.Price.StandardPrice = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Price.StandardPrice, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Price.StandardPrice.displayName = "proto.api.patient.v1.Price.StandardPrice"), proto.api.patient.v1.Price.ReducedPrice = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Price.ReducedPrice, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Price.ReducedPrice.displayName = "proto.api.patient.v1.Price.ReducedPrice"), proto.api.patient.v1.SwedishPersonalIdentityNumber = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.SwedishPersonalIdentityNumber, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.SwedishPersonalIdentityNumber.displayName = "proto.api.patient.v1.SwedishPersonalIdentityNumber"), proto.api.patient.v1.Location = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Location, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Location.displayName = "proto.api.patient.v1.Location"), proto.api.patient.v1.FindLocationsRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindLocationsRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindLocationsRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindLocationsRequest.displayName = "proto.api.patient.v1.FindLocationsRequest"), proto.api.patient.v1.FindLocationsResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindLocationsResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindLocationsResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindLocationsResponse.displayName = "proto.api.patient.v1.FindLocationsResponse"), proto.api.patient.v1.Treatment = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Treatment, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Treatment.displayName = "proto.api.patient.v1.Treatment"), proto.api.patient.v1.FindTreatmentsRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindTreatmentsRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindTreatmentsRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindTreatmentsRequest.displayName = "proto.api.patient.v1.FindTreatmentsRequest"), proto.api.patient.v1.FindTreatmentsResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindTreatmentsResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindTreatmentsResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindTreatmentsResponse.displayName = "proto.api.patient.v1.FindTreatmentsResponse"), proto.api.patient.v1.ClinicHours = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicHours, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicHours.displayName = "proto.api.patient.v1.ClinicHours"), proto.api.patient.v1.ClinicOutofServicePeriods = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicOutofServicePeriods, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicOutofServicePeriods.displayName = "proto.api.patient.v1.ClinicOutofServicePeriods"), proto.api.patient.v1.ClinicKeyword = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicKeyword, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicKeyword.displayName = "proto.api.patient.v1.ClinicKeyword"), proto.api.patient.v1.ClinicLanguage = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicLanguage, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicLanguage.displayName = "proto.api.patient.v1.ClinicLanguage"), proto.api.patient.v1.ClinicOption = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicOption, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicOption.displayName = "proto.api.patient.v1.ClinicOption"), proto.api.patient.v1.ClinicPaymentOption = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicPaymentOption, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicPaymentOption.displayName = "proto.api.patient.v1.ClinicPaymentOption"), proto.api.patient.v1.ClinicImages = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.ClinicImages.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.ClinicImages, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicImages.displayName = "proto.api.patient.v1.ClinicImages"), proto.api.patient.v1.ClinicImageCard = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicImageCard, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicImageCard.displayName = "proto.api.patient.v1.ClinicImageCard"), proto.api.patient.v1.ClinicMembership = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicMembership, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicMembership.displayName = "proto.api.patient.v1.ClinicMembership"), proto.api.patient.v1.ClinicStaff = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicStaff, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicStaff.displayName = "proto.api.patient.v1.ClinicStaff"), proto.api.patient.v1.ClinicTreatment = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicTreatment, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicTreatment.displayName = "proto.api.patient.v1.ClinicTreatment"), proto.api.patient.v1.ClinicLocation = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicLocation, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicLocation.displayName = "proto.api.patient.v1.ClinicLocation"), proto.api.patient.v1.ClinicLocation.Loc = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicLocation.Loc, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicLocation.Loc.displayName = "proto.api.patient.v1.ClinicLocation.Loc"), proto.api.patient.v1.ClinicMeta = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicMeta, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicMeta.displayName = "proto.api.patient.v1.ClinicMeta"), proto.api.patient.v1.Clinic = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.Clinic.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.Clinic, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Clinic.displayName = "proto.api.patient.v1.Clinic"), proto.api.patient.v1.ClinicStatistics = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ClinicStatistics, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ClinicStatistics.displayName = "proto.api.patient.v1.ClinicStatistics"), proto.api.patient.v1.FindClinicsByLocationRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindClinicsByLocationRequest.repeatedFields_, proto.api.patient.v1.FindClinicsByLocationRequest.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.FindClinicsByLocationRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByLocationRequest.displayName = "proto.api.patient.v1.FindClinicsByLocationRequest"), proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.displayName = "proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint"), proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.displayName = "proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox"), proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.displayName = "proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry"), proto.api.patient.v1.FindClinicsByLocationResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindClinicsByLocationResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByLocationResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByLocationResponse.displayName = "proto.api.patient.v1.FindClinicsByLocationResponse"), proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.displayName = "proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo"), proto.api.patient.v1.GetClinicRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.GetClinicRequest.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.GetClinicRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetClinicRequest.displayName = "proto.api.patient.v1.GetClinicRequest"), proto.api.patient.v1.GetClinicResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetClinicResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetClinicResponse.displayName = "proto.api.patient.v1.GetClinicResponse"), proto.api.patient.v1.FindClinicsByIdsRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindClinicsByIdsRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByIdsRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByIdsRequest.displayName = "proto.api.patient.v1.FindClinicsByIdsRequest"), proto.api.patient.v1.FindClinicsByIdsResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindClinicsByIdsResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByIdsResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByIdsResponse.displayName = "proto.api.patient.v1.FindClinicsByIdsResponse"), proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.displayName = "proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo"), proto.api.patient.v1.Appointment = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Appointment, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Appointment.displayName = "proto.api.patient.v1.Appointment"), proto.api.patient.v1.Caregiver = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Caregiver, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Caregiver.displayName = "proto.api.patient.v1.Caregiver"), proto.api.patient.v1.FindAppointmentsRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAppointmentsRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAppointmentsRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAppointmentsRequest.displayName = "proto.api.patient.v1.FindAppointmentsRequest"), proto.api.patient.v1.FindAppointmentsResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAppointmentsResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAppointmentsResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAppointmentsResponse.displayName = "proto.api.patient.v1.FindAppointmentsResponse"), proto.api.patient.v1.FindAppointmentsPerClinicRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAppointmentsPerClinicRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAppointmentsPerClinicRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAppointmentsPerClinicRequest.displayName = "proto.api.patient.v1.FindAppointmentsPerClinicRequest"), proto.api.patient.v1.FindAppointmentsPerClinicResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAppointmentsPerClinicResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAppointmentsPerClinicResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAppointmentsPerClinicResponse.displayName = "proto.api.patient.v1.FindAppointmentsPerClinicResponse"), proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.displayName = "proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic"), proto.api.patient.v1.PatientInfo = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.PatientInfo.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.PatientInfo, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.PatientInfo.displayName = "proto.api.patient.v1.PatientInfo"), proto.api.patient.v1.AppointmentClaim = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.AppointmentClaim, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.AppointmentClaim.displayName = "proto.api.patient.v1.AppointmentClaim"), proto.api.patient.v1.TreatmentInquiry = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.TreatmentInquiry, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.TreatmentInquiry.displayName = "proto.api.patient.v1.TreatmentInquiry"), proto.api.patient.v1.GetBookingFlowTypeRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetBookingFlowTypeRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingFlowTypeRequest.displayName = "proto.api.patient.v1.GetBookingFlowTypeRequest"), proto.api.patient.v1.GetBookingFlowTypeResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetBookingFlowTypeResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingFlowTypeResponse.displayName = "proto.api.patient.v1.GetBookingFlowTypeResponse"), proto.api.patient.v1.GetBookingAuthMethodRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.GetBookingAuthMethodRequest.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.GetBookingAuthMethodRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingAuthMethodRequest.displayName = "proto.api.patient.v1.GetBookingAuthMethodRequest"), proto.api.patient.v1.GetBookingAuthMethodResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.GetBookingAuthMethodResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.GetBookingAuthMethodResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingAuthMethodResponse.displayName = "proto.api.patient.v1.GetBookingAuthMethodResponse"), proto.api.patient.v1.GetBookingAuthMethodResponse.None = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetBookingAuthMethodResponse.None, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingAuthMethodResponse.None.displayName = "proto.api.patient.v1.GetBookingAuthMethodResponse.None"), proto.api.patient.v1.GetBookingAuthMethodResponse.Payment = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetBookingAuthMethodResponse.Payment, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.displayName = "proto.api.patient.v1.GetBookingAuthMethodResponse.Payment"), proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.displayName = "proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa"), proto.api.patient.v1.CreateBookingRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CreateBookingRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingRequest.displayName = "proto.api.patient.v1.CreateBookingRequest"), proto.api.patient.v1.CreateBookingResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.CreateBookingResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.CreateBookingResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingResponse.displayName = "proto.api.patient.v1.CreateBookingResponse"), proto.api.patient.v1.CreateBookingResponse.Success = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CreateBookingResponse.Success, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingResponse.Success.displayName = "proto.api.patient.v1.CreateBookingResponse.Success"), proto.api.patient.v1.CreateBookingResponse.Failure = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.CreateBookingResponse.Failure.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.CreateBookingResponse.Failure, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingResponse.Failure.displayName = "proto.api.patient.v1.CreateBookingResponse.Failure"), proto.api.patient.v1.CreateBookingResponse.PendingActions = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.CreateBookingResponse.PendingActions.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.CreateBookingResponse.PendingActions, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingResponse.PendingActions.displayName = "proto.api.patient.v1.CreateBookingResponse.PendingActions"), proto.api.patient.v1.ProceedBookingRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.ProceedBookingRequest.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.ProceedBookingRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ProceedBookingRequest.displayName = "proto.api.patient.v1.ProceedBookingRequest"), proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.displayName = "proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization"), proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.displayName = "proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication"), proto.api.patient.v1.ProceedBookingResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.ProceedBookingResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.ProceedBookingResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ProceedBookingResponse.displayName = "proto.api.patient.v1.ProceedBookingResponse"), proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.displayName = "proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData"), proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.displayName = "proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData"), proto.api.patient.v1.GetBookingStatusRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetBookingStatusRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingStatusRequest.displayName = "proto.api.patient.v1.GetBookingStatusRequest"), proto.api.patient.v1.GetBookingStatusResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetBookingStatusResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetBookingStatusResponse.displayName = "proto.api.patient.v1.GetBookingStatusResponse"), proto.api.patient.v1.CreateBookingInquiryRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CreateBookingInquiryRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingInquiryRequest.displayName = "proto.api.patient.v1.CreateBookingInquiryRequest"), proto.api.patient.v1.CreateBookingInquiryResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.CreateBookingInquiryResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.CreateBookingInquiryResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingInquiryResponse.displayName = "proto.api.patient.v1.CreateBookingInquiryResponse"), proto.api.patient.v1.CreateBookingInquiryResponse.Success = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CreateBookingInquiryResponse.Success, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingInquiryResponse.Success.displayName = "proto.api.patient.v1.CreateBookingInquiryResponse.Success"), proto.api.patient.v1.CreateBookingInquiryResponse.Failure = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.CreateBookingInquiryResponse.Failure, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateBookingInquiryResponse.Failure.displayName = "proto.api.patient.v1.CreateBookingInquiryResponse.Failure"), proto.api.patient.v1.DeviceMeta = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.DeviceMeta, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.DeviceMeta.displayName = "proto.api.patient.v1.DeviceMeta"), proto.api.patient.v1.BookingMeta = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.BookingMeta, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.BookingMeta.displayName = "proto.api.patient.v1.BookingMeta"), proto.api.patient.v1.CancelBookingRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CancelBookingRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CancelBookingRequest.displayName = "proto.api.patient.v1.CancelBookingRequest"), proto.api.patient.v1.CancelBookingResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.CancelBookingResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.CancelBookingResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CancelBookingResponse.displayName = "proto.api.patient.v1.CancelBookingResponse"), proto.api.patient.v1.CancelBookingResponse.Success = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CancelBookingResponse.Success, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CancelBookingResponse.Success.displayName = "proto.api.patient.v1.CancelBookingResponse.Success"), proto.api.patient.v1.CancelBookingResponse.Failure = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.CancelBookingResponse.Failure.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.CancelBookingResponse.Failure, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CancelBookingResponse.Failure.displayName = "proto.api.patient.v1.CancelBookingResponse.Failure"), proto.api.patient.v1.FindMyExternalBookingsRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindMyExternalBookingsRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindMyExternalBookingsRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindMyExternalBookingsRequest.displayName = "proto.api.patient.v1.FindMyExternalBookingsRequest"), proto.api.patient.v1.FindMyExternalBookingsResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindMyExternalBookingsResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindMyExternalBookingsResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindMyExternalBookingsResponse.displayName = "proto.api.patient.v1.FindMyExternalBookingsResponse"), proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.displayName = "proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking"), proto.api.patient.v1.Review = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.Review.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.Review, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Review.displayName = "proto.api.patient.v1.Review"), proto.api.patient.v1.Review.Answer = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Review.Answer, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Review.Answer.displayName = "proto.api.patient.v1.Review.Answer"), proto.api.patient.v1.Review.Origin = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.Review.Origin, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.Review.Origin.displayName = "proto.api.patient.v1.Review.Origin"), proto.api.patient.v1.ReviewRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ReviewRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ReviewRequest.displayName = "proto.api.patient.v1.ReviewRequest"), proto.api.patient.v1.FindReviewsForClinicRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindReviewsForClinicRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindReviewsForClinicRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindReviewsForClinicRequest.displayName = "proto.api.patient.v1.FindReviewsForClinicRequest"), proto.api.patient.v1.FindReviewsForClinicResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindReviewsForClinicResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindReviewsForClinicResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindReviewsForClinicResponse.displayName = "proto.api.patient.v1.FindReviewsForClinicResponse"), proto.api.patient.v1.GetReviewsScoreForClinicRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetReviewsScoreForClinicRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetReviewsScoreForClinicRequest.displayName = "proto.api.patient.v1.GetReviewsScoreForClinicRequest"), proto.api.patient.v1.GetReviewsScoreForClinicResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetReviewsScoreForClinicResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetReviewsScoreForClinicResponse.displayName = "proto.api.patient.v1.GetReviewsScoreForClinicResponse"), proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.displayName = "proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore"), proto.api.patient.v1.CreateReviewForClinicRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CreateReviewForClinicRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateReviewForClinicRequest.displayName = "proto.api.patient.v1.CreateReviewForClinicRequest"), proto.api.patient.v1.CreateReviewForClinicResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.CreateReviewForClinicResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.CreateReviewForClinicResponse.displayName = "proto.api.patient.v1.CreateReviewForClinicResponse"), proto.api.patient.v1.GetReviewRequestInfoRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetReviewRequestInfoRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetReviewRequestInfoRequest.displayName = "proto.api.patient.v1.GetReviewRequestInfoRequest"), proto.api.patient.v1.GetReviewRequestInfoResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.GetReviewRequestInfoResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.GetReviewRequestInfoResponse.displayName = "proto.api.patient.v1.GetReviewRequestInfoResponse"), proto.api.patient.v1.LookupPatientRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.LookupPatientRequest.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.LookupPatientRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.LookupPatientRequest.displayName = "proto.api.patient.v1.LookupPatientRequest"), proto.api.patient.v1.LookupPatientResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.LookupPatientResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.LookupPatientResponse.displayName = "proto.api.patient.v1.LookupPatientResponse"), proto.api.patient.v1.LookupPatientResponse.Patient = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.LookupPatientResponse.Patient, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.LookupPatientResponse.Patient.displayName = "proto.api.patient.v1.LookupPatientResponse.Patient"), proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.displayName = "proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest"), proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.displayName = "proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse"), proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic = function(t) {
    e.Message.initialize(this, t, 0, -1, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.repeatedFields_, null);
  }, p.inherits(proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.displayName = "proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic"), proto.api.patient.v1.ValidatePromoCodeRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ValidatePromoCodeRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ValidatePromoCodeRequest.displayName = "proto.api.patient.v1.ValidatePromoCodeRequest"), proto.api.patient.v1.ValidatePromoCodeResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, proto.api.patient.v1.ValidatePromoCodeResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.v1.ValidatePromoCodeResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ValidatePromoCodeResponse.displayName = "proto.api.patient.v1.ValidatePromoCodeResponse"), proto.api.patient.v1.ValidatePromoCodeResponse.Success = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ValidatePromoCodeResponse.Success, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ValidatePromoCodeResponse.Success.displayName = "proto.api.patient.v1.ValidatePromoCodeResponse.Success"), proto.api.patient.v1.PatientExistsRequest = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.PatientExistsRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.PatientExistsRequest.displayName = "proto.api.patient.v1.PatientExistsRequest"), proto.api.patient.v1.PatientExistsResponse = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.PatientExistsResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.PatientExistsResponse.displayName = "proto.api.patient.v1.PatientExistsResponse"), proto.api.patient.v1.ReviewPrompt = function(t) {
    e.Message.initialize(this, t, 0, -1, null, null);
  }, p.inherits(proto.api.patient.v1.ReviewPrompt, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.v1.ReviewPrompt.displayName = "proto.api.patient.v1.ReviewPrompt"), proto.api.patient.v1.Price.oneofGroups_ = [[1, 2]], proto.api.patient.v1.Price.PriceCase = {
    PRICE_NOT_SET: 0,
    STANDARD_PRICE: 1,
    REDUCED_PRICE: 2
  }, proto.api.patient.v1.Price.prototype.getPriceCase = function() {
    return (
      /** @type {proto.api.patient.v1.Price.PriceCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.Price.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Price.prototype.toObject = function(t) {
    return proto.api.patient.v1.Price.toObject(t, this);
  }, proto.api.patient.v1.Price.toObject = function(t, r) {
    var n, d = {
      standardPrice: (n = r.getStandardPrice()) && proto.api.patient.v1.Price.StandardPrice.toObject(t, n),
      reducedPrice: (n = r.getReducedPrice()) && proto.api.patient.v1.Price.ReducedPrice.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Price.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Price();
    return proto.api.patient.v1.Price.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Price.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Price.StandardPrice();
          r.readMessage(d, proto.api.patient.v1.Price.StandardPrice.deserializeBinaryFromReader), t.setStandardPrice(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.Price.ReducedPrice();
          r.readMessage(d, proto.api.patient.v1.Price.ReducedPrice.deserializeBinaryFromReader), t.setReducedPrice(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Price.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Price.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Price.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getStandardPrice(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.Price.StandardPrice.serializeBinaryToWriter
    ), n = t.getReducedPrice(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.Price.ReducedPrice.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Price.StandardPrice.prototype.toObject = function(t) {
    return proto.api.patient.v1.Price.StandardPrice.toObject(t, this);
  }, proto.api.patient.v1.Price.StandardPrice.toObject = function(t, r) {
    var n, d = {
      price: (n = r.getPrice()) && C.Money.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Price.StandardPrice.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Price.StandardPrice();
    return proto.api.patient.v1.Price.StandardPrice.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Price.StandardPrice.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new C.Money();
          r.readMessage(d, C.Money.deserializeBinaryFromReader), t.setPrice(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Price.StandardPrice.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Price.StandardPrice.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Price.StandardPrice.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getPrice(), n != null && r.writeMessage(
      1,
      n,
      C.Money.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Price.StandardPrice.prototype.getPrice = function() {
    return (
      /** @type{?proto.google.type.Money} */
      e.Message.getWrapperField(this, C.Money, 1)
    );
  }, proto.api.patient.v1.Price.StandardPrice.prototype.setPrice = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.Price.StandardPrice.prototype.clearPrice = function() {
    return this.setPrice(void 0);
  }, proto.api.patient.v1.Price.StandardPrice.prototype.hasPrice = function() {
    return e.Message.getField(this, 1) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Price.ReducedPrice.prototype.toObject = function(t) {
    return proto.api.patient.v1.Price.ReducedPrice.toObject(t, this);
  }, proto.api.patient.v1.Price.ReducedPrice.toObject = function(t, r) {
    var n, d = {
      price: (n = r.getPrice()) && C.Money.toObject(t, n),
      oldPrice: (n = r.getOldPrice()) && C.Money.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Price.ReducedPrice.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Price.ReducedPrice();
    return proto.api.patient.v1.Price.ReducedPrice.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Price.ReducedPrice.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new C.Money();
          r.readMessage(d, C.Money.deserializeBinaryFromReader), t.setPrice(d);
          break;
        case 2:
          var d = new C.Money();
          r.readMessage(d, C.Money.deserializeBinaryFromReader), t.setOldPrice(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Price.ReducedPrice.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Price.ReducedPrice.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getPrice(), n != null && r.writeMessage(
      1,
      n,
      C.Money.serializeBinaryToWriter
    ), n = t.getOldPrice(), n != null && r.writeMessage(
      2,
      n,
      C.Money.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.getPrice = function() {
    return (
      /** @type{?proto.google.type.Money} */
      e.Message.getWrapperField(this, C.Money, 1)
    );
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.setPrice = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.clearPrice = function() {
    return this.setPrice(void 0);
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.hasPrice = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.getOldPrice = function() {
    return (
      /** @type{?proto.google.type.Money} */
      e.Message.getWrapperField(this, C.Money, 2)
    );
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.setOldPrice = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.clearOldPrice = function() {
    return this.setOldPrice(void 0);
  }, proto.api.patient.v1.Price.ReducedPrice.prototype.hasOldPrice = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.Price.prototype.getStandardPrice = function() {
    return (
      /** @type{?proto.api.patient.v1.Price.StandardPrice} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Price.StandardPrice, 1)
    );
  }, proto.api.patient.v1.Price.prototype.setStandardPrice = function(t) {
    return e.Message.setOneofWrapperField(this, 1, proto.api.patient.v1.Price.oneofGroups_[0], t);
  }, proto.api.patient.v1.Price.prototype.clearStandardPrice = function() {
    return this.setStandardPrice(void 0);
  }, proto.api.patient.v1.Price.prototype.hasStandardPrice = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.Price.prototype.getReducedPrice = function() {
    return (
      /** @type{?proto.api.patient.v1.Price.ReducedPrice} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Price.ReducedPrice, 2)
    );
  }, proto.api.patient.v1.Price.prototype.setReducedPrice = function(t) {
    return e.Message.setOneofWrapperField(this, 2, proto.api.patient.v1.Price.oneofGroups_[0], t);
  }, proto.api.patient.v1.Price.prototype.clearReducedPrice = function() {
    return this.setReducedPrice(void 0);
  }, proto.api.patient.v1.Price.prototype.hasReducedPrice = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.SwedishPersonalIdentityNumber.prototype.toObject = function(t) {
    return proto.api.patient.v1.SwedishPersonalIdentityNumber.toObject(t, this);
  }, proto.api.patient.v1.SwedishPersonalIdentityNumber.toObject = function(t, r) {
    var n = {
      twelveDigitNumber: e.Message.getFieldWithDefault(r, 1, 0)
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.SwedishPersonalIdentityNumber.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.SwedishPersonalIdentityNumber();
    return proto.api.patient.v1.SwedishPersonalIdentityNumber.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.SwedishPersonalIdentityNumber.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt64()
          );
          t.setTwelveDigitNumber(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.SwedishPersonalIdentityNumber.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.SwedishPersonalIdentityNumber.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.SwedishPersonalIdentityNumber.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getTwelveDigitNumber(), n !== 0 && r.writeInt64(
      1,
      n
    );
  }, proto.api.patient.v1.SwedishPersonalIdentityNumber.prototype.getTwelveDigitNumber = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.SwedishPersonalIdentityNumber.prototype.setTwelveDigitNumber = function(t) {
    return e.Message.setProto3IntField(this, 1, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Location.prototype.toObject = function(t) {
    return proto.api.patient.v1.Location.toObject(t, this);
  }, proto.api.patient.v1.Location.toObject = function(t, r) {
    var n, d = {
      name: e.Message.getFieldWithDefault(r, 1, ""),
      url: e.Message.getFieldWithDefault(r, 2, ""),
      type: e.Message.getFieldWithDefault(r, 3, 0),
      latLng: (n = r.getLatLng()) && B.LatLng.toObject(t, n),
      defaultDistanceKm: (n = r.getDefaultDistanceKm()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Location.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Location();
    return proto.api.patient.v1.Location.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Location.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setUrl(d);
          break;
        case 3:
          var d = (
            /** @type {!proto.api.patient.v1.LocationType} */
            r.readEnum()
          );
          t.setType(d);
          break;
        case 4:
          var d = new B.LatLng();
          r.readMessage(d, B.LatLng.deserializeBinaryFromReader), t.setLatLng(d);
          break;
        case 5:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setDefaultDistanceKm(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Location.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Location.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Location.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getUrl(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getType(), n !== 0 && r.writeEnum(
      3,
      n
    ), n = t.getLatLng(), n != null && r.writeMessage(
      4,
      n,
      B.LatLng.serializeBinaryToWriter
    ), n = t.getDefaultDistanceKm(), n != null && r.writeMessage(
      5,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Location.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.Location.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.Location.prototype.getUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.Location.prototype.setUrl = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.Location.prototype.getType = function() {
    return (
      /** @type {!proto.api.patient.v1.LocationType} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.api.patient.v1.Location.prototype.setType = function(t) {
    return e.Message.setProto3EnumField(this, 3, t);
  }, proto.api.patient.v1.Location.prototype.getLatLng = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 4)
    );
  }, proto.api.patient.v1.Location.prototype.setLatLng = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.Location.prototype.clearLatLng = function() {
    return this.setLatLng(void 0);
  }, proto.api.patient.v1.Location.prototype.hasLatLng = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.Location.prototype.getDefaultDistanceKm = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 5)
    );
  }, proto.api.patient.v1.Location.prototype.setDefaultDistanceKm = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.Location.prototype.clearDefaultDistanceKm = function() {
    return this.setDefaultDistanceKm(void 0);
  }, proto.api.patient.v1.Location.prototype.hasDefaultDistanceKm = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.FindLocationsRequest.repeatedFields_ = [2], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindLocationsRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindLocationsRequest.toObject(t, this);
  }, proto.api.patient.v1.FindLocationsRequest.toObject = function(t, r) {
    var n, d = {
      name: (n = r.getName()) && i.StringValue.toObject(t, n),
      typesList: (n = e.Message.getRepeatedField(r, 2)) == null ? void 0 : n,
      pageToken: (n = r.getPageToken()) && i.StringValue.toObject(t, n),
      pageSize: (n = r.getPageSize()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindLocationsRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindLocationsRequest();
    return proto.api.patient.v1.FindLocationsRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindLocationsRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var O = new i.StringValue();
          r.readMessage(O, i.StringValue.deserializeBinaryFromReader), t.setName(O);
          break;
        case 2:
          for (var d = (
            /** @type {!Array<!proto.api.patient.v1.LocationType>} */
            r.isDelimited() ? r.readPackedEnum() : [r.readEnum()]
          ), ne = 0; ne < d.length; ne++)
            t.addTypes(d[ne]);
          break;
        case 11:
          var O = new i.StringValue();
          r.readMessage(O, i.StringValue.deserializeBinaryFromReader), t.setPageToken(O);
          break;
        case 12:
          var O = new i.Int32Value();
          r.readMessage(O, i.Int32Value.deserializeBinaryFromReader), t.setPageSize(O);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindLocationsRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindLocationsRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindLocationsRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getTypesList(), n.length > 0 && r.writePackedEnum(
      2,
      n
    ), n = t.getPageToken(), n != null && r.writeMessage(
      11,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPageSize(), n != null && r.writeMessage(
      12,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindLocationsRequest.prototype.getName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.FindLocationsRequest.prototype.setName = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.clearName = function() {
    return this.setName(void 0);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.hasName = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.FindLocationsRequest.prototype.getTypesList = function() {
    return (
      /** @type {!Array<!proto.api.patient.v1.LocationType>} */
      e.Message.getRepeatedField(this, 2)
    );
  }, proto.api.patient.v1.FindLocationsRequest.prototype.setTypesList = function(t) {
    return e.Message.setField(this, 2, t || []);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.addTypes = function(t, r) {
    return e.Message.addToRepeatedField(this, 2, t, r);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.clearTypesList = function() {
    return this.setTypesList([]);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.getPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 11)
    );
  }, proto.api.patient.v1.FindLocationsRequest.prototype.setPageToken = function(t) {
    return e.Message.setWrapperField(this, 11, t);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.clearPageToken = function() {
    return this.setPageToken(void 0);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.hasPageToken = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.FindLocationsRequest.prototype.getPageSize = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 12)
    );
  }, proto.api.patient.v1.FindLocationsRequest.prototype.setPageSize = function(t) {
    return e.Message.setWrapperField(this, 12, t);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.clearPageSize = function() {
    return this.setPageSize(void 0);
  }, proto.api.patient.v1.FindLocationsRequest.prototype.hasPageSize = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.FindLocationsResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindLocationsResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindLocationsResponse.toObject(t, this);
  }, proto.api.patient.v1.FindLocationsResponse.toObject = function(t, r) {
    var n, d = {
      locationsList: e.Message.toObjectList(
        r.getLocationsList(),
        proto.api.patient.v1.Location.toObject,
        t
      ),
      pageToken: e.Message.getFieldWithDefault(r, 11, ""),
      pageSize: e.Message.getFieldWithDefault(r, 12, 0),
      nextPageToken: (n = r.getNextPageToken()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindLocationsResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindLocationsResponse();
    return proto.api.patient.v1.FindLocationsResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindLocationsResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Location();
          r.readMessage(d, proto.api.patient.v1.Location.deserializeBinaryFromReader), t.addLocations(d);
          break;
        case 11:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPageToken(d);
          break;
        case 12:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setPageSize(d);
          break;
        case 13:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setNextPageToken(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindLocationsResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindLocationsResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindLocationsResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getLocationsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.Location.serializeBinaryToWriter
    ), n = t.getPageToken(), n.length > 0 && r.writeString(
      11,
      n
    ), n = t.getPageSize(), n !== 0 && r.writeInt32(
      12,
      n
    ), n = t.getNextPageToken(), n != null && r.writeMessage(
      13,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindLocationsResponse.prototype.getLocationsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.Location>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.Location, 1)
    );
  }, proto.api.patient.v1.FindLocationsResponse.prototype.setLocationsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindLocationsResponse.prototype.addLocations = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.Location, r);
  }, proto.api.patient.v1.FindLocationsResponse.prototype.clearLocationsList = function() {
    return this.setLocationsList([]);
  }, proto.api.patient.v1.FindLocationsResponse.prototype.getPageToken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.api.patient.v1.FindLocationsResponse.prototype.setPageToken = function(t) {
    return e.Message.setProto3StringField(this, 11, t);
  }, proto.api.patient.v1.FindLocationsResponse.prototype.getPageSize = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.FindLocationsResponse.prototype.setPageSize = function(t) {
    return e.Message.setProto3IntField(this, 12, t);
  }, proto.api.patient.v1.FindLocationsResponse.prototype.getNextPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 13)
    );
  }, proto.api.patient.v1.FindLocationsResponse.prototype.setNextPageToken = function(t) {
    return e.Message.setWrapperField(this, 13, t);
  }, proto.api.patient.v1.FindLocationsResponse.prototype.clearNextPageToken = function() {
    return this.setNextPageToken(void 0);
  }, proto.api.patient.v1.FindLocationsResponse.prototype.hasNextPageToken = function() {
    return e.Message.getField(this, 13) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Treatment.prototype.toObject = function(t) {
    return proto.api.patient.v1.Treatment.toObject(t, this);
  }, proto.api.patient.v1.Treatment.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      name: e.Message.getFieldWithDefault(r, 2, ""),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Treatment.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Treatment();
    return proto.api.patient.v1.Treatment.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Treatment.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 3:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Treatment.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Treatment.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Treatment.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getName(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getDescription(), n != null && r.writeMessage(
      3,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Treatment.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.Treatment.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.Treatment.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.Treatment.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.Treatment.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 3)
    );
  }, proto.api.patient.v1.Treatment.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.Treatment.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.Treatment.prototype.hasDescription = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.FindTreatmentsRequest.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindTreatmentsRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindTreatmentsRequest.toObject(t, this);
  }, proto.api.patient.v1.FindTreatmentsRequest.toObject = function(t, r) {
    var n, d = {
      treatmentIdsList: (n = e.Message.getRepeatedField(r, 1)) == null ? void 0 : n,
      clinicId: (n = r.getClinicId()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindTreatmentsRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindTreatmentsRequest();
    return proto.api.patient.v1.FindTreatmentsRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindTreatmentsRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addTreatmentIds(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setClinicId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindTreatmentsRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindTreatmentsRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getTreatmentIdsList(), n.length > 0 && r.writeRepeatedString(
      1,
      n
    ), n = t.getClinicId(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.getTreatmentIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.setTreatmentIdsList = function(t) {
    return e.Message.setField(this, 1, t || []);
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.addTreatmentIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 1, t, r);
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.clearTreatmentIdsList = function() {
    return this.setTreatmentIdsList([]);
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.getClinicId = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.setClinicId = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.clearClinicId = function() {
    return this.setClinicId(void 0);
  }, proto.api.patient.v1.FindTreatmentsRequest.prototype.hasClinicId = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindTreatmentsResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindTreatmentsResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindTreatmentsResponse.toObject(t, this);
  }, proto.api.patient.v1.FindTreatmentsResponse.toObject = function(t, r) {
    var n = {
      treatmentsList: e.Message.toObjectList(
        r.getTreatmentsList(),
        proto.api.patient.v1.Treatment.toObject,
        t
      )
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.FindTreatmentsResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindTreatmentsResponse();
    return proto.api.patient.v1.FindTreatmentsResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindTreatmentsResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Treatment();
          r.readMessage(d, proto.api.patient.v1.Treatment.deserializeBinaryFromReader), t.addTreatments(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindTreatmentsResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindTreatmentsResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindTreatmentsResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getTreatmentsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.Treatment.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindTreatmentsResponse.prototype.getTreatmentsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.Treatment>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.Treatment, 1)
    );
  }, proto.api.patient.v1.FindTreatmentsResponse.prototype.setTreatmentsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindTreatmentsResponse.prototype.addTreatments = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.Treatment, r);
  }, proto.api.patient.v1.FindTreatmentsResponse.prototype.clearTreatmentsList = function() {
    return this.setTreatmentsList([]);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicHours.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicHours.toObject(t, this);
  }, proto.api.patient.v1.ClinicHours.toObject = function(t, r) {
    var n, d = {
      dayOfWeek: e.Message.getFieldWithDefault(r, 1, 0),
      openingTime: (n = r.getOpeningTime()) && $.TimeOfDay.toObject(t, n),
      closingTime: (n = r.getClosingTime()) && $.TimeOfDay.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicHours.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicHours();
    return proto.api.patient.v1.ClinicHours.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicHours.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {!proto.google.type.DayOfWeek} */
            r.readEnum()
          );
          t.setDayOfWeek(d);
          break;
        case 2:
          var d = new $.TimeOfDay();
          r.readMessage(d, $.TimeOfDay.deserializeBinaryFromReader), t.setOpeningTime(d);
          break;
        case 3:
          var d = new $.TimeOfDay();
          r.readMessage(d, $.TimeOfDay.deserializeBinaryFromReader), t.setClosingTime(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicHours.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicHours.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicHours.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getDayOfWeek(), n !== 0 && r.writeEnum(
      1,
      n
    ), n = t.getOpeningTime(), n != null && r.writeMessage(
      2,
      n,
      $.TimeOfDay.serializeBinaryToWriter
    ), n = t.getClosingTime(), n != null && r.writeMessage(
      3,
      n,
      $.TimeOfDay.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicHours.prototype.getDayOfWeek = function() {
    return (
      /** @type {!proto.google.type.DayOfWeek} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.ClinicHours.prototype.setDayOfWeek = function(t) {
    return e.Message.setProto3EnumField(this, 1, t);
  }, proto.api.patient.v1.ClinicHours.prototype.getOpeningTime = function() {
    return (
      /** @type{?proto.google.type.TimeOfDay} */
      e.Message.getWrapperField(this, $.TimeOfDay, 2)
    );
  }, proto.api.patient.v1.ClinicHours.prototype.setOpeningTime = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.ClinicHours.prototype.clearOpeningTime = function() {
    return this.setOpeningTime(void 0);
  }, proto.api.patient.v1.ClinicHours.prototype.hasOpeningTime = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.ClinicHours.prototype.getClosingTime = function() {
    return (
      /** @type{?proto.google.type.TimeOfDay} */
      e.Message.getWrapperField(this, $.TimeOfDay, 3)
    );
  }, proto.api.patient.v1.ClinicHours.prototype.setClosingTime = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.ClinicHours.prototype.clearClosingTime = function() {
    return this.setClosingTime(void 0);
  }, proto.api.patient.v1.ClinicHours.prototype.hasClosingTime = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicOutofServicePeriods.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicOutofServicePeriods.toObject(t, this);
  }, proto.api.patient.v1.ClinicOutofServicePeriods.toObject = function(t, r) {
    var n, d = {
      startDate: (n = r.getStartDate()) && u.Date.toObject(t, n),
      endDate: (n = r.getEndDate()) && u.Date.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicOutofServicePeriods.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicOutofServicePeriods();
    return proto.api.patient.v1.ClinicOutofServicePeriods.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicOutofServicePeriods.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setStartDate(d);
          break;
        case 2:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setEndDate(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicOutofServicePeriods.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicOutofServicePeriods.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getStartDate(), n != null && r.writeMessage(
      1,
      n,
      u.Date.serializeBinaryToWriter
    ), n = t.getEndDate(), n != null && r.writeMessage(
      2,
      n,
      u.Date.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.getStartDate = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 1)
    );
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.setStartDate = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.clearStartDate = function() {
    return this.setStartDate(void 0);
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.hasStartDate = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.getEndDate = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 2)
    );
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.setEndDate = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.clearEndDate = function() {
    return this.setEndDate(void 0);
  }, proto.api.patient.v1.ClinicOutofServicePeriods.prototype.hasEndDate = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicKeyword.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicKeyword.toObject(t, this);
  }, proto.api.patient.v1.ClinicKeyword.toObject = function(t, r) {
    var n = {
      keyword: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ClinicKeyword.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicKeyword();
    return proto.api.patient.v1.ClinicKeyword.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicKeyword.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setKeyword(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicKeyword.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicKeyword.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicKeyword.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getKeyword(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.ClinicKeyword.prototype.getKeyword = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicKeyword.prototype.setKeyword = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicLanguage.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicLanguage.toObject(t, this);
  }, proto.api.patient.v1.ClinicLanguage.toObject = function(t, r) {
    var n = {
      name: e.Message.getFieldWithDefault(r, 1, ""),
      countryCode: e.Message.getFieldWithDefault(r, 2, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ClinicLanguage.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicLanguage();
    return proto.api.patient.v1.ClinicLanguage.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicLanguage.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setCountryCode(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicLanguage.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicLanguage.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicLanguage.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getCountryCode(), n.length > 0 && r.writeString(
      2,
      n
    );
  }, proto.api.patient.v1.ClinicLanguage.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicLanguage.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ClinicLanguage.prototype.getCountryCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.ClinicLanguage.prototype.setCountryCode = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicOption.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicOption.toObject(t, this);
  }, proto.api.patient.v1.ClinicOption.toObject = function(t, r) {
    var n = {
      name: e.Message.getFieldWithDefault(r, 1, ""),
      type: e.Message.getFieldWithDefault(r, 2, 0)
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ClinicOption.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicOption();
    return proto.api.patient.v1.ClinicOption.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicOption.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 2:
          var d = (
            /** @type {!proto.api.patient.v1.ClinicOptionType} */
            r.readEnum()
          );
          t.setType(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicOption.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicOption.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicOption.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getType(), n !== 0 && r.writeEnum(
      2,
      n
    );
  }, proto.api.patient.v1.ClinicOption.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicOption.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ClinicOption.prototype.getType = function() {
    return (
      /** @type {!proto.api.patient.v1.ClinicOptionType} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.api.patient.v1.ClinicOption.prototype.setType = function(t) {
    return e.Message.setProto3EnumField(this, 2, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicPaymentOption.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicPaymentOption.toObject(t, this);
  }, proto.api.patient.v1.ClinicPaymentOption.toObject = function(t, r) {
    var n = {
      name: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ClinicPaymentOption.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicPaymentOption();
    return proto.api.patient.v1.ClinicPaymentOption.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicPaymentOption.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicPaymentOption.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicPaymentOption.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicPaymentOption.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.ClinicPaymentOption.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicPaymentOption.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ClinicImages.repeatedFields_ = [2, 15], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicImages.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicImages.toObject(t, this);
  }, proto.api.patient.v1.ClinicImages.toObject = function(t, r) {
    var n, d = {
      card: (n = r.getCard()) && i.StringValue.toObject(t, n),
      profilesList: (n = e.Message.getRepeatedField(r, 2)) == null ? void 0 : n,
      logo: (n = r.getLogo()) && i.StringValue.toObject(t, n),
      logoUrl: (n = r.getLogoUrl()) && i.StringValue.toObject(t, n),
      profileUrl: (n = r.getProfileUrl()) && i.StringValue.toObject(t, n),
      cardsList: e.Message.toObjectList(
        r.getCardsList(),
        proto.api.patient.v1.ClinicImageCard.toObject,
        t
      )
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicImages.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicImages();
    return proto.api.patient.v1.ClinicImages.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicImages.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setCard(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addProfiles(d);
          break;
        case 3:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setLogo(d);
          break;
        case 5:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setLogoUrl(d);
          break;
        case 10:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setProfileUrl(d);
          break;
        case 15:
          var d = new proto.api.patient.v1.ClinicImageCard();
          r.readMessage(d, proto.api.patient.v1.ClinicImageCard.deserializeBinaryFromReader), t.addCards(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicImages.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicImages.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicImages.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getCard(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getProfilesList(), n.length > 0 && r.writeRepeatedString(
      2,
      n
    ), n = t.getLogo(), n != null && r.writeMessage(
      3,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getLogoUrl(), n != null && r.writeMessage(
      5,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getProfileUrl(), n != null && r.writeMessage(
      10,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getCardsList(), n.length > 0 && r.writeRepeatedMessage(
      15,
      n,
      proto.api.patient.v1.ClinicImageCard.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicImages.prototype.getCard = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.ClinicImages.prototype.setCard = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.ClinicImages.prototype.clearCard = function() {
    return this.setCard(void 0);
  }, proto.api.patient.v1.ClinicImages.prototype.hasCard = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.ClinicImages.prototype.getProfilesList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 2)
    );
  }, proto.api.patient.v1.ClinicImages.prototype.setProfilesList = function(t) {
    return e.Message.setField(this, 2, t || []);
  }, proto.api.patient.v1.ClinicImages.prototype.addProfiles = function(t, r) {
    return e.Message.addToRepeatedField(this, 2, t, r);
  }, proto.api.patient.v1.ClinicImages.prototype.clearProfilesList = function() {
    return this.setProfilesList([]);
  }, proto.api.patient.v1.ClinicImages.prototype.getLogo = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 3)
    );
  }, proto.api.patient.v1.ClinicImages.prototype.setLogo = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.ClinicImages.prototype.clearLogo = function() {
    return this.setLogo(void 0);
  }, proto.api.patient.v1.ClinicImages.prototype.hasLogo = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.ClinicImages.prototype.getLogoUrl = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 5)
    );
  }, proto.api.patient.v1.ClinicImages.prototype.setLogoUrl = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.ClinicImages.prototype.clearLogoUrl = function() {
    return this.setLogoUrl(void 0);
  }, proto.api.patient.v1.ClinicImages.prototype.hasLogoUrl = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.ClinicImages.prototype.getProfileUrl = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 10)
    );
  }, proto.api.patient.v1.ClinicImages.prototype.setProfileUrl = function(t) {
    return e.Message.setWrapperField(this, 10, t);
  }, proto.api.patient.v1.ClinicImages.prototype.clearProfileUrl = function() {
    return this.setProfileUrl(void 0);
  }, proto.api.patient.v1.ClinicImages.prototype.hasProfileUrl = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.api.patient.v1.ClinicImages.prototype.getCardsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicImageCard>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicImageCard, 15)
    );
  }, proto.api.patient.v1.ClinicImages.prototype.setCardsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 15, t);
  }, proto.api.patient.v1.ClinicImages.prototype.addCards = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 15, t, proto.api.patient.v1.ClinicImageCard, r);
  }, proto.api.patient.v1.ClinicImages.prototype.clearCardsList = function() {
    return this.setCardsList([]);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicImageCard.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicImageCard.toObject(t, this);
  }, proto.api.patient.v1.ClinicImageCard.toObject = function(t, r) {
    var n = {
      smallUrl: e.Message.getFieldWithDefault(r, 1, ""),
      largeUrl: e.Message.getFieldWithDefault(r, 2, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ClinicImageCard.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicImageCard();
    return proto.api.patient.v1.ClinicImageCard.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicImageCard.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setSmallUrl(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setLargeUrl(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicImageCard.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicImageCard.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicImageCard.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getSmallUrl(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getLargeUrl(), n.length > 0 && r.writeString(
      2,
      n
    );
  }, proto.api.patient.v1.ClinicImageCard.prototype.getSmallUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicImageCard.prototype.setSmallUrl = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ClinicImageCard.prototype.getLargeUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.ClinicImageCard.prototype.setLargeUrl = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicMembership.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicMembership.toObject(t, this);
  }, proto.api.patient.v1.ClinicMembership.toObject = function(t, r) {
    var n, d = {
      name: e.Message.getFieldWithDefault(r, 1, ""),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n),
      image: (n = r.getImage()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicMembership.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicMembership();
    return proto.api.patient.v1.ClinicMembership.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicMembership.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        case 3:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setImage(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicMembership.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicMembership.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicMembership.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getDescription(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getImage(), n != null && r.writeMessage(
      3,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicMembership.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicMembership.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ClinicMembership.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.ClinicMembership.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.ClinicMembership.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.ClinicMembership.prototype.hasDescription = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.ClinicMembership.prototype.getImage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 3)
    );
  }, proto.api.patient.v1.ClinicMembership.prototype.setImage = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.ClinicMembership.prototype.clearImage = function() {
    return this.setImage(void 0);
  }, proto.api.patient.v1.ClinicMembership.prototype.hasImage = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicStaff.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicStaff.toObject(t, this);
  }, proto.api.patient.v1.ClinicStaff.toObject = function(t, r) {
    var n, d = {
      name: e.Message.getFieldWithDefault(r, 1, ""),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n),
      profession: (n = r.getProfession()) && i.StringValue.toObject(t, n),
      graduationYear: (n = r.getGraduationYear()) && i.Int32Value.toObject(t, n),
      image: (n = r.getImage()) && i.StringValue.toObject(t, n),
      birthYear: (n = r.getBirthYear()) && i.Int32Value.toObject(t, n),
      speciality: (n = r.getSpeciality()) && i.StringValue.toObject(t, n),
      specialityDate: (n = r.getSpecialityDate()) && u.Date.toObject(t, n),
      imageUrl: (n = r.getImageUrl()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicStaff.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicStaff();
    return proto.api.patient.v1.ClinicStaff.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicStaff.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        case 3:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setProfession(d);
          break;
        case 4:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setGraduationYear(d);
          break;
        case 5:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setImage(d);
          break;
        case 6:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setBirthYear(d);
          break;
        case 7:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setSpeciality(d);
          break;
        case 8:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setSpecialityDate(d);
          break;
        case 9:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setImageUrl(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicStaff.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicStaff.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicStaff.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getDescription(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getProfession(), n != null && r.writeMessage(
      3,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getGraduationYear(), n != null && r.writeMessage(
      4,
      n,
      i.Int32Value.serializeBinaryToWriter
    ), n = t.getImage(), n != null && r.writeMessage(
      5,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getBirthYear(), n != null && r.writeMessage(
      6,
      n,
      i.Int32Value.serializeBinaryToWriter
    ), n = t.getSpeciality(), n != null && r.writeMessage(
      7,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getSpecialityDate(), n != null && r.writeMessage(
      8,
      n,
      u.Date.serializeBinaryToWriter
    ), n = t.getImageUrl(), n != null && r.writeMessage(
      9,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasDescription = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.ClinicStaff.prototype.getProfession = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 3)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setProfession = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearProfession = function() {
    return this.setProfession(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasProfession = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.ClinicStaff.prototype.getGraduationYear = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 4)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setGraduationYear = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearGraduationYear = function() {
    return this.setGraduationYear(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasGraduationYear = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.ClinicStaff.prototype.getImage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 5)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setImage = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearImage = function() {
    return this.setImage(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasImage = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.ClinicStaff.prototype.getBirthYear = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 6)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setBirthYear = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearBirthYear = function() {
    return this.setBirthYear(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasBirthYear = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.ClinicStaff.prototype.getSpeciality = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 7)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setSpeciality = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearSpeciality = function() {
    return this.setSpeciality(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasSpeciality = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.ClinicStaff.prototype.getSpecialityDate = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 8)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setSpecialityDate = function(t) {
    return e.Message.setWrapperField(this, 8, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearSpecialityDate = function() {
    return this.setSpecialityDate(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasSpecialityDate = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.v1.ClinicStaff.prototype.getImageUrl = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 9)
    );
  }, proto.api.patient.v1.ClinicStaff.prototype.setImageUrl = function(t) {
    return e.Message.setWrapperField(this, 9, t);
  }, proto.api.patient.v1.ClinicStaff.prototype.clearImageUrl = function() {
    return this.setImageUrl(void 0);
  }, proto.api.patient.v1.ClinicStaff.prototype.hasImageUrl = function() {
    return e.Message.getField(this, 9) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicTreatment.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicTreatment.toObject(t, this);
  }, proto.api.patient.v1.ClinicTreatment.toObject = function(t, r) {
    var n, d = {
      treatmentId: e.Message.getFieldWithDefault(r, 1, ""),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n),
      price: (n = r.getPrice()) && proto.api.patient.v1.Price.toObject(t, n),
      expireDate: (n = r.getExpireDate()) && u.Date.toObject(t, n),
      name: e.Message.getFieldWithDefault(r, 5, "")
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicTreatment.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicTreatment();
    return proto.api.patient.v1.ClinicTreatment.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicTreatment.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setTreatmentId(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        case 3:
          var d = new proto.api.patient.v1.Price();
          r.readMessage(d, proto.api.patient.v1.Price.deserializeBinaryFromReader), t.setPrice(d);
          break;
        case 4:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setExpireDate(d);
          break;
        case 5:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicTreatment.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicTreatment.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicTreatment.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getTreatmentId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getDescription(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPrice(), n != null && r.writeMessage(
      3,
      n,
      proto.api.patient.v1.Price.serializeBinaryToWriter
    ), n = t.getExpireDate(), n != null && r.writeMessage(
      4,
      n,
      u.Date.serializeBinaryToWriter
    ), n = t.getName(), n.length > 0 && r.writeString(
      5,
      n
    );
  }, proto.api.patient.v1.ClinicTreatment.prototype.getTreatmentId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ClinicTreatment.prototype.setTreatmentId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ClinicTreatment.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.ClinicTreatment.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.ClinicTreatment.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.ClinicTreatment.prototype.hasDescription = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.ClinicTreatment.prototype.getPrice = function() {
    return (
      /** @type{?proto.api.patient.v1.Price} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Price, 3)
    );
  }, proto.api.patient.v1.ClinicTreatment.prototype.setPrice = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.ClinicTreatment.prototype.clearPrice = function() {
    return this.setPrice(void 0);
  }, proto.api.patient.v1.ClinicTreatment.prototype.hasPrice = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.ClinicTreatment.prototype.getExpireDate = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 4)
    );
  }, proto.api.patient.v1.ClinicTreatment.prototype.setExpireDate = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.ClinicTreatment.prototype.clearExpireDate = function() {
    return this.setExpireDate(void 0);
  }, proto.api.patient.v1.ClinicTreatment.prototype.hasExpireDate = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.ClinicTreatment.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.api.patient.v1.ClinicTreatment.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 5, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicLocation.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicLocation.toObject(t, this);
  }, proto.api.patient.v1.ClinicLocation.toObject = function(t, r) {
    var n, d = {
      location: (n = r.getLocation()) && proto.api.patient.v1.ClinicLocation.Loc.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicLocation.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicLocation();
    return proto.api.patient.v1.ClinicLocation.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicLocation.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.ClinicLocation.Loc();
          r.readMessage(d, proto.api.patient.v1.ClinicLocation.Loc.deserializeBinaryFromReader), t.setLocation(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicLocation.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicLocation.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicLocation.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getLocation(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.ClinicLocation.Loc.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicLocation.Loc.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicLocation.Loc.toObject(t, this);
  }, proto.api.patient.v1.ClinicLocation.Loc.toObject = function(t, r) {
    var n, d = {
      location: (n = r.getLocation()) && proto.api.patient.v1.Location.toObject(t, n),
      parent: (n = r.getParent()) && proto.api.patient.v1.ClinicLocation.Loc.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicLocation.Loc.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicLocation.Loc();
    return proto.api.patient.v1.ClinicLocation.Loc.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicLocation.Loc.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Location();
          r.readMessage(d, proto.api.patient.v1.Location.deserializeBinaryFromReader), t.setLocation(d);
          break;
        case 3:
          var d = new proto.api.patient.v1.ClinicLocation.Loc();
          r.readMessage(d, proto.api.patient.v1.ClinicLocation.Loc.deserializeBinaryFromReader), t.setParent(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicLocation.Loc.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicLocation.Loc.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getLocation(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.Location.serializeBinaryToWriter
    ), n = t.getParent(), n != null && r.writeMessage(
      3,
      n,
      proto.api.patient.v1.ClinicLocation.Loc.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.getLocation = function() {
    return (
      /** @type{?proto.api.patient.v1.Location} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Location, 1)
    );
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.setLocation = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.clearLocation = function() {
    return this.setLocation(void 0);
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.hasLocation = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.getParent = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicLocation.Loc} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicLocation.Loc, 3)
    );
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.setParent = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.clearParent = function() {
    return this.setParent(void 0);
  }, proto.api.patient.v1.ClinicLocation.Loc.prototype.hasParent = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.ClinicLocation.prototype.getLocation = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicLocation.Loc} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicLocation.Loc, 1)
    );
  }, proto.api.patient.v1.ClinicLocation.prototype.setLocation = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.ClinicLocation.prototype.clearLocation = function() {
    return this.setLocation(void 0);
  }, proto.api.patient.v1.ClinicLocation.prototype.hasLocation = function() {
    return e.Message.getField(this, 1) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicMeta.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicMeta.toObject(t, this);
  }, proto.api.patient.v1.ClinicMeta.toObject = function(t, r) {
    var n, d = {
      title: (n = r.getTitle()) && i.StringValue.toObject(t, n),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicMeta.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicMeta();
    return proto.api.patient.v1.ClinicMeta.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicMeta.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setTitle(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicMeta.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicMeta.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicMeta.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getTitle(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getDescription(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicMeta.prototype.getTitle = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.ClinicMeta.prototype.setTitle = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.ClinicMeta.prototype.clearTitle = function() {
    return this.setTitle(void 0);
  }, proto.api.patient.v1.ClinicMeta.prototype.hasTitle = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.ClinicMeta.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.ClinicMeta.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.ClinicMeta.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.ClinicMeta.prototype.hasDescription = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.Clinic.repeatedFields_ = [10, 11, 12, 13, 14, 15, 16, 18, 19, 20, 24], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Clinic.prototype.toObject = function(t) {
    return proto.api.patient.v1.Clinic.toObject(t, this);
  }, proto.api.patient.v1.Clinic.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      url: e.Message.getFieldWithDefault(r, 2, ""),
      name: e.Message.getFieldWithDefault(r, 3, ""),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n),
      subscription: e.Message.getFieldWithDefault(r, 5, 0),
      latLng: (n = r.getLatLng()) && B.LatLng.toObject(t, n),
      telephone: (n = r.getTelephone()) && M.PhoneNumber.toObject(t, n),
      visitingAddress: (n = r.getVisitingAddress()) && I.PostalAddress.toObject(t, n),
      acceptedPatientAge: (n = r.getAcceptedPatientAge()) && i.Int32Value.toObject(t, n),
      daysOfAgeRestrictionList: (n = e.Message.getRepeatedField(r, 10)) == null ? void 0 : n,
      surgeryHoursList: e.Message.toObjectList(
        r.getSurgeryHoursList(),
        proto.api.patient.v1.ClinicHours.toObject,
        t
      ),
      telephoneHoursList: e.Message.toObjectList(
        r.getTelephoneHoursList(),
        proto.api.patient.v1.ClinicHours.toObject,
        t
      ),
      keywordsList: e.Message.toObjectList(
        r.getKeywordsList(),
        proto.api.patient.v1.ClinicKeyword.toObject,
        t
      ),
      languagesList: e.Message.toObjectList(
        r.getLanguagesList(),
        proto.api.patient.v1.ClinicLanguage.toObject,
        t
      ),
      optionsList: e.Message.toObjectList(
        r.getOptionsList(),
        proto.api.patient.v1.ClinicOption.toObject,
        t
      ),
      paymentOptionsList: e.Message.toObjectList(
        r.getPaymentOptionsList(),
        proto.api.patient.v1.ClinicPaymentOption.toObject,
        t
      ),
      images: (n = r.getImages()) && proto.api.patient.v1.ClinicImages.toObject(t, n),
      membershipsList: e.Message.toObjectList(
        r.getMembershipsList(),
        proto.api.patient.v1.ClinicMembership.toObject,
        t
      ),
      staffsList: e.Message.toObjectList(
        r.getStaffsList(),
        proto.api.patient.v1.ClinicStaff.toObject,
        t
      ),
      treatmentsList: e.Message.toObjectList(
        r.getTreatmentsList(),
        proto.api.patient.v1.ClinicTreatment.toObject,
        t
      ),
      location: (n = r.getLocation()) && proto.api.patient.v1.ClinicLocation.toObject(t, n),
      meta: (n = r.getMeta()) && proto.api.patient.v1.ClinicMeta.toObject(t, n),
      priceModel: (n = r.getPriceModel()) && i.Int32Value.toObject(t, n),
      temporaryClosedList: e.Message.toObjectList(
        r.getTemporaryClosedList(),
        proto.api.patient.v1.ClinicOutofServicePeriods.toObject,
        t
      ),
      email: (n = r.getEmail()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Clinic.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Clinic();
    return proto.api.patient.v1.Clinic.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Clinic.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var O = (
            /** @type {string} */
            r.readString()
          );
          t.setId(O);
          break;
        case 2:
          var O = (
            /** @type {string} */
            r.readString()
          );
          t.setUrl(O);
          break;
        case 3:
          var O = (
            /** @type {string} */
            r.readString()
          );
          t.setName(O);
          break;
        case 4:
          var O = new i.StringValue();
          r.readMessage(O, i.StringValue.deserializeBinaryFromReader), t.setDescription(O);
          break;
        case 5:
          var O = (
            /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
            r.readEnum()
          );
          t.setSubscription(O);
          break;
        case 6:
          var O = new B.LatLng();
          r.readMessage(O, B.LatLng.deserializeBinaryFromReader), t.setLatLng(O);
          break;
        case 7:
          var O = new M.PhoneNumber();
          r.readMessage(O, M.PhoneNumber.deserializeBinaryFromReader), t.setTelephone(O);
          break;
        case 8:
          var O = new I.PostalAddress();
          r.readMessage(O, I.PostalAddress.deserializeBinaryFromReader), t.setVisitingAddress(O);
          break;
        case 9:
          var O = new i.Int32Value();
          r.readMessage(O, i.Int32Value.deserializeBinaryFromReader), t.setAcceptedPatientAge(O);
          break;
        case 10:
          for (var d = (
            /** @type {!Array<!proto.google.type.DayOfWeek>} */
            r.isDelimited() ? r.readPackedEnum() : [r.readEnum()]
          ), ne = 0; ne < d.length; ne++)
            t.addDaysOfAgeRestriction(d[ne]);
          break;
        case 11:
          var O = new proto.api.patient.v1.ClinicHours();
          r.readMessage(O, proto.api.patient.v1.ClinicHours.deserializeBinaryFromReader), t.addSurgeryHours(O);
          break;
        case 12:
          var O = new proto.api.patient.v1.ClinicHours();
          r.readMessage(O, proto.api.patient.v1.ClinicHours.deserializeBinaryFromReader), t.addTelephoneHours(O);
          break;
        case 13:
          var O = new proto.api.patient.v1.ClinicKeyword();
          r.readMessage(O, proto.api.patient.v1.ClinicKeyword.deserializeBinaryFromReader), t.addKeywords(O);
          break;
        case 14:
          var O = new proto.api.patient.v1.ClinicLanguage();
          r.readMessage(O, proto.api.patient.v1.ClinicLanguage.deserializeBinaryFromReader), t.addLanguages(O);
          break;
        case 15:
          var O = new proto.api.patient.v1.ClinicOption();
          r.readMessage(O, proto.api.patient.v1.ClinicOption.deserializeBinaryFromReader), t.addOptions(O);
          break;
        case 16:
          var O = new proto.api.patient.v1.ClinicPaymentOption();
          r.readMessage(O, proto.api.patient.v1.ClinicPaymentOption.deserializeBinaryFromReader), t.addPaymentOptions(O);
          break;
        case 17:
          var O = new proto.api.patient.v1.ClinicImages();
          r.readMessage(O, proto.api.patient.v1.ClinicImages.deserializeBinaryFromReader), t.setImages(O);
          break;
        case 18:
          var O = new proto.api.patient.v1.ClinicMembership();
          r.readMessage(O, proto.api.patient.v1.ClinicMembership.deserializeBinaryFromReader), t.addMemberships(O);
          break;
        case 19:
          var O = new proto.api.patient.v1.ClinicStaff();
          r.readMessage(O, proto.api.patient.v1.ClinicStaff.deserializeBinaryFromReader), t.addStaffs(O);
          break;
        case 20:
          var O = new proto.api.patient.v1.ClinicTreatment();
          r.readMessage(O, proto.api.patient.v1.ClinicTreatment.deserializeBinaryFromReader), t.addTreatments(O);
          break;
        case 21:
          var O = new proto.api.patient.v1.ClinicLocation();
          r.readMessage(O, proto.api.patient.v1.ClinicLocation.deserializeBinaryFromReader), t.setLocation(O);
          break;
        case 22:
          var O = new proto.api.patient.v1.ClinicMeta();
          r.readMessage(O, proto.api.patient.v1.ClinicMeta.deserializeBinaryFromReader), t.setMeta(O);
          break;
        case 23:
          var O = new i.Int32Value();
          r.readMessage(O, i.Int32Value.deserializeBinaryFromReader), t.setPriceModel(O);
          break;
        case 24:
          var O = new proto.api.patient.v1.ClinicOutofServicePeriods();
          r.readMessage(O, proto.api.patient.v1.ClinicOutofServicePeriods.deserializeBinaryFromReader), t.addTemporaryClosed(O);
          break;
        case 25:
          var O = new i.StringValue();
          r.readMessage(O, i.StringValue.deserializeBinaryFromReader), t.setEmail(O);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Clinic.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Clinic.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Clinic.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getUrl(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getName(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getDescription(), n != null && r.writeMessage(
      4,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getSubscription(), n !== 0 && r.writeEnum(
      5,
      n
    ), n = t.getLatLng(), n != null && r.writeMessage(
      6,
      n,
      B.LatLng.serializeBinaryToWriter
    ), n = t.getTelephone(), n != null && r.writeMessage(
      7,
      n,
      M.PhoneNumber.serializeBinaryToWriter
    ), n = t.getVisitingAddress(), n != null && r.writeMessage(
      8,
      n,
      I.PostalAddress.serializeBinaryToWriter
    ), n = t.getAcceptedPatientAge(), n != null && r.writeMessage(
      9,
      n,
      i.Int32Value.serializeBinaryToWriter
    ), n = t.getDaysOfAgeRestrictionList(), n.length > 0 && r.writePackedEnum(
      10,
      n
    ), n = t.getSurgeryHoursList(), n.length > 0 && r.writeRepeatedMessage(
      11,
      n,
      proto.api.patient.v1.ClinicHours.serializeBinaryToWriter
    ), n = t.getTelephoneHoursList(), n.length > 0 && r.writeRepeatedMessage(
      12,
      n,
      proto.api.patient.v1.ClinicHours.serializeBinaryToWriter
    ), n = t.getKeywordsList(), n.length > 0 && r.writeRepeatedMessage(
      13,
      n,
      proto.api.patient.v1.ClinicKeyword.serializeBinaryToWriter
    ), n = t.getLanguagesList(), n.length > 0 && r.writeRepeatedMessage(
      14,
      n,
      proto.api.patient.v1.ClinicLanguage.serializeBinaryToWriter
    ), n = t.getOptionsList(), n.length > 0 && r.writeRepeatedMessage(
      15,
      n,
      proto.api.patient.v1.ClinicOption.serializeBinaryToWriter
    ), n = t.getPaymentOptionsList(), n.length > 0 && r.writeRepeatedMessage(
      16,
      n,
      proto.api.patient.v1.ClinicPaymentOption.serializeBinaryToWriter
    ), n = t.getImages(), n != null && r.writeMessage(
      17,
      n,
      proto.api.patient.v1.ClinicImages.serializeBinaryToWriter
    ), n = t.getMembershipsList(), n.length > 0 && r.writeRepeatedMessage(
      18,
      n,
      proto.api.patient.v1.ClinicMembership.serializeBinaryToWriter
    ), n = t.getStaffsList(), n.length > 0 && r.writeRepeatedMessage(
      19,
      n,
      proto.api.patient.v1.ClinicStaff.serializeBinaryToWriter
    ), n = t.getTreatmentsList(), n.length > 0 && r.writeRepeatedMessage(
      20,
      n,
      proto.api.patient.v1.ClinicTreatment.serializeBinaryToWriter
    ), n = t.getLocation(), n != null && r.writeMessage(
      21,
      n,
      proto.api.patient.v1.ClinicLocation.serializeBinaryToWriter
    ), n = t.getMeta(), n != null && r.writeMessage(
      22,
      n,
      proto.api.patient.v1.ClinicMeta.serializeBinaryToWriter
    ), n = t.getPriceModel(), n != null && r.writeMessage(
      23,
      n,
      i.Int32Value.serializeBinaryToWriter
    ), n = t.getTemporaryClosedList(), n.length > 0 && r.writeRepeatedMessage(
      24,
      n,
      proto.api.patient.v1.ClinicOutofServicePeriods.serializeBinaryToWriter
    ), n = t.getEmail(), n != null && r.writeMessage(
      25,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Clinic.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.Clinic.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.Clinic.prototype.getUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.Clinic.prototype.setUrl = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.Clinic.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.Clinic.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.Clinic.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 4)
    );
  }, proto.api.patient.v1.Clinic.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.Clinic.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasDescription = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.Clinic.prototype.getSubscription = function() {
    return (
      /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.api.patient.v1.Clinic.prototype.setSubscription = function(t) {
    return e.Message.setProto3EnumField(this, 5, t);
  }, proto.api.patient.v1.Clinic.prototype.getLatLng = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 6)
    );
  }, proto.api.patient.v1.Clinic.prototype.setLatLng = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.Clinic.prototype.clearLatLng = function() {
    return this.setLatLng(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasLatLng = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.Clinic.prototype.getTelephone = function() {
    return (
      /** @type{?proto.google.type.PhoneNumber} */
      e.Message.getWrapperField(this, M.PhoneNumber, 7)
    );
  }, proto.api.patient.v1.Clinic.prototype.setTelephone = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.Clinic.prototype.clearTelephone = function() {
    return this.setTelephone(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasTelephone = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.Clinic.prototype.getVisitingAddress = function() {
    return (
      /** @type{?proto.google.type.PostalAddress} */
      e.Message.getWrapperField(this, I.PostalAddress, 8)
    );
  }, proto.api.patient.v1.Clinic.prototype.setVisitingAddress = function(t) {
    return e.Message.setWrapperField(this, 8, t);
  }, proto.api.patient.v1.Clinic.prototype.clearVisitingAddress = function() {
    return this.setVisitingAddress(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasVisitingAddress = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.v1.Clinic.prototype.getAcceptedPatientAge = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 9)
    );
  }, proto.api.patient.v1.Clinic.prototype.setAcceptedPatientAge = function(t) {
    return e.Message.setWrapperField(this, 9, t);
  }, proto.api.patient.v1.Clinic.prototype.clearAcceptedPatientAge = function() {
    return this.setAcceptedPatientAge(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasAcceptedPatientAge = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.api.patient.v1.Clinic.prototype.getDaysOfAgeRestrictionList = function() {
    return (
      /** @type {!Array<!proto.google.type.DayOfWeek>} */
      e.Message.getRepeatedField(this, 10)
    );
  }, proto.api.patient.v1.Clinic.prototype.setDaysOfAgeRestrictionList = function(t) {
    return e.Message.setField(this, 10, t || []);
  }, proto.api.patient.v1.Clinic.prototype.addDaysOfAgeRestriction = function(t, r) {
    return e.Message.addToRepeatedField(this, 10, t, r);
  }, proto.api.patient.v1.Clinic.prototype.clearDaysOfAgeRestrictionList = function() {
    return this.setDaysOfAgeRestrictionList([]);
  }, proto.api.patient.v1.Clinic.prototype.getSurgeryHoursList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicHours>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicHours, 11)
    );
  }, proto.api.patient.v1.Clinic.prototype.setSurgeryHoursList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 11, t);
  }, proto.api.patient.v1.Clinic.prototype.addSurgeryHours = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 11, t, proto.api.patient.v1.ClinicHours, r);
  }, proto.api.patient.v1.Clinic.prototype.clearSurgeryHoursList = function() {
    return this.setSurgeryHoursList([]);
  }, proto.api.patient.v1.Clinic.prototype.getTelephoneHoursList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicHours>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicHours, 12)
    );
  }, proto.api.patient.v1.Clinic.prototype.setTelephoneHoursList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 12, t);
  }, proto.api.patient.v1.Clinic.prototype.addTelephoneHours = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 12, t, proto.api.patient.v1.ClinicHours, r);
  }, proto.api.patient.v1.Clinic.prototype.clearTelephoneHoursList = function() {
    return this.setTelephoneHoursList([]);
  }, proto.api.patient.v1.Clinic.prototype.getKeywordsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicKeyword>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicKeyword, 13)
    );
  }, proto.api.patient.v1.Clinic.prototype.setKeywordsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 13, t);
  }, proto.api.patient.v1.Clinic.prototype.addKeywords = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 13, t, proto.api.patient.v1.ClinicKeyword, r);
  }, proto.api.patient.v1.Clinic.prototype.clearKeywordsList = function() {
    return this.setKeywordsList([]);
  }, proto.api.patient.v1.Clinic.prototype.getLanguagesList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicLanguage>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicLanguage, 14)
    );
  }, proto.api.patient.v1.Clinic.prototype.setLanguagesList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 14, t);
  }, proto.api.patient.v1.Clinic.prototype.addLanguages = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 14, t, proto.api.patient.v1.ClinicLanguage, r);
  }, proto.api.patient.v1.Clinic.prototype.clearLanguagesList = function() {
    return this.setLanguagesList([]);
  }, proto.api.patient.v1.Clinic.prototype.getOptionsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicOption>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicOption, 15)
    );
  }, proto.api.patient.v1.Clinic.prototype.setOptionsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 15, t);
  }, proto.api.patient.v1.Clinic.prototype.addOptions = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 15, t, proto.api.patient.v1.ClinicOption, r);
  }, proto.api.patient.v1.Clinic.prototype.clearOptionsList = function() {
    return this.setOptionsList([]);
  }, proto.api.patient.v1.Clinic.prototype.getPaymentOptionsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicPaymentOption>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicPaymentOption, 16)
    );
  }, proto.api.patient.v1.Clinic.prototype.setPaymentOptionsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 16, t);
  }, proto.api.patient.v1.Clinic.prototype.addPaymentOptions = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 16, t, proto.api.patient.v1.ClinicPaymentOption, r);
  }, proto.api.patient.v1.Clinic.prototype.clearPaymentOptionsList = function() {
    return this.setPaymentOptionsList([]);
  }, proto.api.patient.v1.Clinic.prototype.getImages = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicImages} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicImages, 17)
    );
  }, proto.api.patient.v1.Clinic.prototype.setImages = function(t) {
    return e.Message.setWrapperField(this, 17, t);
  }, proto.api.patient.v1.Clinic.prototype.clearImages = function() {
    return this.setImages(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasImages = function() {
    return e.Message.getField(this, 17) != null;
  }, proto.api.patient.v1.Clinic.prototype.getMembershipsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicMembership>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicMembership, 18)
    );
  }, proto.api.patient.v1.Clinic.prototype.setMembershipsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 18, t);
  }, proto.api.patient.v1.Clinic.prototype.addMemberships = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 18, t, proto.api.patient.v1.ClinicMembership, r);
  }, proto.api.patient.v1.Clinic.prototype.clearMembershipsList = function() {
    return this.setMembershipsList([]);
  }, proto.api.patient.v1.Clinic.prototype.getStaffsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicStaff>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicStaff, 19)
    );
  }, proto.api.patient.v1.Clinic.prototype.setStaffsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 19, t);
  }, proto.api.patient.v1.Clinic.prototype.addStaffs = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 19, t, proto.api.patient.v1.ClinicStaff, r);
  }, proto.api.patient.v1.Clinic.prototype.clearStaffsList = function() {
    return this.setStaffsList([]);
  }, proto.api.patient.v1.Clinic.prototype.getTreatmentsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicTreatment>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicTreatment, 20)
    );
  }, proto.api.patient.v1.Clinic.prototype.setTreatmentsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 20, t);
  }, proto.api.patient.v1.Clinic.prototype.addTreatments = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 20, t, proto.api.patient.v1.ClinicTreatment, r);
  }, proto.api.patient.v1.Clinic.prototype.clearTreatmentsList = function() {
    return this.setTreatmentsList([]);
  }, proto.api.patient.v1.Clinic.prototype.getLocation = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicLocation} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicLocation, 21)
    );
  }, proto.api.patient.v1.Clinic.prototype.setLocation = function(t) {
    return e.Message.setWrapperField(this, 21, t);
  }, proto.api.patient.v1.Clinic.prototype.clearLocation = function() {
    return this.setLocation(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasLocation = function() {
    return e.Message.getField(this, 21) != null;
  }, proto.api.patient.v1.Clinic.prototype.getMeta = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicMeta} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicMeta, 22)
    );
  }, proto.api.patient.v1.Clinic.prototype.setMeta = function(t) {
    return e.Message.setWrapperField(this, 22, t);
  }, proto.api.patient.v1.Clinic.prototype.clearMeta = function() {
    return this.setMeta(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasMeta = function() {
    return e.Message.getField(this, 22) != null;
  }, proto.api.patient.v1.Clinic.prototype.getPriceModel = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 23)
    );
  }, proto.api.patient.v1.Clinic.prototype.setPriceModel = function(t) {
    return e.Message.setWrapperField(this, 23, t);
  }, proto.api.patient.v1.Clinic.prototype.clearPriceModel = function() {
    return this.setPriceModel(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasPriceModel = function() {
    return e.Message.getField(this, 23) != null;
  }, proto.api.patient.v1.Clinic.prototype.getTemporaryClosedList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicOutofServicePeriods>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicOutofServicePeriods, 24)
    );
  }, proto.api.patient.v1.Clinic.prototype.setTemporaryClosedList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 24, t);
  }, proto.api.patient.v1.Clinic.prototype.addTemporaryClosed = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 24, t, proto.api.patient.v1.ClinicOutofServicePeriods, r);
  }, proto.api.patient.v1.Clinic.prototype.clearTemporaryClosedList = function() {
    return this.setTemporaryClosedList([]);
  }, proto.api.patient.v1.Clinic.prototype.getEmail = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 25)
    );
  }, proto.api.patient.v1.Clinic.prototype.setEmail = function(t) {
    return e.Message.setWrapperField(this, 25, t);
  }, proto.api.patient.v1.Clinic.prototype.clearEmail = function() {
    return this.setEmail(void 0);
  }, proto.api.patient.v1.Clinic.prototype.hasEmail = function() {
    return e.Message.getField(this, 25) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ClinicStatistics.prototype.toObject = function(t) {
    return proto.api.patient.v1.ClinicStatistics.toObject(t, this);
  }, proto.api.patient.v1.ClinicStatistics.toObject = function(t, r) {
    var n, d = {
      recentInternalBookings: (n = r.getRecentInternalBookings()) && i.Int32Value.toObject(t, n),
      recentExternalBookings: (n = r.getRecentExternalBookings()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ClinicStatistics.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ClinicStatistics();
    return proto.api.patient.v1.ClinicStatistics.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ClinicStatistics.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setRecentInternalBookings(d);
          break;
        case 2:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setRecentExternalBookings(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ClinicStatistics.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ClinicStatistics.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ClinicStatistics.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getRecentInternalBookings(), n != null && r.writeMessage(
      1,
      n,
      i.Int32Value.serializeBinaryToWriter
    ), n = t.getRecentExternalBookings(), n != null && r.writeMessage(
      2,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ClinicStatistics.prototype.getRecentInternalBookings = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 1)
    );
  }, proto.api.patient.v1.ClinicStatistics.prototype.setRecentInternalBookings = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.ClinicStatistics.prototype.clearRecentInternalBookings = function() {
    return this.setRecentInternalBookings(void 0);
  }, proto.api.patient.v1.ClinicStatistics.prototype.hasRecentInternalBookings = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.ClinicStatistics.prototype.getRecentExternalBookings = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 2)
    );
  }, proto.api.patient.v1.ClinicStatistics.prototype.setRecentExternalBookings = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.ClinicStatistics.prototype.clearRecentExternalBookings = function() {
    return this.setRecentExternalBookings(void 0);
  }, proto.api.patient.v1.ClinicStatistics.prototype.hasRecentExternalBookings = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.repeatedFields_ = [6], proto.api.patient.v1.FindClinicsByLocationRequest.oneofGroups_ = [[7, 8, 17]], proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintCase = {
    LOCATION_CONSTRAINT_NOT_SET: 0,
    POINT: 7,
    BOX: 8,
    GEOMETRY: 17
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getLocationConstraintCase = function() {
    return (
      /** @type {proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.FindClinicsByLocationRequest.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByLocationRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByLocationRequest.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.toObject = function(t, r) {
    var n, d = {
      location: (n = r.getLocation()) && B.LatLng.toObject(t, n),
      maxDistanceKm: (n = r.getMaxDistanceKm()) && i.Int32Value.toObject(t, n),
      treatmentId: (n = r.getTreatmentId()) && i.StringValue.toObject(t, n),
      subscription: e.Message.getFieldWithDefault(r, 4, 0),
      sorting: e.Message.getFieldWithDefault(r, 5, 0),
      treatmentIdsList: (n = e.Message.getRepeatedField(r, 6)) == null ? void 0 : n,
      point: (n = r.getPoint()) && proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.toObject(t, n),
      box: (n = r.getBox()) && proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.toObject(t, n),
      geometry: (n = r.getGeometry()) && proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.toObject(t, n),
      premiumFirst: e.Message.getBooleanFieldWithDefault(r, 9, !1),
      pageToken: (n = r.getPageToken()) && i.StringValue.toObject(t, n),
      pageSize: (n = r.getPageSize()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindClinicsByLocationRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByLocationRequest();
    return proto.api.patient.v1.FindClinicsByLocationRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new B.LatLng();
          r.readMessage(d, B.LatLng.deserializeBinaryFromReader), t.setLocation(d);
          break;
        case 2:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setMaxDistanceKm(d);
          break;
        case 3:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setTreatmentId(d);
          break;
        case 4:
          var d = (
            /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
            r.readEnum()
          );
          t.setSubscription(d);
          break;
        case 5:
          var d = (
            /** @type {!proto.api.patient.v1.FindClinicsByLocationRequest.Sorting} */
            r.readEnum()
          );
          t.setSorting(d);
          break;
        case 6:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addTreatmentIds(d);
          break;
        case 7:
          var d = new proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint();
          r.readMessage(d, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.deserializeBinaryFromReader), t.setPoint(d);
          break;
        case 8:
          var d = new proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox();
          r.readMessage(d, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.deserializeBinaryFromReader), t.setBox(d);
          break;
        case 17:
          var d = new proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry();
          r.readMessage(d, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.deserializeBinaryFromReader), t.setGeometry(d);
          break;
        case 9:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          t.setPremiumFirst(d);
          break;
        case 11:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setPageToken(d);
          break;
        case 12:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setPageSize(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByLocationRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByLocationRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getLocation(), n != null && r.writeMessage(
      1,
      n,
      B.LatLng.serializeBinaryToWriter
    ), n = t.getMaxDistanceKm(), n != null && r.writeMessage(
      2,
      n,
      i.Int32Value.serializeBinaryToWriter
    ), n = t.getTreatmentId(), n != null && r.writeMessage(
      3,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getSubscription(), n !== 0 && r.writeEnum(
      4,
      n
    ), n = t.getSorting(), n !== 0 && r.writeEnum(
      5,
      n
    ), n = t.getTreatmentIdsList(), n.length > 0 && r.writeRepeatedString(
      6,
      n
    ), n = t.getPoint(), n != null && r.writeMessage(
      7,
      n,
      proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.serializeBinaryToWriter
    ), n = t.getBox(), n != null && r.writeMessage(
      8,
      n,
      proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.serializeBinaryToWriter
    ), n = t.getGeometry(), n != null && r.writeMessage(
      17,
      n,
      proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.serializeBinaryToWriter
    ), n = t.getPremiumFirst(), n && r.writeBool(
      9,
      n
    ), n = t.getPageToken(), n != null && r.writeMessage(
      11,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPageSize(), n != null && r.writeMessage(
      12,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.Sorting = {
    SORTING_UNSPECIFIED: 0,
    SORTING_PROXIMITY: 1,
    SORTING_NAME: 2,
    SORTING_REVIEW_SCORE: 3,
    SORTING_VALUE_PERFORMANCE_SCORE: 4
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.toObject = function(t, r) {
    var n, d = {
      center: (n = r.getCenter()) && B.LatLng.toObject(t, n),
      maxDistanceKm: (n = r.getMaxDistanceKm()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint();
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new B.LatLng();
          r.readMessage(d, B.LatLng.deserializeBinaryFromReader), t.setCenter(d);
          break;
        case 2:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setMaxDistanceKm(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getCenter(), n != null && r.writeMessage(
      1,
      n,
      B.LatLng.serializeBinaryToWriter
    ), n = t.getMaxDistanceKm(), n != null && r.writeMessage(
      2,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.getCenter = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 1)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.setCenter = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.clearCenter = function() {
    return this.setCenter(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.hasCenter = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.getMaxDistanceKm = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 2)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.setMaxDistanceKm = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.clearMaxDistanceKm = function() {
    return this.setMaxDistanceKm(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint.prototype.hasMaxDistanceKm = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.toObject = function(t, r) {
    var n, d = {
      upperLeftCorner: (n = r.getUpperLeftCorner()) && B.LatLng.toObject(t, n),
      lowerRightCorner: (n = r.getLowerRightCorner()) && B.LatLng.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox();
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new B.LatLng();
          r.readMessage(d, B.LatLng.deserializeBinaryFromReader), t.setUpperLeftCorner(d);
          break;
        case 2:
          var d = new B.LatLng();
          r.readMessage(d, B.LatLng.deserializeBinaryFromReader), t.setLowerRightCorner(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getUpperLeftCorner(), n != null && r.writeMessage(
      1,
      n,
      B.LatLng.serializeBinaryToWriter
    ), n = t.getLowerRightCorner(), n != null && r.writeMessage(
      2,
      n,
      B.LatLng.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.getUpperLeftCorner = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 1)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.setUpperLeftCorner = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.clearUpperLeftCorner = function() {
    return this.setUpperLeftCorner(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.hasUpperLeftCorner = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.getLowerRightCorner = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 2)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.setLowerRightCorner = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.clearLowerRightCorner = function() {
    return this.setLowerRightCorner(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox.prototype.hasLowerRightCorner = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.toObject = function(t, r) {
    var n = {
      geojsonGeometry: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry();
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setGeojsonGeometry(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getGeojsonGeometry(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.prototype.getGeojsonGeometry = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry.prototype.setGeojsonGeometry = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getLocation = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 1)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setLocation = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearLocation = function() {
    return this.setLocation(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasLocation = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getMaxDistanceKm = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 2)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setMaxDistanceKm = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearMaxDistanceKm = function() {
    return this.setMaxDistanceKm(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasMaxDistanceKm = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getTreatmentId = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 3)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setTreatmentId = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearTreatmentId = function() {
    return this.setTreatmentId(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasTreatmentId = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getSubscription = function() {
    return (
      /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setSubscription = function(t) {
    return e.Message.setProto3EnumField(this, 4, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getSorting = function() {
    return (
      /** @type {!proto.api.patient.v1.FindClinicsByLocationRequest.Sorting} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setSorting = function(t) {
    return e.Message.setProto3EnumField(this, 5, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getTreatmentIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 6)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setTreatmentIdsList = function(t) {
    return e.Message.setField(this, 6, t || []);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.addTreatmentIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 6, t, r);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearTreatmentIdsList = function() {
    return this.setTreatmentIdsList([]);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getPoint = function() {
    return (
      /** @type{?proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint} */
      e.Message.getWrapperField(this, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintPoint, 7)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setPoint = function(t) {
    return e.Message.setOneofWrapperField(this, 7, proto.api.patient.v1.FindClinicsByLocationRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearPoint = function() {
    return this.setPoint(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasPoint = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getBox = function() {
    return (
      /** @type{?proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox} */
      e.Message.getWrapperField(this, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintBox, 8)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setBox = function(t) {
    return e.Message.setOneofWrapperField(this, 8, proto.api.patient.v1.FindClinicsByLocationRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearBox = function() {
    return this.setBox(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasBox = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getGeometry = function() {
    return (
      /** @type{?proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry} */
      e.Message.getWrapperField(this, proto.api.patient.v1.FindClinicsByLocationRequest.LocationConstraintGeometry, 17)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setGeometry = function(t) {
    return e.Message.setOneofWrapperField(this, 17, proto.api.patient.v1.FindClinicsByLocationRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearGeometry = function() {
    return this.setGeometry(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasGeometry = function() {
    return e.Message.getField(this, 17) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getPremiumFirst = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 9, !1)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setPremiumFirst = function(t) {
    return e.Message.setProto3BooleanField(this, 9, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 11)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setPageToken = function(t) {
    return e.Message.setWrapperField(this, 11, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearPageToken = function() {
    return this.setPageToken(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasPageToken = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.getPageSize = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 12)
    );
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.setPageSize = function(t) {
    return e.Message.setWrapperField(this, 12, t);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.clearPageSize = function() {
    return this.setPageSize(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationRequest.prototype.hasPageSize = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByLocationResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByLocationResponse.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.toObject = function(t, r) {
    var n, d = {
      clinicsList: e.Message.toObjectList(
        r.getClinicsList(),
        proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.toObject,
        t
      ),
      pageToken: e.Message.getFieldWithDefault(r, 11, ""),
      pageSize: e.Message.getFieldWithDefault(r, 12, 0),
      nextPageToken: (n = r.getNextPageToken()) && i.StringValue.toObject(t, n),
      pageCount: e.Message.getFieldWithDefault(r, 14, 0)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindClinicsByLocationResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByLocationResponse();
    return proto.api.patient.v1.FindClinicsByLocationResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo();
          r.readMessage(d, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.deserializeBinaryFromReader), t.addClinics(d);
          break;
        case 11:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPageToken(d);
          break;
        case 12:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setPageSize(d);
          break;
        case 13:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setNextPageToken(d);
          break;
        case 14:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setPageCount(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByLocationResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByLocationResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.serializeBinaryToWriter
    ), n = t.getPageToken(), n.length > 0 && r.writeString(
      11,
      n
    ), n = t.getPageSize(), n !== 0 && r.writeInt32(
      12,
      n
    ), n = t.getNextPageToken(), n != null && r.writeMessage(
      13,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPageCount(), n !== 0 && r.writeInt32(
      14,
      n
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      url: e.Message.getFieldWithDefault(r, 2, ""),
      name: e.Message.getFieldWithDefault(r, 3, ""),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n),
      subscription: e.Message.getFieldWithDefault(r, 5, 0),
      latLng: (n = r.getLatLng()) && B.LatLng.toObject(t, n),
      visitingAddress: (n = r.getVisitingAddress()) && I.PostalAddress.toObject(t, n),
      images: (n = r.getImages()) && proto.api.patient.v1.ClinicImages.toObject(t, n),
      treatment: (n = r.getTreatment()) && proto.api.patient.v1.ClinicTreatment.toObject(t, n),
      reviewScore: (n = r.getReviewScore()) && i.FloatValue.toObject(t, n),
      noOfReviews: e.Message.getFieldWithDefault(r, 16, 0),
      distanceKm: e.Message.getFloatingPointFieldWithDefault(r, 20, 0)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo();
    return proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setUrl(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 4:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        case 5:
          var d = (
            /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
            r.readEnum()
          );
          t.setSubscription(d);
          break;
        case 6:
          var d = new B.LatLng();
          r.readMessage(d, B.LatLng.deserializeBinaryFromReader), t.setLatLng(d);
          break;
        case 7:
          var d = new I.PostalAddress();
          r.readMessage(d, I.PostalAddress.deserializeBinaryFromReader), t.setVisitingAddress(d);
          break;
        case 8:
          var d = new proto.api.patient.v1.ClinicImages();
          r.readMessage(d, proto.api.patient.v1.ClinicImages.deserializeBinaryFromReader), t.setImages(d);
          break;
        case 9:
          var d = new proto.api.patient.v1.ClinicTreatment();
          r.readMessage(d, proto.api.patient.v1.ClinicTreatment.deserializeBinaryFromReader), t.setTreatment(d);
          break;
        case 15:
          var d = new i.FloatValue();
          r.readMessage(d, i.FloatValue.deserializeBinaryFromReader), t.setReviewScore(d);
          break;
        case 16:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setNoOfReviews(d);
          break;
        case 20:
          var d = (
            /** @type {number} */
            r.readDouble()
          );
          t.setDistanceKm(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getUrl(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getName(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getDescription(), n != null && r.writeMessage(
      4,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getSubscription(), n !== 0 && r.writeEnum(
      5,
      n
    ), n = t.getLatLng(), n != null && r.writeMessage(
      6,
      n,
      B.LatLng.serializeBinaryToWriter
    ), n = t.getVisitingAddress(), n != null && r.writeMessage(
      7,
      n,
      I.PostalAddress.serializeBinaryToWriter
    ), n = t.getImages(), n != null && r.writeMessage(
      8,
      n,
      proto.api.patient.v1.ClinicImages.serializeBinaryToWriter
    ), n = t.getTreatment(), n != null && r.writeMessage(
      9,
      n,
      proto.api.patient.v1.ClinicTreatment.serializeBinaryToWriter
    ), n = t.getReviewScore(), n != null && r.writeMessage(
      15,
      n,
      i.FloatValue.serializeBinaryToWriter
    ), n = t.getNoOfReviews(), n !== 0 && r.writeInt32(
      16,
      n
    ), n = t.getDistanceKm(), n !== 0 && r.writeDouble(
      20,
      n
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setUrl = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 4)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.hasDescription = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getSubscription = function() {
    return (
      /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setSubscription = function(t) {
    return e.Message.setProto3EnumField(this, 5, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getLatLng = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 6)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setLatLng = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.clearLatLng = function() {
    return this.setLatLng(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.hasLatLng = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getVisitingAddress = function() {
    return (
      /** @type{?proto.google.type.PostalAddress} */
      e.Message.getWrapperField(this, I.PostalAddress, 7)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setVisitingAddress = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.clearVisitingAddress = function() {
    return this.setVisitingAddress(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.hasVisitingAddress = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getImages = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicImages} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicImages, 8)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setImages = function(t) {
    return e.Message.setWrapperField(this, 8, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.clearImages = function() {
    return this.setImages(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.hasImages = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getTreatment = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicTreatment} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicTreatment, 9)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setTreatment = function(t) {
    return e.Message.setWrapperField(this, 9, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.clearTreatment = function() {
    return this.setTreatment(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.hasTreatment = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getReviewScore = function() {
    return (
      /** @type{?proto.google.protobuf.FloatValue} */
      e.Message.getWrapperField(this, i.FloatValue, 15)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setReviewScore = function(t) {
    return e.Message.setWrapperField(this, 15, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.clearReviewScore = function() {
    return this.setReviewScore(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.hasReviewScore = function() {
    return e.Message.getField(this, 15) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getNoOfReviews = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 16, 0)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setNoOfReviews = function(t) {
    return e.Message.setProto3IntField(this, 16, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.getDistanceKm = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 20, 0)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo.prototype.setDistanceKm = function(t) {
    return e.Message.setProto3FloatField(this, 20, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.getClinicsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo, 1)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.setClinicsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.addClinics = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.FindClinicsByLocationResponse.ClinicInfo, r);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.clearClinicsList = function() {
    return this.setClinicsList([]);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.getPageToken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.setPageToken = function(t) {
    return e.Message.setProto3StringField(this, 11, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.getPageSize = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.setPageSize = function(t) {
    return e.Message.setProto3IntField(this, 12, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.getNextPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 13)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.setNextPageToken = function(t) {
    return e.Message.setWrapperField(this, 13, t);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.clearNextPageToken = function() {
    return this.setNextPageToken(void 0);
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.hasNextPageToken = function() {
    return e.Message.getField(this, 13) != null;
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.getPageCount = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 14, 0)
    );
  }, proto.api.patient.v1.FindClinicsByLocationResponse.prototype.setPageCount = function(t) {
    return e.Message.setProto3IntField(this, 14, t);
  }, proto.api.patient.v1.GetClinicRequest.oneofGroups_ = [[1, 2]], proto.api.patient.v1.GetClinicRequest.IdentifierCase = {
    IDENTIFIER_NOT_SET: 0,
    ID: 1,
    URL: 2
  }, proto.api.patient.v1.GetClinicRequest.prototype.getIdentifierCase = function() {
    return (
      /** @type {proto.api.patient.v1.GetClinicRequest.IdentifierCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.GetClinicRequest.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetClinicRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetClinicRequest.toObject(t, this);
  }, proto.api.patient.v1.GetClinicRequest.toObject = function(t, r) {
    var n = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      url: e.Message.getFieldWithDefault(r, 2, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetClinicRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetClinicRequest();
    return proto.api.patient.v1.GetClinicRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetClinicRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setUrl(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetClinicRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetClinicRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetClinicRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = /** @type {string} */
    e.Message.getField(t, 1), n != null && r.writeString(
      1,
      n
    ), n = /** @type {string} */
    e.Message.getField(t, 2), n != null && r.writeString(
      2,
      n
    );
  }, proto.api.patient.v1.GetClinicRequest.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.GetClinicRequest.prototype.setId = function(t) {
    return e.Message.setOneofField(this, 1, proto.api.patient.v1.GetClinicRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.GetClinicRequest.prototype.clearId = function() {
    return e.Message.setOneofField(this, 1, proto.api.patient.v1.GetClinicRequest.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.GetClinicRequest.prototype.hasId = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.GetClinicRequest.prototype.getUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.GetClinicRequest.prototype.setUrl = function(t) {
    return e.Message.setOneofField(this, 2, proto.api.patient.v1.GetClinicRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.GetClinicRequest.prototype.clearUrl = function() {
    return e.Message.setOneofField(this, 2, proto.api.patient.v1.GetClinicRequest.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.GetClinicRequest.prototype.hasUrl = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetClinicResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetClinicResponse.toObject(t, this);
  }, proto.api.patient.v1.GetClinicResponse.toObject = function(t, r) {
    var n, d = {
      clinic: (n = r.getClinic()) && proto.api.patient.v1.Clinic.toObject(t, n),
      statistics: (n = r.getStatistics()) && proto.api.patient.v1.ClinicStatistics.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetClinicResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetClinicResponse();
    return proto.api.patient.v1.GetClinicResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetClinicResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Clinic();
          r.readMessage(d, proto.api.patient.v1.Clinic.deserializeBinaryFromReader), t.setClinic(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.ClinicStatistics();
          r.readMessage(d, proto.api.patient.v1.ClinicStatistics.deserializeBinaryFromReader), t.setStatistics(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetClinicResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetClinicResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetClinicResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinic(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.Clinic.serializeBinaryToWriter
    ), n = t.getStatistics(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.ClinicStatistics.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.GetClinicResponse.prototype.getClinic = function() {
    return (
      /** @type{?proto.api.patient.v1.Clinic} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Clinic, 1)
    );
  }, proto.api.patient.v1.GetClinicResponse.prototype.setClinic = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.GetClinicResponse.prototype.clearClinic = function() {
    return this.setClinic(void 0);
  }, proto.api.patient.v1.GetClinicResponse.prototype.hasClinic = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.GetClinicResponse.prototype.getStatistics = function() {
    return (
      /** @type{?proto.api.patient.v1.ClinicStatistics} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ClinicStatistics, 2)
    );
  }, proto.api.patient.v1.GetClinicResponse.prototype.setStatistics = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.GetClinicResponse.prototype.clearStatistics = function() {
    return this.setStatistics(void 0);
  }, proto.api.patient.v1.GetClinicResponse.prototype.hasStatistics = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindClinicsByIdsRequest.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByIdsRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByIdsRequest.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByIdsRequest.toObject = function(t, r) {
    var n, d = {
      idsList: (n = e.Message.getRepeatedField(r, 1)) == null ? void 0 : n
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindClinicsByIdsRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByIdsRequest();
    return proto.api.patient.v1.FindClinicsByIdsRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByIdsRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addIds(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByIdsRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByIdsRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByIdsRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getIdsList(), n.length > 0 && r.writeRepeatedString(
      1,
      n
    );
  }, proto.api.patient.v1.FindClinicsByIdsRequest.prototype.getIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.api.patient.v1.FindClinicsByIdsRequest.prototype.setIdsList = function(t) {
    return e.Message.setField(this, 1, t || []);
  }, proto.api.patient.v1.FindClinicsByIdsRequest.prototype.addIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 1, t, r);
  }, proto.api.patient.v1.FindClinicsByIdsRequest.prototype.clearIdsList = function() {
    return this.setIdsList([]);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByIdsResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByIdsResponse.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.toObject = function(t, r) {
    var n = {
      clinicsList: e.Message.toObjectList(
        r.getClinicsList(),
        proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.toObject,
        t
      )
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.FindClinicsByIdsResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByIdsResponse();
    return proto.api.patient.v1.FindClinicsByIdsResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo();
          r.readMessage(d, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.deserializeBinaryFromReader), t.addClinics(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByIdsResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByIdsResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByIdsResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.repeatedFields_ = [20, 30], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.toObject(t, this);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      url: e.Message.getFieldWithDefault(r, 2, ""),
      name: e.Message.getFieldWithDefault(r, 3, ""),
      telephone: (n = r.getTelephone()) && M.PhoneNumber.toObject(t, n),
      visitingAddress: (n = r.getVisitingAddress()) && I.PostalAddress.toObject(t, n),
      latLng: (n = r.getLatLng()) && B.LatLng.toObject(t, n),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n),
      subscription: e.Message.getFieldWithDefault(r, 10, 0),
      reviewScore: (n = r.getReviewScore()) && i.FloatValue.toObject(t, n),
      noOfReviews: e.Message.getFieldWithDefault(r, 16, 0),
      treatmentsList: e.Message.toObjectList(
        r.getTreatmentsList(),
        proto.api.patient.v1.ClinicTreatment.toObject,
        t
      ),
      caregiversList: e.Message.toObjectList(
        r.getCaregiversList(),
        proto.api.patient.v1.Caregiver.toObject,
        t
      )
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo();
    return proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setUrl(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 6:
          var d = new M.PhoneNumber();
          r.readMessage(d, M.PhoneNumber.deserializeBinaryFromReader), t.setTelephone(d);
          break;
        case 7:
          var d = new I.PostalAddress();
          r.readMessage(d, I.PostalAddress.deserializeBinaryFromReader), t.setVisitingAddress(d);
          break;
        case 8:
          var d = new B.LatLng();
          r.readMessage(d, B.LatLng.deserializeBinaryFromReader), t.setLatLng(d);
          break;
        case 9:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        case 10:
          var d = (
            /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
            r.readEnum()
          );
          t.setSubscription(d);
          break;
        case 15:
          var d = new i.FloatValue();
          r.readMessage(d, i.FloatValue.deserializeBinaryFromReader), t.setReviewScore(d);
          break;
        case 16:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setNoOfReviews(d);
          break;
        case 20:
          var d = new proto.api.patient.v1.ClinicTreatment();
          r.readMessage(d, proto.api.patient.v1.ClinicTreatment.deserializeBinaryFromReader), t.addTreatments(d);
          break;
        case 30:
          var d = new proto.api.patient.v1.Caregiver();
          r.readMessage(d, proto.api.patient.v1.Caregiver.deserializeBinaryFromReader), t.addCaregivers(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getUrl(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getName(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getTelephone(), n != null && r.writeMessage(
      6,
      n,
      M.PhoneNumber.serializeBinaryToWriter
    ), n = t.getVisitingAddress(), n != null && r.writeMessage(
      7,
      n,
      I.PostalAddress.serializeBinaryToWriter
    ), n = t.getLatLng(), n != null && r.writeMessage(
      8,
      n,
      B.LatLng.serializeBinaryToWriter
    ), n = t.getDescription(), n != null && r.writeMessage(
      9,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getSubscription(), n !== 0 && r.writeEnum(
      10,
      n
    ), n = t.getReviewScore(), n != null && r.writeMessage(
      15,
      n,
      i.FloatValue.serializeBinaryToWriter
    ), n = t.getNoOfReviews(), n !== 0 && r.writeInt32(
      16,
      n
    ), n = t.getTreatmentsList(), n.length > 0 && r.writeRepeatedMessage(
      20,
      n,
      proto.api.patient.v1.ClinicTreatment.serializeBinaryToWriter
    ), n = t.getCaregiversList(), n.length > 0 && r.writeRepeatedMessage(
      30,
      n,
      proto.api.patient.v1.Caregiver.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setUrl = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getTelephone = function() {
    return (
      /** @type{?proto.google.type.PhoneNumber} */
      e.Message.getWrapperField(this, M.PhoneNumber, 6)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setTelephone = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.clearTelephone = function() {
    return this.setTelephone(void 0);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.hasTelephone = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getVisitingAddress = function() {
    return (
      /** @type{?proto.google.type.PostalAddress} */
      e.Message.getWrapperField(this, I.PostalAddress, 7)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setVisitingAddress = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.clearVisitingAddress = function() {
    return this.setVisitingAddress(void 0);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.hasVisitingAddress = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getLatLng = function() {
    return (
      /** @type{?proto.google.type.LatLng} */
      e.Message.getWrapperField(this, B.LatLng, 8)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setLatLng = function(t) {
    return e.Message.setWrapperField(this, 8, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.clearLatLng = function() {
    return this.setLatLng(void 0);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.hasLatLng = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 9)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 9, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.hasDescription = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getSubscription = function() {
    return (
      /** @type {!proto.api.patient.v1.ClinicSubscriptionType} */
      e.Message.getFieldWithDefault(this, 10, 0)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setSubscription = function(t) {
    return e.Message.setProto3EnumField(this, 10, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getReviewScore = function() {
    return (
      /** @type{?proto.google.protobuf.FloatValue} */
      e.Message.getWrapperField(this, i.FloatValue, 15)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setReviewScore = function(t) {
    return e.Message.setWrapperField(this, 15, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.clearReviewScore = function() {
    return this.setReviewScore(void 0);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.hasReviewScore = function() {
    return e.Message.getField(this, 15) != null;
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getNoOfReviews = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 16, 0)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setNoOfReviews = function(t) {
    return e.Message.setProto3IntField(this, 16, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getTreatmentsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.ClinicTreatment>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.ClinicTreatment, 20)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setTreatmentsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 20, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.addTreatments = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 20, t, proto.api.patient.v1.ClinicTreatment, r);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.clearTreatmentsList = function() {
    return this.setTreatmentsList([]);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.getCaregiversList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.Caregiver>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.Caregiver, 30)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.setCaregiversList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 30, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.addCaregivers = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 30, t, proto.api.patient.v1.Caregiver, r);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo.prototype.clearCaregiversList = function() {
    return this.setCaregiversList([]);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.prototype.getClinicsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo, 1)
    );
  }, proto.api.patient.v1.FindClinicsByIdsResponse.prototype.setClinicsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.prototype.addClinics = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.FindClinicsByIdsResponse.ClinicInfo, r);
  }, proto.api.patient.v1.FindClinicsByIdsResponse.prototype.clearClinicsList = function() {
    return this.setClinicsList([]);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Appointment.prototype.toObject = function(t) {
    return proto.api.patient.v1.Appointment.toObject(t, this);
  }, proto.api.patient.v1.Appointment.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      clinicId: e.Message.getFieldWithDefault(r, 2, ""),
      treatmentId: e.Message.getFieldWithDefault(r, 3, ""),
      appointmentPrice: (n = r.getAppointmentPrice()) && proto.api.patient.v1.Price.toObject(t, n),
      startTime: (n = r.getStartTime()) && y.DateTime.toObject(t, n),
      endTime: (n = r.getEndTime()) && y.DateTime.toObject(t, n),
      description: (n = r.getDescription()) && i.StringValue.toObject(t, n),
      primaryCaregiver: (n = r.getPrimaryCaregiver()) && proto.api.patient.v1.Caregiver.toObject(t, n),
      primaryCaregiverId: (n = r.getPrimaryCaregiverId()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Appointment.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Appointment();
    return proto.api.patient.v1.Appointment.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Appointment.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setTreatmentId(d);
          break;
        case 4:
          var d = new proto.api.patient.v1.Price();
          r.readMessage(d, proto.api.patient.v1.Price.deserializeBinaryFromReader), t.setAppointmentPrice(d);
          break;
        case 5:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setStartTime(d);
          break;
        case 6:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setEndTime(d);
          break;
        case 7:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setDescription(d);
          break;
        case 8:
          var d = new proto.api.patient.v1.Caregiver();
          r.readMessage(d, proto.api.patient.v1.Caregiver.deserializeBinaryFromReader), t.setPrimaryCaregiver(d);
          break;
        case 9:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setPrimaryCaregiverId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Appointment.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Appointment.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Appointment.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getClinicId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getTreatmentId(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getAppointmentPrice(), n != null && r.writeMessage(
      4,
      n,
      proto.api.patient.v1.Price.serializeBinaryToWriter
    ), n = t.getStartTime(), n != null && r.writeMessage(
      5,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getEndTime(), n != null && r.writeMessage(
      6,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getDescription(), n != null && r.writeMessage(
      7,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPrimaryCaregiver(), n != null && r.writeMessage(
      8,
      n,
      proto.api.patient.v1.Caregiver.serializeBinaryToWriter
    ), n = t.getPrimaryCaregiverId(), n != null && r.writeMessage(
      9,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Appointment.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.Appointment.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.Appointment.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.Appointment.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.Appointment.prototype.getTreatmentId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.Appointment.prototype.setTreatmentId = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.Appointment.prototype.getAppointmentPrice = function() {
    return (
      /** @type{?proto.api.patient.v1.Price} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Price, 4)
    );
  }, proto.api.patient.v1.Appointment.prototype.setAppointmentPrice = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.Appointment.prototype.clearAppointmentPrice = function() {
    return this.setAppointmentPrice(void 0);
  }, proto.api.patient.v1.Appointment.prototype.hasAppointmentPrice = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.Appointment.prototype.getStartTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 5)
    );
  }, proto.api.patient.v1.Appointment.prototype.setStartTime = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.Appointment.prototype.clearStartTime = function() {
    return this.setStartTime(void 0);
  }, proto.api.patient.v1.Appointment.prototype.hasStartTime = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.Appointment.prototype.getEndTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 6)
    );
  }, proto.api.patient.v1.Appointment.prototype.setEndTime = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.Appointment.prototype.clearEndTime = function() {
    return this.setEndTime(void 0);
  }, proto.api.patient.v1.Appointment.prototype.hasEndTime = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.Appointment.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 7)
    );
  }, proto.api.patient.v1.Appointment.prototype.setDescription = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.Appointment.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.v1.Appointment.prototype.hasDescription = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.Appointment.prototype.getPrimaryCaregiver = function() {
    return (
      /** @type{?proto.api.patient.v1.Caregiver} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Caregiver, 8)
    );
  }, proto.api.patient.v1.Appointment.prototype.setPrimaryCaregiver = function(t) {
    return e.Message.setWrapperField(this, 8, t);
  }, proto.api.patient.v1.Appointment.prototype.clearPrimaryCaregiver = function() {
    return this.setPrimaryCaregiver(void 0);
  }, proto.api.patient.v1.Appointment.prototype.hasPrimaryCaregiver = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.v1.Appointment.prototype.getPrimaryCaregiverId = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 9)
    );
  }, proto.api.patient.v1.Appointment.prototype.setPrimaryCaregiverId = function(t) {
    return e.Message.setWrapperField(this, 9, t);
  }, proto.api.patient.v1.Appointment.prototype.clearPrimaryCaregiverId = function() {
    return this.setPrimaryCaregiverId(void 0);
  }, proto.api.patient.v1.Appointment.prototype.hasPrimaryCaregiverId = function() {
    return e.Message.getField(this, 9) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Caregiver.prototype.toObject = function(t) {
    return proto.api.patient.v1.Caregiver.toObject(t, this);
  }, proto.api.patient.v1.Caregiver.toObject = function(t, r) {
    var n, d = {
      externalId: (n = r.getExternalId()) && i.StringValue.toObject(t, n),
      name: (n = r.getName()) && i.StringValue.toObject(t, n),
      id: e.Message.getFieldWithDefault(r, 3, ""),
      title: e.Message.getFieldWithDefault(r, 4, ""),
      imageUrl: (n = r.getImageUrl()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Caregiver.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Caregiver();
    return proto.api.patient.v1.Caregiver.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Caregiver.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setExternalId(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setName(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setTitle(d);
          break;
        case 5:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setImageUrl(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Caregiver.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Caregiver.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Caregiver.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getExternalId(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getName(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getId(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getTitle(), n.length > 0 && r.writeString(
      4,
      n
    ), n = t.getImageUrl(), n != null && r.writeMessage(
      5,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Caregiver.prototype.getExternalId = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.Caregiver.prototype.setExternalId = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.Caregiver.prototype.clearExternalId = function() {
    return this.setExternalId(void 0);
  }, proto.api.patient.v1.Caregiver.prototype.hasExternalId = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.Caregiver.prototype.getName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.Caregiver.prototype.setName = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.Caregiver.prototype.clearName = function() {
    return this.setName(void 0);
  }, proto.api.patient.v1.Caregiver.prototype.hasName = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.Caregiver.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.Caregiver.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.Caregiver.prototype.getTitle = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.api.patient.v1.Caregiver.prototype.setTitle = function(t) {
    return e.Message.setProto3StringField(this, 4, t);
  }, proto.api.patient.v1.Caregiver.prototype.getImageUrl = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 5)
    );
  }, proto.api.patient.v1.Caregiver.prototype.setImageUrl = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.Caregiver.prototype.clearImageUrl = function() {
    return this.setImageUrl(void 0);
  }, proto.api.patient.v1.Caregiver.prototype.hasImageUrl = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.FindAppointmentsRequest.repeatedFields_ = [3, 4], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAppointmentsRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAppointmentsRequest.toObject(t, this);
  }, proto.api.patient.v1.FindAppointmentsRequest.toObject = function(t, r) {
    var n, d = {
      startTime: (n = r.getStartTime()) && y.DateTime.toObject(t, n),
      endTime: (n = r.getEndTime()) && y.DateTime.toObject(t, n),
      treatmentIdsList: (n = e.Message.getRepeatedField(r, 3)) == null ? void 0 : n,
      clinicIdsList: (n = e.Message.getRepeatedField(r, 4)) == null ? void 0 : n,
      sorting: e.Message.getFieldWithDefault(r, 5, 0),
      startTimeOfDay: (n = r.getStartTimeOfDay()) && $.TimeOfDay.toObject(t, n),
      endTimeOfDay: (n = r.getEndTimeOfDay()) && $.TimeOfDay.toObject(t, n),
      pageToken: (n = r.getPageToken()) && i.StringValue.toObject(t, n),
      pageSize: (n = r.getPageSize()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindAppointmentsRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAppointmentsRequest();
    return proto.api.patient.v1.FindAppointmentsRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAppointmentsRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setStartTime(d);
          break;
        case 2:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setEndTime(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addTreatmentIds(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addClinicIds(d);
          break;
        case 5:
          var d = (
            /** @type {!proto.api.patient.v1.FindAppointmentsRequest.Sorting} */
            r.readEnum()
          );
          t.setSorting(d);
          break;
        case 6:
          var d = new $.TimeOfDay();
          r.readMessage(d, $.TimeOfDay.deserializeBinaryFromReader), t.setStartTimeOfDay(d);
          break;
        case 7:
          var d = new $.TimeOfDay();
          r.readMessage(d, $.TimeOfDay.deserializeBinaryFromReader), t.setEndTimeOfDay(d);
          break;
        case 11:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setPageToken(d);
          break;
        case 12:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setPageSize(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAppointmentsRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAppointmentsRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getStartTime(), n != null && r.writeMessage(
      1,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getEndTime(), n != null && r.writeMessage(
      2,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getTreatmentIdsList(), n.length > 0 && r.writeRepeatedString(
      3,
      n
    ), n = t.getClinicIdsList(), n.length > 0 && r.writeRepeatedString(
      4,
      n
    ), n = t.getSorting(), n !== 0 && r.writeEnum(
      5,
      n
    ), n = t.getStartTimeOfDay(), n != null && r.writeMessage(
      6,
      n,
      $.TimeOfDay.serializeBinaryToWriter
    ), n = t.getEndTimeOfDay(), n != null && r.writeMessage(
      7,
      n,
      $.TimeOfDay.serializeBinaryToWriter
    ), n = t.getPageToken(), n != null && r.writeMessage(
      11,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPageSize(), n != null && r.writeMessage(
      12,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.Sorting = {
    SORTING_UNSPECIFIED: 0,
    SORTING_TIME: 1,
    SORTING_PRICE: 2,
    SORTING_PRESERVE_CLINIC_IDS_ORDER: 3
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getStartTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 1)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setStartTime = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearStartTime = function() {
    return this.setStartTime(void 0);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.hasStartTime = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getEndTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 2)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setEndTime = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearEndTime = function() {
    return this.setEndTime(void 0);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.hasEndTime = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getTreatmentIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 3)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setTreatmentIdsList = function(t) {
    return e.Message.setField(this, 3, t || []);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.addTreatmentIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 3, t, r);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearTreatmentIdsList = function() {
    return this.setTreatmentIdsList([]);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 4)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setClinicIdsList = function(t) {
    return e.Message.setField(this, 4, t || []);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.addClinicIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 4, t, r);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getSorting = function() {
    return (
      /** @type {!proto.api.patient.v1.FindAppointmentsRequest.Sorting} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setSorting = function(t) {
    return e.Message.setProto3EnumField(this, 5, t);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getStartTimeOfDay = function() {
    return (
      /** @type{?proto.google.type.TimeOfDay} */
      e.Message.getWrapperField(this, $.TimeOfDay, 6)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setStartTimeOfDay = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearStartTimeOfDay = function() {
    return this.setStartTimeOfDay(void 0);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.hasStartTimeOfDay = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getEndTimeOfDay = function() {
    return (
      /** @type{?proto.google.type.TimeOfDay} */
      e.Message.getWrapperField(this, $.TimeOfDay, 7)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setEndTimeOfDay = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearEndTimeOfDay = function() {
    return this.setEndTimeOfDay(void 0);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.hasEndTimeOfDay = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 11)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setPageToken = function(t) {
    return e.Message.setWrapperField(this, 11, t);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearPageToken = function() {
    return this.setPageToken(void 0);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.hasPageToken = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.getPageSize = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 12)
    );
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.setPageSize = function(t) {
    return e.Message.setWrapperField(this, 12, t);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.clearPageSize = function() {
    return this.setPageSize(void 0);
  }, proto.api.patient.v1.FindAppointmentsRequest.prototype.hasPageSize = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.FindAppointmentsResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAppointmentsResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAppointmentsResponse.toObject(t, this);
  }, proto.api.patient.v1.FindAppointmentsResponse.toObject = function(t, r) {
    var n, d = {
      appointmentsList: e.Message.toObjectList(
        r.getAppointmentsList(),
        proto.api.patient.v1.Appointment.toObject,
        t
      ),
      pageToken: e.Message.getFieldWithDefault(r, 11, ""),
      pageSize: e.Message.getFieldWithDefault(r, 12, 0),
      nextPageToken: (n = r.getNextPageToken()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindAppointmentsResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAppointmentsResponse();
    return proto.api.patient.v1.FindAppointmentsResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAppointmentsResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Appointment();
          r.readMessage(d, proto.api.patient.v1.Appointment.deserializeBinaryFromReader), t.addAppointments(d);
          break;
        case 11:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPageToken(d);
          break;
        case 12:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setPageSize(d);
          break;
        case 13:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setNextPageToken(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAppointmentsResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAppointmentsResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getAppointmentsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.Appointment.serializeBinaryToWriter
    ), n = t.getPageToken(), n.length > 0 && r.writeString(
      11,
      n
    ), n = t.getPageSize(), n !== 0 && r.writeInt32(
      12,
      n
    ), n = t.getNextPageToken(), n != null && r.writeMessage(
      13,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.getAppointmentsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.Appointment>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.Appointment, 1)
    );
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.setAppointmentsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.addAppointments = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.Appointment, r);
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.clearAppointmentsList = function() {
    return this.setAppointmentsList([]);
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.getPageToken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.setPageToken = function(t) {
    return e.Message.setProto3StringField(this, 11, t);
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.getPageSize = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.setPageSize = function(t) {
    return e.Message.setProto3IntField(this, 12, t);
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.getNextPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 13)
    );
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.setNextPageToken = function(t) {
    return e.Message.setWrapperField(this, 13, t);
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.clearNextPageToken = function() {
    return this.setNextPageToken(void 0);
  }, proto.api.patient.v1.FindAppointmentsResponse.prototype.hasNextPageToken = function() {
    return e.Message.getField(this, 13) != null;
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.repeatedFields_ = [3, 4], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAppointmentsPerClinicRequest.toObject(t, this);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.toObject = function(t, r) {
    var n, d = {
      startTime: (n = r.getStartTime()) && y.DateTime.toObject(t, n),
      endTime: (n = r.getEndTime()) && y.DateTime.toObject(t, n),
      treatmentIdsList: (n = e.Message.getRepeatedField(r, 3)) == null ? void 0 : n,
      clinicIdsList: (n = e.Message.getRepeatedField(r, 4)) == null ? void 0 : n,
      maxAppointmentsPerClinic: (n = r.getMaxAppointmentsPerClinic()) && i.Int32Value.toObject(t, n),
      sorting: e.Message.getFieldWithDefault(r, 11, 0)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindAppointmentsPerClinicRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAppointmentsPerClinicRequest();
    return proto.api.patient.v1.FindAppointmentsPerClinicRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setStartTime(d);
          break;
        case 2:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setEndTime(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addTreatmentIds(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addClinicIds(d);
          break;
        case 10:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setMaxAppointmentsPerClinic(d);
          break;
        case 11:
          var d = (
            /** @type {!proto.api.patient.v1.FindAppointmentsPerClinicRequest.Sorting} */
            r.readEnum()
          );
          t.setSorting(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAppointmentsPerClinicRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getStartTime(), n != null && r.writeMessage(
      1,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getEndTime(), n != null && r.writeMessage(
      2,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getTreatmentIdsList(), n.length > 0 && r.writeRepeatedString(
      3,
      n
    ), n = t.getClinicIdsList(), n.length > 0 && r.writeRepeatedString(
      4,
      n
    ), n = t.getMaxAppointmentsPerClinic(), n != null && r.writeMessage(
      10,
      n,
      i.Int32Value.serializeBinaryToWriter
    ), n = t.getSorting(), n !== 0 && r.writeEnum(
      11,
      n
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.Sorting = {
    SORTING_UNSPECIFIED: 0,
    SORTING_PRESERVE_CLINIC_IDS_ORDER: 3
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.getStartTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 1)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.setStartTime = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.clearStartTime = function() {
    return this.setStartTime(void 0);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.hasStartTime = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.getEndTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 2)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.setEndTime = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.clearEndTime = function() {
    return this.setEndTime(void 0);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.hasEndTime = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.getTreatmentIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 3)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.setTreatmentIdsList = function(t) {
    return e.Message.setField(this, 3, t || []);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.addTreatmentIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 3, t, r);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.clearTreatmentIdsList = function() {
    return this.setTreatmentIdsList([]);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 4)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.setClinicIdsList = function(t) {
    return e.Message.setField(this, 4, t || []);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.addClinicIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 4, t, r);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.getMaxAppointmentsPerClinic = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 10)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.setMaxAppointmentsPerClinic = function(t) {
    return e.Message.setWrapperField(this, 10, t);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.clearMaxAppointmentsPerClinic = function() {
    return this.setMaxAppointmentsPerClinic(void 0);
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.hasMaxAppointmentsPerClinic = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.getSorting = function() {
    return (
      /** @type {!proto.api.patient.v1.FindAppointmentsPerClinicRequest.Sorting} */
      e.Message.getFieldWithDefault(this, 11, 0)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicRequest.prototype.setSorting = function(t) {
    return e.Message.setProto3EnumField(this, 11, t);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAppointmentsPerClinicResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAppointmentsPerClinicResponse.toObject(t, this);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.toObject = function(t, r) {
    var n = {
      clinicsList: e.Message.toObjectList(
        r.getClinicsList(),
        proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.toObject,
        t
      )
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.FindAppointmentsPerClinicResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAppointmentsPerClinicResponse();
    return proto.api.patient.v1.FindAppointmentsPerClinicResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic();
          r.readMessage(d, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.deserializeBinaryFromReader), t.addClinics(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAppointmentsPerClinicResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.repeatedFields_ = [20], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.toObject(t, this);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.toObject = function(t, r) {
    var n = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      appointmentsList: e.Message.toObjectList(
        r.getAppointmentsList(),
        proto.api.patient.v1.Appointment.toObject,
        t
      )
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic();
    return proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 20:
          var d = new proto.api.patient.v1.Appointment();
          r.readMessage(d, proto.api.patient.v1.Appointment.deserializeBinaryFromReader), t.addAppointments(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getAppointmentsList(), n.length > 0 && r.writeRepeatedMessage(
      20,
      n,
      proto.api.patient.v1.Appointment.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.getAppointmentsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.Appointment>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.Appointment, 20)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.setAppointmentsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 20, t);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.addAppointments = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 20, t, proto.api.patient.v1.Appointment, r);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic.prototype.clearAppointmentsList = function() {
    return this.setAppointmentsList([]);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.prototype.getClinicsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic, 1)
    );
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.prototype.setClinicsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.prototype.addClinics = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.FindAppointmentsPerClinicResponse.Clinic, r);
  }, proto.api.patient.v1.FindAppointmentsPerClinicResponse.prototype.clearClinicsList = function() {
    return this.setClinicsList([]);
  }, proto.api.patient.v1.PatientInfo.oneofGroups_ = [[1]], proto.api.patient.v1.PatientInfo.PidCase = {
    PID_NOT_SET: 0,
    SWEDISH_PERSONAL_IDENTITY_NUMBER: 1
  }, proto.api.patient.v1.PatientInfo.prototype.getPidCase = function() {
    return (
      /** @type {proto.api.patient.v1.PatientInfo.PidCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.PatientInfo.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.PatientInfo.prototype.toObject = function(t) {
    return proto.api.patient.v1.PatientInfo.toObject(t, this);
  }, proto.api.patient.v1.PatientInfo.toObject = function(t, r) {
    var n, d = {
      swedishPersonalIdentityNumber: (n = r.getSwedishPersonalIdentityNumber()) && proto.api.patient.v1.SwedishPersonalIdentityNumber.toObject(t, n),
      firstName: e.Message.getFieldWithDefault(r, 11, ""),
      lastName: e.Message.getFieldWithDefault(r, 12, ""),
      mobilePhone: (n = r.getMobilePhone()) && M.PhoneNumber.toObject(t, n),
      email: e.Message.getFieldWithDefault(r, 14, "")
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.PatientInfo.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.PatientInfo();
    return proto.api.patient.v1.PatientInfo.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.PatientInfo.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.SwedishPersonalIdentityNumber();
          r.readMessage(d, proto.api.patient.v1.SwedishPersonalIdentityNumber.deserializeBinaryFromReader), t.setSwedishPersonalIdentityNumber(d);
          break;
        case 11:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setFirstName(d);
          break;
        case 12:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setLastName(d);
          break;
        case 13:
          var d = new M.PhoneNumber();
          r.readMessage(d, M.PhoneNumber.deserializeBinaryFromReader), t.setMobilePhone(d);
          break;
        case 14:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setEmail(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.PatientInfo.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.PatientInfo.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.PatientInfo.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getSwedishPersonalIdentityNumber(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.SwedishPersonalIdentityNumber.serializeBinaryToWriter
    ), n = t.getFirstName(), n.length > 0 && r.writeString(
      11,
      n
    ), n = t.getLastName(), n.length > 0 && r.writeString(
      12,
      n
    ), n = t.getMobilePhone(), n != null && r.writeMessage(
      13,
      n,
      M.PhoneNumber.serializeBinaryToWriter
    ), n = t.getEmail(), n.length > 0 && r.writeString(
      14,
      n
    );
  }, proto.api.patient.v1.PatientInfo.prototype.getSwedishPersonalIdentityNumber = function() {
    return (
      /** @type{?proto.api.patient.v1.SwedishPersonalIdentityNumber} */
      e.Message.getWrapperField(this, proto.api.patient.v1.SwedishPersonalIdentityNumber, 1)
    );
  }, proto.api.patient.v1.PatientInfo.prototype.setSwedishPersonalIdentityNumber = function(t) {
    return e.Message.setOneofWrapperField(this, 1, proto.api.patient.v1.PatientInfo.oneofGroups_[0], t);
  }, proto.api.patient.v1.PatientInfo.prototype.clearSwedishPersonalIdentityNumber = function() {
    return this.setSwedishPersonalIdentityNumber(void 0);
  }, proto.api.patient.v1.PatientInfo.prototype.hasSwedishPersonalIdentityNumber = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.PatientInfo.prototype.getFirstName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.api.patient.v1.PatientInfo.prototype.setFirstName = function(t) {
    return e.Message.setProto3StringField(this, 11, t);
  }, proto.api.patient.v1.PatientInfo.prototype.getLastName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 12, "")
    );
  }, proto.api.patient.v1.PatientInfo.prototype.setLastName = function(t) {
    return e.Message.setProto3StringField(this, 12, t);
  }, proto.api.patient.v1.PatientInfo.prototype.getMobilePhone = function() {
    return (
      /** @type{?proto.google.type.PhoneNumber} */
      e.Message.getWrapperField(this, M.PhoneNumber, 13)
    );
  }, proto.api.patient.v1.PatientInfo.prototype.setMobilePhone = function(t) {
    return e.Message.setWrapperField(this, 13, t);
  }, proto.api.patient.v1.PatientInfo.prototype.clearMobilePhone = function() {
    return this.setMobilePhone(void 0);
  }, proto.api.patient.v1.PatientInfo.prototype.hasMobilePhone = function() {
    return e.Message.getField(this, 13) != null;
  }, proto.api.patient.v1.PatientInfo.prototype.getEmail = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 14, "")
    );
  }, proto.api.patient.v1.PatientInfo.prototype.setEmail = function(t) {
    return e.Message.setProto3StringField(this, 14, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.AppointmentClaim.prototype.toObject = function(t) {
    return proto.api.patient.v1.AppointmentClaim.toObject(t, this);
  }, proto.api.patient.v1.AppointmentClaim.toObject = function(t, r) {
    var n = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      appointmentId: e.Message.getFieldWithDefault(r, 2, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.AppointmentClaim.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.AppointmentClaim();
    return proto.api.patient.v1.AppointmentClaim.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.AppointmentClaim.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setAppointmentId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.AppointmentClaim.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.AppointmentClaim.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.AppointmentClaim.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getAppointmentId(), n.length > 0 && r.writeString(
      2,
      n
    );
  }, proto.api.patient.v1.AppointmentClaim.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.AppointmentClaim.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.AppointmentClaim.prototype.getAppointmentId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.AppointmentClaim.prototype.setAppointmentId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.TreatmentInquiry.prototype.toObject = function(t) {
    return proto.api.patient.v1.TreatmentInquiry.toObject(t, this);
  }, proto.api.patient.v1.TreatmentInquiry.toObject = function(t, r) {
    var n, d = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      treatmentId: e.Message.getFieldWithDefault(r, 2, ""),
      dateTime: (n = r.getDateTime()) && u.Date.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.TreatmentInquiry.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.TreatmentInquiry();
    return proto.api.patient.v1.TreatmentInquiry.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.TreatmentInquiry.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setTreatmentId(d);
          break;
        case 3:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setDateTime(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.TreatmentInquiry.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.TreatmentInquiry.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.TreatmentInquiry.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getTreatmentId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getDateTime(), n != null && r.writeMessage(
      3,
      n,
      u.Date.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.TreatmentInquiry.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.TreatmentInquiry.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.TreatmentInquiry.prototype.getTreatmentId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.TreatmentInquiry.prototype.setTreatmentId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.TreatmentInquiry.prototype.getDateTime = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 3)
    );
  }, proto.api.patient.v1.TreatmentInquiry.prototype.setDateTime = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.TreatmentInquiry.prototype.clearDateTime = function() {
    return this.setDateTime(void 0);
  }, proto.api.patient.v1.TreatmentInquiry.prototype.hasDateTime = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingFlowTypeRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingFlowTypeRequest.toObject(t, this);
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.toObject = function(t, r) {
    var n, d = {
      appointmentClaim: (n = r.getAppointmentClaim()) && proto.api.patient.v1.AppointmentClaim.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetBookingFlowTypeRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingFlowTypeRequest();
    return proto.api.patient.v1.GetBookingFlowTypeRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.AppointmentClaim();
          r.readMessage(d, proto.api.patient.v1.AppointmentClaim.deserializeBinaryFromReader), t.setAppointmentClaim(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingFlowTypeRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getAppointmentClaim(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.AppointmentClaim.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.prototype.getAppointmentClaim = function() {
    return (
      /** @type{?proto.api.patient.v1.AppointmentClaim} */
      e.Message.getWrapperField(this, proto.api.patient.v1.AppointmentClaim, 1)
    );
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.prototype.setAppointmentClaim = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.prototype.clearAppointmentClaim = function() {
    return this.setAppointmentClaim(void 0);
  }, proto.api.patient.v1.GetBookingFlowTypeRequest.prototype.hasAppointmentClaim = function() {
    return e.Message.getField(this, 1) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingFlowTypeResponse.toObject(t, this);
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.toObject = function(t, r) {
    var n, d = {
      bookingFlowType: e.Message.getFieldWithDefault(r, 1, 0),
      bookingNoshowFee: (n = r.getBookingNoshowFee()) && i.FloatValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetBookingFlowTypeResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingFlowTypeResponse();
    return proto.api.patient.v1.GetBookingFlowTypeResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {!proto.api.patient.v1.GetBookingFlowTypeResponse.BookingFlowType} */
            r.readEnum()
          );
          t.setBookingFlowType(d);
          break;
        case 5:
          var d = new i.FloatValue();
          r.readMessage(d, i.FloatValue.deserializeBinaryFromReader), t.setBookingNoshowFee(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingFlowTypeResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingFlowType(), n !== 0 && r.writeEnum(
      1,
      n
    ), n = t.getBookingNoshowFee(), n != null && r.writeMessage(
      5,
      n,
      i.FloatValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.BookingFlowType = {
    BOOKING_FLOW_TYPE_UNSPECIFIED: 0,
    BOOKING_FLOW_TYPE_SIMPLE: 1,
    BOOKING_FLOW_TYPE_TOKENIZE_CARD: 2
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.getBookingFlowType = function() {
    return (
      /** @type {!proto.api.patient.v1.GetBookingFlowTypeResponse.BookingFlowType} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.setBookingFlowType = function(t) {
    return e.Message.setProto3EnumField(this, 1, t);
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.getBookingNoshowFee = function() {
    return (
      /** @type{?proto.google.protobuf.FloatValue} */
      e.Message.getWrapperField(this, i.FloatValue, 5)
    );
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.setBookingNoshowFee = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.clearBookingNoshowFee = function() {
    return this.setBookingNoshowFee(void 0);
  }, proto.api.patient.v1.GetBookingFlowTypeResponse.prototype.hasBookingNoshowFee = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.oneofGroups_ = [[1, 2]], proto.api.patient.v1.GetBookingAuthMethodRequest.BookingCase = {
    BOOKING_NOT_SET: 0,
    APPOINTMENT_CLAIM: 1,
    TREATMENT_INQUIRY: 2
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.getBookingCase = function() {
    return (
      /** @type {proto.api.patient.v1.GetBookingAuthMethodRequest.BookingCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.GetBookingAuthMethodRequest.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingAuthMethodRequest.toObject(t, this);
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.toObject = function(t, r) {
    var n, d = {
      appointmentClaim: (n = r.getAppointmentClaim()) && proto.api.patient.v1.AppointmentClaim.toObject(t, n),
      treatmentInquiry: (n = r.getTreatmentInquiry()) && proto.api.patient.v1.TreatmentInquiry.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetBookingAuthMethodRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingAuthMethodRequest();
    return proto.api.patient.v1.GetBookingAuthMethodRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.AppointmentClaim();
          r.readMessage(d, proto.api.patient.v1.AppointmentClaim.deserializeBinaryFromReader), t.setAppointmentClaim(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.TreatmentInquiry();
          r.readMessage(d, proto.api.patient.v1.TreatmentInquiry.deserializeBinaryFromReader), t.setTreatmentInquiry(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingAuthMethodRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getAppointmentClaim(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.AppointmentClaim.serializeBinaryToWriter
    ), n = t.getTreatmentInquiry(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.TreatmentInquiry.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.getAppointmentClaim = function() {
    return (
      /** @type{?proto.api.patient.v1.AppointmentClaim} */
      e.Message.getWrapperField(this, proto.api.patient.v1.AppointmentClaim, 1)
    );
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.setAppointmentClaim = function(t) {
    return e.Message.setOneofWrapperField(this, 1, proto.api.patient.v1.GetBookingAuthMethodRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.clearAppointmentClaim = function() {
    return this.setAppointmentClaim(void 0);
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.hasAppointmentClaim = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.getTreatmentInquiry = function() {
    return (
      /** @type{?proto.api.patient.v1.TreatmentInquiry} */
      e.Message.getWrapperField(this, proto.api.patient.v1.TreatmentInquiry, 2)
    );
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.setTreatmentInquiry = function(t) {
    return e.Message.setOneofWrapperField(this, 2, proto.api.patient.v1.GetBookingAuthMethodRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.clearTreatmentInquiry = function() {
    return this.setTreatmentInquiry(void 0);
  }, proto.api.patient.v1.GetBookingAuthMethodRequest.prototype.hasTreatmentInquiry = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.oneofGroups_ = [[1, 2, 3]], proto.api.patient.v1.GetBookingAuthMethodResponse.MethodCase = {
    METHOD_NOT_SET: 0,
    NONE: 1,
    PAYMENT: 2,
    MFA: 3
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.getMethodCase = function() {
    return (
      /** @type {proto.api.patient.v1.GetBookingAuthMethodResponse.MethodCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.GetBookingAuthMethodResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingAuthMethodResponse.toObject(t, this);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.toObject = function(t, r) {
    var n, d = {
      none: (n = r.getNone()) && proto.api.patient.v1.GetBookingAuthMethodResponse.None.toObject(t, n),
      payment: (n = r.getPayment()) && proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.toObject(t, n),
      mfa: (n = r.getMfa()) && proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetBookingAuthMethodResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingAuthMethodResponse();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.GetBookingAuthMethodResponse.None();
          r.readMessage(d, proto.api.patient.v1.GetBookingAuthMethodResponse.None.deserializeBinaryFromReader), t.setNone(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.GetBookingAuthMethodResponse.Payment();
          r.readMessage(d, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.deserializeBinaryFromReader), t.setPayment(d);
          break;
        case 3:
          var d = new proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa();
          r.readMessage(d, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.deserializeBinaryFromReader), t.setMfa(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getNone(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.GetBookingAuthMethodResponse.None.serializeBinaryToWriter
    ), n = t.getPayment(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.serializeBinaryToWriter
    ), n = t.getMfa(), n != null && r.writeMessage(
      3,
      n,
      proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingAuthMethodResponse.None.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingAuthMethodResponse.None.toObject(t, this);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.None.toObject = function(t, r) {
    var n = {};
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetBookingAuthMethodResponse.None.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingAuthMethodResponse.None();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.None.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.None.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.None.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.None.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.None.serializeBinaryToWriter = function(t, r) {
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.toObject(t, this);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.toObject = function(t, r) {
    var n = {
      provider: e.Message.getFieldWithDefault(r, 1, 0)
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingAuthMethodResponse.Payment();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {!proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.Provider} */
            r.readEnum()
          );
          t.setProvider(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getProvider(), n !== 0 && r.writeEnum(
      1,
      n
    );
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.Provider = {
    PROVIDER_UNSPECIFIED: 0,
    PROVIDER_KLARNA: 1
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.prototype.getProvider = function() {
    return (
      /** @type {!proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.Provider} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment.prototype.setProvider = function(t) {
    return e.Message.setProto3EnumField(this, 1, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.toObject(t, this);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.toObject = function(t, r) {
    var n = {
      provider: e.Message.getFieldWithDefault(r, 1, 0)
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {!proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.Provider} */
            r.readEnum()
          );
          t.setProvider(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getProvider(), n !== 0 && r.writeEnum(
      1,
      n
    );
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.Provider = {
    PROVIDER_UNSPECIFIED: 0,
    PROVIDER_BANK_ID: 1
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.prototype.getProvider = function() {
    return (
      /** @type {!proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.Provider} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa.prototype.setProvider = function(t) {
    return e.Message.setProto3EnumField(this, 1, t);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.getNone = function() {
    return (
      /** @type{?proto.api.patient.v1.GetBookingAuthMethodResponse.None} */
      e.Message.getWrapperField(this, proto.api.patient.v1.GetBookingAuthMethodResponse.None, 1)
    );
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.setNone = function(t) {
    return e.Message.setOneofWrapperField(this, 1, proto.api.patient.v1.GetBookingAuthMethodResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.clearNone = function() {
    return this.setNone(void 0);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.hasNone = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.getPayment = function() {
    return (
      /** @type{?proto.api.patient.v1.GetBookingAuthMethodResponse.Payment} */
      e.Message.getWrapperField(this, proto.api.patient.v1.GetBookingAuthMethodResponse.Payment, 2)
    );
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.setPayment = function(t) {
    return e.Message.setOneofWrapperField(this, 2, proto.api.patient.v1.GetBookingAuthMethodResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.clearPayment = function() {
    return this.setPayment(void 0);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.hasPayment = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.getMfa = function() {
    return (
      /** @type{?proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa} */
      e.Message.getWrapperField(this, proto.api.patient.v1.GetBookingAuthMethodResponse.Mfa, 3)
    );
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.setMfa = function(t) {
    return e.Message.setOneofWrapperField(this, 3, proto.api.patient.v1.GetBookingAuthMethodResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.clearMfa = function() {
    return this.setMfa(void 0);
  }, proto.api.patient.v1.GetBookingAuthMethodResponse.prototype.hasMfa = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingRequest.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingRequest.toObject = function(t, r) {
    var n, d = {
      appointmentClaim: (n = r.getAppointmentClaim()) && proto.api.patient.v1.AppointmentClaim.toObject(t, n),
      patient: (n = r.getPatient()) && proto.api.patient.v1.PatientInfo.toObject(t, n),
      message: (n = r.getMessage()) && i.StringValue.toObject(t, n),
      promoCode: (n = r.getPromoCode()) && i.StringValue.toObject(t, n),
      deviceMeta: (n = r.getDeviceMeta()) && proto.api.patient.v1.DeviceMeta.toObject(t, n),
      bookingMeta: (n = r.getBookingMeta()) && proto.api.patient.v1.BookingMeta.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateBookingRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingRequest();
    return proto.api.patient.v1.CreateBookingRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.AppointmentClaim();
          r.readMessage(d, proto.api.patient.v1.AppointmentClaim.deserializeBinaryFromReader), t.setAppointmentClaim(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.PatientInfo();
          r.readMessage(d, proto.api.patient.v1.PatientInfo.deserializeBinaryFromReader), t.setPatient(d);
          break;
        case 3:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setMessage(d);
          break;
        case 7:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setPromoCode(d);
          break;
        case 10:
          var d = new proto.api.patient.v1.DeviceMeta();
          r.readMessage(d, proto.api.patient.v1.DeviceMeta.deserializeBinaryFromReader), t.setDeviceMeta(d);
          break;
        case 11:
          var d = new proto.api.patient.v1.BookingMeta();
          r.readMessage(d, proto.api.patient.v1.BookingMeta.deserializeBinaryFromReader), t.setBookingMeta(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getAppointmentClaim(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.AppointmentClaim.serializeBinaryToWriter
    ), n = t.getPatient(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.PatientInfo.serializeBinaryToWriter
    ), n = t.getMessage(), n != null && r.writeMessage(
      3,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPromoCode(), n != null && r.writeMessage(
      7,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getDeviceMeta(), n != null && r.writeMessage(
      10,
      n,
      proto.api.patient.v1.DeviceMeta.serializeBinaryToWriter
    ), n = t.getBookingMeta(), n != null && r.writeMessage(
      11,
      n,
      proto.api.patient.v1.BookingMeta.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.CreateBookingRequest.prototype.getAppointmentClaim = function() {
    return (
      /** @type{?proto.api.patient.v1.AppointmentClaim} */
      e.Message.getWrapperField(this, proto.api.patient.v1.AppointmentClaim, 1)
    );
  }, proto.api.patient.v1.CreateBookingRequest.prototype.setAppointmentClaim = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.clearAppointmentClaim = function() {
    return this.setAppointmentClaim(void 0);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.hasAppointmentClaim = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.CreateBookingRequest.prototype.getPatient = function() {
    return (
      /** @type{?proto.api.patient.v1.PatientInfo} */
      e.Message.getWrapperField(this, proto.api.patient.v1.PatientInfo, 2)
    );
  }, proto.api.patient.v1.CreateBookingRequest.prototype.setPatient = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.clearPatient = function() {
    return this.setPatient(void 0);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.hasPatient = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.CreateBookingRequest.prototype.getMessage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 3)
    );
  }, proto.api.patient.v1.CreateBookingRequest.prototype.setMessage = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.hasMessage = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.CreateBookingRequest.prototype.getPromoCode = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 7)
    );
  }, proto.api.patient.v1.CreateBookingRequest.prototype.setPromoCode = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.clearPromoCode = function() {
    return this.setPromoCode(void 0);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.hasPromoCode = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.CreateBookingRequest.prototype.getDeviceMeta = function() {
    return (
      /** @type{?proto.api.patient.v1.DeviceMeta} */
      e.Message.getWrapperField(this, proto.api.patient.v1.DeviceMeta, 10)
    );
  }, proto.api.patient.v1.CreateBookingRequest.prototype.setDeviceMeta = function(t) {
    return e.Message.setWrapperField(this, 10, t);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.clearDeviceMeta = function() {
    return this.setDeviceMeta(void 0);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.hasDeviceMeta = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.api.patient.v1.CreateBookingRequest.prototype.getBookingMeta = function() {
    return (
      /** @type{?proto.api.patient.v1.BookingMeta} */
      e.Message.getWrapperField(this, proto.api.patient.v1.BookingMeta, 11)
    );
  }, proto.api.patient.v1.CreateBookingRequest.prototype.setBookingMeta = function(t) {
    return e.Message.setWrapperField(this, 11, t);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.clearBookingMeta = function() {
    return this.setBookingMeta(void 0);
  }, proto.api.patient.v1.CreateBookingRequest.prototype.hasBookingMeta = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.CreateBookingResponse.oneofGroups_ = [[21, 22, 23]], proto.api.patient.v1.CreateBookingResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    SUCCESS: 21,
    FAILURE: 22,
    PENDING_ACTIONS: 23
  }, proto.api.patient.v1.CreateBookingResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto.api.patient.v1.CreateBookingResponse.ResultCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.CreateBookingResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingResponse.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingResponse.toObject = function(t, r) {
    var n, d = {
      success: (n = r.getSuccess()) && proto.api.patient.v1.CreateBookingResponse.Success.toObject(t, n),
      failure: (n = r.getFailure()) && proto.api.patient.v1.CreateBookingResponse.Failure.toObject(t, n),
      pendingActions: (n = r.getPendingActions()) && proto.api.patient.v1.CreateBookingResponse.PendingActions.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateBookingResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingResponse();
    return proto.api.patient.v1.CreateBookingResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 21:
          var d = new proto.api.patient.v1.CreateBookingResponse.Success();
          r.readMessage(d, proto.api.patient.v1.CreateBookingResponse.Success.deserializeBinaryFromReader), t.setSuccess(d);
          break;
        case 22:
          var d = new proto.api.patient.v1.CreateBookingResponse.Failure();
          r.readMessage(d, proto.api.patient.v1.CreateBookingResponse.Failure.deserializeBinaryFromReader), t.setFailure(d);
          break;
        case 23:
          var d = new proto.api.patient.v1.CreateBookingResponse.PendingActions();
          r.readMessage(d, proto.api.patient.v1.CreateBookingResponse.PendingActions.deserializeBinaryFromReader), t.setPendingActions(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getSuccess(), n != null && r.writeMessage(
      21,
      n,
      proto.api.patient.v1.CreateBookingResponse.Success.serializeBinaryToWriter
    ), n = t.getFailure(), n != null && r.writeMessage(
      22,
      n,
      proto.api.patient.v1.CreateBookingResponse.Failure.serializeBinaryToWriter
    ), n = t.getPendingActions(), n != null && r.writeMessage(
      23,
      n,
      proto.api.patient.v1.CreateBookingResponse.PendingActions.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.CreateBookingResponse.BookingAction = {
    BOOKING_ACTION_UNSPECIFIED: 0,
    BOOKING_ACTION_ADYEN_CARD_TOKENIZATION: 1,
    BOOKING_ACTION_BANKID_AUTHENTICATION: 2
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingResponse.Success.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingResponse.Success.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingResponse.Success.toObject = function(t, r) {
    var n = {
      bookingId: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.CreateBookingResponse.Success.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingResponse.Success();
    return proto.api.patient.v1.CreateBookingResponse.Success.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingResponse.Success.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingResponse.Success.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingResponse.Success.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingResponse.Success.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.CreateBookingResponse.Success.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.CreateBookingResponse.Success.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.oneofGroups_ = [[11, 12]], proto.api.patient.v1.CreateBookingResponse.Failure.ErrorCase = {
    ERROR_NOT_SET: 0,
    PRECONDITION_ERROR: 11,
    INTEGRATION_ERROR: 12
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.getErrorCase = function() {
    return (
      /** @type {proto.api.patient.v1.CreateBookingResponse.Failure.ErrorCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.CreateBookingResponse.Failure.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingResponse.Failure.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingResponse.Failure.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.toObject = function(t, r) {
    var n, d = {
      message: (n = r.getMessage()) && i.StringValue.toObject(t, n),
      preconditionError: e.Message.getFieldWithDefault(r, 11, 0),
      integrationError: e.Message.getFieldWithDefault(r, 12, 0)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateBookingResponse.Failure.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingResponse.Failure();
    return proto.api.patient.v1.CreateBookingResponse.Failure.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setMessage(d);
          break;
        case 11:
          var d = (
            /** @type {!proto.api.patient.v1.PreconditionError} */
            r.readEnum()
          );
          t.setPreconditionError(d);
          break;
        case 12:
          var d = (
            /** @type {!proto.api.patient.v1.IntegrationError} */
            r.readEnum()
          );
          t.setIntegrationError(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingResponse.Failure.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingResponse.Failure.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getMessage(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = /** @type {!proto.api.patient.v1.PreconditionError} */
    e.Message.getField(t, 11), n != null && r.writeEnum(
      11,
      n
    ), n = /** @type {!proto.api.patient.v1.IntegrationError} */
    e.Message.getField(t, 12), n != null && r.writeEnum(
      12,
      n
    );
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.getMessage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.setMessage = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.hasMessage = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.getPreconditionError = function() {
    return (
      /** @type {!proto.api.patient.v1.PreconditionError} */
      e.Message.getFieldWithDefault(this, 11, 0)
    );
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.setPreconditionError = function(t) {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.CreateBookingResponse.Failure.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.clearPreconditionError = function() {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.CreateBookingResponse.Failure.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.hasPreconditionError = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.getIntegrationError = function() {
    return (
      /** @type {!proto.api.patient.v1.IntegrationError} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.setIntegrationError = function(t) {
    return e.Message.setOneofField(this, 12, proto.api.patient.v1.CreateBookingResponse.Failure.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.clearIntegrationError = function() {
    return e.Message.setOneofField(this, 12, proto.api.patient.v1.CreateBookingResponse.Failure.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.CreateBookingResponse.Failure.prototype.hasIntegrationError = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.repeatedFields_ = [10], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingResponse.PendingActions.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.toObject = function(t, r) {
    var n, d = {
      bookingId: e.Message.getFieldWithDefault(r, 1, ""),
      bookingActionsList: (n = e.Message.getRepeatedField(r, 10)) == null ? void 0 : n
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateBookingResponse.PendingActions.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingResponse.PendingActions();
    return proto.api.patient.v1.CreateBookingResponse.PendingActions.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        case 10:
          for (var ne = (
            /** @type {!Array<!proto.api.patient.v1.CreateBookingResponse.BookingAction>} */
            r.isDelimited() ? r.readPackedEnum() : [r.readEnum()]
          ), O = 0; O < ne.length; O++)
            t.addBookingActions(ne[O]);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingResponse.PendingActions.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getBookingActionsList(), n.length > 0 && r.writePackedEnum(
      10,
      n
    );
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.getBookingActionsList = function() {
    return (
      /** @type {!Array<!proto.api.patient.v1.CreateBookingResponse.BookingAction>} */
      e.Message.getRepeatedField(this, 10)
    );
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.setBookingActionsList = function(t) {
    return e.Message.setField(this, 10, t || []);
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.addBookingActions = function(t, r) {
    return e.Message.addToRepeatedField(this, 10, t, r);
  }, proto.api.patient.v1.CreateBookingResponse.PendingActions.prototype.clearBookingActionsList = function() {
    return this.setBookingActionsList([]);
  }, proto.api.patient.v1.CreateBookingResponse.prototype.getSuccess = function() {
    return (
      /** @type{?proto.api.patient.v1.CreateBookingResponse.Success} */
      e.Message.getWrapperField(this, proto.api.patient.v1.CreateBookingResponse.Success, 21)
    );
  }, proto.api.patient.v1.CreateBookingResponse.prototype.setSuccess = function(t) {
    return e.Message.setOneofWrapperField(this, 21, proto.api.patient.v1.CreateBookingResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingResponse.prototype.clearSuccess = function() {
    return this.setSuccess(void 0);
  }, proto.api.patient.v1.CreateBookingResponse.prototype.hasSuccess = function() {
    return e.Message.getField(this, 21) != null;
  }, proto.api.patient.v1.CreateBookingResponse.prototype.getFailure = function() {
    return (
      /** @type{?proto.api.patient.v1.CreateBookingResponse.Failure} */
      e.Message.getWrapperField(this, proto.api.patient.v1.CreateBookingResponse.Failure, 22)
    );
  }, proto.api.patient.v1.CreateBookingResponse.prototype.setFailure = function(t) {
    return e.Message.setOneofWrapperField(this, 22, proto.api.patient.v1.CreateBookingResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingResponse.prototype.clearFailure = function() {
    return this.setFailure(void 0);
  }, proto.api.patient.v1.CreateBookingResponse.prototype.hasFailure = function() {
    return e.Message.getField(this, 22) != null;
  }, proto.api.patient.v1.CreateBookingResponse.prototype.getPendingActions = function() {
    return (
      /** @type{?proto.api.patient.v1.CreateBookingResponse.PendingActions} */
      e.Message.getWrapperField(this, proto.api.patient.v1.CreateBookingResponse.PendingActions, 23)
    );
  }, proto.api.patient.v1.CreateBookingResponse.prototype.setPendingActions = function(t) {
    return e.Message.setOneofWrapperField(this, 23, proto.api.patient.v1.CreateBookingResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingResponse.prototype.clearPendingActions = function() {
    return this.setPendingActions(void 0);
  }, proto.api.patient.v1.CreateBookingResponse.prototype.hasPendingActions = function() {
    return e.Message.getField(this, 23) != null;
  }, proto.api.patient.v1.ProceedBookingRequest.oneofGroups_ = [[11, 12]], proto.api.patient.v1.ProceedBookingRequest.ActionCase = {
    ACTION_NOT_SET: 0,
    ADYEN_CARD_TOKENIZATION: 11,
    BANK_ID_AUTHENTICATION: 12
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.getActionCase = function() {
    return (
      /** @type {proto.api.patient.v1.ProceedBookingRequest.ActionCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.ProceedBookingRequest.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ProceedBookingRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.ProceedBookingRequest.toObject(t, this);
  }, proto.api.patient.v1.ProceedBookingRequest.toObject = function(t, r) {
    var n, d = {
      bookingId: e.Message.getFieldWithDefault(r, 1, ""),
      adyenCardTokenization: (n = r.getAdyenCardTokenization()) && proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.toObject(t, n),
      bankIdAuthentication: (n = r.getBankIdAuthentication()) && proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ProceedBookingRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ProceedBookingRequest();
    return proto.api.patient.v1.ProceedBookingRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ProceedBookingRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        case 11:
          var d = new proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization();
          r.readMessage(d, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.deserializeBinaryFromReader), t.setAdyenCardTokenization(d);
          break;
        case 12:
          var d = new proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication();
          r.readMessage(d, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.deserializeBinaryFromReader), t.setBankIdAuthentication(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ProceedBookingRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ProceedBookingRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getAdyenCardTokenization(), n != null && r.writeMessage(
      11,
      n,
      proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.serializeBinaryToWriter
    ), n = t.getBankIdAuthentication(), n != null && r.writeMessage(
      12,
      n,
      proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.prototype.toObject = function(t) {
    return proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.toObject(t, this);
  }, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.toObject = function(t, r) {
    var n = {
      returnUrl: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization();
    return proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setReturnUrl(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getReturnUrl(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.prototype.getReturnUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization.prototype.setReturnUrl = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.prototype.toObject = function(t) {
    return proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.toObject(t, this);
  }, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.toObject = function(t, r) {
    var n = {
      returnUrl: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication();
    return proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setReturnUrl(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getReturnUrl(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.prototype.getReturnUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication.prototype.setReturnUrl = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.getAdyenCardTokenization = function() {
    return (
      /** @type{?proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ProceedBookingRequest.AdyenCardTokenization, 11)
    );
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.setAdyenCardTokenization = function(t) {
    return e.Message.setOneofWrapperField(this, 11, proto.api.patient.v1.ProceedBookingRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.clearAdyenCardTokenization = function() {
    return this.setAdyenCardTokenization(void 0);
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.hasAdyenCardTokenization = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.getBankIdAuthentication = function() {
    return (
      /** @type{?proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ProceedBookingRequest.BankIDAuthentication, 12)
    );
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.setBankIdAuthentication = function(t) {
    return e.Message.setOneofWrapperField(this, 12, proto.api.patient.v1.ProceedBookingRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.clearBankIdAuthentication = function() {
    return this.setBankIdAuthentication(void 0);
  }, proto.api.patient.v1.ProceedBookingRequest.prototype.hasBankIdAuthentication = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.ProceedBookingResponse.oneofGroups_ = [[11, 12]], proto.api.patient.v1.ProceedBookingResponse.SessionDataCase = {
    SESSION_DATA_NOT_SET: 0,
    ADYEN_SESSION_DATA: 11,
    BANK_ID_SESSION_DATA: 12
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.getSessionDataCase = function() {
    return (
      /** @type {proto.api.patient.v1.ProceedBookingResponse.SessionDataCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.ProceedBookingResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ProceedBookingResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.ProceedBookingResponse.toObject(t, this);
  }, proto.api.patient.v1.ProceedBookingResponse.toObject = function(t, r) {
    var n, d = {
      bookingId: e.Message.getFieldWithDefault(r, 1, ""),
      adyenSessionData: (n = r.getAdyenSessionData()) && proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.toObject(t, n),
      bankIdSessionData: (n = r.getBankIdSessionData()) && proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ProceedBookingResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ProceedBookingResponse();
    return proto.api.patient.v1.ProceedBookingResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ProceedBookingResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        case 11:
          var d = new proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData();
          r.readMessage(d, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.deserializeBinaryFromReader), t.setAdyenSessionData(d);
          break;
        case 12:
          var d = new proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData();
          r.readMessage(d, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.deserializeBinaryFromReader), t.setBankIdSessionData(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ProceedBookingResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ProceedBookingResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getAdyenSessionData(), n != null && r.writeMessage(
      11,
      n,
      proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.serializeBinaryToWriter
    ), n = t.getBankIdSessionData(), n != null && r.writeMessage(
      12,
      n,
      proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.toObject = function(t) {
    return proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.toObject(t, this);
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.toObject = function(t, r) {
    var n = {
      purchaseId: e.Message.getFieldWithDefault(r, 1, ""),
      sessionsId: e.Message.getFieldWithDefault(r, 2, ""),
      sessionData: e.Message.getFieldWithDefault(r, 3, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData();
    return proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPurchaseId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setSessionsId(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setSessionData(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getPurchaseId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getSessionsId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getSessionData(), n.length > 0 && r.writeString(
      3,
      n
    );
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.getPurchaseId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.setPurchaseId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.getSessionsId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.setSessionsId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.getSessionData = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData.prototype.setSessionData = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.toObject = function(t) {
    return proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.toObject(t, this);
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.toObject = function(t, r) {
    var n = {
      authId: e.Message.getFieldWithDefault(r, 1, ""),
      refId: e.Message.getFieldWithDefault(r, 2, ""),
      status: e.Message.getFieldWithDefault(r, 3, ""),
      autoStartToken: e.Message.getFieldWithDefault(r, 4, ""),
      qrStartSoken: e.Message.getFieldWithDefault(r, 5, ""),
      qrStartSecret: e.Message.getFieldWithDefault(r, 6, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData();
    return proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setAuthId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setRefId(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setStatus(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setAutoStartToken(d);
          break;
        case 5:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setQrStartSoken(d);
          break;
        case 6:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setQrStartSecret(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getAuthId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getRefId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getStatus(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getAutoStartToken(), n.length > 0 && r.writeString(
      4,
      n
    ), n = t.getQrStartSoken(), n.length > 0 && r.writeString(
      5,
      n
    ), n = t.getQrStartSecret(), n.length > 0 && r.writeString(
      6,
      n
    );
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.getAuthId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.setAuthId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.getRefId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.setRefId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.getStatus = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.setStatus = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.getAutoStartToken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.setAutoStartToken = function(t) {
    return e.Message.setProto3StringField(this, 4, t);
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.getQrStartSoken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.setQrStartSoken = function(t) {
    return e.Message.setProto3StringField(this, 5, t);
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.getQrStartSecret = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData.prototype.setQrStartSecret = function(t) {
    return e.Message.setProto3StringField(this, 6, t);
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.getAdyenSessionData = function() {
    return (
      /** @type{?proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ProceedBookingResponse.AdyenSessionData, 11)
    );
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.setAdyenSessionData = function(t) {
    return e.Message.setOneofWrapperField(this, 11, proto.api.patient.v1.ProceedBookingResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.clearAdyenSessionData = function() {
    return this.setAdyenSessionData(void 0);
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.hasAdyenSessionData = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.getBankIdSessionData = function() {
    return (
      /** @type{?proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ProceedBookingResponse.BankIDSessionData, 12)
    );
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.setBankIdSessionData = function(t) {
    return e.Message.setOneofWrapperField(this, 12, proto.api.patient.v1.ProceedBookingResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.clearBankIdSessionData = function() {
    return this.setBankIdSessionData(void 0);
  }, proto.api.patient.v1.ProceedBookingResponse.prototype.hasBankIdSessionData = function() {
    return e.Message.getField(this, 12) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingStatusRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingStatusRequest.toObject(t, this);
  }, proto.api.patient.v1.GetBookingStatusRequest.toObject = function(t, r) {
    var n = {
      bookingId: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetBookingStatusRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingStatusRequest();
    return proto.api.patient.v1.GetBookingStatusRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingStatusRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingStatusRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingStatusRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingStatusRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.GetBookingStatusRequest.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.GetBookingStatusRequest.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetBookingStatusResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetBookingStatusResponse.toObject(t, this);
  }, proto.api.patient.v1.GetBookingStatusResponse.toObject = function(t, r) {
    var n = {
      bookingId: e.Message.getFieldWithDefault(r, 1, ""),
      status: e.Message.getFieldWithDefault(r, 2, 0),
      failReason: e.Message.getFieldWithDefault(r, 3, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetBookingStatusResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetBookingStatusResponse();
    return proto.api.patient.v1.GetBookingStatusResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetBookingStatusResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        case 2:
          var d = (
            /** @type {!proto.api.patient.v1.BookingStatus} */
            r.readEnum()
          );
          t.setStatus(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setFailReason(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetBookingStatusResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetBookingStatusResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetBookingStatusResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getStatus(), n !== 0 && r.writeEnum(
      2,
      n
    ), n = t.getFailReason(), n.length > 0 && r.writeString(
      3,
      n
    );
  }, proto.api.patient.v1.GetBookingStatusResponse.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.GetBookingStatusResponse.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.GetBookingStatusResponse.prototype.getStatus = function() {
    return (
      /** @type {!proto.api.patient.v1.BookingStatus} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.api.patient.v1.GetBookingStatusResponse.prototype.setStatus = function(t) {
    return e.Message.setProto3EnumField(this, 2, t);
  }, proto.api.patient.v1.GetBookingStatusResponse.prototype.getFailReason = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.GetBookingStatusResponse.prototype.setFailReason = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingInquiryRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingInquiryRequest.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.toObject = function(t, r) {
    var n, d = {
      treatmentInquiry: (n = r.getTreatmentInquiry()) && proto.api.patient.v1.TreatmentInquiry.toObject(t, n),
      patient: (n = r.getPatient()) && proto.api.patient.v1.PatientInfo.toObject(t, n),
      message: (n = r.getMessage()) && i.StringValue.toObject(t, n),
      deviceMeta: (n = r.getDeviceMeta()) && proto.api.patient.v1.DeviceMeta.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateBookingInquiryRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingInquiryRequest();
    return proto.api.patient.v1.CreateBookingInquiryRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.TreatmentInquiry();
          r.readMessage(d, proto.api.patient.v1.TreatmentInquiry.deserializeBinaryFromReader), t.setTreatmentInquiry(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.PatientInfo();
          r.readMessage(d, proto.api.patient.v1.PatientInfo.deserializeBinaryFromReader), t.setPatient(d);
          break;
        case 3:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setMessage(d);
          break;
        case 10:
          var d = new proto.api.patient.v1.DeviceMeta();
          r.readMessage(d, proto.api.patient.v1.DeviceMeta.deserializeBinaryFromReader), t.setDeviceMeta(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingInquiryRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingInquiryRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getTreatmentInquiry(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.TreatmentInquiry.serializeBinaryToWriter
    ), n = t.getPatient(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.PatientInfo.serializeBinaryToWriter
    ), n = t.getMessage(), n != null && r.writeMessage(
      3,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getDeviceMeta(), n != null && r.writeMessage(
      10,
      n,
      proto.api.patient.v1.DeviceMeta.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.getTreatmentInquiry = function() {
    return (
      /** @type{?proto.api.patient.v1.TreatmentInquiry} */
      e.Message.getWrapperField(this, proto.api.patient.v1.TreatmentInquiry, 1)
    );
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.setTreatmentInquiry = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.clearTreatmentInquiry = function() {
    return this.setTreatmentInquiry(void 0);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.hasTreatmentInquiry = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.getPatient = function() {
    return (
      /** @type{?proto.api.patient.v1.PatientInfo} */
      e.Message.getWrapperField(this, proto.api.patient.v1.PatientInfo, 2)
    );
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.setPatient = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.clearPatient = function() {
    return this.setPatient(void 0);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.hasPatient = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.getMessage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 3)
    );
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.setMessage = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.hasMessage = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.getDeviceMeta = function() {
    return (
      /** @type{?proto.api.patient.v1.DeviceMeta} */
      e.Message.getWrapperField(this, proto.api.patient.v1.DeviceMeta, 10)
    );
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.setDeviceMeta = function(t) {
    return e.Message.setWrapperField(this, 10, t);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.clearDeviceMeta = function() {
    return this.setDeviceMeta(void 0);
  }, proto.api.patient.v1.CreateBookingInquiryRequest.prototype.hasDeviceMeta = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.api.patient.v1.CreateBookingInquiryResponse.oneofGroups_ = [[21, 22]], proto.api.patient.v1.CreateBookingInquiryResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    SUCCESS: 21,
    FAILURE: 22
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto.api.patient.v1.CreateBookingInquiryResponse.ResultCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.CreateBookingInquiryResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingInquiryResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingInquiryResponse.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.toObject = function(t, r) {
    var n, d = {
      success: (n = r.getSuccess()) && proto.api.patient.v1.CreateBookingInquiryResponse.Success.toObject(t, n),
      failure: (n = r.getFailure()) && proto.api.patient.v1.CreateBookingInquiryResponse.Failure.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateBookingInquiryResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingInquiryResponse();
    return proto.api.patient.v1.CreateBookingInquiryResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 21:
          var d = new proto.api.patient.v1.CreateBookingInquiryResponse.Success();
          r.readMessage(d, proto.api.patient.v1.CreateBookingInquiryResponse.Success.deserializeBinaryFromReader), t.setSuccess(d);
          break;
        case 22:
          var d = new proto.api.patient.v1.CreateBookingInquiryResponse.Failure();
          r.readMessage(d, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.deserializeBinaryFromReader), t.setFailure(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingInquiryResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingInquiryResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getSuccess(), n != null && r.writeMessage(
      21,
      n,
      proto.api.patient.v1.CreateBookingInquiryResponse.Success.serializeBinaryToWriter
    ), n = t.getFailure(), n != null && r.writeMessage(
      22,
      n,
      proto.api.patient.v1.CreateBookingInquiryResponse.Failure.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingInquiryResponse.Success.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingInquiryResponse.Success.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Success.toObject = function(t, r) {
    var n = {
      bookingId: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.CreateBookingInquiryResponse.Success.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingInquiryResponse.Success();
    return proto.api.patient.v1.CreateBookingInquiryResponse.Success.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Success.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Success.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingInquiryResponse.Success.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Success.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Success.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Success.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.oneofGroups_ = [[11]], proto.api.patient.v1.CreateBookingInquiryResponse.Failure.ErrorCase = {
    ERROR_NOT_SET: 0,
    PRECONDITION_ERROR: 11
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.getErrorCase = function() {
    return (
      /** @type {proto.api.patient.v1.CreateBookingInquiryResponse.Failure.ErrorCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateBookingInquiryResponse.Failure.toObject(t, this);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.toObject = function(t, r) {
    var n, d = {
      message: (n = r.getMessage()) && i.StringValue.toObject(t, n),
      preconditionError: e.Message.getFieldWithDefault(r, 11, 0)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateBookingInquiryResponse.Failure.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateBookingInquiryResponse.Failure();
    return proto.api.patient.v1.CreateBookingInquiryResponse.Failure.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setMessage(d);
          break;
        case 11:
          var d = (
            /** @type {!proto.api.patient.v1.PreconditionError} */
            r.readEnum()
          );
          t.setPreconditionError(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateBookingInquiryResponse.Failure.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getMessage(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = /** @type {!proto.api.patient.v1.PreconditionError} */
    e.Message.getField(t, 11), n != null && r.writeEnum(
      11,
      n
    );
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.getMessage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.setMessage = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.hasMessage = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.getPreconditionError = function() {
    return (
      /** @type {!proto.api.patient.v1.PreconditionError} */
      e.Message.getFieldWithDefault(this, 11, 0)
    );
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.setPreconditionError = function(t) {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.clearPreconditionError = function() {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.Failure.prototype.hasPreconditionError = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.getSuccess = function() {
    return (
      /** @type{?proto.api.patient.v1.CreateBookingInquiryResponse.Success} */
      e.Message.getWrapperField(this, proto.api.patient.v1.CreateBookingInquiryResponse.Success, 21)
    );
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.setSuccess = function(t) {
    return e.Message.setOneofWrapperField(this, 21, proto.api.patient.v1.CreateBookingInquiryResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.clearSuccess = function() {
    return this.setSuccess(void 0);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.hasSuccess = function() {
    return e.Message.getField(this, 21) != null;
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.getFailure = function() {
    return (
      /** @type{?proto.api.patient.v1.CreateBookingInquiryResponse.Failure} */
      e.Message.getWrapperField(this, proto.api.patient.v1.CreateBookingInquiryResponse.Failure, 22)
    );
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.setFailure = function(t) {
    return e.Message.setOneofWrapperField(this, 22, proto.api.patient.v1.CreateBookingInquiryResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.clearFailure = function() {
    return this.setFailure(void 0);
  }, proto.api.patient.v1.CreateBookingInquiryResponse.prototype.hasFailure = function() {
    return e.Message.getField(this, 22) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.DeviceMeta.prototype.toObject = function(t) {
    return proto.api.patient.v1.DeviceMeta.toObject(t, this);
  }, proto.api.patient.v1.DeviceMeta.toObject = function(t, r) {
    var n = {
      type: e.Message.getFieldWithDefault(r, 1, 0),
      requestId: e.Message.getFieldWithDefault(r, 2, ""),
      deviceFound: e.Message.getBooleanFieldWithDefault(r, 3, !1),
      deviceId: e.Message.getFieldWithDefault(r, 4, ""),
      deviceConfidence: e.Message.getFloatingPointFieldWithDefault(r, 5, 0),
      deviceIp: e.Message.getFieldWithDefault(r, 6, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.DeviceMeta.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.DeviceMeta();
    return proto.api.patient.v1.DeviceMeta.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.DeviceMeta.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {!proto.api.patient.v1.DeviceMeta.Type} */
            r.readEnum()
          );
          t.setType(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setRequestId(d);
          break;
        case 3:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          t.setDeviceFound(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setDeviceId(d);
          break;
        case 5:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          t.setDeviceConfidence(d);
          break;
        case 6:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setDeviceIp(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.DeviceMeta.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.DeviceMeta.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.DeviceMeta.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getType(), n !== 0 && r.writeEnum(
      1,
      n
    ), n = t.getRequestId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getDeviceFound(), n && r.writeBool(
      3,
      n
    ), n = t.getDeviceId(), n.length > 0 && r.writeString(
      4,
      n
    ), n = t.getDeviceConfidence(), n !== 0 && r.writeFloat(
      5,
      n
    ), n = t.getDeviceIp(), n.length > 0 && r.writeString(
      6,
      n
    );
  }, proto.api.patient.v1.DeviceMeta.Type = {
    TYPE_UNSPECIFIED: 0,
    TYPE_FINGERPRINT_DOT_COM: 1
  }, proto.api.patient.v1.DeviceMeta.prototype.getType = function() {
    return (
      /** @type {!proto.api.patient.v1.DeviceMeta.Type} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.DeviceMeta.prototype.setType = function(t) {
    return e.Message.setProto3EnumField(this, 1, t);
  }, proto.api.patient.v1.DeviceMeta.prototype.getRequestId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.DeviceMeta.prototype.setRequestId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.DeviceMeta.prototype.getDeviceFound = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.api.patient.v1.DeviceMeta.prototype.setDeviceFound = function(t) {
    return e.Message.setProto3BooleanField(this, 3, t);
  }, proto.api.patient.v1.DeviceMeta.prototype.getDeviceId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.api.patient.v1.DeviceMeta.prototype.setDeviceId = function(t) {
    return e.Message.setProto3StringField(this, 4, t);
  }, proto.api.patient.v1.DeviceMeta.prototype.getDeviceConfidence = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 5, 0)
    );
  }, proto.api.patient.v1.DeviceMeta.prototype.setDeviceConfidence = function(t) {
    return e.Message.setProto3FloatField(this, 5, t);
  }, proto.api.patient.v1.DeviceMeta.prototype.getDeviceIp = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.api.patient.v1.DeviceMeta.prototype.setDeviceIp = function(t) {
    return e.Message.setProto3StringField(this, 6, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.BookingMeta.prototype.toObject = function(t) {
    return proto.api.patient.v1.BookingMeta.toObject(t, this);
  }, proto.api.patient.v1.BookingMeta.toObject = function(t, r) {
    var n, d = {
      agentEmail: (n = r.getAgentEmail()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.BookingMeta.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.BookingMeta();
    return proto.api.patient.v1.BookingMeta.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.BookingMeta.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setAgentEmail(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.BookingMeta.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.BookingMeta.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.BookingMeta.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getAgentEmail(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.BookingMeta.prototype.getAgentEmail = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.BookingMeta.prototype.setAgentEmail = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.BookingMeta.prototype.clearAgentEmail = function() {
    return this.setAgentEmail(void 0);
  }, proto.api.patient.v1.BookingMeta.prototype.hasAgentEmail = function() {
    return e.Message.getField(this, 1) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CancelBookingRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.CancelBookingRequest.toObject(t, this);
  }, proto.api.patient.v1.CancelBookingRequest.toObject = function(t, r) {
    var n = {
      bookingId: e.Message.getFieldWithDefault(r, 1, ""),
      clinicId: e.Message.getFieldWithDefault(r, 2, ""),
      hash: e.Message.getFieldWithDefault(r, 3, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.CancelBookingRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CancelBookingRequest();
    return proto.api.patient.v1.CancelBookingRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CancelBookingRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setBookingId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setHash(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CancelBookingRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CancelBookingRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CancelBookingRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getBookingId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getClinicId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getHash(), n.length > 0 && r.writeString(
      3,
      n
    );
  }, proto.api.patient.v1.CancelBookingRequest.prototype.getBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.CancelBookingRequest.prototype.setBookingId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.CancelBookingRequest.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.CancelBookingRequest.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.CancelBookingRequest.prototype.getHash = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.CancelBookingRequest.prototype.setHash = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.CancelBookingResponse.oneofGroups_ = [[21, 22]], proto.api.patient.v1.CancelBookingResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    SUCCESS: 21,
    FAILURE: 22
  }, proto.api.patient.v1.CancelBookingResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto.api.patient.v1.CancelBookingResponse.ResultCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.CancelBookingResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CancelBookingResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.CancelBookingResponse.toObject(t, this);
  }, proto.api.patient.v1.CancelBookingResponse.toObject = function(t, r) {
    var n, d = {
      success: (n = r.getSuccess()) && proto.api.patient.v1.CancelBookingResponse.Success.toObject(t, n),
      failure: (n = r.getFailure()) && proto.api.patient.v1.CancelBookingResponse.Failure.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CancelBookingResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CancelBookingResponse();
    return proto.api.patient.v1.CancelBookingResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CancelBookingResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 21:
          var d = new proto.api.patient.v1.CancelBookingResponse.Success();
          r.readMessage(d, proto.api.patient.v1.CancelBookingResponse.Success.deserializeBinaryFromReader), t.setSuccess(d);
          break;
        case 22:
          var d = new proto.api.patient.v1.CancelBookingResponse.Failure();
          r.readMessage(d, proto.api.patient.v1.CancelBookingResponse.Failure.deserializeBinaryFromReader), t.setFailure(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CancelBookingResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CancelBookingResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CancelBookingResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getSuccess(), n != null && r.writeMessage(
      21,
      n,
      proto.api.patient.v1.CancelBookingResponse.Success.serializeBinaryToWriter
    ), n = t.getFailure(), n != null && r.writeMessage(
      22,
      n,
      proto.api.patient.v1.CancelBookingResponse.Failure.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CancelBookingResponse.Success.prototype.toObject = function(t) {
    return proto.api.patient.v1.CancelBookingResponse.Success.toObject(t, this);
  }, proto.api.patient.v1.CancelBookingResponse.Success.toObject = function(t, r) {
    var n = {};
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.CancelBookingResponse.Success.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CancelBookingResponse.Success();
    return proto.api.patient.v1.CancelBookingResponse.Success.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CancelBookingResponse.Success.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CancelBookingResponse.Success.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CancelBookingResponse.Success.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CancelBookingResponse.Success.serializeBinaryToWriter = function(t, r) {
  }, proto.api.patient.v1.CancelBookingResponse.Failure.oneofGroups_ = [[11, 12]], proto.api.patient.v1.CancelBookingResponse.Failure.ErrorCase = {
    ERROR_NOT_SET: 0,
    PRECONDITION_ERROR: 11,
    INTEGRATION_ERROR: 12
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.getErrorCase = function() {
    return (
      /** @type {proto.api.patient.v1.CancelBookingResponse.Failure.ErrorCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.CancelBookingResponse.Failure.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CancelBookingResponse.Failure.prototype.toObject = function(t) {
    return proto.api.patient.v1.CancelBookingResponse.Failure.toObject(t, this);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.toObject = function(t, r) {
    var n, d = {
      message: (n = r.getMessage()) && i.StringValue.toObject(t, n),
      preconditionError: e.Message.getFieldWithDefault(r, 11, 0),
      integrationError: e.Message.getFieldWithDefault(r, 12, 0)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CancelBookingResponse.Failure.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CancelBookingResponse.Failure();
    return proto.api.patient.v1.CancelBookingResponse.Failure.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setMessage(d);
          break;
        case 11:
          var d = (
            /** @type {!proto.api.patient.v1.PreconditionError} */
            r.readEnum()
          );
          t.setPreconditionError(d);
          break;
        case 12:
          var d = (
            /** @type {!proto.api.patient.v1.IntegrationError} */
            r.readEnum()
          );
          t.setIntegrationError(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CancelBookingResponse.Failure.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CancelBookingResponse.Failure.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getMessage(), n != null && r.writeMessage(
      1,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = /** @type {!proto.api.patient.v1.PreconditionError} */
    e.Message.getField(t, 11), n != null && r.writeEnum(
      11,
      n
    ), n = /** @type {!proto.api.patient.v1.IntegrationError} */
    e.Message.getField(t, 12), n != null && r.writeEnum(
      12,
      n
    );
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.getMessage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 1)
    );
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.setMessage = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.hasMessage = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.getPreconditionError = function() {
    return (
      /** @type {!proto.api.patient.v1.PreconditionError} */
      e.Message.getFieldWithDefault(this, 11, 0)
    );
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.setPreconditionError = function(t) {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.CancelBookingResponse.Failure.oneofGroups_[0], t);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.clearPreconditionError = function() {
    return e.Message.setOneofField(this, 11, proto.api.patient.v1.CancelBookingResponse.Failure.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.hasPreconditionError = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.getIntegrationError = function() {
    return (
      /** @type {!proto.api.patient.v1.IntegrationError} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.setIntegrationError = function(t) {
    return e.Message.setOneofField(this, 12, proto.api.patient.v1.CancelBookingResponse.Failure.oneofGroups_[0], t);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.clearIntegrationError = function() {
    return e.Message.setOneofField(this, 12, proto.api.patient.v1.CancelBookingResponse.Failure.oneofGroups_[0], void 0);
  }, proto.api.patient.v1.CancelBookingResponse.Failure.prototype.hasIntegrationError = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.CancelBookingResponse.prototype.getSuccess = function() {
    return (
      /** @type{?proto.api.patient.v1.CancelBookingResponse.Success} */
      e.Message.getWrapperField(this, proto.api.patient.v1.CancelBookingResponse.Success, 21)
    );
  }, proto.api.patient.v1.CancelBookingResponse.prototype.setSuccess = function(t) {
    return e.Message.setOneofWrapperField(this, 21, proto.api.patient.v1.CancelBookingResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.CancelBookingResponse.prototype.clearSuccess = function() {
    return this.setSuccess(void 0);
  }, proto.api.patient.v1.CancelBookingResponse.prototype.hasSuccess = function() {
    return e.Message.getField(this, 21) != null;
  }, proto.api.patient.v1.CancelBookingResponse.prototype.getFailure = function() {
    return (
      /** @type{?proto.api.patient.v1.CancelBookingResponse.Failure} */
      e.Message.getWrapperField(this, proto.api.patient.v1.CancelBookingResponse.Failure, 22)
    );
  }, proto.api.patient.v1.CancelBookingResponse.prototype.setFailure = function(t) {
    return e.Message.setOneofWrapperField(this, 22, proto.api.patient.v1.CancelBookingResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.CancelBookingResponse.prototype.clearFailure = function() {
    return this.setFailure(void 0);
  }, proto.api.patient.v1.CancelBookingResponse.prototype.hasFailure = function() {
    return e.Message.getField(this, 22) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindMyExternalBookingsRequest.toObject(t, this);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.toObject = function(t, r) {
    var n, d = {
      clinicIdsList: (n = e.Message.getRepeatedField(r, 1)) == null ? void 0 : n,
      dateFrom: (n = r.getDateFrom()) && u.Date.toObject(t, n),
      dateTo: (n = r.getDateTo()) && u.Date.toObject(t, n),
      pageToken: (n = r.getPageToken()) && i.StringValue.toObject(t, n),
      pageSize: (n = r.getPageSize()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindMyExternalBookingsRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindMyExternalBookingsRequest();
    return proto.api.patient.v1.FindMyExternalBookingsRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addClinicIds(d);
          break;
        case 2:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setDateFrom(d);
          break;
        case 3:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setDateTo(d);
          break;
        case 11:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setPageToken(d);
          break;
        case 12:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setPageSize(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindMyExternalBookingsRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicIdsList(), n.length > 0 && r.writeRepeatedString(
      1,
      n
    ), n = t.getDateFrom(), n != null && r.writeMessage(
      2,
      n,
      u.Date.serializeBinaryToWriter
    ), n = t.getDateTo(), n != null && r.writeMessage(
      3,
      n,
      u.Date.serializeBinaryToWriter
    ), n = t.getPageToken(), n != null && r.writeMessage(
      11,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPageSize(), n != null && r.writeMessage(
      12,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.setClinicIdsList = function(t) {
    return e.Message.setField(this, 1, t || []);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.addClinicIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 1, t, r);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.getDateFrom = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 2)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.setDateFrom = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.clearDateFrom = function() {
    return this.setDateFrom(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.hasDateFrom = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.getDateTo = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 3)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.setDateTo = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.clearDateTo = function() {
    return this.setDateTo(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.hasDateTo = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.getPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 11)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.setPageToken = function(t) {
    return e.Message.setWrapperField(this, 11, t);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.clearPageToken = function() {
    return this.setPageToken(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.hasPageToken = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.getPageSize = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 12)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.setPageSize = function(t) {
    return e.Message.setWrapperField(this, 12, t);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.clearPageSize = function() {
    return this.setPageSize(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsRequest.prototype.hasPageSize = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindMyExternalBookingsResponse.toObject(t, this);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.toObject = function(t, r) {
    var n, d = {
      externalBookingsList: e.Message.toObjectList(
        r.getExternalBookingsList(),
        proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.toObject,
        t
      ),
      pageToken: e.Message.getFieldWithDefault(r, 11, ""),
      pageSize: e.Message.getFieldWithDefault(r, 12, 0),
      nextPageToken: (n = r.getNextPageToken()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindMyExternalBookingsResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindMyExternalBookingsResponse();
    return proto.api.patient.v1.FindMyExternalBookingsResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking();
          r.readMessage(d, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.deserializeBinaryFromReader), t.addExternalBookings(d);
          break;
        case 11:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPageToken(d);
          break;
        case 12:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setPageSize(d);
          break;
        case 13:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setNextPageToken(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindMyExternalBookingsResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getExternalBookingsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.serializeBinaryToWriter
    ), n = t.getPageToken(), n.length > 0 && r.writeString(
      11,
      n
    ), n = t.getPageSize(), n !== 0 && r.writeInt32(
      12,
      n
    ), n = t.getNextPageToken(), n != null && r.writeMessage(
      13,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.toObject(t, this);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      connectionId: e.Message.getFieldWithDefault(r, 2, 0),
      startTime: (n = r.getStartTime()) && y.DateTime.toObject(t, n),
      endTime: (n = r.getEndTime()) && y.DateTime.toObject(t, n),
      clinicName: (n = r.getClinicName()) && i.StringValue.toObject(t, n),
      treatmentName: (n = r.getTreatmentName()) && i.StringValue.toObject(t, n),
      caregiverName: (n = r.getCaregiverName()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking();
    return proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 2:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setConnectionId(d);
          break;
        case 3:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setStartTime(d);
          break;
        case 4:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setEndTime(d);
          break;
        case 5:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setClinicName(d);
          break;
        case 6:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setTreatmentName(d);
          break;
        case 7:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setCaregiverName(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getConnectionId(), n !== 0 && r.writeInt32(
      2,
      n
    ), n = t.getStartTime(), n != null && r.writeMessage(
      3,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getEndTime(), n != null && r.writeMessage(
      4,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getClinicName(), n != null && r.writeMessage(
      5,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getTreatmentName(), n != null && r.writeMessage(
      6,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getCaregiverName(), n != null && r.writeMessage(
      7,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.getConnectionId = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.setConnectionId = function(t) {
    return e.Message.setProto3IntField(this, 2, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.getStartTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 3)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.setStartTime = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.clearStartTime = function() {
    return this.setStartTime(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.hasStartTime = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.getEndTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 4)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.setEndTime = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.clearEndTime = function() {
    return this.setEndTime(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.hasEndTime = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.getClinicName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 5)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.setClinicName = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.clearClinicName = function() {
    return this.setClinicName(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.hasClinicName = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.getTreatmentName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 6)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.setTreatmentName = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.clearTreatmentName = function() {
    return this.setTreatmentName(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.hasTreatmentName = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.getCaregiverName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 7)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.setCaregiverName = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.clearCaregiverName = function() {
    return this.setCaregiverName(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking.prototype.hasCaregiverName = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.getExternalBookingsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking, 1)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.setExternalBookingsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.addExternalBookings = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.FindMyExternalBookingsResponse.ExternalBooking, r);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.clearExternalBookingsList = function() {
    return this.setExternalBookingsList([]);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.getPageToken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.setPageToken = function(t) {
    return e.Message.setProto3StringField(this, 11, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.getPageSize = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.setPageSize = function(t) {
    return e.Message.setProto3IntField(this, 12, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.getNextPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 13)
    );
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.setNextPageToken = function(t) {
    return e.Message.setWrapperField(this, 13, t);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.clearNextPageToken = function() {
    return this.setNextPageToken(void 0);
  }, proto.api.patient.v1.FindMyExternalBookingsResponse.prototype.hasNextPageToken = function() {
    return e.Message.getField(this, 13) != null;
  }, proto.api.patient.v1.Review.repeatedFields_ = [20], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Review.prototype.toObject = function(t) {
    return proto.api.patient.v1.Review.toObject(t, this);
  }, proto.api.patient.v1.Review.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      clinicId: e.Message.getFieldWithDefault(r, 2, ""),
      authorEmail: e.Message.getFieldWithDefault(r, 3, ""),
      authorPhone: e.Message.getFieldWithDefault(r, 4, ""),
      recommendation: e.Message.getBooleanFieldWithDefault(r, 5, !1),
      content: (n = r.getContent()) && i.StringValue.toObject(t, n),
      authorName: (n = r.getAuthorName()) && i.StringValue.toObject(t, n),
      authorGender: e.Message.getFieldWithDefault(r, 8, 0),
      authorAge: e.Message.getFieldWithDefault(r, 9, 0),
      anonym: e.Message.getBooleanFieldWithDefault(r, 10, !1),
      scoreTreatment: e.Message.getFieldWithDefault(r, 11, 0),
      scoreDentalCare: e.Message.getFieldWithDefault(r, 12, 0),
      scoreAvailability: e.Message.getFieldWithDefault(r, 13, 0),
      totalScore: e.Message.getFloatingPointFieldWithDefault(r, 14, 0),
      createdAt: (n = r.getCreatedAt()) && y.DateTime.toObject(t, n),
      origin: (n = r.getOrigin()) && proto.api.patient.v1.Review.Origin.toObject(t, n),
      answersList: e.Message.toObjectList(
        r.getAnswersList(),
        proto.api.patient.v1.Review.Answer.toObject,
        t
      )
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Review.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Review();
    return proto.api.patient.v1.Review.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Review.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setAuthorEmail(d);
          break;
        case 4:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setAuthorPhone(d);
          break;
        case 5:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          t.setRecommendation(d);
          break;
        case 6:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setContent(d);
          break;
        case 7:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setAuthorName(d);
          break;
        case 8:
          var d = (
            /** @type {!proto.api.patient.v1.Gender} */
            r.readEnum()
          );
          t.setAuthorGender(d);
          break;
        case 9:
          var d = (
            /** @type {number} */
            r.readUint32()
          );
          t.setAuthorAge(d);
          break;
        case 10:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          t.setAnonym(d);
          break;
        case 11:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setScoreTreatment(d);
          break;
        case 12:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setScoreDentalCare(d);
          break;
        case 13:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setScoreAvailability(d);
          break;
        case 14:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          t.setTotalScore(d);
          break;
        case 15:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setCreatedAt(d);
          break;
        case 16:
          var d = new proto.api.patient.v1.Review.Origin();
          r.readMessage(d, proto.api.patient.v1.Review.Origin.deserializeBinaryFromReader), t.setOrigin(d);
          break;
        case 20:
          var d = new proto.api.patient.v1.Review.Answer();
          r.readMessage(d, proto.api.patient.v1.Review.Answer.deserializeBinaryFromReader), t.addAnswers(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Review.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Review.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Review.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getClinicId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getAuthorEmail(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getAuthorPhone(), n.length > 0 && r.writeString(
      4,
      n
    ), n = t.getRecommendation(), n && r.writeBool(
      5,
      n
    ), n = t.getContent(), n != null && r.writeMessage(
      6,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getAuthorName(), n != null && r.writeMessage(
      7,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getAuthorGender(), n !== 0 && r.writeEnum(
      8,
      n
    ), n = t.getAuthorAge(), n !== 0 && r.writeUint32(
      9,
      n
    ), n = t.getAnonym(), n && r.writeBool(
      10,
      n
    ), n = t.getScoreTreatment(), n !== 0 && r.writeInt32(
      11,
      n
    ), n = t.getScoreDentalCare(), n !== 0 && r.writeInt32(
      12,
      n
    ), n = t.getScoreAvailability(), n !== 0 && r.writeInt32(
      13,
      n
    ), n = t.getTotalScore(), n !== 0 && r.writeFloat(
      14,
      n
    ), n = t.getCreatedAt(), n != null && r.writeMessage(
      15,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getOrigin(), n != null && r.writeMessage(
      16,
      n,
      proto.api.patient.v1.Review.Origin.serializeBinaryToWriter
    ), n = t.getAnswersList(), n.length > 0 && r.writeRepeatedMessage(
      20,
      n,
      proto.api.patient.v1.Review.Answer.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Review.Answer.prototype.toObject = function(t) {
    return proto.api.patient.v1.Review.Answer.toObject(t, this);
  }, proto.api.patient.v1.Review.Answer.toObject = function(t, r) {
    var n, d = {
      id: e.Message.getFieldWithDefault(r, 1, ""),
      content: (n = r.getContent()) && i.StringValue.toObject(t, n),
      authorName: (n = r.getAuthorName()) && i.StringValue.toObject(t, n),
      createdAt: (n = r.getCreatedAt()) && y.DateTime.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.Review.Answer.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Review.Answer();
    return proto.api.patient.v1.Review.Answer.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Review.Answer.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setId(d);
          break;
        case 6:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setContent(d);
          break;
        case 7:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setAuthorName(d);
          break;
        case 16:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setCreatedAt(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Review.Answer.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Review.Answer.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Review.Answer.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getContent(), n != null && r.writeMessage(
      6,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getAuthorName(), n != null && r.writeMessage(
      7,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getCreatedAt(), n != null && r.writeMessage(
      16,
      n,
      y.DateTime.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.Review.Answer.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.Review.Answer.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.Review.Answer.prototype.getContent = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 6)
    );
  }, proto.api.patient.v1.Review.Answer.prototype.setContent = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.Review.Answer.prototype.clearContent = function() {
    return this.setContent(void 0);
  }, proto.api.patient.v1.Review.Answer.prototype.hasContent = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.Review.Answer.prototype.getAuthorName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 7)
    );
  }, proto.api.patient.v1.Review.Answer.prototype.setAuthorName = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.Review.Answer.prototype.clearAuthorName = function() {
    return this.setAuthorName(void 0);
  }, proto.api.patient.v1.Review.Answer.prototype.hasAuthorName = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.Review.Answer.prototype.getCreatedAt = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 16)
    );
  }, proto.api.patient.v1.Review.Answer.prototype.setCreatedAt = function(t) {
    return e.Message.setWrapperField(this, 16, t);
  }, proto.api.patient.v1.Review.Answer.prototype.clearCreatedAt = function() {
    return this.setCreatedAt(void 0);
  }, proto.api.patient.v1.Review.Answer.prototype.hasCreatedAt = function() {
    return e.Message.getField(this, 16) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.Review.Origin.prototype.toObject = function(t) {
    return proto.api.patient.v1.Review.Origin.toObject(t, this);
  }, proto.api.patient.v1.Review.Origin.toObject = function(t, r) {
    var n = {
      name: e.Message.getFieldWithDefault(r, 1, ""),
      url: e.Message.getFieldWithDefault(r, 2, ""),
      verified: e.Message.getBooleanFieldWithDefault(r, 3, !1)
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.Review.Origin.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.Review.Origin();
    return proto.api.patient.v1.Review.Origin.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.Review.Origin.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setName(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setUrl(d);
          break;
        case 3:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          t.setVerified(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.Review.Origin.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.Review.Origin.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.Review.Origin.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getName(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getUrl(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getVerified(), n && r.writeBool(
      3,
      n
    );
  }, proto.api.patient.v1.Review.Origin.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.Review.Origin.prototype.setName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.Review.Origin.prototype.getUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.Review.Origin.prototype.setUrl = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.Review.Origin.prototype.getVerified = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.api.patient.v1.Review.Origin.prototype.setVerified = function(t) {
    return e.Message.setProto3BooleanField(this, 3, t);
  }, proto.api.patient.v1.Review.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.Review.prototype.setId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.Review.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.Review.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.Review.prototype.getAuthorEmail = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.Review.prototype.setAuthorEmail = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.Review.prototype.getAuthorPhone = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.api.patient.v1.Review.prototype.setAuthorPhone = function(t) {
    return e.Message.setProto3StringField(this, 4, t);
  }, proto.api.patient.v1.Review.prototype.getRecommendation = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.api.patient.v1.Review.prototype.setRecommendation = function(t) {
    return e.Message.setProto3BooleanField(this, 5, t);
  }, proto.api.patient.v1.Review.prototype.getContent = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 6)
    );
  }, proto.api.patient.v1.Review.prototype.setContent = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.Review.prototype.clearContent = function() {
    return this.setContent(void 0);
  }, proto.api.patient.v1.Review.prototype.hasContent = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.Review.prototype.getAuthorName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 7)
    );
  }, proto.api.patient.v1.Review.prototype.setAuthorName = function(t) {
    return e.Message.setWrapperField(this, 7, t);
  }, proto.api.patient.v1.Review.prototype.clearAuthorName = function() {
    return this.setAuthorName(void 0);
  }, proto.api.patient.v1.Review.prototype.hasAuthorName = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.v1.Review.prototype.getAuthorGender = function() {
    return (
      /** @type {!proto.api.patient.v1.Gender} */
      e.Message.getFieldWithDefault(this, 8, 0)
    );
  }, proto.api.patient.v1.Review.prototype.setAuthorGender = function(t) {
    return e.Message.setProto3EnumField(this, 8, t);
  }, proto.api.patient.v1.Review.prototype.getAuthorAge = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 9, 0)
    );
  }, proto.api.patient.v1.Review.prototype.setAuthorAge = function(t) {
    return e.Message.setProto3IntField(this, 9, t);
  }, proto.api.patient.v1.Review.prototype.getAnonym = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 10, !1)
    );
  }, proto.api.patient.v1.Review.prototype.setAnonym = function(t) {
    return e.Message.setProto3BooleanField(this, 10, t);
  }, proto.api.patient.v1.Review.prototype.getScoreTreatment = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 11, 0)
    );
  }, proto.api.patient.v1.Review.prototype.setScoreTreatment = function(t) {
    return e.Message.setProto3IntField(this, 11, t);
  }, proto.api.patient.v1.Review.prototype.getScoreDentalCare = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.Review.prototype.setScoreDentalCare = function(t) {
    return e.Message.setProto3IntField(this, 12, t);
  }, proto.api.patient.v1.Review.prototype.getScoreAvailability = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 13, 0)
    );
  }, proto.api.patient.v1.Review.prototype.setScoreAvailability = function(t) {
    return e.Message.setProto3IntField(this, 13, t);
  }, proto.api.patient.v1.Review.prototype.getTotalScore = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 14, 0)
    );
  }, proto.api.patient.v1.Review.prototype.setTotalScore = function(t) {
    return e.Message.setProto3FloatField(this, 14, t);
  }, proto.api.patient.v1.Review.prototype.getCreatedAt = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 15)
    );
  }, proto.api.patient.v1.Review.prototype.setCreatedAt = function(t) {
    return e.Message.setWrapperField(this, 15, t);
  }, proto.api.patient.v1.Review.prototype.clearCreatedAt = function() {
    return this.setCreatedAt(void 0);
  }, proto.api.patient.v1.Review.prototype.hasCreatedAt = function() {
    return e.Message.getField(this, 15) != null;
  }, proto.api.patient.v1.Review.prototype.getOrigin = function() {
    return (
      /** @type{?proto.api.patient.v1.Review.Origin} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Review.Origin, 16)
    );
  }, proto.api.patient.v1.Review.prototype.setOrigin = function(t) {
    return e.Message.setWrapperField(this, 16, t);
  }, proto.api.patient.v1.Review.prototype.clearOrigin = function() {
    return this.setOrigin(void 0);
  }, proto.api.patient.v1.Review.prototype.hasOrigin = function() {
    return e.Message.getField(this, 16) != null;
  }, proto.api.patient.v1.Review.prototype.getAnswersList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.Review.Answer>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.Review.Answer, 20)
    );
  }, proto.api.patient.v1.Review.prototype.setAnswersList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 20, t);
  }, proto.api.patient.v1.Review.prototype.addAnswers = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 20, t, proto.api.patient.v1.Review.Answer, r);
  }, proto.api.patient.v1.Review.prototype.clearAnswersList = function() {
    return this.setAnswersList([]);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ReviewRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.ReviewRequest.toObject(t, this);
  }, proto.api.patient.v1.ReviewRequest.toObject = function(t, r) {
    var n, d = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      patientFirstName: e.Message.getFieldWithDefault(r, 2, ""),
      appointmentDate: (n = r.getAppointmentDate()) && u.Date.toObject(t, n),
      hasReview: e.Message.getBooleanFieldWithDefault(r, 11, !1)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ReviewRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ReviewRequest();
    return proto.api.patient.v1.ReviewRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ReviewRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPatientFirstName(d);
          break;
        case 10:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setAppointmentDate(d);
          break;
        case 11:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          t.setHasReview(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ReviewRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ReviewRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ReviewRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getPatientFirstName(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getAppointmentDate(), n != null && r.writeMessage(
      10,
      n,
      u.Date.serializeBinaryToWriter
    ), n = t.getHasReview(), n && r.writeBool(
      11,
      n
    );
  }, proto.api.patient.v1.ReviewRequest.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ReviewRequest.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ReviewRequest.prototype.getPatientFirstName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.ReviewRequest.prototype.setPatientFirstName = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.ReviewRequest.prototype.getAppointmentDate = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 10)
    );
  }, proto.api.patient.v1.ReviewRequest.prototype.setAppointmentDate = function(t) {
    return e.Message.setWrapperField(this, 10, t);
  }, proto.api.patient.v1.ReviewRequest.prototype.clearAppointmentDate = function() {
    return this.setAppointmentDate(void 0);
  }, proto.api.patient.v1.ReviewRequest.prototype.hasAppointmentDate = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.api.patient.v1.ReviewRequest.prototype.getHasReview = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 11, !1)
    );
  }, proto.api.patient.v1.ReviewRequest.prototype.setHasReview = function(t) {
    return e.Message.setProto3BooleanField(this, 11, t);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.repeatedFields_ = [3], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindReviewsForClinicRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindReviewsForClinicRequest.toObject(t, this);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.toObject = function(t, r) {
    var n, d = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      includeImported: (n = r.getIncludeImported()) && i.BoolValue.toObject(t, n),
      clinicIdsList: (n = e.Message.getRepeatedField(r, 3)) == null ? void 0 : n,
      pageToken: (n = r.getPageToken()) && i.StringValue.toObject(t, n),
      pageSize: (n = r.getPageSize()) && i.Int32Value.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindReviewsForClinicRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindReviewsForClinicRequest();
    return proto.api.patient.v1.FindReviewsForClinicRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 2:
          var d = new i.BoolValue();
          r.readMessage(d, i.BoolValue.deserializeBinaryFromReader), t.setIncludeImported(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addClinicIds(d);
          break;
        case 11:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setPageToken(d);
          break;
        case 12:
          var d = new i.Int32Value();
          r.readMessage(d, i.Int32Value.deserializeBinaryFromReader), t.setPageSize(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindReviewsForClinicRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindReviewsForClinicRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getIncludeImported(), n != null && r.writeMessage(
      2,
      n,
      i.BoolValue.serializeBinaryToWriter
    ), n = t.getClinicIdsList(), n.length > 0 && r.writeRepeatedString(
      3,
      n
    ), n = t.getPageToken(), n != null && r.writeMessage(
      11,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getPageSize(), n != null && r.writeMessage(
      12,
      n,
      i.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.getIncludeImported = function() {
    return (
      /** @type{?proto.google.protobuf.BoolValue} */
      e.Message.getWrapperField(this, i.BoolValue, 2)
    );
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.setIncludeImported = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.clearIncludeImported = function() {
    return this.setIncludeImported(void 0);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.hasIncludeImported = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 3)
    );
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.setClinicIdsList = function(t) {
    return e.Message.setField(this, 3, t || []);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.addClinicIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 3, t, r);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.getPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 11)
    );
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.setPageToken = function(t) {
    return e.Message.setWrapperField(this, 11, t);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.clearPageToken = function() {
    return this.setPageToken(void 0);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.hasPageToken = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.getPageSize = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, i.Int32Value, 12)
    );
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.setPageSize = function(t) {
    return e.Message.setWrapperField(this, 12, t);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.clearPageSize = function() {
    return this.setPageSize(void 0);
  }, proto.api.patient.v1.FindReviewsForClinicRequest.prototype.hasPageSize = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.v1.FindReviewsForClinicResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindReviewsForClinicResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindReviewsForClinicResponse.toObject(t, this);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.toObject = function(t, r) {
    var n, d = {
      reviewsList: e.Message.toObjectList(
        r.getReviewsList(),
        proto.api.patient.v1.Review.toObject,
        t
      ),
      pageToken: e.Message.getFieldWithDefault(r, 11, ""),
      pageSize: e.Message.getFieldWithDefault(r, 12, 0),
      nextPageToken: (n = r.getNextPageToken()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindReviewsForClinicResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindReviewsForClinicResponse();
    return proto.api.patient.v1.FindReviewsForClinicResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Review();
          r.readMessage(d, proto.api.patient.v1.Review.deserializeBinaryFromReader), t.addReviews(d);
          break;
        case 11:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPageToken(d);
          break;
        case 12:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setPageSize(d);
          break;
        case 13:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setNextPageToken(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindReviewsForClinicResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindReviewsForClinicResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getReviewsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.Review.serializeBinaryToWriter
    ), n = t.getPageToken(), n.length > 0 && r.writeString(
      11,
      n
    ), n = t.getPageSize(), n !== 0 && r.writeInt32(
      12,
      n
    ), n = t.getNextPageToken(), n != null && r.writeMessage(
      13,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.getReviewsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.Review>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.Review, 1)
    );
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.setReviewsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.addReviews = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.Review, r);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.clearReviewsList = function() {
    return this.setReviewsList([]);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.getPageToken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.setPageToken = function(t) {
    return e.Message.setProto3StringField(this, 11, t);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.getPageSize = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.setPageSize = function(t) {
    return e.Message.setProto3IntField(this, 12, t);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.getNextPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 13)
    );
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.setNextPageToken = function(t) {
    return e.Message.setWrapperField(this, 13, t);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.clearNextPageToken = function() {
    return this.setNextPageToken(void 0);
  }, proto.api.patient.v1.FindReviewsForClinicResponse.prototype.hasNextPageToken = function() {
    return e.Message.getField(this, 13) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetReviewsScoreForClinicRequest.toObject(t, this);
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.toObject = function(t, r) {
    var n, d = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      dateFrom: (n = r.getDateFrom()) && u.Date.toObject(t, n),
      dateTo: (n = r.getDateTo()) && u.Date.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetReviewsScoreForClinicRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetReviewsScoreForClinicRequest();
    return proto.api.patient.v1.GetReviewsScoreForClinicRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 5:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setDateFrom(d);
          break;
        case 6:
          var d = new u.Date();
          r.readMessage(d, u.Date.deserializeBinaryFromReader), t.setDateTo(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetReviewsScoreForClinicRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getDateFrom(), n != null && r.writeMessage(
      5,
      n,
      u.Date.serializeBinaryToWriter
    ), n = t.getDateTo(), n != null && r.writeMessage(
      6,
      n,
      u.Date.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.getDateFrom = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 5)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.setDateFrom = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.clearDateFrom = function() {
    return this.setDateFrom(void 0);
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.hasDateFrom = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.getDateTo = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, u.Date, 6)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.setDateTo = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.clearDateTo = function() {
    return this.setDateTo(void 0);
  }, proto.api.patient.v1.GetReviewsScoreForClinicRequest.prototype.hasDateTo = function() {
    return e.Message.getField(this, 6) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetReviewsScoreForClinicResponse.toObject(t, this);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.toObject = function(t, r) {
    var n, d = {
      reviewsCount: e.Message.getFieldWithDefault(r, 1, 0),
      averageScore: (n = r.getAverageScore()) && proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetReviewsScoreForClinicResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetReviewsScoreForClinicResponse();
    return proto.api.patient.v1.GetReviewsScoreForClinicResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setReviewsCount(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore();
          r.readMessage(d, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.deserializeBinaryFromReader), t.setAverageScore(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetReviewsScoreForClinicResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getReviewsCount(), n !== 0 && r.writeInt32(
      1,
      n
    ), n = t.getAverageScore(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.toObject(t, this);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.toObject = function(t, r) {
    var n = {
      treatment: e.Message.getFloatingPointFieldWithDefault(r, 1, 0),
      dentalCare: e.Message.getFloatingPointFieldWithDefault(r, 2, 0),
      availability: e.Message.getFloatingPointFieldWithDefault(r, 3, 0),
      total: e.Message.getFloatingPointFieldWithDefault(r, 4, 0)
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore();
    return proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          t.setTreatment(d);
          break;
        case 2:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          t.setDentalCare(d);
          break;
        case 3:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          t.setAvailability(d);
          break;
        case 4:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          t.setTotal(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getTreatment(), n !== 0 && r.writeFloat(
      1,
      n
    ), n = t.getDentalCare(), n !== 0 && r.writeFloat(
      2,
      n
    ), n = t.getAvailability(), n !== 0 && r.writeFloat(
      3,
      n
    ), n = t.getTotal(), n !== 0 && r.writeFloat(
      4,
      n
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.getTreatment = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.setTreatment = function(t) {
    return e.Message.setProto3FloatField(this, 1, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.getDentalCare = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.setDentalCare = function(t) {
    return e.Message.setProto3FloatField(this, 2, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.getAvailability = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 3, 0)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.setAvailability = function(t) {
    return e.Message.setProto3FloatField(this, 3, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.getTotal = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 4, 0)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore.prototype.setTotal = function(t) {
    return e.Message.setProto3FloatField(this, 4, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.getReviewsCount = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.setReviewsCount = function(t) {
    return e.Message.setProto3IntField(this, 1, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.getAverageScore = function() {
    return (
      /** @type{?proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore} */
      e.Message.getWrapperField(this, proto.api.patient.v1.GetReviewsScoreForClinicResponse.AverageScore, 2)
    );
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.setAverageScore = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.clearAverageScore = function() {
    return this.setAverageScore(void 0);
  }, proto.api.patient.v1.GetReviewsScoreForClinicResponse.prototype.hasAverageScore = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateReviewForClinicRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateReviewForClinicRequest.toObject(t, this);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.toObject = function(t, r) {
    var n, d = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      authorEmail: (n = r.getAuthorEmail()) && i.StringValue.toObject(t, n),
      authorPhone: (n = r.getAuthorPhone()) && M.PhoneNumber.toObject(t, n),
      recommendation: (n = r.getRecommendation()) && i.BoolValue.toObject(t, n),
      content: e.Message.getFieldWithDefault(r, 5, ""),
      authorName: (n = r.getAuthorName()) && i.StringValue.toObject(t, n),
      authorGender: e.Message.getFieldWithDefault(r, 7, 0),
      authorAge: (n = r.getAuthorAge()) && i.UInt32Value.toObject(t, n),
      anonym: (n = r.getAnonym()) && i.BoolValue.toObject(t, n),
      scoreTreatment: e.Message.getFieldWithDefault(r, 10, 0),
      scoreDentalCare: e.Message.getFieldWithDefault(r, 11, 0),
      scoreAvailability: e.Message.getFieldWithDefault(r, 12, 0),
      reviewRequestId: (n = r.getReviewRequestId()) && i.StringValue.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateReviewForClinicRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateReviewForClinicRequest();
    return proto.api.patient.v1.CreateReviewForClinicRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setAuthorEmail(d);
          break;
        case 3:
          var d = new M.PhoneNumber();
          r.readMessage(d, M.PhoneNumber.deserializeBinaryFromReader), t.setAuthorPhone(d);
          break;
        case 4:
          var d = new i.BoolValue();
          r.readMessage(d, i.BoolValue.deserializeBinaryFromReader), t.setRecommendation(d);
          break;
        case 5:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setContent(d);
          break;
        case 6:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setAuthorName(d);
          break;
        case 7:
          var d = (
            /** @type {!proto.api.patient.v1.Gender} */
            r.readEnum()
          );
          t.setAuthorGender(d);
          break;
        case 8:
          var d = new i.UInt32Value();
          r.readMessage(d, i.UInt32Value.deserializeBinaryFromReader), t.setAuthorAge(d);
          break;
        case 9:
          var d = new i.BoolValue();
          r.readMessage(d, i.BoolValue.deserializeBinaryFromReader), t.setAnonym(d);
          break;
        case 10:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setScoreTreatment(d);
          break;
        case 11:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setScoreDentalCare(d);
          break;
        case 12:
          var d = (
            /** @type {number} */
            r.readInt32()
          );
          t.setScoreAvailability(d);
          break;
        case 13:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setReviewRequestId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateReviewForClinicRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateReviewForClinicRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getAuthorEmail(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getAuthorPhone(), n != null && r.writeMessage(
      3,
      n,
      M.PhoneNumber.serializeBinaryToWriter
    ), n = t.getRecommendation(), n != null && r.writeMessage(
      4,
      n,
      i.BoolValue.serializeBinaryToWriter
    ), n = t.getContent(), n.length > 0 && r.writeString(
      5,
      n
    ), n = t.getAuthorName(), n != null && r.writeMessage(
      6,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getAuthorGender(), n !== 0 && r.writeEnum(
      7,
      n
    ), n = t.getAuthorAge(), n != null && r.writeMessage(
      8,
      n,
      i.UInt32Value.serializeBinaryToWriter
    ), n = t.getAnonym(), n != null && r.writeMessage(
      9,
      n,
      i.BoolValue.serializeBinaryToWriter
    ), n = t.getScoreTreatment(), n !== 0 && r.writeInt32(
      10,
      n
    ), n = t.getScoreDentalCare(), n !== 0 && r.writeInt32(
      11,
      n
    ), n = t.getScoreAvailability(), n !== 0 && r.writeInt32(
      12,
      n
    ), n = t.getReviewRequestId(), n != null && r.writeMessage(
      13,
      n,
      i.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getAuthorEmail = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setAuthorEmail = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.clearAuthorEmail = function() {
    return this.setAuthorEmail(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.hasAuthorEmail = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getAuthorPhone = function() {
    return (
      /** @type{?proto.google.type.PhoneNumber} */
      e.Message.getWrapperField(this, M.PhoneNumber, 3)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setAuthorPhone = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.clearAuthorPhone = function() {
    return this.setAuthorPhone(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.hasAuthorPhone = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getRecommendation = function() {
    return (
      /** @type{?proto.google.protobuf.BoolValue} */
      e.Message.getWrapperField(this, i.BoolValue, 4)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setRecommendation = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.clearRecommendation = function() {
    return this.setRecommendation(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.hasRecommendation = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getContent = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 5, "")
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setContent = function(t) {
    return e.Message.setProto3StringField(this, 5, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getAuthorName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 6)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setAuthorName = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.clearAuthorName = function() {
    return this.setAuthorName(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.hasAuthorName = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getAuthorGender = function() {
    return (
      /** @type {!proto.api.patient.v1.Gender} */
      e.Message.getFieldWithDefault(this, 7, 0)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setAuthorGender = function(t) {
    return e.Message.setProto3EnumField(this, 7, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getAuthorAge = function() {
    return (
      /** @type{?proto.google.protobuf.UInt32Value} */
      e.Message.getWrapperField(this, i.UInt32Value, 8)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setAuthorAge = function(t) {
    return e.Message.setWrapperField(this, 8, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.clearAuthorAge = function() {
    return this.setAuthorAge(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.hasAuthorAge = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getAnonym = function() {
    return (
      /** @type{?proto.google.protobuf.BoolValue} */
      e.Message.getWrapperField(this, i.BoolValue, 9)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setAnonym = function(t) {
    return e.Message.setWrapperField(this, 9, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.clearAnonym = function() {
    return this.setAnonym(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.hasAnonym = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getScoreTreatment = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 10, 0)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setScoreTreatment = function(t) {
    return e.Message.setProto3IntField(this, 10, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getScoreDentalCare = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 11, 0)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setScoreDentalCare = function(t) {
    return e.Message.setProto3IntField(this, 11, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getScoreAvailability = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setScoreAvailability = function(t) {
    return e.Message.setProto3IntField(this, 12, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.getReviewRequestId = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 13)
    );
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.setReviewRequestId = function(t) {
    return e.Message.setWrapperField(this, 13, t);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.clearReviewRequestId = function() {
    return this.setReviewRequestId(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicRequest.prototype.hasReviewRequestId = function() {
    return e.Message.getField(this, 13) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.CreateReviewForClinicResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.CreateReviewForClinicResponse.toObject(t, this);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.toObject = function(t, r) {
    var n, d = {
      review: (n = r.getReview()) && proto.api.patient.v1.Review.toObject(t, n),
      googleReviewLink: (n = r.getGoogleReviewLink()) && i.StringValue.toObject(t, n),
      reviewPrompt: (n = r.getReviewPrompt()) && proto.api.patient.v1.ReviewPrompt.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.CreateReviewForClinicResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.CreateReviewForClinicResponse();
    return proto.api.patient.v1.CreateReviewForClinicResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.Review();
          r.readMessage(d, proto.api.patient.v1.Review.deserializeBinaryFromReader), t.setReview(d);
          break;
        case 2:
          var d = new i.StringValue();
          r.readMessage(d, i.StringValue.deserializeBinaryFromReader), t.setGoogleReviewLink(d);
          break;
        case 3:
          var d = new proto.api.patient.v1.ReviewPrompt();
          r.readMessage(d, proto.api.patient.v1.ReviewPrompt.deserializeBinaryFromReader), t.setReviewPrompt(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.CreateReviewForClinicResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.CreateReviewForClinicResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getReview(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.Review.serializeBinaryToWriter
    ), n = t.getGoogleReviewLink(), n != null && r.writeMessage(
      2,
      n,
      i.StringValue.serializeBinaryToWriter
    ), n = t.getReviewPrompt(), n != null && r.writeMessage(
      3,
      n,
      proto.api.patient.v1.ReviewPrompt.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.getReview = function() {
    return (
      /** @type{?proto.api.patient.v1.Review} */
      e.Message.getWrapperField(this, proto.api.patient.v1.Review, 1)
    );
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.setReview = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.clearReview = function() {
    return this.setReview(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.hasReview = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.getGoogleReviewLink = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, i.StringValue, 2)
    );
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.setGoogleReviewLink = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.clearGoogleReviewLink = function() {
    return this.setGoogleReviewLink(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.hasGoogleReviewLink = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.getReviewPrompt = function() {
    return (
      /** @type{?proto.api.patient.v1.ReviewPrompt} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ReviewPrompt, 3)
    );
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.setReviewPrompt = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.clearReviewPrompt = function() {
    return this.setReviewPrompt(void 0);
  }, proto.api.patient.v1.CreateReviewForClinicResponse.prototype.hasReviewPrompt = function() {
    return e.Message.getField(this, 3) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetReviewRequestInfoRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetReviewRequestInfoRequest.toObject(t, this);
  }, proto.api.patient.v1.GetReviewRequestInfoRequest.toObject = function(t, r) {
    var n = {
      reviewRequestId: e.Message.getFieldWithDefault(r, 1, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.GetReviewRequestInfoRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetReviewRequestInfoRequest();
    return proto.api.patient.v1.GetReviewRequestInfoRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetReviewRequestInfoRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setReviewRequestId(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetReviewRequestInfoRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetReviewRequestInfoRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetReviewRequestInfoRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getReviewRequestId(), n.length > 0 && r.writeString(
      1,
      n
    );
  }, proto.api.patient.v1.GetReviewRequestInfoRequest.prototype.getReviewRequestId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.GetReviewRequestInfoRequest.prototype.setReviewRequestId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.GetReviewRequestInfoResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.GetReviewRequestInfoResponse.toObject(t, this);
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.toObject = function(t, r) {
    var n, d = {
      reviewRequest: (n = r.getReviewRequest()) && proto.api.patient.v1.ReviewRequest.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.GetReviewRequestInfoResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.GetReviewRequestInfoResponse();
    return proto.api.patient.v1.GetReviewRequestInfoResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.ReviewRequest();
          r.readMessage(d, proto.api.patient.v1.ReviewRequest.deserializeBinaryFromReader), t.setReviewRequest(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.GetReviewRequestInfoResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getReviewRequest(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.ReviewRequest.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.prototype.getReviewRequest = function() {
    return (
      /** @type{?proto.api.patient.v1.ReviewRequest} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ReviewRequest, 1)
    );
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.prototype.setReviewRequest = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.prototype.clearReviewRequest = function() {
    return this.setReviewRequest(void 0);
  }, proto.api.patient.v1.GetReviewRequestInfoResponse.prototype.hasReviewRequest = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.LookupPatientRequest.oneofGroups_ = [[1]], proto.api.patient.v1.LookupPatientRequest.IdentifierCase = {
    IDENTIFIER_NOT_SET: 0,
    SWEDISH_PERSONAL_IDENTITY_NUMBER: 1
  }, proto.api.patient.v1.LookupPatientRequest.prototype.getIdentifierCase = function() {
    return (
      /** @type {proto.api.patient.v1.LookupPatientRequest.IdentifierCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.LookupPatientRequest.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.LookupPatientRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.LookupPatientRequest.toObject(t, this);
  }, proto.api.patient.v1.LookupPatientRequest.toObject = function(t, r) {
    var n, d = {
      swedishPersonalIdentityNumber: (n = r.getSwedishPersonalIdentityNumber()) && proto.api.patient.v1.SwedishPersonalIdentityNumber.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.LookupPatientRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.LookupPatientRequest();
    return proto.api.patient.v1.LookupPatientRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.LookupPatientRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.SwedishPersonalIdentityNumber();
          r.readMessage(d, proto.api.patient.v1.SwedishPersonalIdentityNumber.deserializeBinaryFromReader), t.setSwedishPersonalIdentityNumber(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.LookupPatientRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.LookupPatientRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.LookupPatientRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getSwedishPersonalIdentityNumber(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.SwedishPersonalIdentityNumber.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.LookupPatientRequest.prototype.getSwedishPersonalIdentityNumber = function() {
    return (
      /** @type{?proto.api.patient.v1.SwedishPersonalIdentityNumber} */
      e.Message.getWrapperField(this, proto.api.patient.v1.SwedishPersonalIdentityNumber, 1)
    );
  }, proto.api.patient.v1.LookupPatientRequest.prototype.setSwedishPersonalIdentityNumber = function(t) {
    return e.Message.setOneofWrapperField(this, 1, proto.api.patient.v1.LookupPatientRequest.oneofGroups_[0], t);
  }, proto.api.patient.v1.LookupPatientRequest.prototype.clearSwedishPersonalIdentityNumber = function() {
    return this.setSwedishPersonalIdentityNumber(void 0);
  }, proto.api.patient.v1.LookupPatientRequest.prototype.hasSwedishPersonalIdentityNumber = function() {
    return e.Message.getField(this, 1) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.LookupPatientResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.LookupPatientResponse.toObject(t, this);
  }, proto.api.patient.v1.LookupPatientResponse.toObject = function(t, r) {
    var n, d = {
      patient: (n = r.getPatient()) && proto.api.patient.v1.LookupPatientResponse.Patient.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.LookupPatientResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.LookupPatientResponse();
    return proto.api.patient.v1.LookupPatientResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.LookupPatientResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.LookupPatientResponse.Patient();
          r.readMessage(d, proto.api.patient.v1.LookupPatientResponse.Patient.deserializeBinaryFromReader), t.setPatient(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.LookupPatientResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.LookupPatientResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.LookupPatientResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getPatient(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.LookupPatientResponse.Patient.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.LookupPatientResponse.Patient.prototype.toObject = function(t) {
    return proto.api.patient.v1.LookupPatientResponse.Patient.toObject(t, this);
  }, proto.api.patient.v1.LookupPatientResponse.Patient.toObject = function(t, r) {
    var n = {
      firstName: e.Message.getFieldWithDefault(r, 1, ""),
      lastName: e.Message.getFieldWithDefault(r, 2, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.LookupPatientResponse.Patient.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.LookupPatientResponse.Patient();
    return proto.api.patient.v1.LookupPatientResponse.Patient.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.LookupPatientResponse.Patient.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setFirstName(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setLastName(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.LookupPatientResponse.Patient.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.LookupPatientResponse.Patient.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.LookupPatientResponse.Patient.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getFirstName(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getLastName(), n.length > 0 && r.writeString(
      2,
      n
    );
  }, proto.api.patient.v1.LookupPatientResponse.Patient.prototype.getFirstName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.LookupPatientResponse.Patient.prototype.setFirstName = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.LookupPatientResponse.Patient.prototype.getLastName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.LookupPatientResponse.Patient.prototype.setLastName = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.LookupPatientResponse.prototype.getPatient = function() {
    return (
      /** @type{?proto.api.patient.v1.LookupPatientResponse.Patient} */
      e.Message.getWrapperField(this, proto.api.patient.v1.LookupPatientResponse.Patient, 1)
    );
  }, proto.api.patient.v1.LookupPatientResponse.prototype.setPatient = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.LookupPatientResponse.prototype.clearPatient = function() {
    return this.setPatient(void 0);
  }, proto.api.patient.v1.LookupPatientResponse.prototype.hasPatient = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.toObject(t, this);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.toObject = function(t, r) {
    var n, d = {
      clinicIdsList: (n = e.Message.getRepeatedField(r, 1)) == null ? void 0 : n,
      startTime: (n = r.getStartTime()) && y.DateTime.toObject(t, n),
      endTime: (n = r.getEndTime()) && y.DateTime.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest();
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addClinicIds(d);
          break;
        case 2:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setStartTime(d);
          break;
        case 3:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setEndTime(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicIdsList(), n.length > 0 && r.writeRepeatedString(
      1,
      n
    ), n = t.getStartTime(), n != null && r.writeMessage(
      2,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getEndTime(), n != null && r.writeMessage(
      3,
      n,
      y.DateTime.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.setClinicIdsList = function(t) {
    return e.Message.setField(this, 1, t || []);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.addClinicIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 1, t, r);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.getStartTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 2)
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.setStartTime = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.clearStartTime = function() {
    return this.setStartTime(void 0);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.hasStartTime = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.getEndTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 3)
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.setEndTime = function(t) {
    return e.Message.setWrapperField(this, 3, t);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.clearEndTime = function() {
    return this.setEndTime(void 0);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest.prototype.hasEndTime = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.toObject(t, this);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.toObject = function(t, r) {
    var n = {
      clinicsList: e.Message.toObjectList(
        r.getClinicsList(),
        proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.toObject,
        t
      )
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse();
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic();
          r.readMessage(d, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.deserializeBinaryFromReader), t.addClinics(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicsList(), n.length > 0 && r.writeRepeatedMessage(
      1,
      n,
      proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.repeatedFields_ = [2], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.toObject = function(t) {
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.toObject(t, this);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.toObject = function(t, r) {
    var n, d = {
      clinicId: e.Message.getFieldWithDefault(r, 1, ""),
      treatmentIdsList: (n = e.Message.getRepeatedField(r, 2)) == null ? void 0 : n
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic();
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.addTreatmentIds(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getClinicId(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getTreatmentIdsList(), n.length > 0 && r.writeRepeatedString(
      2,
      n
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.getTreatmentIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 2)
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.setTreatmentIdsList = function(t) {
    return e.Message.setField(this, 2, t || []);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.addTreatmentIds = function(t, r) {
    return e.Message.addToRepeatedField(this, 2, t, r);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic.prototype.clearTreatmentIdsList = function() {
    return this.setTreatmentIdsList([]);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.prototype.getClinicsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic, 1)
    );
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.prototype.setClinicsList = function(t) {
    return e.Message.setRepeatedWrapperField(this, 1, t);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.prototype.addClinics = function(t, r) {
    return e.Message.addToRepeatedWrapperField(this, 1, t, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.Clinic, r);
  }, proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.prototype.clearClinicsList = function() {
    return this.setClinicsList([]);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ValidatePromoCodeRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.ValidatePromoCodeRequest.toObject(t, this);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.toObject = function(t, r) {
    var n, d = {
      promoCode: e.Message.getFieldWithDefault(r, 1, ""),
      clinicId: e.Message.getFieldWithDefault(r, 2, ""),
      treatmentId: e.Message.getFieldWithDefault(r, 3, ""),
      originalPrice: (n = r.getOriginalPrice()) && C.Money.toObject(t, n),
      appointmentDatetime: (n = r.getAppointmentDatetime()) && y.DateTime.toObject(t, n),
      swedishPersonalIdentityNumber: (n = r.getSwedishPersonalIdentityNumber()) && proto.api.patient.v1.SwedishPersonalIdentityNumber.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ValidatePromoCodeRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ValidatePromoCodeRequest();
    return proto.api.patient.v1.ValidatePromoCodeRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPromoCode(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setClinicId(d);
          break;
        case 3:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setTreatmentId(d);
          break;
        case 4:
          var d = new C.Money();
          r.readMessage(d, C.Money.deserializeBinaryFromReader), t.setOriginalPrice(d);
          break;
        case 5:
          var d = new y.DateTime();
          r.readMessage(d, y.DateTime.deserializeBinaryFromReader), t.setAppointmentDatetime(d);
          break;
        case 6:
          var d = new proto.api.patient.v1.SwedishPersonalIdentityNumber();
          r.readMessage(d, proto.api.patient.v1.SwedishPersonalIdentityNumber.deserializeBinaryFromReader), t.setSwedishPersonalIdentityNumber(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ValidatePromoCodeRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ValidatePromoCodeRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getPromoCode(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getClinicId(), n.length > 0 && r.writeString(
      2,
      n
    ), n = t.getTreatmentId(), n.length > 0 && r.writeString(
      3,
      n
    ), n = t.getOriginalPrice(), n != null && r.writeMessage(
      4,
      n,
      C.Money.serializeBinaryToWriter
    ), n = t.getAppointmentDatetime(), n != null && r.writeMessage(
      5,
      n,
      y.DateTime.serializeBinaryToWriter
    ), n = t.getSwedishPersonalIdentityNumber(), n != null && r.writeMessage(
      6,
      n,
      proto.api.patient.v1.SwedishPersonalIdentityNumber.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.getPromoCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.setPromoCode = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.setClinicId = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.getTreatmentId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.setTreatmentId = function(t) {
    return e.Message.setProto3StringField(this, 3, t);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.getOriginalPrice = function() {
    return (
      /** @type{?proto.google.type.Money} */
      e.Message.getWrapperField(this, C.Money, 4)
    );
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.setOriginalPrice = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.clearOriginalPrice = function() {
    return this.setOriginalPrice(void 0);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.hasOriginalPrice = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.getAppointmentDatetime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, y.DateTime, 5)
    );
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.setAppointmentDatetime = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.clearAppointmentDatetime = function() {
    return this.setAppointmentDatetime(void 0);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.hasAppointmentDatetime = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.getSwedishPersonalIdentityNumber = function() {
    return (
      /** @type{?proto.api.patient.v1.SwedishPersonalIdentityNumber} */
      e.Message.getWrapperField(this, proto.api.patient.v1.SwedishPersonalIdentityNumber, 6)
    );
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.setSwedishPersonalIdentityNumber = function(t) {
    return e.Message.setWrapperField(this, 6, t);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.clearSwedishPersonalIdentityNumber = function() {
    return this.setSwedishPersonalIdentityNumber(void 0);
  }, proto.api.patient.v1.ValidatePromoCodeRequest.prototype.hasSwedishPersonalIdentityNumber = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.v1.ValidatePromoCodeResponse.oneofGroups_ = [[21, 22]], proto.api.patient.v1.ValidatePromoCodeResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    SUCCESS: 21,
    FAILURE: 22
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto.api.patient.v1.ValidatePromoCodeResponse.ResultCase} */
      e.Message.computeOneofCase(this, proto.api.patient.v1.ValidatePromoCodeResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ValidatePromoCodeResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.ValidatePromoCodeResponse.toObject(t, this);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.toObject = function(t, r) {
    var n, d = {
      success: (n = r.getSuccess()) && proto.api.patient.v1.ValidatePromoCodeResponse.Success.toObject(t, n),
      failure: (n = r.getFailure()) && o.RequestFailure.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ValidatePromoCodeResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ValidatePromoCodeResponse();
    return proto.api.patient.v1.ValidatePromoCodeResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 21:
          var d = new proto.api.patient.v1.ValidatePromoCodeResponse.Success();
          r.readMessage(d, proto.api.patient.v1.ValidatePromoCodeResponse.Success.deserializeBinaryFromReader), t.setSuccess(d);
          break;
        case 22:
          var d = new o.RequestFailure();
          r.readMessage(d, o.RequestFailure.deserializeBinaryFromReader), t.setFailure(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ValidatePromoCodeResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ValidatePromoCodeResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getSuccess(), n != null && r.writeMessage(
      21,
      n,
      proto.api.patient.v1.ValidatePromoCodeResponse.Success.serializeBinaryToWriter
    ), n = t.getFailure(), n != null && r.writeMessage(
      22,
      n,
      o.RequestFailure.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.DiscountType = {
    DISCOUNT_TYPE_UNSPECIFIED: 0,
    DISCOUNT_TYPE_PERCENTAGE: 1,
    DISCOUNT_TYPE_FIXED: 2
  }, proto.api.patient.v1.ValidatePromoCodeResponse.PatientRelationshipType = {
    PATIENT_RELATIONSHIP_TYPE_UNSPECIFIED: 0,
    PATIENT_RELATIONSHIP_TYPE_NEW: 1,
    PATIENT_RELATIONSHIP_TYPE_EXISTING: 2
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.toObject = function(t) {
    return proto.api.patient.v1.ValidatePromoCodeResponse.Success.toObject(t, this);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.toObject = function(t, r) {
    var n, d = {
      promoCode: e.Message.getFieldWithDefault(r, 1, ""),
      discountType: e.Message.getFieldWithDefault(r, 2, 0),
      discountValue: e.Message.getFloatingPointFieldWithDefault(r, 3, 0),
      originalPrice: (n = r.getOriginalPrice()) && C.Money.toObject(t, n),
      finalPrice: (n = r.getFinalPrice()) && C.Money.toObject(t, n),
      patientRelationshipType: e.Message.getFieldWithDefault(r, 6, 0)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.ValidatePromoCodeResponse.Success.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ValidatePromoCodeResponse.Success();
    return proto.api.patient.v1.ValidatePromoCodeResponse.Success.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setPromoCode(d);
          break;
        case 2:
          var d = (
            /** @type {!proto.api.patient.v1.ValidatePromoCodeResponse.DiscountType} */
            r.readEnum()
          );
          t.setDiscountType(d);
          break;
        case 3:
          var d = (
            /** @type {number} */
            r.readFloat()
          );
          t.setDiscountValue(d);
          break;
        case 4:
          var d = new C.Money();
          r.readMessage(d, C.Money.deserializeBinaryFromReader), t.setOriginalPrice(d);
          break;
        case 5:
          var d = new C.Money();
          r.readMessage(d, C.Money.deserializeBinaryFromReader), t.setFinalPrice(d);
          break;
        case 6:
          var d = (
            /** @type {!proto.api.patient.v1.ValidatePromoCodeResponse.PatientRelationshipType} */
            r.readEnum()
          );
          t.setPatientRelationshipType(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ValidatePromoCodeResponse.Success.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getPromoCode(), n.length > 0 && r.writeString(
      1,
      n
    ), n = t.getDiscountType(), n !== 0 && r.writeEnum(
      2,
      n
    ), n = t.getDiscountValue(), n !== 0 && r.writeFloat(
      3,
      n
    ), n = t.getOriginalPrice(), n != null && r.writeMessage(
      4,
      n,
      C.Money.serializeBinaryToWriter
    ), n = t.getFinalPrice(), n != null && r.writeMessage(
      5,
      n,
      C.Money.serializeBinaryToWriter
    ), n = t.getPatientRelationshipType(), n !== 0 && r.writeEnum(
      6,
      n
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.getPromoCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.setPromoCode = function(t) {
    return e.Message.setProto3StringField(this, 1, t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.getDiscountType = function() {
    return (
      /** @type {!proto.api.patient.v1.ValidatePromoCodeResponse.DiscountType} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.setDiscountType = function(t) {
    return e.Message.setProto3EnumField(this, 2, t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.getDiscountValue = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 3, 0)
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.setDiscountValue = function(t) {
    return e.Message.setProto3FloatField(this, 3, t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.getOriginalPrice = function() {
    return (
      /** @type{?proto.google.type.Money} */
      e.Message.getWrapperField(this, C.Money, 4)
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.setOriginalPrice = function(t) {
    return e.Message.setWrapperField(this, 4, t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.clearOriginalPrice = function() {
    return this.setOriginalPrice(void 0);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.hasOriginalPrice = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.getFinalPrice = function() {
    return (
      /** @type{?proto.google.type.Money} */
      e.Message.getWrapperField(this, C.Money, 5)
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.setFinalPrice = function(t) {
    return e.Message.setWrapperField(this, 5, t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.clearFinalPrice = function() {
    return this.setFinalPrice(void 0);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.hasFinalPrice = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.getPatientRelationshipType = function() {
    return (
      /** @type {!proto.api.patient.v1.ValidatePromoCodeResponse.PatientRelationshipType} */
      e.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.Success.prototype.setPatientRelationshipType = function(t) {
    return e.Message.setProto3EnumField(this, 6, t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.getSuccess = function() {
    return (
      /** @type{?proto.api.patient.v1.ValidatePromoCodeResponse.Success} */
      e.Message.getWrapperField(this, proto.api.patient.v1.ValidatePromoCodeResponse.Success, 21)
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.setSuccess = function(t) {
    return e.Message.setOneofWrapperField(this, 21, proto.api.patient.v1.ValidatePromoCodeResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.clearSuccess = function() {
    return this.setSuccess(void 0);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.hasSuccess = function() {
    return e.Message.getField(this, 21) != null;
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.getFailure = function() {
    return (
      /** @type{?proto.api.patient.v1.RequestFailure} */
      e.Message.getWrapperField(this, o.RequestFailure, 22)
    );
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.setFailure = function(t) {
    return e.Message.setOneofWrapperField(this, 22, proto.api.patient.v1.ValidatePromoCodeResponse.oneofGroups_[0], t);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.clearFailure = function() {
    return this.setFailure(void 0);
  }, proto.api.patient.v1.ValidatePromoCodeResponse.prototype.hasFailure = function() {
    return e.Message.getField(this, 22) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.PatientExistsRequest.prototype.toObject = function(t) {
    return proto.api.patient.v1.PatientExistsRequest.toObject(t, this);
  }, proto.api.patient.v1.PatientExistsRequest.toObject = function(t, r) {
    var n, d = {
      appointmentClaim: (n = r.getAppointmentClaim()) && proto.api.patient.v1.AppointmentClaim.toObject(t, n),
      swedishPersonalIdentityNumber: (n = r.getSwedishPersonalIdentityNumber()) && proto.api.patient.v1.SwedishPersonalIdentityNumber.toObject(t, n)
    };
    return t && (d.$jspbMessageInstance = r), d;
  }), proto.api.patient.v1.PatientExistsRequest.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.PatientExistsRequest();
    return proto.api.patient.v1.PatientExistsRequest.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.PatientExistsRequest.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = new proto.api.patient.v1.AppointmentClaim();
          r.readMessage(d, proto.api.patient.v1.AppointmentClaim.deserializeBinaryFromReader), t.setAppointmentClaim(d);
          break;
        case 2:
          var d = new proto.api.patient.v1.SwedishPersonalIdentityNumber();
          r.readMessage(d, proto.api.patient.v1.SwedishPersonalIdentityNumber.deserializeBinaryFromReader), t.setSwedishPersonalIdentityNumber(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.PatientExistsRequest.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.PatientExistsRequest.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.PatientExistsRequest.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getAppointmentClaim(), n != null && r.writeMessage(
      1,
      n,
      proto.api.patient.v1.AppointmentClaim.serializeBinaryToWriter
    ), n = t.getSwedishPersonalIdentityNumber(), n != null && r.writeMessage(
      2,
      n,
      proto.api.patient.v1.SwedishPersonalIdentityNumber.serializeBinaryToWriter
    );
  }, proto.api.patient.v1.PatientExistsRequest.prototype.getAppointmentClaim = function() {
    return (
      /** @type{?proto.api.patient.v1.AppointmentClaim} */
      e.Message.getWrapperField(this, proto.api.patient.v1.AppointmentClaim, 1)
    );
  }, proto.api.patient.v1.PatientExistsRequest.prototype.setAppointmentClaim = function(t) {
    return e.Message.setWrapperField(this, 1, t);
  }, proto.api.patient.v1.PatientExistsRequest.prototype.clearAppointmentClaim = function() {
    return this.setAppointmentClaim(void 0);
  }, proto.api.patient.v1.PatientExistsRequest.prototype.hasAppointmentClaim = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.v1.PatientExistsRequest.prototype.getSwedishPersonalIdentityNumber = function() {
    return (
      /** @type{?proto.api.patient.v1.SwedishPersonalIdentityNumber} */
      e.Message.getWrapperField(this, proto.api.patient.v1.SwedishPersonalIdentityNumber, 2)
    );
  }, proto.api.patient.v1.PatientExistsRequest.prototype.setSwedishPersonalIdentityNumber = function(t) {
    return e.Message.setWrapperField(this, 2, t);
  }, proto.api.patient.v1.PatientExistsRequest.prototype.clearSwedishPersonalIdentityNumber = function() {
    return this.setSwedishPersonalIdentityNumber(void 0);
  }, proto.api.patient.v1.PatientExistsRequest.prototype.hasSwedishPersonalIdentityNumber = function() {
    return e.Message.getField(this, 2) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.PatientExistsResponse.prototype.toObject = function(t) {
    return proto.api.patient.v1.PatientExistsResponse.toObject(t, this);
  }, proto.api.patient.v1.PatientExistsResponse.toObject = function(t, r) {
    var n = {
      exists: e.Message.getBooleanFieldWithDefault(r, 1, !1)
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.PatientExistsResponse.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.PatientExistsResponse();
    return proto.api.patient.v1.PatientExistsResponse.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.PatientExistsResponse.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {boolean} */
            r.readBool()
          );
          t.setExists(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.PatientExistsResponse.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.PatientExistsResponse.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.PatientExistsResponse.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getExists(), n && r.writeBool(
      1,
      n
    );
  }, proto.api.patient.v1.PatientExistsResponse.prototype.getExists = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.api.patient.v1.PatientExistsResponse.prototype.setExists = function(t) {
    return e.Message.setProto3BooleanField(this, 1, t);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.v1.ReviewPrompt.prototype.toObject = function(t) {
    return proto.api.patient.v1.ReviewPrompt.toObject(t, this);
  }, proto.api.patient.v1.ReviewPrompt.toObject = function(t, r) {
    var n = {
      type: e.Message.getFieldWithDefault(r, 1, 0),
      url: e.Message.getFieldWithDefault(r, 2, "")
    };
    return t && (n.$jspbMessageInstance = r), n;
  }), proto.api.patient.v1.ReviewPrompt.deserializeBinary = function(t) {
    var r = new e.BinaryReader(t), n = new proto.api.patient.v1.ReviewPrompt();
    return proto.api.patient.v1.ReviewPrompt.deserializeBinaryFromReader(n, r);
  }, proto.api.patient.v1.ReviewPrompt.deserializeBinaryFromReader = function(t, r) {
    for (; r.nextField() && !r.isEndGroup(); ) {
      var n = r.getFieldNumber();
      switch (n) {
        case 1:
          var d = (
            /** @type {!proto.api.patient.v1.ReviewPrompt.Type} */
            r.readEnum()
          );
          t.setType(d);
          break;
        case 2:
          var d = (
            /** @type {string} */
            r.readString()
          );
          t.setUrl(d);
          break;
        default:
          r.skipField();
          break;
      }
    }
    return t;
  }, proto.api.patient.v1.ReviewPrompt.prototype.serializeBinary = function() {
    var t = new e.BinaryWriter();
    return proto.api.patient.v1.ReviewPrompt.serializeBinaryToWriter(this, t), t.getResultBuffer();
  }, proto.api.patient.v1.ReviewPrompt.serializeBinaryToWriter = function(t, r) {
    var n = void 0;
    n = t.getType(), n !== 0 && r.writeEnum(
      1,
      n
    ), n = t.getUrl(), n.length > 0 && r.writeString(
      2,
      n
    );
  }, proto.api.patient.v1.ReviewPrompt.Type = {
    TYPE_UNSPECIFIED: 0,
    TYPE_GOOGLE_REVIEWS: 1,
    TYPE_TRUSTPILOT: 2
  }, proto.api.patient.v1.ReviewPrompt.prototype.getType = function() {
    return (
      /** @type {!proto.api.patient.v1.ReviewPrompt.Type} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.v1.ReviewPrompt.prototype.setType = function(t) {
    return e.Message.setProto3EnumField(this, 1, t);
  }, proto.api.patient.v1.ReviewPrompt.prototype.getUrl = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.v1.ReviewPrompt.prototype.setUrl = function(t) {
    return e.Message.setProto3StringField(this, 2, t);
  }, proto.api.patient.v1.Gender = {
    GENDER_UNSPECIFIED: 0,
    GENDER_MALE: 1,
    GENDER_FEMALE: 2
  }, proto.api.patient.v1.LocationType = {
    LOCATION_TYPE_UNSPECIFIED: 0,
    LOCATION_TYPE_REGION: 1,
    LOCATION_TYPE_DISTRICT: 2,
    LOCATION_TYPE_MUNICIPALITY: 3,
    LOCATION_TYPE_ZIPCITY: 4
  }, proto.api.patient.v1.ClinicSubscriptionType = {
    CLINIC_SUBSCRIPTION_TYPE_UNSPECIFIED: 0,
    CLINIC_SUBSCRIPTION_TYPE_NON_PREMIUM: 1,
    CLINIC_SUBSCRIPTION_TYPE_PREMIUM: 2
  }, proto.api.patient.v1.ClinicOptionType = {
    CLINIC_OPTION_TYPE_UNSPECIFIED: 0,
    CLINIC_OPTION_TYPE_OTHER: 1,
    CLINIC_OPTION_TYPE_PRICE_REDUCTION: 2,
    CLINIC_OPTION_TYPE_PARKING: 3
  }, proto.api.patient.v1.BookingStatus = {
    BOOKING_STATUS_UNSPECIFIED: 0,
    BOOKING_STATUS_PENDING: 1,
    BOOKING_STATUS_COMPLETED: 2,
    BOOKING_STATUS_FAILED: 3
  }, p.object.extend(s, proto.api.patient.v1);
})(D);
const A = {};
A.web = Te;
const E = {};
E.api = {};
E.api.patient = {};
E.api.patient.v1 = D;
E.api.patient.v1.PatientGatewayServiceClient = function(s, e, p) {
  p || (p = {}), p.format = "binary", this.client_ = new A.web.GrpcWebClientBase(p), this.hostname_ = s.replace(/\/+$/, "");
};
E.api.patient.v1.PatientGatewayServicePromiseClient = function(s, e, p) {
  p || (p = {}), p.format = "binary", this.client_ = new A.web.GrpcWebClientBase(p), this.hostname_ = s.replace(/\/+$/, "");
};
const cn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindLocations",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindLocationsRequest,
  E.api.patient.v1.FindLocationsResponse,
  /**
   * @param {!proto.api.patient.v1.FindLocationsRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindLocationsResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findLocations = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindLocations",
    s,
    e || {},
    cn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findLocations = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindLocations",
    s,
    e || {},
    cn
  );
};
const fn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindTreatments",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindTreatmentsRequest,
  E.api.patient.v1.FindTreatmentsResponse,
  /**
   * @param {!proto.api.patient.v1.FindTreatmentsRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindTreatmentsResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findTreatments = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindTreatments",
    s,
    e || {},
    fn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findTreatments = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindTreatments",
    s,
    e || {},
    fn
  );
};
const yn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindClinicsByLocation",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindClinicsByLocationRequest,
  E.api.patient.v1.FindClinicsByLocationResponse,
  /**
   * @param {!proto.api.patient.v1.FindClinicsByLocationRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindClinicsByLocationResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findClinicsByLocation = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindClinicsByLocation",
    s,
    e || {},
    yn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findClinicsByLocation = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindClinicsByLocation",
    s,
    e || {},
    yn
  );
};
const hn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/GetClinic",
  A.web.MethodType.UNARY,
  E.api.patient.v1.GetClinicRequest,
  E.api.patient.v1.GetClinicResponse,
  /**
   * @param {!proto.api.patient.v1.GetClinicRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.GetClinicResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.getClinic = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetClinic",
    s,
    e || {},
    hn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.getClinic = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetClinic",
    s,
    e || {},
    hn
  );
};
const vn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindClinicsByIds",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindClinicsByIdsRequest,
  E.api.patient.v1.FindClinicsByIdsResponse,
  /**
   * @param {!proto.api.patient.v1.FindClinicsByIdsRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindClinicsByIdsResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findClinicsByIds = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindClinicsByIds",
    s,
    e || {},
    vn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findClinicsByIds = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindClinicsByIds",
    s,
    e || {},
    vn
  );
};
const Fn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindAppointmentsPerClinic",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindAppointmentsPerClinicRequest,
  E.api.patient.v1.FindAppointmentsPerClinicResponse,
  /**
   * @param {!proto.api.patient.v1.FindAppointmentsPerClinicRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindAppointmentsPerClinicResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findAppointmentsPerClinic = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindAppointmentsPerClinic",
    s,
    e || {},
    Fn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findAppointmentsPerClinic = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindAppointmentsPerClinic",
    s,
    e || {},
    Fn
  );
};
const Rn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindAppointments",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindAppointmentsRequest,
  E.api.patient.v1.FindAppointmentsResponse,
  /**
   * @param {!proto.api.patient.v1.FindAppointmentsRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindAppointmentsResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findAppointments = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindAppointments",
    s,
    e || {},
    Rn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findAppointments = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindAppointments",
    s,
    e || {},
    Rn
  );
};
const bn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/GetBookingAuthMethod",
  A.web.MethodType.UNARY,
  E.api.patient.v1.GetBookingAuthMethodRequest,
  E.api.patient.v1.GetBookingAuthMethodResponse,
  /**
   * @param {!proto.api.patient.v1.GetBookingAuthMethodRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.GetBookingAuthMethodResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.getBookingAuthMethod = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetBookingAuthMethod",
    s,
    e || {},
    bn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.getBookingAuthMethod = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetBookingAuthMethod",
    s,
    e || {},
    bn
  );
};
const Bn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/GetBookingFlowType",
  A.web.MethodType.UNARY,
  E.api.patient.v1.GetBookingFlowTypeRequest,
  E.api.patient.v1.GetBookingFlowTypeResponse,
  /**
   * @param {!proto.api.patient.v1.GetBookingFlowTypeRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.GetBookingFlowTypeResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.getBookingFlowType = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetBookingFlowType",
    s,
    e || {},
    Bn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.getBookingFlowType = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetBookingFlowType",
    s,
    e || {},
    Bn
  );
};
const Mn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/CreateBooking",
  A.web.MethodType.UNARY,
  E.api.patient.v1.CreateBookingRequest,
  E.api.patient.v1.CreateBookingResponse,
  /**
   * @param {!proto.api.patient.v1.CreateBookingRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.CreateBookingResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.createBooking = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CreateBooking",
    s,
    e || {},
    Mn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.createBooking = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CreateBooking",
    s,
    e || {},
    Mn
  );
};
const Cn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/ProceedBooking",
  A.web.MethodType.UNARY,
  E.api.patient.v1.ProceedBookingRequest,
  E.api.patient.v1.ProceedBookingResponse,
  /**
   * @param {!proto.api.patient.v1.ProceedBookingRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.ProceedBookingResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.proceedBooking = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/ProceedBooking",
    s,
    e || {},
    Cn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.proceedBooking = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/ProceedBooking",
    s,
    e || {},
    Cn
  );
};
const Tn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/GetBookingStatus",
  A.web.MethodType.UNARY,
  E.api.patient.v1.GetBookingStatusRequest,
  E.api.patient.v1.GetBookingStatusResponse,
  /**
   * @param {!proto.api.patient.v1.GetBookingStatusRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.GetBookingStatusResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.getBookingStatus = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetBookingStatus",
    s,
    e || {},
    Tn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.getBookingStatus = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetBookingStatus",
    s,
    e || {},
    Tn
  );
};
const mn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/CreateBookingInquiry",
  A.web.MethodType.UNARY,
  E.api.patient.v1.CreateBookingInquiryRequest,
  E.api.patient.v1.CreateBookingInquiryResponse,
  /**
   * @param {!proto.api.patient.v1.CreateBookingInquiryRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.CreateBookingInquiryResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.createBookingInquiry = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CreateBookingInquiry",
    s,
    e || {},
    mn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.createBookingInquiry = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CreateBookingInquiry",
    s,
    e || {},
    mn
  );
};
const wn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/CancelBooking",
  A.web.MethodType.UNARY,
  E.api.patient.v1.CancelBookingRequest,
  E.api.patient.v1.CancelBookingResponse,
  /**
   * @param {!proto.api.patient.v1.CancelBookingRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.CancelBookingResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.cancelBooking = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CancelBooking",
    s,
    e || {},
    wn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.cancelBooking = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CancelBooking",
    s,
    e || {},
    wn
  );
};
const En = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindMyExternalBookings",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindMyExternalBookingsRequest,
  E.api.patient.v1.FindMyExternalBookingsResponse,
  /**
   * @param {!proto.api.patient.v1.FindMyExternalBookingsRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindMyExternalBookingsResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findMyExternalBookings = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindMyExternalBookings",
    s,
    e || {},
    En,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findMyExternalBookings = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindMyExternalBookings",
    s,
    e || {},
    En
  );
};
const Pn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindReviewsForClinic",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindReviewsForClinicRequest,
  E.api.patient.v1.FindReviewsForClinicResponse,
  /**
   * @param {!proto.api.patient.v1.FindReviewsForClinicRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindReviewsForClinicResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findReviewsForClinic = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindReviewsForClinic",
    s,
    e || {},
    Pn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findReviewsForClinic = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindReviewsForClinic",
    s,
    e || {},
    Pn
  );
};
const Sn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/GetReviewsScoreForClinic",
  A.web.MethodType.UNARY,
  E.api.patient.v1.GetReviewsScoreForClinicRequest,
  E.api.patient.v1.GetReviewsScoreForClinicResponse,
  /**
   * @param {!proto.api.patient.v1.GetReviewsScoreForClinicRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.GetReviewsScoreForClinicResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.getReviewsScoreForClinic = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetReviewsScoreForClinic",
    s,
    e || {},
    Sn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.getReviewsScoreForClinic = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetReviewsScoreForClinic",
    s,
    e || {},
    Sn
  );
};
const On = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/CreateReviewForClinic",
  A.web.MethodType.UNARY,
  E.api.patient.v1.CreateReviewForClinicRequest,
  E.api.patient.v1.CreateReviewForClinicResponse,
  /**
   * @param {!proto.api.patient.v1.CreateReviewForClinicRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.CreateReviewForClinicResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.createReviewForClinic = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CreateReviewForClinic",
    s,
    e || {},
    On,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.createReviewForClinic = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/CreateReviewForClinic",
    s,
    e || {},
    On
  );
};
const kn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/GetReviewRequestInfo",
  A.web.MethodType.UNARY,
  E.api.patient.v1.GetReviewRequestInfoRequest,
  E.api.patient.v1.GetReviewRequestInfoResponse,
  /**
   * @param {!proto.api.patient.v1.GetReviewRequestInfoRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.GetReviewRequestInfoResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.getReviewRequestInfo = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetReviewRequestInfo",
    s,
    e || {},
    kn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.getReviewRequestInfo = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/GetReviewRequestInfo",
    s,
    e || {},
    kn
  );
};
const Dn = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/LookupPatient",
  A.web.MethodType.UNARY,
  E.api.patient.v1.LookupPatientRequest,
  E.api.patient.v1.LookupPatientResponse,
  /**
   * @param {!proto.api.patient.v1.LookupPatientRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.LookupPatientResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.lookupPatient = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/LookupPatient",
    s,
    e || {},
    Dn,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.lookupPatient = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/LookupPatient",
    s,
    e || {},
    Dn
  );
};
const In = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/FindAvailableTreatmentIdsPerClinic",
  A.web.MethodType.UNARY,
  E.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest,
  E.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse,
  /**
   * @param {!proto.api.patient.v1.FindAvailableTreatmentIdsPerClinicRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.FindAvailableTreatmentIdsPerClinicResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.findAvailableTreatmentIdsPerClinic = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindAvailableTreatmentIdsPerClinic",
    s,
    e || {},
    In,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.findAvailableTreatmentIdsPerClinic = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/FindAvailableTreatmentIdsPerClinic",
    s,
    e || {},
    In
  );
};
const $n = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/ValidatePromoCode",
  A.web.MethodType.UNARY,
  E.api.patient.v1.ValidatePromoCodeRequest,
  E.api.patient.v1.ValidatePromoCodeResponse,
  /**
   * @param {!proto.api.patient.v1.ValidatePromoCodeRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.ValidatePromoCodeResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.validatePromoCode = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/ValidatePromoCode",
    s,
    e || {},
    $n,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.validatePromoCode = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/ValidatePromoCode",
    s,
    e || {},
    $n
  );
};
const Ln = new A.web.MethodDescriptor(
  "/api.patient.v1.PatientGatewayService/PatientExists",
  A.web.MethodType.UNARY,
  E.api.patient.v1.PatientExistsRequest,
  E.api.patient.v1.PatientExistsResponse,
  /**
   * @param {!proto.api.patient.v1.PatientExistsRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  E.api.patient.v1.PatientExistsResponse.deserializeBinary
);
E.api.patient.v1.PatientGatewayServiceClient.prototype.patientExists = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/PatientExists",
    s,
    e || {},
    Ln,
    p
  );
};
E.api.patient.v1.PatientGatewayServicePromiseClient.prototype.patientExists = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.v1.PatientGatewayService/PatientExists",
    s,
    e || {},
    Ln
  );
};
var op = E.api.patient.v1;
let To, mo, Wn, zn;
const ip = (s, e, p, c) => {
  To = s, mo = e, Wn = p, zn = c;
}, Y = () => {
  if (!To || !mo)
    throw new Error("API not initialized.");
  return {
    patientApiClient: To,
    widgetApiClient: mo,
    restrictedApiClient: Wn,
    grpcMetadata: zn
  };
};
var H = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = he;
  p.object.extend(proto, o);
  var a = ri;
  p.object.extend(proto, a), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.Screen", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.Theme", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.Theme.Colors", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.Theme.Image", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.Theme.Image.Type", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.Theme.Preset", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.TreatmentGroup", null, c), p.exportSymbol("proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment", null, c), proto.api.patient.widget.v1.BookingConfig = function(i) {
    e.Message.initialize(this, i, 0, -1, proto.api.patient.widget.v1.BookingConfig.repeatedFields_, null);
  }, p.inherits(proto.api.patient.widget.v1.BookingConfig, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.BookingConfig.displayName = "proto.api.patient.widget.v1.BookingConfig"), proto.api.patient.widget.v1.BookingConfig.TreatmentGroup = function(i) {
    e.Message.initialize(this, i, 0, -1, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.repeatedFields_, null);
  }, p.inherits(proto.api.patient.widget.v1.BookingConfig.TreatmentGroup, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.displayName = "proto.api.patient.widget.v1.BookingConfig.TreatmentGroup"), proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment = function(i) {
    e.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.displayName = "proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment"), proto.api.patient.widget.v1.BookingConfig.Theme = function(i) {
    e.Message.initialize(this, i, 0, -1, proto.api.patient.widget.v1.BookingConfig.Theme.repeatedFields_, null);
  }, p.inherits(proto.api.patient.widget.v1.BookingConfig.Theme, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.BookingConfig.Theme.displayName = "proto.api.patient.widget.v1.BookingConfig.Theme"), proto.api.patient.widget.v1.BookingConfig.Theme.Image = function(i) {
    e.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.api.patient.widget.v1.BookingConfig.Theme.Image, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.BookingConfig.Theme.Image.displayName = "proto.api.patient.widget.v1.BookingConfig.Theme.Image"), proto.api.patient.widget.v1.BookingConfig.Theme.Colors = function(i) {
    e.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.api.patient.widget.v1.BookingConfig.Theme.Colors, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.BookingConfig.Theme.Colors.displayName = "proto.api.patient.widget.v1.BookingConfig.Theme.Colors"), proto.api.patient.widget.v1.BookingConfig.repeatedFields_ = [1, 2], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.BookingConfig.prototype.toObject = function(i) {
    return proto.api.patient.widget.v1.BookingConfig.toObject(i, this);
  }, proto.api.patient.widget.v1.BookingConfig.toObject = function(i, u) {
    var y, h = {
      clinicIdsList: (y = e.Message.getRepeatedField(u, 1)) == null ? void 0 : y,
      treatmentGroupsList: e.Message.toObjectList(
        u.getTreatmentGroupsList(),
        proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.toObject,
        i
      ),
      initialScreen: e.Message.getFieldWithDefault(u, 3, 0),
      language: (y = u.getLanguage()) && o.StringValue.toObject(i, y),
      customerServicePhone: (y = u.getCustomerServicePhone()) && a.PhoneNumber.toObject(i, y),
      theme: (y = u.getTheme()) && proto.api.patient.widget.v1.BookingConfig.Theme.toObject(i, y),
      privacyPolicyUrl: (y = u.getPrivacyPolicyUrl()) && o.StringValue.toObject(i, y),
      featuresMap: (y = u.getFeaturesMap()) ? y.toObject(i, void 0) : []
    };
    return i && (h.$jspbMessageInstance = u), h;
  }), proto.api.patient.widget.v1.BookingConfig.deserializeBinary = function(i) {
    var u = new e.BinaryReader(i), y = new proto.api.patient.widget.v1.BookingConfig();
    return proto.api.patient.widget.v1.BookingConfig.deserializeBinaryFromReader(y, u);
  }, proto.api.patient.widget.v1.BookingConfig.deserializeBinaryFromReader = function(i, u) {
    for (; u.nextField() && !u.isEndGroup(); ) {
      var y = u.getFieldNumber();
      switch (y) {
        case 1:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.addClinicIds(h);
          break;
        case 2:
          var h = new proto.api.patient.widget.v1.BookingConfig.TreatmentGroup();
          u.readMessage(h, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.deserializeBinaryFromReader), i.addTreatmentGroups(h);
          break;
        case 3:
          var h = (
            /** @type {!proto.api.patient.widget.v1.BookingConfig.Screen} */
            u.readEnum()
          );
          i.setInitialScreen(h);
          break;
        case 4:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setLanguage(h);
          break;
        case 5:
          var h = new a.PhoneNumber();
          u.readMessage(h, a.PhoneNumber.deserializeBinaryFromReader), i.setCustomerServicePhone(h);
          break;
        case 6:
          var h = new proto.api.patient.widget.v1.BookingConfig.Theme();
          u.readMessage(h, proto.api.patient.widget.v1.BookingConfig.Theme.deserializeBinaryFromReader), i.setTheme(h);
          break;
        case 7:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setPrivacyPolicyUrl(h);
          break;
        case 8:
          var h = i.getFeaturesMap();
          u.readMessage(h, function(B, C) {
            e.Map.deserializeBinary(B, C, e.BinaryReader.prototype.readString, e.BinaryReader.prototype.readBool, null, "", !1);
          });
          break;
        default:
          u.skipField();
          break;
      }
    }
    return i;
  }, proto.api.patient.widget.v1.BookingConfig.prototype.serializeBinary = function() {
    var i = new e.BinaryWriter();
    return proto.api.patient.widget.v1.BookingConfig.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.api.patient.widget.v1.BookingConfig.serializeBinaryToWriter = function(i, u) {
    var y = void 0;
    y = i.getClinicIdsList(), y.length > 0 && u.writeRepeatedString(
      1,
      y
    ), y = i.getTreatmentGroupsList(), y.length > 0 && u.writeRepeatedMessage(
      2,
      y,
      proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.serializeBinaryToWriter
    ), y = i.getInitialScreen(), y !== 0 && u.writeEnum(
      3,
      y
    ), y = i.getLanguage(), y != null && u.writeMessage(
      4,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCustomerServicePhone(), y != null && u.writeMessage(
      5,
      y,
      a.PhoneNumber.serializeBinaryToWriter
    ), y = i.getTheme(), y != null && u.writeMessage(
      6,
      y,
      proto.api.patient.widget.v1.BookingConfig.Theme.serializeBinaryToWriter
    ), y = i.getPrivacyPolicyUrl(), y != null && u.writeMessage(
      7,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getFeaturesMap(!0), y && y.getLength() > 0 && y.serializeBinary(8, u, e.BinaryWriter.prototype.writeString, e.BinaryWriter.prototype.writeBool);
  }, proto.api.patient.widget.v1.BookingConfig.Screen = {
    SCREEN_UNSPECIFIED: 0,
    SCREEN_START: 1,
    SCREEN_TREATMENT: 2,
    SCREEN_CITY: 3,
    SCREEN_CLINIC: 4,
    SCREEN_APPOINTMENT: 5,
    SCREEN_BOOKING_SUMMARY: 6,
    SCREEN_BOOKING_CONTACT: 7,
    SCREEN_CONTACT_INFORMATION: 8,
    SCREEN_BOOKING_CONFIRMATION: 9,
    SCREEN_MY_BOOKINGS: 10,
    SCREEN_YOUR_BOOKINGS: 11,
    SCREEN_BOOKING_DETAILS: 12,
    SCREEN_TREATMENT_SELECTION: 13
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.repeatedFields_ = [3, 5], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.toObject = function(i) {
    return proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.toObject(i, this);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.toObject = function(i, u) {
    var y, h = {
      name: e.Message.getFieldWithDefault(u, 1, ""),
      description: e.Message.getFieldWithDefault(u, 2, ""),
      treatmentIdsList: (y = e.Message.getRepeatedField(u, 3)) == null ? void 0 : y,
      extendedDescription: (y = u.getExtendedDescription()) && o.StringValue.toObject(i, y),
      treatmentsList: e.Message.toObjectList(
        u.getTreatmentsList(),
        proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.toObject,
        i
      )
    };
    return i && (h.$jspbMessageInstance = u), h;
  }), proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.deserializeBinary = function(i) {
    var u = new e.BinaryReader(i), y = new proto.api.patient.widget.v1.BookingConfig.TreatmentGroup();
    return proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.deserializeBinaryFromReader(y, u);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.deserializeBinaryFromReader = function(i, u) {
    for (; u.nextField() && !u.isEndGroup(); ) {
      var y = u.getFieldNumber();
      switch (y) {
        case 1:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.setName(h);
          break;
        case 2:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.setDescription(h);
          break;
        case 3:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.addTreatmentIds(h);
          break;
        case 4:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setExtendedDescription(h);
          break;
        case 5:
          var h = new proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment();
          u.readMessage(h, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.deserializeBinaryFromReader), i.addTreatments(h);
          break;
        default:
          u.skipField();
          break;
      }
    }
    return i;
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.serializeBinary = function() {
    var i = new e.BinaryWriter();
    return proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.serializeBinaryToWriter = function(i, u) {
    var y = void 0;
    y = i.getName(), y.length > 0 && u.writeString(
      1,
      y
    ), y = i.getDescription(), y.length > 0 && u.writeString(
      2,
      y
    ), y = i.getTreatmentIdsList(), y.length > 0 && u.writeRepeatedString(
      3,
      y
    ), y = i.getExtendedDescription(), y != null && u.writeMessage(
      4,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getTreatmentsList(), y.length > 0 && u.writeRepeatedMessage(
      5,
      y,
      proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.toObject = function(i) {
    return proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.toObject(i, this);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.toObject = function(i, u) {
    var y, h = {
      id: e.Message.getFieldWithDefault(u, 1, ""),
      name: (y = u.getName()) && o.StringValue.toObject(i, y),
      description: (y = u.getDescription()) && o.StringValue.toObject(i, y),
      extendedDescription: (y = u.getExtendedDescription()) && o.StringValue.toObject(i, y)
    };
    return i && (h.$jspbMessageInstance = u), h;
  }), proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.deserializeBinary = function(i) {
    var u = new e.BinaryReader(i), y = new proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment();
    return proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.deserializeBinaryFromReader(y, u);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.deserializeBinaryFromReader = function(i, u) {
    for (; u.nextField() && !u.isEndGroup(); ) {
      var y = u.getFieldNumber();
      switch (y) {
        case 1:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.setId(h);
          break;
        case 2:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setName(h);
          break;
        case 3:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setDescription(h);
          break;
        case 4:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setExtendedDescription(h);
          break;
        default:
          u.skipField();
          break;
      }
    }
    return i;
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.serializeBinary = function() {
    var i = new e.BinaryWriter();
    return proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.serializeBinaryToWriter = function(i, u) {
    var y = void 0;
    y = i.getId(), y.length > 0 && u.writeString(
      1,
      y
    ), y = i.getName(), y != null && u.writeMessage(
      2,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getDescription(), y != null && u.writeMessage(
      3,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getExtendedDescription(), y != null && u.writeMessage(
      4,
      y,
      o.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.setId = function(i) {
    return e.Message.setProto3StringField(this, 1, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.getName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 2)
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.setName = function(i) {
    return e.Message.setWrapperField(this, 2, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.clearName = function() {
    return this.setName(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.hasName = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.getDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 3)
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.setDescription = function(i) {
    return e.Message.setWrapperField(this, 3, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.hasDescription = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.getExtendedDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 4)
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.setExtendedDescription = function(i) {
    return e.Message.setWrapperField(this, 4, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.clearExtendedDescription = function() {
    return this.setExtendedDescription(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment.prototype.hasExtendedDescription = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.getName = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.setName = function(i) {
    return e.Message.setProto3StringField(this, 1, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.getDescription = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.setDescription = function(i) {
    return e.Message.setProto3StringField(this, 2, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.getTreatmentIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 3)
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.setTreatmentIdsList = function(i) {
    return e.Message.setField(this, 3, i || []);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.addTreatmentIds = function(i, u) {
    return e.Message.addToRepeatedField(this, 3, i, u);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.clearTreatmentIdsList = function() {
    return this.setTreatmentIdsList([]);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.getExtendedDescription = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 4)
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.setExtendedDescription = function(i) {
    return e.Message.setWrapperField(this, 4, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.clearExtendedDescription = function() {
    return this.setExtendedDescription(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.hasExtendedDescription = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.getTreatmentsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment, 5)
    );
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.setTreatmentsList = function(i) {
    return e.Message.setRepeatedWrapperField(this, 5, i);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.addTreatments = function(i, u) {
    return e.Message.addToRepeatedWrapperField(this, 5, i, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.Treatment, u);
  }, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup.prototype.clearTreatmentsList = function() {
    return this.setTreatmentsList([]);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.repeatedFields_ = [2, 4], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.BookingConfig.Theme.prototype.toObject = function(i) {
    return proto.api.patient.widget.v1.BookingConfig.Theme.toObject(i, this);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.toObject = function(i, u) {
    var y, h = {
      preset: e.Message.getFieldWithDefault(u, 1, 0),
      imagesList: e.Message.toObjectList(
        u.getImagesList(),
        proto.api.patient.widget.v1.BookingConfig.Theme.Image.toObject,
        i
      ),
      jumbotronTitle: (y = u.getJumbotronTitle()) && o.StringValue.toObject(i, y),
      jumbotronBulletsList: (y = e.Message.getRepeatedField(u, 4)) == null ? void 0 : y,
      colors: (y = u.getColors()) && proto.api.patient.widget.v1.BookingConfig.Theme.Colors.toObject(i, y)
    };
    return i && (h.$jspbMessageInstance = u), h;
  }), proto.api.patient.widget.v1.BookingConfig.Theme.deserializeBinary = function(i) {
    var u = new e.BinaryReader(i), y = new proto.api.patient.widget.v1.BookingConfig.Theme();
    return proto.api.patient.widget.v1.BookingConfig.Theme.deserializeBinaryFromReader(y, u);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.deserializeBinaryFromReader = function(i, u) {
    for (; u.nextField() && !u.isEndGroup(); ) {
      var y = u.getFieldNumber();
      switch (y) {
        case 1:
          var h = (
            /** @type {!proto.api.patient.widget.v1.BookingConfig.Theme.Preset} */
            u.readEnum()
          );
          i.setPreset(h);
          break;
        case 2:
          var h = new proto.api.patient.widget.v1.BookingConfig.Theme.Image();
          u.readMessage(h, proto.api.patient.widget.v1.BookingConfig.Theme.Image.deserializeBinaryFromReader), i.addImages(h);
          break;
        case 3:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setJumbotronTitle(h);
          break;
        case 4:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.addJumbotronBullets(h);
          break;
        case 5:
          var h = new proto.api.patient.widget.v1.BookingConfig.Theme.Colors();
          u.readMessage(h, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.deserializeBinaryFromReader), i.setColors(h);
          break;
        default:
          u.skipField();
          break;
      }
    }
    return i;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.serializeBinary = function() {
    var i = new e.BinaryWriter();
    return proto.api.patient.widget.v1.BookingConfig.Theme.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.api.patient.widget.v1.BookingConfig.Theme.serializeBinaryToWriter = function(i, u) {
    var y = void 0;
    y = i.getPreset(), y !== 0 && u.writeEnum(
      1,
      y
    ), y = i.getImagesList(), y.length > 0 && u.writeRepeatedMessage(
      2,
      y,
      proto.api.patient.widget.v1.BookingConfig.Theme.Image.serializeBinaryToWriter
    ), y = i.getJumbotronTitle(), y != null && u.writeMessage(
      3,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getJumbotronBulletsList(), y.length > 0 && u.writeRepeatedString(
      4,
      y
    ), y = i.getColors(), y != null && u.writeMessage(
      5,
      y,
      proto.api.patient.widget.v1.BookingConfig.Theme.Colors.serializeBinaryToWriter
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Preset = {
    PRESET_UNSPECIFIED: 0,
    PRESET_DEFAULT: 1,
    PRESET_ARISTOTLE: 2,
    PRESET_DIPLOMAT: 3
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.BookingConfig.Theme.Image.prototype.toObject = function(i) {
    return proto.api.patient.widget.v1.BookingConfig.Theme.Image.toObject(i, this);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.toObject = function(i, u) {
    var y = {
      type: e.Message.getFieldWithDefault(u, 1, 0),
      src: e.Message.getFieldWithDefault(u, 2, "")
    };
    return i && (y.$jspbMessageInstance = u), y;
  }), proto.api.patient.widget.v1.BookingConfig.Theme.Image.deserializeBinary = function(i) {
    var u = new e.BinaryReader(i), y = new proto.api.patient.widget.v1.BookingConfig.Theme.Image();
    return proto.api.patient.widget.v1.BookingConfig.Theme.Image.deserializeBinaryFromReader(y, u);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.deserializeBinaryFromReader = function(i, u) {
    for (; u.nextField() && !u.isEndGroup(); ) {
      var y = u.getFieldNumber();
      switch (y) {
        case 1:
          var h = (
            /** @type {!proto.api.patient.widget.v1.BookingConfig.Theme.Image.Type} */
            u.readEnum()
          );
          i.setType(h);
          break;
        case 2:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.setSrc(h);
          break;
        default:
          u.skipField();
          break;
      }
    }
    return i;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.prototype.serializeBinary = function() {
    var i = new e.BinaryWriter();
    return proto.api.patient.widget.v1.BookingConfig.Theme.Image.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.serializeBinaryToWriter = function(i, u) {
    var y = void 0;
    y = i.getType(), y !== 0 && u.writeEnum(
      1,
      y
    ), y = i.getSrc(), y.length > 0 && u.writeString(
      2,
      y
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.Type = {
    TYPE_UNSPECIFIED: 0,
    TYPE_LOGO: 1,
    TYPE_JUMBOTRON: 2
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.prototype.getType = function() {
    return (
      /** @type {!proto.api.patient.widget.v1.BookingConfig.Theme.Image.Type} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.prototype.setType = function(i) {
    return e.Message.setProto3EnumField(this, 1, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.prototype.getSrc = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Image.prototype.setSrc = function(i) {
    return e.Message.setProto3StringField(this, 2, i);
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.toObject = function(i) {
    return proto.api.patient.widget.v1.BookingConfig.Theme.Colors.toObject(i, this);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.toObject = function(i, u) {
    var y, h = {
      scrollbarThumb: (y = u.getScrollbarThumb()) && o.StringValue.toObject(i, y),
      scrollbarTrack: (y = u.getScrollbarTrack()) && o.StringValue.toObject(i, y),
      progressBarActive: (y = u.getProgressBarActive()) && o.StringValue.toObject(i, y),
      progressBarInactive: (y = u.getProgressBarInactive()) && o.StringValue.toObject(i, y),
      progressBarText: (y = u.getProgressBarText()) && o.StringValue.toObject(i, y),
      groupDivider: (y = u.getGroupDivider()) && o.StringValue.toObject(i, y),
      background: (y = u.getBackground()) && o.StringValue.toObject(i, y),
      jumbotronTitle: (y = u.getJumbotronTitle()) && o.StringValue.toObject(i, y),
      jumbotronText: (y = u.getJumbotronText()) && o.StringValue.toObject(i, y),
      screenTitle: (y = u.getScreenTitle()) && o.StringValue.toObject(i, y),
      screenSubtitle: (y = u.getScreenSubtitle()) && o.StringValue.toObject(i, y),
      cardBackground: (y = u.getCardBackground()) && o.StringValue.toObject(i, y),
      cardTitle: (y = u.getCardTitle()) && o.StringValue.toObject(i, y),
      cardText: (y = u.getCardText()) && o.StringValue.toObject(i, y),
      buttonBackground: (y = u.getButtonBackground()) && o.StringValue.toObject(i, y),
      buttonText: (y = u.getButtonText()) && o.StringValue.toObject(i, y),
      filterButtonText: (y = u.getFilterButtonText()) && o.StringValue.toObject(i, y),
      notFoundBackground: (y = u.getNotFoundBackground()) && o.StringValue.toObject(i, y),
      notFoundText: (y = u.getNotFoundText()) && o.StringValue.toObject(i, y),
      progressBarLabel: (y = u.getProgressBarLabel()) && o.StringValue.toObject(i, y),
      calendarCellText: (y = u.getCalendarCellText()) && o.StringValue.toObject(i, y),
      calendarActiveBackground: (y = u.getCalendarActiveBackground()) && o.StringValue.toObject(i, y),
      calendarActiveText: (y = u.getCalendarActiveText()) && o.StringValue.toObject(i, y)
    };
    return i && (h.$jspbMessageInstance = u), h;
  }), proto.api.patient.widget.v1.BookingConfig.Theme.Colors.deserializeBinary = function(i) {
    var u = new e.BinaryReader(i), y = new proto.api.patient.widget.v1.BookingConfig.Theme.Colors();
    return proto.api.patient.widget.v1.BookingConfig.Theme.Colors.deserializeBinaryFromReader(y, u);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.deserializeBinaryFromReader = function(i, u) {
    for (; u.nextField() && !u.isEndGroup(); ) {
      var y = u.getFieldNumber();
      switch (y) {
        case 1:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setScrollbarThumb(h);
          break;
        case 2:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setScrollbarTrack(h);
          break;
        case 3:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setProgressBarActive(h);
          break;
        case 4:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setProgressBarInactive(h);
          break;
        case 5:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setProgressBarText(h);
          break;
        case 6:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setGroupDivider(h);
          break;
        case 7:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setBackground(h);
          break;
        case 8:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setJumbotronTitle(h);
          break;
        case 9:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setJumbotronText(h);
          break;
        case 10:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setScreenTitle(h);
          break;
        case 11:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setScreenSubtitle(h);
          break;
        case 12:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setCardBackground(h);
          break;
        case 13:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setCardTitle(h);
          break;
        case 14:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setCardText(h);
          break;
        case 15:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setButtonBackground(h);
          break;
        case 16:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setButtonText(h);
          break;
        case 17:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setFilterButtonText(h);
          break;
        case 18:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setNotFoundBackground(h);
          break;
        case 19:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setNotFoundText(h);
          break;
        case 20:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setProgressBarLabel(h);
          break;
        case 21:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setCalendarCellText(h);
          break;
        case 22:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setCalendarActiveBackground(h);
          break;
        case 23:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setCalendarActiveText(h);
          break;
        default:
          u.skipField();
          break;
      }
    }
    return i;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.serializeBinary = function() {
    var i = new e.BinaryWriter();
    return proto.api.patient.widget.v1.BookingConfig.Theme.Colors.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.serializeBinaryToWriter = function(i, u) {
    var y = void 0;
    y = i.getScrollbarThumb(), y != null && u.writeMessage(
      1,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getScrollbarTrack(), y != null && u.writeMessage(
      2,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getProgressBarActive(), y != null && u.writeMessage(
      3,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getProgressBarInactive(), y != null && u.writeMessage(
      4,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getProgressBarText(), y != null && u.writeMessage(
      5,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getGroupDivider(), y != null && u.writeMessage(
      6,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getBackground(), y != null && u.writeMessage(
      7,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getJumbotronTitle(), y != null && u.writeMessage(
      8,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getJumbotronText(), y != null && u.writeMessage(
      9,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getScreenTitle(), y != null && u.writeMessage(
      10,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getScreenSubtitle(), y != null && u.writeMessage(
      11,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCardBackground(), y != null && u.writeMessage(
      12,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCardTitle(), y != null && u.writeMessage(
      13,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCardText(), y != null && u.writeMessage(
      14,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getButtonBackground(), y != null && u.writeMessage(
      15,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getButtonText(), y != null && u.writeMessage(
      16,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getFilterButtonText(), y != null && u.writeMessage(
      17,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getNotFoundBackground(), y != null && u.writeMessage(
      18,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getNotFoundText(), y != null && u.writeMessage(
      19,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getProgressBarLabel(), y != null && u.writeMessage(
      20,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCalendarCellText(), y != null && u.writeMessage(
      21,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCalendarActiveBackground(), y != null && u.writeMessage(
      22,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCalendarActiveText(), y != null && u.writeMessage(
      23,
      y,
      o.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getScrollbarThumb = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 1)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setScrollbarThumb = function(i) {
    return e.Message.setWrapperField(this, 1, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearScrollbarThumb = function() {
    return this.setScrollbarThumb(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasScrollbarThumb = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getScrollbarTrack = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 2)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setScrollbarTrack = function(i) {
    return e.Message.setWrapperField(this, 2, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearScrollbarTrack = function() {
    return this.setScrollbarTrack(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasScrollbarTrack = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getProgressBarActive = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 3)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setProgressBarActive = function(i) {
    return e.Message.setWrapperField(this, 3, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearProgressBarActive = function() {
    return this.setProgressBarActive(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasProgressBarActive = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getProgressBarInactive = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 4)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setProgressBarInactive = function(i) {
    return e.Message.setWrapperField(this, 4, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearProgressBarInactive = function() {
    return this.setProgressBarInactive(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasProgressBarInactive = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getProgressBarText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 5)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setProgressBarText = function(i) {
    return e.Message.setWrapperField(this, 5, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearProgressBarText = function() {
    return this.setProgressBarText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasProgressBarText = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getGroupDivider = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 6)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setGroupDivider = function(i) {
    return e.Message.setWrapperField(this, 6, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearGroupDivider = function() {
    return this.setGroupDivider(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasGroupDivider = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getBackground = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 7)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setBackground = function(i) {
    return e.Message.setWrapperField(this, 7, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearBackground = function() {
    return this.setBackground(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasBackground = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getJumbotronTitle = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 8)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setJumbotronTitle = function(i) {
    return e.Message.setWrapperField(this, 8, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearJumbotronTitle = function() {
    return this.setJumbotronTitle(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasJumbotronTitle = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getJumbotronText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 9)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setJumbotronText = function(i) {
    return e.Message.setWrapperField(this, 9, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearJumbotronText = function() {
    return this.setJumbotronText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasJumbotronText = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getScreenTitle = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 10)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setScreenTitle = function(i) {
    return e.Message.setWrapperField(this, 10, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearScreenTitle = function() {
    return this.setScreenTitle(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasScreenTitle = function() {
    return e.Message.getField(this, 10) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getScreenSubtitle = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 11)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setScreenSubtitle = function(i) {
    return e.Message.setWrapperField(this, 11, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearScreenSubtitle = function() {
    return this.setScreenSubtitle(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasScreenSubtitle = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getCardBackground = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 12)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setCardBackground = function(i) {
    return e.Message.setWrapperField(this, 12, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearCardBackground = function() {
    return this.setCardBackground(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasCardBackground = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getCardTitle = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 13)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setCardTitle = function(i) {
    return e.Message.setWrapperField(this, 13, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearCardTitle = function() {
    return this.setCardTitle(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasCardTitle = function() {
    return e.Message.getField(this, 13) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getCardText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 14)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setCardText = function(i) {
    return e.Message.setWrapperField(this, 14, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearCardText = function() {
    return this.setCardText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasCardText = function() {
    return e.Message.getField(this, 14) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getButtonBackground = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 15)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setButtonBackground = function(i) {
    return e.Message.setWrapperField(this, 15, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearButtonBackground = function() {
    return this.setButtonBackground(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasButtonBackground = function() {
    return e.Message.getField(this, 15) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getButtonText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 16)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setButtonText = function(i) {
    return e.Message.setWrapperField(this, 16, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearButtonText = function() {
    return this.setButtonText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasButtonText = function() {
    return e.Message.getField(this, 16) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getFilterButtonText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 17)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setFilterButtonText = function(i) {
    return e.Message.setWrapperField(this, 17, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearFilterButtonText = function() {
    return this.setFilterButtonText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasFilterButtonText = function() {
    return e.Message.getField(this, 17) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getNotFoundBackground = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 18)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setNotFoundBackground = function(i) {
    return e.Message.setWrapperField(this, 18, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearNotFoundBackground = function() {
    return this.setNotFoundBackground(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasNotFoundBackground = function() {
    return e.Message.getField(this, 18) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getNotFoundText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 19)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setNotFoundText = function(i) {
    return e.Message.setWrapperField(this, 19, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearNotFoundText = function() {
    return this.setNotFoundText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasNotFoundText = function() {
    return e.Message.getField(this, 19) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getProgressBarLabel = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 20)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setProgressBarLabel = function(i) {
    return e.Message.setWrapperField(this, 20, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearProgressBarLabel = function() {
    return this.setProgressBarLabel(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasProgressBarLabel = function() {
    return e.Message.getField(this, 20) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getCalendarCellText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 21)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setCalendarCellText = function(i) {
    return e.Message.setWrapperField(this, 21, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearCalendarCellText = function() {
    return this.setCalendarCellText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasCalendarCellText = function() {
    return e.Message.getField(this, 21) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getCalendarActiveBackground = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 22)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setCalendarActiveBackground = function(i) {
    return e.Message.setWrapperField(this, 22, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearCalendarActiveBackground = function() {
    return this.setCalendarActiveBackground(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasCalendarActiveBackground = function() {
    return e.Message.getField(this, 22) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.getCalendarActiveText = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 23)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.setCalendarActiveText = function(i) {
    return e.Message.setWrapperField(this, 23, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.clearCalendarActiveText = function() {
    return this.setCalendarActiveText(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.Colors.prototype.hasCalendarActiveText = function() {
    return e.Message.getField(this, 23) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.getPreset = function() {
    return (
      /** @type {!proto.api.patient.widget.v1.BookingConfig.Theme.Preset} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.setPreset = function(i) {
    return e.Message.setProto3EnumField(this, 1, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.getImagesList = function() {
    return (
      /** @type{!Array<!proto.api.patient.widget.v1.BookingConfig.Theme.Image>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.widget.v1.BookingConfig.Theme.Image, 2)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.setImagesList = function(i) {
    return e.Message.setRepeatedWrapperField(this, 2, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.addImages = function(i, u) {
    return e.Message.addToRepeatedWrapperField(this, 2, i, proto.api.patient.widget.v1.BookingConfig.Theme.Image, u);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.clearImagesList = function() {
    return this.setImagesList([]);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.getJumbotronTitle = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 3)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.setJumbotronTitle = function(i) {
    return e.Message.setWrapperField(this, 3, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.clearJumbotronTitle = function() {
    return this.setJumbotronTitle(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.hasJumbotronTitle = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.getJumbotronBulletsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 4)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.setJumbotronBulletsList = function(i) {
    return e.Message.setField(this, 4, i || []);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.addJumbotronBullets = function(i, u) {
    return e.Message.addToRepeatedField(this, 4, i, u);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.clearJumbotronBulletsList = function() {
    return this.setJumbotronBulletsList([]);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.getColors = function() {
    return (
      /** @type{?proto.api.patient.widget.v1.BookingConfig.Theme.Colors} */
      e.Message.getWrapperField(this, proto.api.patient.widget.v1.BookingConfig.Theme.Colors, 5)
    );
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.setColors = function(i) {
    return e.Message.setWrapperField(this, 5, i);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.clearColors = function() {
    return this.setColors(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.Theme.prototype.hasColors = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.setClinicIdsList = function(i) {
    return e.Message.setField(this, 1, i || []);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.addClinicIds = function(i, u) {
    return e.Message.addToRepeatedField(this, 1, i, u);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getTreatmentGroupsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.widget.v1.BookingConfig.TreatmentGroup>} */
      e.Message.getRepeatedWrapperField(this, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup, 2)
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.setTreatmentGroupsList = function(i) {
    return e.Message.setRepeatedWrapperField(this, 2, i);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.addTreatmentGroups = function(i, u) {
    return e.Message.addToRepeatedWrapperField(this, 2, i, proto.api.patient.widget.v1.BookingConfig.TreatmentGroup, u);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.clearTreatmentGroupsList = function() {
    return this.setTreatmentGroupsList([]);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getInitialScreen = function() {
    return (
      /** @type {!proto.api.patient.widget.v1.BookingConfig.Screen} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.setInitialScreen = function(i) {
    return e.Message.setProto3EnumField(this, 3, i);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getLanguage = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 4)
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.setLanguage = function(i) {
    return e.Message.setWrapperField(this, 4, i);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.clearLanguage = function() {
    return this.setLanguage(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.hasLanguage = function() {
    return e.Message.getField(this, 4) != null;
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getCustomerServicePhone = function() {
    return (
      /** @type{?proto.google.type.PhoneNumber} */
      e.Message.getWrapperField(this, a.PhoneNumber, 5)
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.setCustomerServicePhone = function(i) {
    return e.Message.setWrapperField(this, 5, i);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.clearCustomerServicePhone = function() {
    return this.setCustomerServicePhone(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.hasCustomerServicePhone = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getTheme = function() {
    return (
      /** @type{?proto.api.patient.widget.v1.BookingConfig.Theme} */
      e.Message.getWrapperField(this, proto.api.patient.widget.v1.BookingConfig.Theme, 6)
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.setTheme = function(i) {
    return e.Message.setWrapperField(this, 6, i);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.clearTheme = function() {
    return this.setTheme(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.hasTheme = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getPrivacyPolicyUrl = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 7)
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.setPrivacyPolicyUrl = function(i) {
    return e.Message.setWrapperField(this, 7, i);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.clearPrivacyPolicyUrl = function() {
    return this.setPrivacyPolicyUrl(void 0);
  }, proto.api.patient.widget.v1.BookingConfig.prototype.hasPrivacyPolicyUrl = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.widget.v1.BookingConfig.prototype.getFeaturesMap = function(i) {
    return (
      /** @type {!jspb.Map<string,boolean>} */
      e.Message.getMapField(
        this,
        8,
        i,
        null
      )
    );
  }, proto.api.patient.widget.v1.BookingConfig.prototype.clearFeaturesMap = function() {
    return this.getFeaturesMap().clear(), this;
  }, p.object.extend(s, proto.api.patient.widget.v1);
})(H);
var Nn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.api.patient.widget.v1.ReviewCollectorConfig", null, c), proto.api.patient.widget.v1.ReviewCollectorConfig = function(o) {
    e.Message.initialize(this, o, 0, -1, proto.api.patient.widget.v1.ReviewCollectorConfig.repeatedFields_, null);
  }, p.inherits(proto.api.patient.widget.v1.ReviewCollectorConfig, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.ReviewCollectorConfig.displayName = "proto.api.patient.widget.v1.ReviewCollectorConfig"), proto.api.patient.widget.v1.ReviewCollectorConfig.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.ReviewCollectorConfig.prototype.toObject = function(o) {
    return proto.api.patient.widget.v1.ReviewCollectorConfig.toObject(o, this);
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.toObject = function(o, a) {
    var i, u = {
      clinicIdsList: (i = e.Message.getRepeatedField(a, 1)) == null ? void 0 : i
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.api.patient.widget.v1.ReviewCollectorConfig.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.api.patient.widget.v1.ReviewCollectorConfig();
    return proto.api.patient.widget.v1.ReviewCollectorConfig.deserializeBinaryFromReader(i, a);
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.addClinicIds(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.api.patient.widget.v1.ReviewCollectorConfig.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getClinicIdsList(), i.length > 0 && a.writeRepeatedString(
      1,
      i
    );
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.prototype.setClinicIdsList = function(o) {
    return e.Message.setField(this, 1, o || []);
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.prototype.addClinicIds = function(o, a) {
    return e.Message.addToRepeatedField(this, 1, o, a);
  }, proto.api.patient.widget.v1.ReviewCollectorConfig.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, p.object.extend(s, proto.api.patient.widget.v1);
})(Nn);
var ni = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = H;
  p.object.extend(proto, o);
  var a = Nn;
  p.object.extend(proto, a);
  var i = Ut;
  p.object.extend(proto, i), p.exportSymbol("proto.api.patient.widget.v1.GetConfigRequest", null, c), p.exportSymbol("proto.api.patient.widget.v1.GetConfigResponse", null, c), p.exportSymbol("proto.api.patient.widget.v1.GetConfigResponse.ConfigCase", null, c), proto.api.patient.widget.v1.GetConfigRequest = function(u) {
    e.Message.initialize(this, u, 0, -1, null, null);
  }, p.inherits(proto.api.patient.widget.v1.GetConfigRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.GetConfigRequest.displayName = "proto.api.patient.widget.v1.GetConfigRequest"), proto.api.patient.widget.v1.GetConfigResponse = function(u) {
    e.Message.initialize(this, u, 0, -1, null, proto.api.patient.widget.v1.GetConfigResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.widget.v1.GetConfigResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.widget.v1.GetConfigResponse.displayName = "proto.api.patient.widget.v1.GetConfigResponse"), e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.GetConfigRequest.prototype.toObject = function(u) {
    return proto.api.patient.widget.v1.GetConfigRequest.toObject(u, this);
  }, proto.api.patient.widget.v1.GetConfigRequest.toObject = function(u, y) {
    var h = {};
    return u && (h.$jspbMessageInstance = y), h;
  }), proto.api.patient.widget.v1.GetConfigRequest.deserializeBinary = function(u) {
    var y = new e.BinaryReader(u), h = new proto.api.patient.widget.v1.GetConfigRequest();
    return proto.api.patient.widget.v1.GetConfigRequest.deserializeBinaryFromReader(h, y);
  }, proto.api.patient.widget.v1.GetConfigRequest.deserializeBinaryFromReader = function(u, y) {
    for (; y.nextField() && !y.isEndGroup(); ) {
      var h = y.getFieldNumber();
      switch (h) {
        default:
          y.skipField();
          break;
      }
    }
    return u;
  }, proto.api.patient.widget.v1.GetConfigRequest.prototype.serializeBinary = function() {
    var u = new e.BinaryWriter();
    return proto.api.patient.widget.v1.GetConfigRequest.serializeBinaryToWriter(this, u), u.getResultBuffer();
  }, proto.api.patient.widget.v1.GetConfigRequest.serializeBinaryToWriter = function(u, y) {
  }, proto.api.patient.widget.v1.GetConfigResponse.oneofGroups_ = [[1, 2]], proto.api.patient.widget.v1.GetConfigResponse.ConfigCase = {
    CONFIG_NOT_SET: 0,
    BOOKING_CONFIG: 1,
    REVIEW_COLLECTOR_CONFIG: 2
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.getConfigCase = function() {
    return (
      /** @type {proto.api.patient.widget.v1.GetConfigResponse.ConfigCase} */
      e.Message.computeOneofCase(this, proto.api.patient.widget.v1.GetConfigResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.widget.v1.GetConfigResponse.prototype.toObject = function(u) {
    return proto.api.patient.widget.v1.GetConfigResponse.toObject(u, this);
  }, proto.api.patient.widget.v1.GetConfigResponse.toObject = function(u, y) {
    var h, B = {
      bookingConfig: (h = y.getBookingConfig()) && o.BookingConfig.toObject(u, h),
      reviewCollectorConfig: (h = y.getReviewCollectorConfig()) && a.ReviewCollectorConfig.toObject(u, h)
    };
    return u && (B.$jspbMessageInstance = y), B;
  }), proto.api.patient.widget.v1.GetConfigResponse.deserializeBinary = function(u) {
    var y = new e.BinaryReader(u), h = new proto.api.patient.widget.v1.GetConfigResponse();
    return proto.api.patient.widget.v1.GetConfigResponse.deserializeBinaryFromReader(h, y);
  }, proto.api.patient.widget.v1.GetConfigResponse.deserializeBinaryFromReader = function(u, y) {
    for (; y.nextField() && !y.isEndGroup(); ) {
      var h = y.getFieldNumber();
      switch (h) {
        case 1:
          var B = new o.BookingConfig();
          y.readMessage(B, o.BookingConfig.deserializeBinaryFromReader), u.setBookingConfig(B);
          break;
        case 2:
          var B = new a.ReviewCollectorConfig();
          y.readMessage(B, a.ReviewCollectorConfig.deserializeBinaryFromReader), u.setReviewCollectorConfig(B);
          break;
        default:
          y.skipField();
          break;
      }
    }
    return u;
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.serializeBinary = function() {
    var u = new e.BinaryWriter();
    return proto.api.patient.widget.v1.GetConfigResponse.serializeBinaryToWriter(this, u), u.getResultBuffer();
  }, proto.api.patient.widget.v1.GetConfigResponse.serializeBinaryToWriter = function(u, y) {
    var h = void 0;
    h = u.getBookingConfig(), h != null && y.writeMessage(
      1,
      h,
      o.BookingConfig.serializeBinaryToWriter
    ), h = u.getReviewCollectorConfig(), h != null && y.writeMessage(
      2,
      h,
      a.ReviewCollectorConfig.serializeBinaryToWriter
    );
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.getBookingConfig = function() {
    return (
      /** @type{?proto.api.patient.widget.v1.BookingConfig} */
      e.Message.getWrapperField(this, o.BookingConfig, 1)
    );
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.setBookingConfig = function(u) {
    return e.Message.setOneofWrapperField(this, 1, proto.api.patient.widget.v1.GetConfigResponse.oneofGroups_[0], u);
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.clearBookingConfig = function() {
    return this.setBookingConfig(void 0);
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.hasBookingConfig = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.getReviewCollectorConfig = function() {
    return (
      /** @type{?proto.api.patient.widget.v1.ReviewCollectorConfig} */
      e.Message.getWrapperField(this, a.ReviewCollectorConfig, 2)
    );
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.setReviewCollectorConfig = function(u) {
    return e.Message.setOneofWrapperField(this, 2, proto.api.patient.widget.v1.GetConfigResponse.oneofGroups_[0], u);
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.clearReviewCollectorConfig = function() {
    return this.setReviewCollectorConfig(void 0);
  }, proto.api.patient.widget.v1.GetConfigResponse.prototype.hasReviewCollectorConfig = function() {
    return e.Message.getField(this, 2) != null;
  }, p.object.extend(s, proto.api.patient.widget.v1);
})(ni);
const ut = {};
ut.web = Te;
const pe = {};
pe.api = {};
pe.api.patient = {};
pe.api.patient.widget = {};
pe.api.patient.widget.v1 = ni;
pe.api.patient.widget.v1.WidgetGatewayServiceClient = function(s, e, p) {
  p || (p = {}), p.format = "binary", this.client_ = new ut.web.GrpcWebClientBase(p), this.hostname_ = s.replace(/\/+$/, "");
};
pe.api.patient.widget.v1.WidgetGatewayServicePromiseClient = function(s, e, p) {
  p || (p = {}), p.format = "binary", this.client_ = new ut.web.GrpcWebClientBase(p), this.hostname_ = s.replace(/\/+$/, "");
};
const An = new ut.web.MethodDescriptor(
  "/api.patient.widget.v1.WidgetGatewayService/GetConfig",
  ut.web.MethodType.UNARY,
  pe.api.patient.widget.v1.GetConfigRequest,
  pe.api.patient.widget.v1.GetConfigResponse,
  /**
   * @param {!proto.api.patient.widget.v1.GetConfigRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  pe.api.patient.widget.v1.GetConfigResponse.deserializeBinary
);
pe.api.patient.widget.v1.WidgetGatewayServiceClient.prototype.getConfig = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.widget.v1.WidgetGatewayService/GetConfig",
    s,
    e || {},
    An,
    p
  );
};
pe.api.patient.widget.v1.WidgetGatewayServicePromiseClient.prototype.getConfig = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.widget.v1.WidgetGatewayService/GetConfig",
    s,
    e || {},
    An
  );
};
var rp = pe.api.patient.widget.v1, xn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = he;
  p.object.extend(proto, o);
  var a = oi;
  p.object.extend(proto, a), p.exportSymbol("proto.api.patient.restricted.v1.ExternalBooking", null, c), proto.api.patient.restricted.v1.ExternalBooking = function(i) {
    e.Message.initialize(this, i, 0, -1, null, null);
  }, p.inherits(proto.api.patient.restricted.v1.ExternalBooking, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.restricted.v1.ExternalBooking.displayName = "proto.api.patient.restricted.v1.ExternalBooking"), e.Message.GENERATE_TO_OBJECT && (proto.api.patient.restricted.v1.ExternalBooking.prototype.toObject = function(i) {
    return proto.api.patient.restricted.v1.ExternalBooking.toObject(i, this);
  }, proto.api.patient.restricted.v1.ExternalBooking.toObject = function(i, u) {
    var y, h = {
      id: e.Message.getFieldWithDefault(u, 1, ""),
      clinicId: e.Message.getFieldWithDefault(u, 2, ""),
      connectionId: e.Message.getFieldWithDefault(u, 3, ""),
      reschedulable: e.Message.getBooleanFieldWithDefault(u, 4, !1),
      startTime: (y = u.getStartTime()) && a.DateTime.toObject(i, y),
      endTime: (y = u.getEndTime()) && a.DateTime.toObject(i, y),
      clinicName: (y = u.getClinicName()) && o.StringValue.toObject(i, y),
      treatmentId: (y = u.getTreatmentId()) && o.StringValue.toObject(i, y),
      treatmentName: (y = u.getTreatmentName()) && o.StringValue.toObject(i, y),
      caregiverName: (y = u.getCaregiverName()) && o.StringValue.toObject(i, y)
    };
    return i && (h.$jspbMessageInstance = u), h;
  }), proto.api.patient.restricted.v1.ExternalBooking.deserializeBinary = function(i) {
    var u = new e.BinaryReader(i), y = new proto.api.patient.restricted.v1.ExternalBooking();
    return proto.api.patient.restricted.v1.ExternalBooking.deserializeBinaryFromReader(y, u);
  }, proto.api.patient.restricted.v1.ExternalBooking.deserializeBinaryFromReader = function(i, u) {
    for (; u.nextField() && !u.isEndGroup(); ) {
      var y = u.getFieldNumber();
      switch (y) {
        case 1:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.setId(h);
          break;
        case 2:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.setClinicId(h);
          break;
        case 3:
          var h = (
            /** @type {string} */
            u.readString()
          );
          i.setConnectionId(h);
          break;
        case 4:
          var h = (
            /** @type {boolean} */
            u.readBool()
          );
          i.setReschedulable(h);
          break;
        case 5:
          var h = new a.DateTime();
          u.readMessage(h, a.DateTime.deserializeBinaryFromReader), i.setStartTime(h);
          break;
        case 6:
          var h = new a.DateTime();
          u.readMessage(h, a.DateTime.deserializeBinaryFromReader), i.setEndTime(h);
          break;
        case 7:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setClinicName(h);
          break;
        case 8:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setTreatmentId(h);
          break;
        case 9:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setTreatmentName(h);
          break;
        case 10:
          var h = new o.StringValue();
          u.readMessage(h, o.StringValue.deserializeBinaryFromReader), i.setCaregiverName(h);
          break;
        default:
          u.skipField();
          break;
      }
    }
    return i;
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.serializeBinary = function() {
    var i = new e.BinaryWriter();
    return proto.api.patient.restricted.v1.ExternalBooking.serializeBinaryToWriter(this, i), i.getResultBuffer();
  }, proto.api.patient.restricted.v1.ExternalBooking.serializeBinaryToWriter = function(i, u) {
    var y = void 0;
    y = i.getId(), y.length > 0 && u.writeString(
      1,
      y
    ), y = i.getClinicId(), y.length > 0 && u.writeString(
      2,
      y
    ), y = i.getConnectionId(), y.length > 0 && u.writeString(
      3,
      y
    ), y = i.getReschedulable(), y && u.writeBool(
      4,
      y
    ), y = i.getStartTime(), y != null && u.writeMessage(
      5,
      y,
      a.DateTime.serializeBinaryToWriter
    ), y = i.getEndTime(), y != null && u.writeMessage(
      6,
      y,
      a.DateTime.serializeBinaryToWriter
    ), y = i.getClinicName(), y != null && u.writeMessage(
      7,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getTreatmentId(), y != null && u.writeMessage(
      8,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getTreatmentName(), y != null && u.writeMessage(
      9,
      y,
      o.StringValue.serializeBinaryToWriter
    ), y = i.getCaregiverName(), y != null && u.writeMessage(
      10,
      y,
      o.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setId = function(i) {
    return e.Message.setProto3StringField(this, 1, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setClinicId = function(i) {
    return e.Message.setProto3StringField(this, 2, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getConnectionId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setConnectionId = function(i) {
    return e.Message.setProto3StringField(this, 3, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getReschedulable = function() {
    return (
      /** @type {boolean} */
      e.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setReschedulable = function(i) {
    return e.Message.setProto3BooleanField(this, 4, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getStartTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, a.DateTime, 5)
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setStartTime = function(i) {
    return e.Message.setWrapperField(this, 5, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.clearStartTime = function() {
    return this.setStartTime(void 0);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.hasStartTime = function() {
    return e.Message.getField(this, 5) != null;
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getEndTime = function() {
    return (
      /** @type{?proto.google.type.DateTime} */
      e.Message.getWrapperField(this, a.DateTime, 6)
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setEndTime = function(i) {
    return e.Message.setWrapperField(this, 6, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.clearEndTime = function() {
    return this.setEndTime(void 0);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.hasEndTime = function() {
    return e.Message.getField(this, 6) != null;
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getClinicName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 7)
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setClinicName = function(i) {
    return e.Message.setWrapperField(this, 7, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.clearClinicName = function() {
    return this.setClinicName(void 0);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.hasClinicName = function() {
    return e.Message.getField(this, 7) != null;
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getTreatmentId = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 8)
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setTreatmentId = function(i) {
    return e.Message.setWrapperField(this, 8, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.clearTreatmentId = function() {
    return this.setTreatmentId(void 0);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.hasTreatmentId = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getTreatmentName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 9)
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setTreatmentName = function(i) {
    return e.Message.setWrapperField(this, 9, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.clearTreatmentName = function() {
    return this.setTreatmentName(void 0);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.hasTreatmentName = function() {
    return e.Message.getField(this, 9) != null;
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.getCaregiverName = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, o.StringValue, 10)
    );
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.setCaregiverName = function(i) {
    return e.Message.setWrapperField(this, 10, i);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.clearCaregiverName = function() {
    return this.setCaregiverName(void 0);
  }, proto.api.patient.restricted.v1.ExternalBooking.prototype.hasCaregiverName = function() {
    return e.Message.getField(this, 10) != null;
  }, p.object.extend(s, proto.api.patient.restricted.v1);
})(xn);
var Ht = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = xn;
  p.object.extend(proto, o);
  var a = ei;
  p.object.extend(proto, a);
  var i = Ut;
  p.object.extend(proto, i);
  var u = he;
  p.object.extend(proto, u);
  var y = ti;
  p.object.extend(proto, y), p.exportSymbol("proto.api.patient.restricted.v1.FindExternalBookingsRequest", null, c), p.exportSymbol("proto.api.patient.restricted.v1.FindExternalBookingsResponse", null, c), p.exportSymbol("proto.api.patient.restricted.v1.RescheduleExternalBookingRequest", null, c), p.exportSymbol("proto.api.patient.restricted.v1.RescheduleExternalBookingResponse", null, c), p.exportSymbol("proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.ResultCase", null, c), p.exportSymbol("proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success", null, c), proto.api.patient.restricted.v1.FindExternalBookingsRequest = function(h) {
    e.Message.initialize(this, h, 0, -1, proto.api.patient.restricted.v1.FindExternalBookingsRequest.repeatedFields_, null);
  }, p.inherits(proto.api.patient.restricted.v1.FindExternalBookingsRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.restricted.v1.FindExternalBookingsRequest.displayName = "proto.api.patient.restricted.v1.FindExternalBookingsRequest"), proto.api.patient.restricted.v1.FindExternalBookingsResponse = function(h) {
    e.Message.initialize(this, h, 0, -1, proto.api.patient.restricted.v1.FindExternalBookingsResponse.repeatedFields_, null);
  }, p.inherits(proto.api.patient.restricted.v1.FindExternalBookingsResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.restricted.v1.FindExternalBookingsResponse.displayName = "proto.api.patient.restricted.v1.FindExternalBookingsResponse"), proto.api.patient.restricted.v1.RescheduleExternalBookingRequest = function(h) {
    e.Message.initialize(this, h, 0, -1, null, null);
  }, p.inherits(proto.api.patient.restricted.v1.RescheduleExternalBookingRequest, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.displayName = "proto.api.patient.restricted.v1.RescheduleExternalBookingRequest"), proto.api.patient.restricted.v1.RescheduleExternalBookingResponse = function(h) {
    e.Message.initialize(this, h, 0, -1, null, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.oneofGroups_);
  }, p.inherits(proto.api.patient.restricted.v1.RescheduleExternalBookingResponse, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.displayName = "proto.api.patient.restricted.v1.RescheduleExternalBookingResponse"), proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success = function(h) {
    e.Message.initialize(this, h, 0, -1, null, null);
  }, p.inherits(proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success, e.Message), p.DEBUG && !COMPILED && (proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.displayName = "proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success"), proto.api.patient.restricted.v1.FindExternalBookingsRequest.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.toObject = function(h) {
    return proto.api.patient.restricted.v1.FindExternalBookingsRequest.toObject(h, this);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.toObject = function(h, B) {
    var C, M = {
      clinicIdsList: (C = e.Message.getRepeatedField(B, 1)) == null ? void 0 : C,
      dateFrom: (C = B.getDateFrom()) && y.Date.toObject(h, C),
      dateTo: (C = B.getDateTo()) && y.Date.toObject(h, C),
      pageToken: (C = B.getPageToken()) && u.StringValue.toObject(h, C),
      pageSize: (C = B.getPageSize()) && u.Int32Value.toObject(h, C)
    };
    return h && (M.$jspbMessageInstance = B), M;
  }), proto.api.patient.restricted.v1.FindExternalBookingsRequest.deserializeBinary = function(h) {
    var B = new e.BinaryReader(h), C = new proto.api.patient.restricted.v1.FindExternalBookingsRequest();
    return proto.api.patient.restricted.v1.FindExternalBookingsRequest.deserializeBinaryFromReader(C, B);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.deserializeBinaryFromReader = function(h, B) {
    for (; B.nextField() && !B.isEndGroup(); ) {
      var C = B.getFieldNumber();
      switch (C) {
        case 1:
          var M = (
            /** @type {string} */
            B.readString()
          );
          h.addClinicIds(M);
          break;
        case 2:
          var M = new y.Date();
          B.readMessage(M, y.Date.deserializeBinaryFromReader), h.setDateFrom(M);
          break;
        case 3:
          var M = new y.Date();
          B.readMessage(M, y.Date.deserializeBinaryFromReader), h.setDateTo(M);
          break;
        case 11:
          var M = new u.StringValue();
          B.readMessage(M, u.StringValue.deserializeBinaryFromReader), h.setPageToken(M);
          break;
        case 12:
          var M = new u.Int32Value();
          B.readMessage(M, u.Int32Value.deserializeBinaryFromReader), h.setPageSize(M);
          break;
        default:
          B.skipField();
          break;
      }
    }
    return h;
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.serializeBinary = function() {
    var h = new e.BinaryWriter();
    return proto.api.patient.restricted.v1.FindExternalBookingsRequest.serializeBinaryToWriter(this, h), h.getResultBuffer();
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.serializeBinaryToWriter = function(h, B) {
    var C = void 0;
    C = h.getClinicIdsList(), C.length > 0 && B.writeRepeatedString(
      1,
      C
    ), C = h.getDateFrom(), C != null && B.writeMessage(
      2,
      C,
      y.Date.serializeBinaryToWriter
    ), C = h.getDateTo(), C != null && B.writeMessage(
      3,
      C,
      y.Date.serializeBinaryToWriter
    ), C = h.getPageToken(), C != null && B.writeMessage(
      11,
      C,
      u.StringValue.serializeBinaryToWriter
    ), C = h.getPageSize(), C != null && B.writeMessage(
      12,
      C,
      u.Int32Value.serializeBinaryToWriter
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.getClinicIdsList = function() {
    return (
      /** @type {!Array<string>} */
      e.Message.getRepeatedField(this, 1)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.setClinicIdsList = function(h) {
    return e.Message.setField(this, 1, h || []);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.addClinicIds = function(h, B) {
    return e.Message.addToRepeatedField(this, 1, h, B);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.clearClinicIdsList = function() {
    return this.setClinicIdsList([]);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.getDateFrom = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, y.Date, 2)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.setDateFrom = function(h) {
    return e.Message.setWrapperField(this, 2, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.clearDateFrom = function() {
    return this.setDateFrom(void 0);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.hasDateFrom = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.getDateTo = function() {
    return (
      /** @type{?proto.google.type.Date} */
      e.Message.getWrapperField(this, y.Date, 3)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.setDateTo = function(h) {
    return e.Message.setWrapperField(this, 3, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.clearDateTo = function() {
    return this.setDateTo(void 0);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.hasDateTo = function() {
    return e.Message.getField(this, 3) != null;
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.getPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, u.StringValue, 11)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.setPageToken = function(h) {
    return e.Message.setWrapperField(this, 11, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.clearPageToken = function() {
    return this.setPageToken(void 0);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.hasPageToken = function() {
    return e.Message.getField(this, 11) != null;
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.getPageSize = function() {
    return (
      /** @type{?proto.google.protobuf.Int32Value} */
      e.Message.getWrapperField(this, u.Int32Value, 12)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.setPageSize = function(h) {
    return e.Message.setWrapperField(this, 12, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.clearPageSize = function() {
    return this.setPageSize(void 0);
  }, proto.api.patient.restricted.v1.FindExternalBookingsRequest.prototype.hasPageSize = function() {
    return e.Message.getField(this, 12) != null;
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.repeatedFields_ = [1], e.Message.GENERATE_TO_OBJECT && (proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.toObject = function(h) {
    return proto.api.patient.restricted.v1.FindExternalBookingsResponse.toObject(h, this);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.toObject = function(h, B) {
    var C, M = {
      externalBookingsList: e.Message.toObjectList(
        B.getExternalBookingsList(),
        o.ExternalBooking.toObject,
        h
      ),
      pageToken: e.Message.getFieldWithDefault(B, 11, ""),
      pageSize: e.Message.getFieldWithDefault(B, 12, 0),
      nextPageToken: (C = B.getNextPageToken()) && u.StringValue.toObject(h, C)
    };
    return h && (M.$jspbMessageInstance = B), M;
  }), proto.api.patient.restricted.v1.FindExternalBookingsResponse.deserializeBinary = function(h) {
    var B = new e.BinaryReader(h), C = new proto.api.patient.restricted.v1.FindExternalBookingsResponse();
    return proto.api.patient.restricted.v1.FindExternalBookingsResponse.deserializeBinaryFromReader(C, B);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.deserializeBinaryFromReader = function(h, B) {
    for (; B.nextField() && !B.isEndGroup(); ) {
      var C = B.getFieldNumber();
      switch (C) {
        case 1:
          var M = new o.ExternalBooking();
          B.readMessage(M, o.ExternalBooking.deserializeBinaryFromReader), h.addExternalBookings(M);
          break;
        case 11:
          var M = (
            /** @type {string} */
            B.readString()
          );
          h.setPageToken(M);
          break;
        case 12:
          var M = (
            /** @type {number} */
            B.readInt32()
          );
          h.setPageSize(M);
          break;
        case 13:
          var M = new u.StringValue();
          B.readMessage(M, u.StringValue.deserializeBinaryFromReader), h.setNextPageToken(M);
          break;
        default:
          B.skipField();
          break;
      }
    }
    return h;
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.serializeBinary = function() {
    var h = new e.BinaryWriter();
    return proto.api.patient.restricted.v1.FindExternalBookingsResponse.serializeBinaryToWriter(this, h), h.getResultBuffer();
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.serializeBinaryToWriter = function(h, B) {
    var C = void 0;
    C = h.getExternalBookingsList(), C.length > 0 && B.writeRepeatedMessage(
      1,
      C,
      o.ExternalBooking.serializeBinaryToWriter
    ), C = h.getPageToken(), C.length > 0 && B.writeString(
      11,
      C
    ), C = h.getPageSize(), C !== 0 && B.writeInt32(
      12,
      C
    ), C = h.getNextPageToken(), C != null && B.writeMessage(
      13,
      C,
      u.StringValue.serializeBinaryToWriter
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.getExternalBookingsList = function() {
    return (
      /** @type{!Array<!proto.api.patient.restricted.v1.ExternalBooking>} */
      e.Message.getRepeatedWrapperField(this, o.ExternalBooking, 1)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.setExternalBookingsList = function(h) {
    return e.Message.setRepeatedWrapperField(this, 1, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.addExternalBookings = function(h, B) {
    return e.Message.addToRepeatedWrapperField(this, 1, h, proto.api.patient.restricted.v1.ExternalBooking, B);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.clearExternalBookingsList = function() {
    return this.setExternalBookingsList([]);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.getPageToken = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.setPageToken = function(h) {
    return e.Message.setProto3StringField(this, 11, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.getPageSize = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 12, 0)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.setPageSize = function(h) {
    return e.Message.setProto3IntField(this, 12, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.getNextPageToken = function() {
    return (
      /** @type{?proto.google.protobuf.StringValue} */
      e.Message.getWrapperField(this, u.StringValue, 13)
    );
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.setNextPageToken = function(h) {
    return e.Message.setWrapperField(this, 13, h);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.clearNextPageToken = function() {
    return this.setNextPageToken(void 0);
  }, proto.api.patient.restricted.v1.FindExternalBookingsResponse.prototype.hasNextPageToken = function() {
    return e.Message.getField(this, 13) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.toObject = function(h) {
    return proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.toObject(h, this);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.toObject = function(h, B) {
    var C = {
      connectionId: e.Message.getFieldWithDefault(B, 1, ""),
      externalBookingId: e.Message.getFieldWithDefault(B, 2, ""),
      clinicId: e.Message.getFieldWithDefault(B, 3, ""),
      appointmentId: e.Message.getFieldWithDefault(B, 4, "")
    };
    return h && (C.$jspbMessageInstance = B), C;
  }), proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.deserializeBinary = function(h) {
    var B = new e.BinaryReader(h), C = new proto.api.patient.restricted.v1.RescheduleExternalBookingRequest();
    return proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.deserializeBinaryFromReader(C, B);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.deserializeBinaryFromReader = function(h, B) {
    for (; B.nextField() && !B.isEndGroup(); ) {
      var C = B.getFieldNumber();
      switch (C) {
        case 1:
          var M = (
            /** @type {string} */
            B.readString()
          );
          h.setConnectionId(M);
          break;
        case 2:
          var M = (
            /** @type {string} */
            B.readString()
          );
          h.setExternalBookingId(M);
          break;
        case 3:
          var M = (
            /** @type {string} */
            B.readString()
          );
          h.setClinicId(M);
          break;
        case 4:
          var M = (
            /** @type {string} */
            B.readString()
          );
          h.setAppointmentId(M);
          break;
        default:
          B.skipField();
          break;
      }
    }
    return h;
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.serializeBinary = function() {
    var h = new e.BinaryWriter();
    return proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.serializeBinaryToWriter(this, h), h.getResultBuffer();
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.serializeBinaryToWriter = function(h, B) {
    var C = void 0;
    C = h.getConnectionId(), C.length > 0 && B.writeString(
      1,
      C
    ), C = h.getExternalBookingId(), C.length > 0 && B.writeString(
      2,
      C
    ), C = h.getClinicId(), C.length > 0 && B.writeString(
      3,
      C
    ), C = h.getAppointmentId(), C.length > 0 && B.writeString(
      4,
      C
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.getConnectionId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.setConnectionId = function(h) {
    return e.Message.setProto3StringField(this, 1, h);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.getExternalBookingId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.setExternalBookingId = function(h) {
    return e.Message.setProto3StringField(this, 2, h);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.getClinicId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.setClinicId = function(h) {
    return e.Message.setProto3StringField(this, 3, h);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.getAppointmentId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingRequest.prototype.setAppointmentId = function(h) {
    return e.Message.setProto3StringField(this, 4, h);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.oneofGroups_ = [[1, 2]], proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    SUCCESS: 1,
    FAILURE: 2
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.ResultCase} */
      e.Message.computeOneofCase(this, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.toObject = function(h) {
    return proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.toObject(h, this);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.toObject = function(h, B) {
    var C, M = {
      success: (C = B.getSuccess()) && proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.toObject(h, C),
      failure: (C = B.getFailure()) && a.RequestFailure.toObject(h, C)
    };
    return h && (M.$jspbMessageInstance = B), M;
  }), proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.deserializeBinary = function(h) {
    var B = new e.BinaryReader(h), C = new proto.api.patient.restricted.v1.RescheduleExternalBookingResponse();
    return proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.deserializeBinaryFromReader(C, B);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.deserializeBinaryFromReader = function(h, B) {
    for (; B.nextField() && !B.isEndGroup(); ) {
      var C = B.getFieldNumber();
      switch (C) {
        case 1:
          var M = new proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success();
          B.readMessage(M, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.deserializeBinaryFromReader), h.setSuccess(M);
          break;
        case 2:
          var M = new a.RequestFailure();
          B.readMessage(M, a.RequestFailure.deserializeBinaryFromReader), h.setFailure(M);
          break;
        default:
          B.skipField();
          break;
      }
    }
    return h;
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.serializeBinary = function() {
    var h = new e.BinaryWriter();
    return proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.serializeBinaryToWriter(this, h), h.getResultBuffer();
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.serializeBinaryToWriter = function(h, B) {
    var C = void 0;
    C = h.getSuccess(), C != null && B.writeMessage(
      1,
      C,
      proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.serializeBinaryToWriter
    ), C = h.getFailure(), C != null && B.writeMessage(
      2,
      C,
      a.RequestFailure.serializeBinaryToWriter
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.prototype.toObject = function(h) {
    return proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.toObject(h, this);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.toObject = function(h, B) {
    var C, M = {
      externalBooking: (C = B.getExternalBooking()) && o.ExternalBooking.toObject(h, C)
    };
    return h && (M.$jspbMessageInstance = B), M;
  }), proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.deserializeBinary = function(h) {
    var B = new e.BinaryReader(h), C = new proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success();
    return proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.deserializeBinaryFromReader(C, B);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.deserializeBinaryFromReader = function(h, B) {
    for (; B.nextField() && !B.isEndGroup(); ) {
      var C = B.getFieldNumber();
      switch (C) {
        case 1:
          var M = new o.ExternalBooking();
          B.readMessage(M, o.ExternalBooking.deserializeBinaryFromReader), h.setExternalBooking(M);
          break;
        default:
          B.skipField();
          break;
      }
    }
    return h;
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.prototype.serializeBinary = function() {
    var h = new e.BinaryWriter();
    return proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.serializeBinaryToWriter(this, h), h.getResultBuffer();
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.serializeBinaryToWriter = function(h, B) {
    var C = void 0;
    C = h.getExternalBooking(), C != null && B.writeMessage(
      1,
      C,
      o.ExternalBooking.serializeBinaryToWriter
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.prototype.getExternalBooking = function() {
    return (
      /** @type{?proto.api.patient.restricted.v1.ExternalBooking} */
      e.Message.getWrapperField(this, o.ExternalBooking, 1)
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.prototype.setExternalBooking = function(h) {
    return e.Message.setWrapperField(this, 1, h);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.prototype.clearExternalBooking = function() {
    return this.setExternalBooking(void 0);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success.prototype.hasExternalBooking = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.getSuccess = function() {
    return (
      /** @type{?proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success} */
      e.Message.getWrapperField(this, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.Success, 1)
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.setSuccess = function(h) {
    return e.Message.setOneofWrapperField(this, 1, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.oneofGroups_[0], h);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.clearSuccess = function() {
    return this.setSuccess(void 0);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.hasSuccess = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.getFailure = function() {
    return (
      /** @type{?proto.api.patient.v1.RequestFailure} */
      e.Message.getWrapperField(this, a.RequestFailure, 2)
    );
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.setFailure = function(h) {
    return e.Message.setOneofWrapperField(this, 2, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.oneofGroups_[0], h);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.clearFailure = function() {
    return this.setFailure(void 0);
  }, proto.api.patient.restricted.v1.RescheduleExternalBookingResponse.prototype.hasFailure = function() {
    return e.Message.getField(this, 2) != null;
  }, p.object.extend(s, proto.api.patient.restricted.v1);
})(Ht);
const $e = {};
$e.web = Te;
const X = {};
X.api = {};
X.api.patient = {};
X.api.patient.restricted = {};
X.api.patient.restricted.v1 = Ht;
X.api.patient.restricted.v1.RestrictedGatewayServiceClient = function(s, e, p) {
  p || (p = {}), p.format = "binary", this.client_ = new $e.web.GrpcWebClientBase(p), this.hostname_ = s.replace(/\/+$/, "");
};
X.api.patient.restricted.v1.RestrictedGatewayServicePromiseClient = function(s, e, p) {
  p || (p = {}), p.format = "binary", this.client_ = new $e.web.GrpcWebClientBase(p), this.hostname_ = s.replace(/\/+$/, "");
};
const Gn = new $e.web.MethodDescriptor(
  "/api.patient.restricted.v1.RestrictedGatewayService/FindExternalBookings",
  $e.web.MethodType.UNARY,
  X.api.patient.restricted.v1.FindExternalBookingsRequest,
  X.api.patient.restricted.v1.FindExternalBookingsResponse,
  /**
   * @param {!proto.api.patient.restricted.v1.FindExternalBookingsRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  X.api.patient.restricted.v1.FindExternalBookingsResponse.deserializeBinary
);
X.api.patient.restricted.v1.RestrictedGatewayServiceClient.prototype.findExternalBookings = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.restricted.v1.RestrictedGatewayService/FindExternalBookings",
    s,
    e || {},
    Gn,
    p
  );
};
X.api.patient.restricted.v1.RestrictedGatewayServicePromiseClient.prototype.findExternalBookings = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.restricted.v1.RestrictedGatewayService/FindExternalBookings",
    s,
    e || {},
    Gn
  );
};
const _n = new $e.web.MethodDescriptor(
  "/api.patient.restricted.v1.RestrictedGatewayService/RescheduleExternalBooking",
  $e.web.MethodType.UNARY,
  X.api.patient.restricted.v1.RescheduleExternalBookingRequest,
  X.api.patient.restricted.v1.RescheduleExternalBookingResponse,
  /**
   * @param {!proto.api.patient.restricted.v1.RescheduleExternalBookingRequest} request
   * @return {!Uint8Array}
   */
  function(s) {
    return s.serializeBinary();
  },
  X.api.patient.restricted.v1.RescheduleExternalBookingResponse.deserializeBinary
);
X.api.patient.restricted.v1.RestrictedGatewayServiceClient.prototype.rescheduleExternalBooking = function(s, e, p) {
  return this.client_.rpcCall(
    this.hostname_ + "/api.patient.restricted.v1.RestrictedGatewayService/RescheduleExternalBooking",
    s,
    e || {},
    _n,
    p
  );
};
X.api.patient.restricted.v1.RestrictedGatewayServicePromiseClient.prototype.rescheduleExternalBooking = function(s, e) {
  return this.client_.unaryCall(
    this.hostname_ + "/api.patient.restricted.v1.RestrictedGatewayService/RescheduleExternalBooking",
    s,
    e || {},
    _n
  );
};
var np = X.api.patient.restricted.v1;
const _l = (s, e, p) => {
  const c = { "api-token": e }, o = new rp.WidgetGatewayServiceClient(
    s,
    null,
    null
  ), a = new op.PatientGatewayServiceClient(
    s,
    null,
    null
  ), i = new np.RestrictedGatewayServiceClient(
    s,
    null,
    null
  );
  return p && (window.__GRPCWEB_DEVTOOLS__ || (() => {
  }))([a, o, i]), ip(a, o, i, c), { widgetApiClient: o, patientApiClient: a, restrictedApiClient: i };
}, se = (s) => {
  const e = new he.StringValue();
  return e.setValue(s), e;
}, Jt = (s) => {
  const e = new he.UInt32Value();
  return e.setValue(s), e;
}, wo = (s) => {
  const e = new he.Int32Value();
  return e.setValue(s), e;
}, Eo = (s) => {
  const e = new he.BoolValue();
  return e.setValue(s), e;
};
var jn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.Money", null, c), proto.google.type.Money = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.Money, e.Message), p.DEBUG && !COMPILED && (proto.google.type.Money.displayName = "proto.google.type.Money"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.Money.prototype.toObject = function(o) {
    return proto.google.type.Money.toObject(o, this);
  }, proto.google.type.Money.toObject = function(o, a) {
    var i = {
      currencyCode: e.Message.getFieldWithDefault(a, 1, ""),
      units: e.Message.getFieldWithDefault(a, 2, 0),
      nanos: e.Message.getFieldWithDefault(a, 3, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.Money.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.Money();
    return proto.google.type.Money.deserializeBinaryFromReader(i, a);
  }, proto.google.type.Money.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setCurrencyCode(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt64()
          );
          o.setUnits(u);
          break;
        case 3:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNanos(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.Money.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.Money.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.Money.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getCurrencyCode(), i.length > 0 && a.writeString(
      1,
      i
    ), i = o.getUnits(), i !== 0 && a.writeInt64(
      2,
      i
    ), i = o.getNanos(), i !== 0 && a.writeInt32(
      3,
      i
    );
  }, proto.google.type.Money.prototype.getCurrencyCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.Money.prototype.setCurrencyCode = function(o) {
    return e.Message.setProto3StringField(this, 1, o);
  }, proto.google.type.Money.prototype.getUnits = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.Money.prototype.setUnits = function(o) {
    return e.Message.setProto3IntField(this, 2, o);
  }, proto.google.type.Money.prototype.getNanos = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.Money.prototype.setNanos = function(o) {
    return e.Message.setProto3IntField(this, 3, o);
  }, p.object.extend(s, proto.google.type);
})(jn);
var qn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.LatLng", null, c), proto.google.type.LatLng = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.LatLng, e.Message), p.DEBUG && !COMPILED && (proto.google.type.LatLng.displayName = "proto.google.type.LatLng"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.LatLng.prototype.toObject = function(o) {
    return proto.google.type.LatLng.toObject(o, this);
  }, proto.google.type.LatLng.toObject = function(o, a) {
    var i = {
      latitude: e.Message.getFloatingPointFieldWithDefault(a, 1, 0),
      longitude: e.Message.getFloatingPointFieldWithDefault(a, 2, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.LatLng.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.LatLng();
    return proto.google.type.LatLng.deserializeBinaryFromReader(i, a);
  }, proto.google.type.LatLng.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readDouble()
          );
          o.setLatitude(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readDouble()
          );
          o.setLongitude(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.LatLng.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.LatLng.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.LatLng.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getLatitude(), i !== 0 && a.writeDouble(
      1,
      i
    ), i = o.getLongitude(), i !== 0 && a.writeDouble(
      2,
      i
    );
  }, proto.google.type.LatLng.prototype.getLatitude = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.LatLng.prototype.setLatitude = function(o) {
    return e.Message.setProto3FloatField(this, 1, o);
  }, proto.google.type.LatLng.prototype.getLongitude = function() {
    return (
      /** @type {number} */
      e.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.LatLng.prototype.setLongitude = function(o) {
    return e.Message.setProto3FloatField(this, 2, o);
  }, p.object.extend(s, proto.google.type);
})(qn);
var ap = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.TimeOfDay", null, c), proto.google.type.TimeOfDay = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.TimeOfDay, e.Message), p.DEBUG && !COMPILED && (proto.google.type.TimeOfDay.displayName = "proto.google.type.TimeOfDay"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.TimeOfDay.prototype.toObject = function(o) {
    return proto.google.type.TimeOfDay.toObject(o, this);
  }, proto.google.type.TimeOfDay.toObject = function(o, a) {
    var i = {
      hours: e.Message.getFieldWithDefault(a, 1, 0),
      minutes: e.Message.getFieldWithDefault(a, 2, 0),
      seconds: e.Message.getFieldWithDefault(a, 3, 0),
      nanos: e.Message.getFieldWithDefault(a, 4, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.TimeOfDay.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.TimeOfDay();
    return proto.google.type.TimeOfDay.deserializeBinaryFromReader(i, a);
  }, proto.google.type.TimeOfDay.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setHours(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setMinutes(u);
          break;
        case 3:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setSeconds(u);
          break;
        case 4:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setNanos(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.TimeOfDay.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.TimeOfDay.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.TimeOfDay.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getHours(), i !== 0 && a.writeInt32(
      1,
      i
    ), i = o.getMinutes(), i !== 0 && a.writeInt32(
      2,
      i
    ), i = o.getSeconds(), i !== 0 && a.writeInt32(
      3,
      i
    ), i = o.getNanos(), i !== 0 && a.writeInt32(
      4,
      i
    );
  }, proto.google.type.TimeOfDay.prototype.getHours = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setHours = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, proto.google.type.TimeOfDay.prototype.getMinutes = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setMinutes = function(o) {
    return e.Message.setProto3IntField(this, 2, o);
  }, proto.google.type.TimeOfDay.prototype.getSeconds = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setSeconds = function(o) {
    return e.Message.setProto3IntField(this, 3, o);
  }, proto.google.type.TimeOfDay.prototype.getNanos = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.type.TimeOfDay.prototype.setNanos = function(o) {
    return e.Message.setProto3IntField(this, 4, o);
  }, p.object.extend(s, proto.google.type);
})(ap);
var pp = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.Date", null, c), proto.google.type.Date = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.Date, e.Message), p.DEBUG && !COMPILED && (proto.google.type.Date.displayName = "proto.google.type.Date"), e.Message.GENERATE_TO_OBJECT && (proto.google.type.Date.prototype.toObject = function(o) {
    return proto.google.type.Date.toObject(o, this);
  }, proto.google.type.Date.toObject = function(o, a) {
    var i = {
      year: e.Message.getFieldWithDefault(a, 1, 0),
      month: e.Message.getFieldWithDefault(a, 2, 0),
      day: e.Message.getFieldWithDefault(a, 3, 0)
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.Date.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.Date();
    return proto.google.type.Date.deserializeBinaryFromReader(i, a);
  }, proto.google.type.Date.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setYear(u);
          break;
        case 2:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setMonth(u);
          break;
        case 3:
          var u = (
            /** @type {number} */
            a.readInt32()
          );
          o.setDay(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.Date.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.Date.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.Date.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getYear(), i !== 0 && a.writeInt32(
      1,
      i
    ), i = o.getMonth(), i !== 0 && a.writeInt32(
      2,
      i
    ), i = o.getDay(), i !== 0 && a.writeInt32(
      3,
      i
    );
  }, proto.google.type.Date.prototype.getYear = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.Date.prototype.setYear = function(o) {
    return e.Message.setProto3IntField(this, 1, o);
  }, proto.google.type.Date.prototype.getMonth = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.Date.prototype.setMonth = function(o) {
    return e.Message.setProto3IntField(this, 2, o);
  }, proto.google.type.Date.prototype.getDay = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.Date.prototype.setDay = function(o) {
    return e.Message.setProto3IntField(this, 3, o);
  }, p.object.extend(s, proto.google.type);
})(pp);
var Po = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")(), o = ii;
  p.object.extend(proto, o), p.exportSymbol("proto.google.type.DateTime", null, c), p.exportSymbol("proto.google.type.DateTime.TimeOffsetCase", null, c), p.exportSymbol("proto.google.type.TimeZone", null, c), proto.google.type.DateTime = function(a) {
    e.Message.initialize(this, a, 0, -1, null, proto.google.type.DateTime.oneofGroups_);
  }, p.inherits(proto.google.type.DateTime, e.Message), p.DEBUG && !COMPILED && (proto.google.type.DateTime.displayName = "proto.google.type.DateTime"), proto.google.type.TimeZone = function(a) {
    e.Message.initialize(this, a, 0, -1, null, null);
  }, p.inherits(proto.google.type.TimeZone, e.Message), p.DEBUG && !COMPILED && (proto.google.type.TimeZone.displayName = "proto.google.type.TimeZone"), proto.google.type.DateTime.oneofGroups_ = [[8, 9]], proto.google.type.DateTime.TimeOffsetCase = {
    TIME_OFFSET_NOT_SET: 0,
    UTC_OFFSET: 8,
    TIME_ZONE: 9
  }, proto.google.type.DateTime.prototype.getTimeOffsetCase = function() {
    return (
      /** @type {proto.google.type.DateTime.TimeOffsetCase} */
      e.Message.computeOneofCase(this, proto.google.type.DateTime.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.DateTime.prototype.toObject = function(a) {
    return proto.google.type.DateTime.toObject(a, this);
  }, proto.google.type.DateTime.toObject = function(a, i) {
    var u, y = {
      year: e.Message.getFieldWithDefault(i, 1, 0),
      month: e.Message.getFieldWithDefault(i, 2, 0),
      day: e.Message.getFieldWithDefault(i, 3, 0),
      hours: e.Message.getFieldWithDefault(i, 4, 0),
      minutes: e.Message.getFieldWithDefault(i, 5, 0),
      seconds: e.Message.getFieldWithDefault(i, 6, 0),
      nanos: e.Message.getFieldWithDefault(i, 7, 0),
      utcOffset: (u = i.getUtcOffset()) && o.Duration.toObject(a, u),
      timeZone: (u = i.getTimeZone()) && proto.google.type.TimeZone.toObject(a, u)
    };
    return a && (y.$jspbMessageInstance = i), y;
  }), proto.google.type.DateTime.deserializeBinary = function(a) {
    var i = new e.BinaryReader(a), u = new proto.google.type.DateTime();
    return proto.google.type.DateTime.deserializeBinaryFromReader(u, i);
  }, proto.google.type.DateTime.deserializeBinaryFromReader = function(a, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var u = i.getFieldNumber();
      switch (u) {
        case 1:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setYear(y);
          break;
        case 2:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setMonth(y);
          break;
        case 3:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setDay(y);
          break;
        case 4:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setHours(y);
          break;
        case 5:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setMinutes(y);
          break;
        case 6:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setSeconds(y);
          break;
        case 7:
          var y = (
            /** @type {number} */
            i.readInt32()
          );
          a.setNanos(y);
          break;
        case 8:
          var y = new o.Duration();
          i.readMessage(y, o.Duration.deserializeBinaryFromReader), a.setUtcOffset(y);
          break;
        case 9:
          var y = new proto.google.type.TimeZone();
          i.readMessage(y, proto.google.type.TimeZone.deserializeBinaryFromReader), a.setTimeZone(y);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return a;
  }, proto.google.type.DateTime.prototype.serializeBinary = function() {
    var a = new e.BinaryWriter();
    return proto.google.type.DateTime.serializeBinaryToWriter(this, a), a.getResultBuffer();
  }, proto.google.type.DateTime.serializeBinaryToWriter = function(a, i) {
    var u = void 0;
    u = a.getYear(), u !== 0 && i.writeInt32(
      1,
      u
    ), u = a.getMonth(), u !== 0 && i.writeInt32(
      2,
      u
    ), u = a.getDay(), u !== 0 && i.writeInt32(
      3,
      u
    ), u = a.getHours(), u !== 0 && i.writeInt32(
      4,
      u
    ), u = a.getMinutes(), u !== 0 && i.writeInt32(
      5,
      u
    ), u = a.getSeconds(), u !== 0 && i.writeInt32(
      6,
      u
    ), u = a.getNanos(), u !== 0 && i.writeInt32(
      7,
      u
    ), u = a.getUtcOffset(), u != null && i.writeMessage(
      8,
      u,
      o.Duration.serializeBinaryToWriter
    ), u = a.getTimeZone(), u != null && i.writeMessage(
      9,
      u,
      proto.google.type.TimeZone.serializeBinaryToWriter
    );
  }, proto.google.type.DateTime.prototype.getYear = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.type.DateTime.prototype.setYear = function(a) {
    return e.Message.setProto3IntField(this, 1, a);
  }, proto.google.type.DateTime.prototype.getMonth = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.type.DateTime.prototype.setMonth = function(a) {
    return e.Message.setProto3IntField(this, 2, a);
  }, proto.google.type.DateTime.prototype.getDay = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.type.DateTime.prototype.setDay = function(a) {
    return e.Message.setProto3IntField(this, 3, a);
  }, proto.google.type.DateTime.prototype.getHours = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.type.DateTime.prototype.setHours = function(a) {
    return e.Message.setProto3IntField(this, 4, a);
  }, proto.google.type.DateTime.prototype.getMinutes = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.google.type.DateTime.prototype.setMinutes = function(a) {
    return e.Message.setProto3IntField(this, 5, a);
  }, proto.google.type.DateTime.prototype.getSeconds = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.google.type.DateTime.prototype.setSeconds = function(a) {
    return e.Message.setProto3IntField(this, 6, a);
  }, proto.google.type.DateTime.prototype.getNanos = function() {
    return (
      /** @type {number} */
      e.Message.getFieldWithDefault(this, 7, 0)
    );
  }, proto.google.type.DateTime.prototype.setNanos = function(a) {
    return e.Message.setProto3IntField(this, 7, a);
  }, proto.google.type.DateTime.prototype.getUtcOffset = function() {
    return (
      /** @type{?proto.google.protobuf.Duration} */
      e.Message.getWrapperField(this, o.Duration, 8)
    );
  }, proto.google.type.DateTime.prototype.setUtcOffset = function(a) {
    return e.Message.setOneofWrapperField(this, 8, proto.google.type.DateTime.oneofGroups_[0], a);
  }, proto.google.type.DateTime.prototype.clearUtcOffset = function() {
    return this.setUtcOffset(void 0);
  }, proto.google.type.DateTime.prototype.hasUtcOffset = function() {
    return e.Message.getField(this, 8) != null;
  }, proto.google.type.DateTime.prototype.getTimeZone = function() {
    return (
      /** @type{?proto.google.type.TimeZone} */
      e.Message.getWrapperField(this, proto.google.type.TimeZone, 9)
    );
  }, proto.google.type.DateTime.prototype.setTimeZone = function(a) {
    return e.Message.setOneofWrapperField(this, 9, proto.google.type.DateTime.oneofGroups_[0], a);
  }, proto.google.type.DateTime.prototype.clearTimeZone = function() {
    return this.setTimeZone(void 0);
  }, proto.google.type.DateTime.prototype.hasTimeZone = function() {
    return e.Message.getField(this, 9) != null;
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.TimeZone.prototype.toObject = function(a) {
    return proto.google.type.TimeZone.toObject(a, this);
  }, proto.google.type.TimeZone.toObject = function(a, i) {
    var u = {
      id: e.Message.getFieldWithDefault(i, 1, ""),
      version: e.Message.getFieldWithDefault(i, 2, "")
    };
    return a && (u.$jspbMessageInstance = i), u;
  }), proto.google.type.TimeZone.deserializeBinary = function(a) {
    var i = new e.BinaryReader(a), u = new proto.google.type.TimeZone();
    return proto.google.type.TimeZone.deserializeBinaryFromReader(u, i);
  }, proto.google.type.TimeZone.deserializeBinaryFromReader = function(a, i) {
    for (; i.nextField() && !i.isEndGroup(); ) {
      var u = i.getFieldNumber();
      switch (u) {
        case 1:
          var y = (
            /** @type {string} */
            i.readString()
          );
          a.setId(y);
          break;
        case 2:
          var y = (
            /** @type {string} */
            i.readString()
          );
          a.setVersion(y);
          break;
        default:
          i.skipField();
          break;
      }
    }
    return a;
  }, proto.google.type.TimeZone.prototype.serializeBinary = function() {
    var a = new e.BinaryWriter();
    return proto.google.type.TimeZone.serializeBinaryToWriter(this, a), a.getResultBuffer();
  }, proto.google.type.TimeZone.serializeBinaryToWriter = function(a, i) {
    var u = void 0;
    u = a.getId(), u.length > 0 && i.writeString(
      1,
      u
    ), u = a.getVersion(), u.length > 0 && i.writeString(
      2,
      u
    );
  }, proto.google.type.TimeZone.prototype.getId = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.TimeZone.prototype.setId = function(a) {
    return e.Message.setProto3StringField(this, 1, a);
  }, proto.google.type.TimeZone.prototype.getVersion = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.type.TimeZone.prototype.setVersion = function(a) {
    return e.Message.setProto3StringField(this, 2, a);
  }, p.object.extend(s, proto.google.type);
})(Po);
var Vn = {};
(function(s) {
  var e = _, p = e, c = typeof globalThis < "u" && globalThis || typeof window < "u" && window || typeof c < "u" && c || typeof self < "u" && self || (function() {
    return this;
  }).call(null) || Function("return this")();
  p.exportSymbol("proto.google.type.PhoneNumber", null, c), p.exportSymbol("proto.google.type.PhoneNumber.KindCase", null, c), p.exportSymbol("proto.google.type.PhoneNumber.ShortCode", null, c), proto.google.type.PhoneNumber = function(o) {
    e.Message.initialize(this, o, 0, -1, null, proto.google.type.PhoneNumber.oneofGroups_);
  }, p.inherits(proto.google.type.PhoneNumber, e.Message), p.DEBUG && !COMPILED && (proto.google.type.PhoneNumber.displayName = "proto.google.type.PhoneNumber"), proto.google.type.PhoneNumber.ShortCode = function(o) {
    e.Message.initialize(this, o, 0, -1, null, null);
  }, p.inherits(proto.google.type.PhoneNumber.ShortCode, e.Message), p.DEBUG && !COMPILED && (proto.google.type.PhoneNumber.ShortCode.displayName = "proto.google.type.PhoneNumber.ShortCode"), proto.google.type.PhoneNumber.oneofGroups_ = [[1, 2]], proto.google.type.PhoneNumber.KindCase = {
    KIND_NOT_SET: 0,
    E164_NUMBER: 1,
    SHORT_CODE: 2
  }, proto.google.type.PhoneNumber.prototype.getKindCase = function() {
    return (
      /** @type {proto.google.type.PhoneNumber.KindCase} */
      e.Message.computeOneofCase(this, proto.google.type.PhoneNumber.oneofGroups_[0])
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.PhoneNumber.prototype.toObject = function(o) {
    return proto.google.type.PhoneNumber.toObject(o, this);
  }, proto.google.type.PhoneNumber.toObject = function(o, a) {
    var i, u = {
      e164Number: e.Message.getFieldWithDefault(a, 1, ""),
      shortCode: (i = a.getShortCode()) && proto.google.type.PhoneNumber.ShortCode.toObject(o, i),
      extension: e.Message.getFieldWithDefault(a, 3, "")
    };
    return o && (u.$jspbMessageInstance = a), u;
  }), proto.google.type.PhoneNumber.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.PhoneNumber();
    return proto.google.type.PhoneNumber.deserializeBinaryFromReader(i, a);
  }, proto.google.type.PhoneNumber.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setE164Number(u);
          break;
        case 2:
          var u = new proto.google.type.PhoneNumber.ShortCode();
          a.readMessage(u, proto.google.type.PhoneNumber.ShortCode.deserializeBinaryFromReader), o.setShortCode(u);
          break;
        case 3:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setExtension$(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.PhoneNumber.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.PhoneNumber.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.PhoneNumber.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = /** @type {string} */
    e.Message.getField(o, 1), i != null && a.writeString(
      1,
      i
    ), i = o.getShortCode(), i != null && a.writeMessage(
      2,
      i,
      proto.google.type.PhoneNumber.ShortCode.serializeBinaryToWriter
    ), i = o.getExtension$(), i.length > 0 && a.writeString(
      3,
      i
    );
  }, e.Message.GENERATE_TO_OBJECT && (proto.google.type.PhoneNumber.ShortCode.prototype.toObject = function(o) {
    return proto.google.type.PhoneNumber.ShortCode.toObject(o, this);
  }, proto.google.type.PhoneNumber.ShortCode.toObject = function(o, a) {
    var i = {
      regionCode: e.Message.getFieldWithDefault(a, 1, ""),
      number: e.Message.getFieldWithDefault(a, 2, "")
    };
    return o && (i.$jspbMessageInstance = a), i;
  }), proto.google.type.PhoneNumber.ShortCode.deserializeBinary = function(o) {
    var a = new e.BinaryReader(o), i = new proto.google.type.PhoneNumber.ShortCode();
    return proto.google.type.PhoneNumber.ShortCode.deserializeBinaryFromReader(i, a);
  }, proto.google.type.PhoneNumber.ShortCode.deserializeBinaryFromReader = function(o, a) {
    for (; a.nextField() && !a.isEndGroup(); ) {
      var i = a.getFieldNumber();
      switch (i) {
        case 1:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setRegionCode(u);
          break;
        case 2:
          var u = (
            /** @type {string} */
            a.readString()
          );
          o.setNumber(u);
          break;
        default:
          a.skipField();
          break;
      }
    }
    return o;
  }, proto.google.type.PhoneNumber.ShortCode.prototype.serializeBinary = function() {
    var o = new e.BinaryWriter();
    return proto.google.type.PhoneNumber.ShortCode.serializeBinaryToWriter(this, o), o.getResultBuffer();
  }, proto.google.type.PhoneNumber.ShortCode.serializeBinaryToWriter = function(o, a) {
    var i = void 0;
    i = o.getRegionCode(), i.length > 0 && a.writeString(
      1,
      i
    ), i = o.getNumber(), i.length > 0 && a.writeString(
      2,
      i
    );
  }, proto.google.type.PhoneNumber.ShortCode.prototype.getRegionCode = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.PhoneNumber.ShortCode.prototype.setRegionCode = function(o) {
    return e.Message.setProto3StringField(this, 1, o);
  }, proto.google.type.PhoneNumber.ShortCode.prototype.getNumber = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.type.PhoneNumber.ShortCode.prototype.setNumber = function(o) {
    return e.Message.setProto3StringField(this, 2, o);
  }, proto.google.type.PhoneNumber.prototype.getE164Number = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.type.PhoneNumber.prototype.setE164Number = function(o) {
    return e.Message.setOneofField(this, 1, proto.google.type.PhoneNumber.oneofGroups_[0], o);
  }, proto.google.type.PhoneNumber.prototype.clearE164Number = function() {
    return e.Message.setOneofField(this, 1, proto.google.type.PhoneNumber.oneofGroups_[0], void 0);
  }, proto.google.type.PhoneNumber.prototype.hasE164Number = function() {
    return e.Message.getField(this, 1) != null;
  }, proto.google.type.PhoneNumber.prototype.getShortCode = function() {
    return (
      /** @type{?proto.google.type.PhoneNumber.ShortCode} */
      e.Message.getWrapperField(this, proto.google.type.PhoneNumber.ShortCode, 2)
    );
  }, proto.google.type.PhoneNumber.prototype.setShortCode = function(o) {
    return e.Message.setOneofWrapperField(this, 2, proto.google.type.PhoneNumber.oneofGroups_[0], o);
  }, proto.google.type.PhoneNumber.prototype.clearShortCode = function() {
    return this.setShortCode(void 0);
  }, proto.google.type.PhoneNumber.prototype.hasShortCode = function() {
    return e.Message.getField(this, 2) != null;
  }, proto.google.type.PhoneNumber.prototype.getExtension$ = function() {
    return (
      /** @type {string} */
      e.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.type.PhoneNumber.prototype.setExtension$ = function(o) {
    return e.Message.setProto3StringField(this, 3, o);
  }, p.object.extend(s, proto.google.type);
})(Vn);
const sp = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function lp(s, e) {
  var p = Array.prototype.slice.call(e);
  return p.push(sp), s.apply(this, p);
}
function nr(s, e) {
  s = s.split("-"), e = e.split("-");
  for (var p = s[0].split("."), c = e[0].split("."), o = 0; o < 3; o++) {
    var a = Number(p[o]), i = Number(c[o]);
    if (a > i)
      return 1;
    if (i > a)
      return -1;
    if (!isNaN(a) && isNaN(i))
      return 1;
    if (isNaN(a) && !isNaN(i))
      return -1;
  }
  return s[1] && e[1] ? s[1] > e[1] ? 1 : s[1] < e[1] ? -1 : 0 : !s[1] && e[1] ? 1 : s[1] && !e[1] ? -1 : 0;
}
var up = {}.constructor;
function qe(s) {
  return s != null && s.constructor === up;
}
function So(s) {
  "@babel/helpers - typeof";
  return So = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, So(s);
}
function Yt(s, e) {
  if (!(s instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ar(s, e) {
  for (var p = 0; p < e.length; p++) {
    var c = e[p];
    c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(s, c.key, c);
  }
}
function Kt(s, e, p) {
  return e && ar(s.prototype, e), p && ar(s, p), Object.defineProperty(s, "prototype", { writable: !1 }), s;
}
var gp = "1.2.0", dp = "1.7.35", pr = " ext. ", cp = /^\d+$/, te = /* @__PURE__ */ function() {
  function s(e) {
    Yt(this, s), Un(e), this.metadata = e, Hn.call(this, e);
  }
  return Kt(s, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(p) {
        return p !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(p) {
      return this.metadata.countries[p];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(p) {
      return this.getCountryMetadata(p) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(p) {
      if (this.getCountryCodesForCallingCode(p))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[p])
          return !0;
      } else {
        var c = this.countryCallingCodes()[p];
        if (c && c.length === 1 && c[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(p) {
      return this.nonGeographic() ? !!this.nonGeographic()[p] : !this.getCountryCodesForCallingCode(p);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(p) {
      return this.selectNumberingPlan(p);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(p, c) {
      if (p && cp.test(p) && (c = p, p = null), p && p !== "001") {
        if (!this.hasCountry(p))
          throw new Error("Unknown country: ".concat(p));
        this.numberingPlan = new sr(this.getCountryMetadata(p), this);
      } else if (c) {
        if (!this.hasCallingCode(c))
          throw new Error("Unknown calling code: ".concat(c));
        this.numberingPlan = new sr(this.getNumberingPlanMetadata(c), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(p) {
      var c = this.countryCallingCodes()[p];
      if (c)
        return c.length === 1 && c[0].length === 3 ? void 0 : c;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(p) {
      var c = this.getCountryCodesForCallingCode(p);
      if (c)
        return c[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(p) {
      var c = this.getCountryCodeForCallingCode(p);
      if (c)
        return this.getCountryMetadata(c);
      if (this.nonGeographic()) {
        var o = this.nonGeographic()[p];
        if (o)
          return o;
      } else {
        var a = this.countryCallingCodes()[p];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(p) {
      return this.numberingPlan.type(p);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(p) {
      return this.selectNumberingPlan(p);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), s;
}(), sr = /* @__PURE__ */ function() {
  function s(e, p) {
    Yt(this, s), this.globalMetadataObject = p, this.metadata = e, Hn.call(this, p.metadata);
  }
  return Kt(s, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(p) {
      return p[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var p = this, c = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return c.map(function(o) {
        return new fp(o, p);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(p) {
      return p[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(p) {
      if (this.hasTypes() && lr(this.types(), p))
        return new hp(lr(this.types(), p), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? pr : this.metadata[13] || pr;
    }
  }]), s;
}(), fp = /* @__PURE__ */ function() {
  function s(e, p) {
    Yt(this, s), this._format = e, this.metadata = p;
  }
  return Kt(s, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !yp.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), s;
}(), yp = /^\(?\$1\)?$/, hp = /* @__PURE__ */ function() {
  function s(e, p) {
    Yt(this, s), this.type = e, this.metadata = p;
  }
  return Kt(s, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), s;
}();
function lr(s, e) {
  switch (e) {
    case "FIXED_LINE":
      return s[0];
    case "MOBILE":
      return s[1];
    case "TOLL_FREE":
      return s[2];
    case "PREMIUM_RATE":
      return s[3];
    case "PERSONAL_NUMBER":
      return s[4];
    case "VOICEMAIL":
      return s[5];
    case "UAN":
      return s[6];
    case "PAGER":
      return s[7];
    case "VOIP":
      return s[8];
    case "SHARED_COST":
      return s[9];
  }
}
function Un(s) {
  if (!s)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!qe(s) || !qe(s.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(qe(s) ? "an object of shape: { " + Object.keys(s).join(", ") + " }" : "a " + vp(s) + ": " + s, "."));
}
var vp = function(e) {
  return So(e);
};
function ai(s, e) {
  if (e = new te(e), e.hasCountry(s))
    return e.country(s).countryCallingCode();
  throw new Error("Unknown country: ".concat(s));
}
function Fp(s, e) {
  return e.countries.hasOwnProperty(s);
}
function Hn(s) {
  var e = s.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? nr(e, gp) === -1 ? this.v2 = !0 : nr(e, dp) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function Rp(s, e) {
  var p = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (p)
    return (p = p.call(s)).next.bind(p);
  if (Array.isArray(s) || (p = bp(s)) || e && s && typeof s.length == "number") {
    p && (s = p);
    var c = 0;
    return function() {
      return c >= s.length ? { done: !0 } : { done: !1, value: s[c++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bp(s, e) {
  if (s) {
    if (typeof s == "string")
      return ur(s, e);
    var p = Object.prototype.toString.call(s).slice(8, -1);
    if (p === "Object" && s.constructor && (p = s.constructor.name), p === "Map" || p === "Set")
      return Array.from(s);
    if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
      return ur(s, e);
  }
}
function ur(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var p = 0, c = new Array(e); p < e; p++)
    c[p] = s[p];
  return c;
}
function Bp(s, e) {
  for (var p = s.slice(), c = Rp(e), o; !(o = c()).done; ) {
    var a = o.value;
    s.indexOf(a) < 0 && p.push(a);
  }
  return p.sort(function(i, u) {
    return i - u;
  });
}
function pi(s, e) {
  return Jn(s, void 0, e);
}
function Jn(s, e, p) {
  var c = p.type(e), o = c && c.possibleLengths() || p.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  if (e === "FIXED_LINE_OR_MOBILE") {
    if (!p.type("FIXED_LINE"))
      return Jn(s, "MOBILE", p);
    var a = p.type("MOBILE");
    a && (o = Bp(o, a.possibleLengths()));
  } else if (e && !c)
    return "INVALID_LENGTH";
  var i = s.length, u = o[0];
  return u === i ? "IS_POSSIBLE" : u > i ? "TOO_SHORT" : o[o.length - 1] < i ? "TOO_LONG" : o.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Mp(s, e, p) {
  if (e === void 0 && (e = {}), p = new te(p), e.v2) {
    if (!s.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    p.selectNumberingPlan(s.countryCallingCode);
  } else {
    if (!s.phone)
      return !1;
    if (s.country) {
      if (!p.hasCountry(s.country))
        throw new Error("Unknown country: ".concat(s.country));
      p.country(s.country);
    } else {
      if (!s.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      p.selectNumberingPlan(s.countryCallingCode);
    }
  }
  if (p.possibleLengths())
    return Yn(s.phone || s.nationalNumber, p);
  if (s.countryCallingCode && p.isNonGeographicCallingCode(s.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Yn(s, e) {
  switch (pi(s, e)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Ce(s, e) {
  return s = s || "", new RegExp("^(?:" + e + ")$").test(s);
}
function Cp(s, e) {
  var p = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (p)
    return (p = p.call(s)).next.bind(p);
  if (Array.isArray(s) || (p = Tp(s)) || e && s && typeof s.length == "number") {
    p && (s = p);
    var c = 0;
    return function() {
      return c >= s.length ? { done: !0 } : { done: !1, value: s[c++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tp(s, e) {
  if (s) {
    if (typeof s == "string")
      return gr(s, e);
    var p = Object.prototype.toString.call(s).slice(8, -1);
    if (p === "Object" && s.constructor && (p = s.constructor.name), p === "Map" || p === "Set")
      return Array.from(s);
    if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
      return gr(s, e);
  }
}
function gr(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var p = 0, c = new Array(e); p < e; p++)
    c[p] = s[p];
  return c;
}
var mp = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function si(s, e, p) {
  if (e = e || {}, !(!s.country && !s.countryCallingCode)) {
    p = new te(p), p.selectNumberingPlan(s.country, s.countryCallingCode);
    var c = e.v2 ? s.nationalNumber : s.phone;
    if (Ce(c, p.nationalNumberPattern())) {
      if (co(c, "FIXED_LINE", p))
        return p.type("MOBILE") && p.type("MOBILE").pattern() === "" || !p.type("MOBILE") || co(c, "MOBILE", p) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = Cp(mp), a; !(a = o()).done; ) {
        var i = a.value;
        if (co(c, i, p))
          return i;
      }
    }
  }
}
function co(s, e, p) {
  return e = p.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(s.length) < 0 ? !1 : Ce(s, e.pattern());
}
function wp(s, e, p) {
  if (e = e || {}, p = new te(p), p.selectNumberingPlan(s.country, s.countryCallingCode), p.hasTypes())
    return si(s, e, p.metadata) !== void 0;
  var c = e.v2 ? s.nationalNumber : s.phone;
  return Ce(c, p.nationalNumberPattern());
}
function Ep(s, e, p) {
  var c = new te(p), o = c.getCountryCodesForCallingCode(s);
  return o ? o.filter(function(a) {
    return Pp(e, a, p);
  }) : [];
}
function Pp(s, e, p) {
  var c = new te(p);
  return c.selectNumberingPlan(e), c.numberingPlan.possibleLengths().indexOf(s.length) >= 0;
}
var li = 2, Sp = 17, Op = 3, ce = "0-9０-９٠-٩۰-۹", kp = "-‐-―−ー－", Dp = "／/", Ip = "．.", $p = "  ­​⁠　", Lp = "()（）［］\\[\\]", Wp = "~⁓∼～", Nt = "".concat(kp).concat(Dp).concat(Ip).concat($p).concat(Lp).concat(Wp), ui = "+＋", zp = new RegExp("([" + ce + "])");
function Np(s, e, p, c) {
  if (e) {
    var o = new te(c);
    o.selectNumberingPlan(e, p);
    var a = new RegExp(o.IDDPrefix());
    if (s.search(a) === 0) {
      s = s.slice(s.match(a)[0].length);
      var i = s.match(zp);
      if (!(i && i[1] != null && i[1].length > 0 && i[1] === "0"))
        return s;
    }
  }
}
function Ap(s, e) {
  if (s && e.numberingPlan.nationalPrefixForParsing()) {
    var p = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), c = p.exec(s);
    if (c) {
      var o, a, i = c.length - 1, u = i > 0 && c[i];
      if (e.nationalPrefixTransformRule() && u)
        o = s.replace(p, e.nationalPrefixTransformRule()), i > 1 && (a = c[1]);
      else {
        var y = c[0];
        o = s.slice(y.length), u && (a = c[1]);
      }
      var h;
      if (u) {
        var B = s.indexOf(c[1]), C = s.slice(0, B);
        C === e.numberingPlan.nationalPrefix() && (h = e.numberingPlan.nationalPrefix());
      } else
        h = c[0];
      return {
        nationalNumber: o,
        nationalPrefix: h,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: s
  };
}
function Oo(s, e) {
  var p = Ap(s, e), c = p.carrierCode, o = p.nationalNumber;
  if (o !== s) {
    if (!xp(s, o, e))
      return {
        nationalNumber: s
      };
    if (e.possibleLengths() && !Gp(o, e))
      return {
        nationalNumber: s
      };
  }
  return {
    nationalNumber: o,
    carrierCode: c
  };
}
function xp(s, e, p) {
  return !(Ce(s, p.nationalNumberPattern()) && !Ce(e, p.nationalNumberPattern()));
}
function Gp(s, e) {
  switch (pi(s, e)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function _p(s, e, p, c) {
  var o = e ? ai(e, c) : p;
  if (s.indexOf(o) === 0) {
    c = new te(c), c.selectNumberingPlan(e, p);
    var a = s.slice(o.length), i = Oo(a, c), u = i.nationalNumber, y = Oo(s, c), h = y.nationalNumber;
    if (!Ce(h, c.nationalNumberPattern()) && Ce(u, c.nationalNumberPattern()) || pi(h, c) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: a
      };
  }
  return {
    number: s
  };
}
function Kn(s, e, p, c) {
  if (!s)
    return {};
  var o;
  if (s[0] !== "+") {
    var a = Np(s, e, p, c);
    if (a && a !== s)
      o = !0, s = "+" + a;
    else {
      if (e || p) {
        var i = _p(s, e, p, c), u = i.countryCallingCode, y = i.number;
        if (u)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: u,
            number: y
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: s
      };
    }
  }
  if (s[1] === "0")
    return {};
  c = new te(c);
  for (var h = 2; h - 1 <= Op && h <= s.length; ) {
    var B = s.slice(1, h);
    if (c.hasCallingCode(B))
      return c.selectNumberingPlan(B), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: B,
        number: s.slice(h)
      };
    h++;
  }
  return {};
}
function jp(s) {
  return s.replace(new RegExp("[".concat(Nt, "]+"), "g"), " ").trim();
}
var qp = /(\$\d)/;
function Vp(s, e, p) {
  var c = p.useInternationalFormat, o = p.withNationalPrefix;
  p.carrierCode, p.metadata;
  var a = s.replace(new RegExp(e.pattern()), c ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && e.nationalPrefixFormattingRule() ? e.format().replace(qp, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return c ? jp(a) : a;
}
var Up = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Hp(s, e, p) {
  var c = new te(p);
  if (c.selectNumberingPlan(s, e), c.defaultIDDPrefix())
    return c.defaultIDDPrefix();
  if (Up.test(c.IDDPrefix()))
    return c.IDDPrefix();
}
var Jp = ";ext=", Ge = function(e) {
  return "([".concat(ce, "]{1,").concat(e, "})");
};
function Zn(s) {
  var e = "20", p = "15", c = "9", o = "6", a = "[  \\t,]*", i = "[:\\.．]?[  \\t,-]*", u = "#?", y = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", h = "(?:[xｘ#＃~～]|int|ｉｎｔ)", B = "[- ]+", C = "[  \\t]*", M = "(?:,{2}|;)", I = Jp + Ge(e), $ = a + y + i + Ge(e) + u, t = a + h + i + Ge(c) + u, r = B + Ge(o) + "#", n = C + M + i + Ge(p) + u, d = C + "(?:,)+" + i + Ge(c) + u;
  return I + "|" + $ + "|" + t + "|" + r + "|" + n + "|" + d;
}
var Yp = "[" + ce + "]{" + li + "}", Kp = "[" + ui + "]{0,1}(?:[" + Nt + "]*[" + ce + "]){3,}[" + Nt + ce + "]*", Zp = new RegExp("^[" + ui + "]{0,1}(?:[" + Nt + "]*[" + ce + "]){1,2}$", "i"), Xp = Kp + // Phone number extensions
"(?:" + Zn() + ")?", Qp = new RegExp(
  // Either a short two-digit-only phone number
  "^" + Yp + "$|^" + Xp + "$",
  "i"
);
function es(s) {
  return s.length >= li && Qp.test(s);
}
function ts(s) {
  return Zp.test(s);
}
function os(s) {
  var e = s.number, p = s.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(p ? ";ext=" + p : "");
}
function is(s, e) {
  var p = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (p)
    return (p = p.call(s)).next.bind(p);
  if (Array.isArray(s) || (p = rs(s)) || e && s && typeof s.length == "number") {
    p && (s = p);
    var c = 0;
    return function() {
      return c >= s.length ? { done: !0 } : { done: !1, value: s[c++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rs(s, e) {
  if (s) {
    if (typeof s == "string")
      return dr(s, e);
    var p = Object.prototype.toString.call(s).slice(8, -1);
    if (p === "Object" && s.constructor && (p = s.constructor.name), p === "Map" || p === "Set")
      return Array.from(s);
    if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
      return dr(s, e);
  }
}
function dr(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var p = 0, c = new Array(e); p < e; p++)
    c[p] = s[p];
  return c;
}
function cr(s, e) {
  var p = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(s);
    e && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(s, o).enumerable;
    })), p.push.apply(p, c);
  }
  return p;
}
function fr(s) {
  for (var e = 1; e < arguments.length; e++) {
    var p = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cr(Object(p), !0).forEach(function(c) {
      ns(s, c, p[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(p)) : cr(Object(p)).forEach(function(c) {
      Object.defineProperty(s, c, Object.getOwnPropertyDescriptor(p, c));
    });
  }
  return s;
}
function ns(s, e, p) {
  return e in s ? Object.defineProperty(s, e, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : s[e] = p, s;
}
var yr = {
  formatExtension: function(e, p, c) {
    return "".concat(e).concat(c.ext()).concat(p);
  }
};
function as(s, e, p, c) {
  if (p ? p = fr(fr({}, yr), p) : p = yr, c = new te(c), s.country && s.country !== "001") {
    if (!c.hasCountry(s.country))
      throw new Error("Unknown country: ".concat(s.country));
    c.country(s.country);
  } else if (s.countryCallingCode)
    c.selectNumberingPlan(s.countryCallingCode);
  else
    return s.phone || "";
  var o = c.countryCallingCode(), a = p.v2 ? s.nationalNumber : s.phone, i;
  switch (e) {
    case "NATIONAL":
      return a ? (i = At(a, s.carrierCode, "NATIONAL", c, p), fo(i, s.ext, c, p.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (i = At(a, null, "INTERNATIONAL", c, p), i = "+".concat(o, " ").concat(i), fo(i, s.ext, c, p.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(a);
    case "RFC3966":
      return os({
        number: "+".concat(o).concat(a),
        ext: s.ext
      });
    case "IDD":
      if (!p.fromCountry)
        return;
      var u = ss(a, s.carrierCode, o, p.fromCountry, c);
      return fo(u, s.ext, c, p.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function At(s, e, p, c, o) {
  var a = ps(c.formats(), s);
  return a ? Vp(s, a, {
    useInternationalFormat: p === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1),
    carrierCode: e,
    metadata: c
  }) : s;
}
function ps(s, e) {
  for (var p = is(s), c; !(c = p()).done; ) {
    var o = c.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var a = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (e.search(a) !== 0)
        continue;
    }
    if (Ce(e, o.pattern()))
      return o;
  }
}
function fo(s, e, p, c) {
  return e ? c(s, e, p) : s;
}
function ss(s, e, p, c, o) {
  var a = ai(c, o.metadata);
  if (a === p) {
    var i = At(s, e, "NATIONAL", o);
    return p === "1" ? p + " " + i : i;
  }
  var u = Hp(c, void 0, o.metadata);
  if (u)
    return "".concat(u, " ").concat(p, " ").concat(At(s, null, "INTERNATIONAL", o));
}
function hr(s, e) {
  var p = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(s);
    e && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(s, o).enumerable;
    })), p.push.apply(p, c);
  }
  return p;
}
function vr(s) {
  for (var e = 1; e < arguments.length; e++) {
    var p = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hr(Object(p), !0).forEach(function(c) {
      ls(s, c, p[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(p)) : hr(Object(p)).forEach(function(c) {
      Object.defineProperty(s, c, Object.getOwnPropertyDescriptor(p, c));
    });
  }
  return s;
}
function ls(s, e, p) {
  return e in s ? Object.defineProperty(s, e, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : s[e] = p, s;
}
function us(s, e) {
  if (!(s instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fr(s, e) {
  for (var p = 0; p < e.length; p++) {
    var c = e[p];
    c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(s, c.key, c);
  }
}
function gs(s, e, p) {
  return e && Fr(s.prototype, e), p && Fr(s, p), Object.defineProperty(s, "prototype", { writable: !1 }), s;
}
var ds = /* @__PURE__ */ function() {
  function s(e, p, c) {
    if (us(this, s), !e)
      throw new TypeError("First argument is required");
    if (typeof e != "string")
      throw new TypeError("First argument must be a string");
    if (typeof e == "string") {
      if (e[0] === "+" && !p)
        throw new TypeError("`metadata` argument not passed");
      if (qe(p) && qe(p.countries)) {
        c = p;
        var o = e;
        if (!ys.test(o))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = Kn(o, void 0, void 0, c), i = a.countryCallingCode, u = a.number;
        if (p = u, e = i, !p)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!p)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof p != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Un(c);
    var y = fs(e, c), h = y.country, B = y.countryCallingCode;
    this.country = h, this.countryCallingCode = B, this.nationalNumber = p, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return c;
    };
  }
  return gs(s, [{
    key: "setExt",
    value: function(p) {
      this.ext = p;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Ep(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Mp(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return wp(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var p = new te(this.getMetadata());
      return p.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(p) {
      return this.number === p.number && this.ext === p.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return si(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(p, c) {
      return as(this, p, c ? vr(vr({}, c), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(p) {
      return this.format("NATIONAL", p);
    }
  }, {
    key: "formatInternational",
    value: function(p) {
      return this.format("INTERNATIONAL", p);
    }
  }, {
    key: "getURI",
    value: function(p) {
      return this.format("RFC3966", p);
    }
  }]), s;
}(), cs = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function fs(s, e) {
  var p, c, o = new te(e);
  return cs(s) ? (p = s, o.selectNumberingPlan(p), c = o.countryCallingCode()) : c = s, {
    country: p,
    countryCallingCode: c
  };
}
var ys = /^\+\d+$/;
function ko(s) {
  "@babel/helpers - typeof";
  return ko = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ko(s);
}
function Rr(s, e) {
  for (var p = 0; p < e.length; p++) {
    var c = e[p];
    c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(s, c.key, c);
  }
}
function hs(s, e, p) {
  return e && Rr(s.prototype, e), p && Rr(s, p), Object.defineProperty(s, "prototype", { writable: !1 }), s;
}
function vs(s, e) {
  if (!(s instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fs(s, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  s.prototype = Object.create(e && e.prototype, { constructor: { value: s, writable: !0, configurable: !0 } }), Object.defineProperty(s, "prototype", { writable: !1 }), e && gt(s, e);
}
function Rs(s) {
  var e = Qn();
  return function() {
    var c = dt(s), o;
    if (e) {
      var a = dt(this).constructor;
      o = Reflect.construct(c, arguments, a);
    } else
      o = c.apply(this, arguments);
    return bs(this, o);
  };
}
function bs(s, e) {
  if (e && (ko(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xn(s);
}
function Xn(s) {
  if (s === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s;
}
function Do(s) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Do = function(c) {
    if (c === null || !Bs(c))
      return c;
    if (typeof c != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(c))
        return e.get(c);
      e.set(c, o);
    }
    function o() {
      return Dt(c, arguments, dt(this).constructor);
    }
    return o.prototype = Object.create(c.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), gt(o, c);
  }, Do(s);
}
function Dt(s, e, p) {
  return Qn() ? Dt = Reflect.construct : Dt = function(o, a, i) {
    var u = [null];
    u.push.apply(u, a);
    var y = Function.bind.apply(o, u), h = new y();
    return i && gt(h, i.prototype), h;
  }, Dt.apply(null, arguments);
}
function Qn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Bs(s) {
  return Function.toString.call(s).indexOf("[native code]") !== -1;
}
function gt(s, e) {
  return gt = Object.setPrototypeOf || function(c, o) {
    return c.__proto__ = o, c;
  }, gt(s, e);
}
function dt(s) {
  return dt = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
    return p.__proto__ || Object.getPrototypeOf(p);
  }, dt(s);
}
var Fe = /* @__PURE__ */ function(s) {
  Fs(p, s);
  var e = Rs(p);
  function p(c) {
    var o;
    return vs(this, p), o = e.call(this, c), Object.setPrototypeOf(Xn(o), p.prototype), o.name = o.constructor.name, o;
  }
  return hs(p);
}(/* @__PURE__ */ Do(Error)), br = new RegExp("(?:" + Zn() + ")$", "i");
function Ms(s) {
  var e = s.search(br);
  if (e < 0)
    return {};
  for (var p = s.slice(0, e), c = s.match(br), o = 1; o < c.length; ) {
    if (c[o])
      return {
        number: p,
        ext: c[o]
      };
    o++;
  }
}
var Cs = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Ts(s) {
  return Cs[s];
}
function ms(s, e) {
  var p = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (p)
    return (p = p.call(s)).next.bind(p);
  if (Array.isArray(s) || (p = ws(s)) || e && s && typeof s.length == "number") {
    p && (s = p);
    var c = 0;
    return function() {
      return c >= s.length ? { done: !0 } : { done: !1, value: s[c++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ws(s, e) {
  if (s) {
    if (typeof s == "string")
      return Br(s, e);
    var p = Object.prototype.toString.call(s).slice(8, -1);
    if (p === "Object" && s.constructor && (p = s.constructor.name), p === "Map" || p === "Set")
      return Array.from(s);
    if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
      return Br(s, e);
  }
}
function Br(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var p = 0, c = new Array(e); p < e; p++)
    c[p] = s[p];
  return c;
}
function Mr(s) {
  for (var e = "", p = ms(s.split("")), c; !(c = p()).done; ) {
    var o = c.value;
    e += Es(o, e) || "";
  }
  return e;
}
function Es(s, e, p) {
  if (s === "+") {
    if (e) {
      typeof p == "function" && p("end");
      return;
    }
    return "+";
  }
  return Ts(s);
}
function Ps(s, e) {
  var p = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (p)
    return (p = p.call(s)).next.bind(p);
  if (Array.isArray(s) || (p = Ss(s)) || e && s && typeof s.length == "number") {
    p && (s = p);
    var c = 0;
    return function() {
      return c >= s.length ? { done: !0 } : { done: !1, value: s[c++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ss(s, e) {
  if (s) {
    if (typeof s == "string")
      return Cr(s, e);
    var p = Object.prototype.toString.call(s).slice(8, -1);
    if (p === "Object" && s.constructor && (p = s.constructor.name), p === "Map" || p === "Set")
      return Array.from(s);
    if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
      return Cr(s, e);
  }
}
function Cr(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var p = 0, c = new Array(e); p < e; p++)
    c[p] = s[p];
  return c;
}
function Os(s, e) {
  var p = e.countries;
  e.defaultCountry;
  var c = e.metadata;
  c = new te(c);
  for (var o = Ps(p), a; !(a = o()).done; ) {
    var i = a.value;
    if (c.country(i), c.leadingDigits()) {
      if (s && s.search(c.leadingDigits()) === 0)
        return i;
    } else if (si({
      phone: s,
      country: i
    }, void 0, c.metadata))
      return i;
  }
}
var ks = !1;
function Ds(s, e) {
  var p = e.nationalNumber, c = e.defaultCountry, o = e.metadata;
  if (ks && o.isNonGeographicCallingCode(s))
    return "001";
  var a = o.getCountryCodesForCallingCode(s);
  if (a)
    return a.length === 1 ? a[0] : Os(p, {
      countries: a,
      defaultCountry: c,
      metadata: o.metadata
    });
}
var ea = "+", Is = "[\\-\\.\\(\\)]?", Tr = "([" + ce + "]|" + Is + ")", $s = "^\\" + ea + Tr + "*[" + ce + "]" + Tr + "*$", Ls = new RegExp($s, "g"), Io = ce, Ws = "[" + Io + "]+((\\-)*[" + Io + "])*", zs = "a-zA-Z", Ns = "[" + zs + "]+((\\-)*[" + Io + "])*", As = "^(" + Ws + "\\.)*" + Ns + "\\.?$", xs = new RegExp(As, "g"), mr = "tel:", $o = ";phone-context=", Gs = ";isub=";
function _s(s) {
  var e = s.indexOf($o);
  if (e < 0)
    return null;
  var p = e + $o.length;
  if (p >= s.length)
    return "";
  var c = s.indexOf(";", p);
  return c >= 0 ? s.substring(p, c) : s.substring(p);
}
function js(s) {
  return s === null ? !0 : s.length === 0 ? !1 : Ls.test(s) || xs.test(s);
}
function qs(s, e) {
  var p = e.extractFormattedPhoneNumber, c = _s(s);
  if (!js(c))
    throw new Fe("NOT_A_NUMBER");
  var o;
  if (c === null)
    o = p(s) || "";
  else {
    o = "", c.charAt(0) === ea && (o += c);
    var a = s.indexOf(mr), i;
    a >= 0 ? i = a + mr.length : i = 0;
    var u = s.indexOf($o);
    o += s.substring(i, u);
  }
  var y = o.indexOf(Gs);
  if (y > 0 && (o = o.substring(0, y)), o !== "")
    return o;
}
var Vs = 250, Us = new RegExp("[" + ui + ce + "]"), Hs = new RegExp("[^" + ce + "#]+$");
function Js(s, e, p) {
  if (e = e || {}, p = new te(p), e.defaultCountry && !p.hasCountry(e.defaultCountry))
    throw e.v2 ? new Fe("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var c = Ks(s, e.v2, e.extract), o = c.number, a = c.ext, i = c.error;
  if (!o) {
    if (e.v2)
      throw i === "TOO_SHORT" ? new Fe("TOO_SHORT") : new Fe("NOT_A_NUMBER");
    return {};
  }
  var u = Xs(o, e.defaultCountry, e.defaultCallingCode, p), y = u.country, h = u.nationalNumber, B = u.countryCallingCode, C = u.countryCallingCodeSource, M = u.carrierCode;
  if (!p.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new Fe("INVALID_COUNTRY");
    return {};
  }
  if (!h || h.length < li) {
    if (e.v2)
      throw new Fe("TOO_SHORT");
    return {};
  }
  if (h.length > Sp) {
    if (e.v2)
      throw new Fe("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var I = new ds(B, h, p.metadata);
    return y && (I.country = y), M && (I.carrierCode = M), a && (I.ext = a), I.__countryCallingCodeSource = C, I;
  }
  var $ = (e.extended ? p.hasSelectedNumberingPlan() : y) ? Ce(h, p.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: y,
    countryCallingCode: B,
    carrierCode: M,
    valid: $,
    possible: $ ? !0 : !!(e.extended === !0 && p.possibleLengths() && Yn(h, p)),
    phone: h,
    ext: a
  } : $ ? Zs(y, h, a) : {};
}
function Ys(s, e, p) {
  if (s) {
    if (s.length > Vs) {
      if (p)
        throw new Fe("TOO_LONG");
      return;
    }
    if (e === !1)
      return s;
    var c = s.search(Us);
    if (!(c < 0))
      return s.slice(c).replace(Hs, "");
  }
}
function Ks(s, e, p) {
  var c = qs(s, {
    extractFormattedPhoneNumber: function(i) {
      return Ys(i, p, e);
    }
  });
  if (!c)
    return {};
  if (!es(c))
    return ts(c) ? {
      error: "TOO_SHORT"
    } : {};
  var o = Ms(c);
  return o.ext ? o : {
    number: c
  };
}
function Zs(s, e, p) {
  var c = {
    country: s,
    phone: e
  };
  return p && (c.ext = p), c;
}
function Xs(s, e, p, c) {
  var o = Kn(Mr(s), e, p, c.metadata), a = o.countryCallingCodeSource, i = o.countryCallingCode, u = o.number, y;
  if (i)
    c.selectNumberingPlan(i);
  else if (u && (e || p))
    c.selectNumberingPlan(e, p), e && (y = e), i = p || ai(e, c.metadata);
  else
    return {};
  if (!u)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: i
    };
  var h = Oo(Mr(u), c), B = h.nationalNumber, C = h.carrierCode, M = Ds(i, {
    nationalNumber: B,
    defaultCountry: e,
    metadata: c
  });
  return M && (y = M, M === "001" || c.country(y)), {
    country: y,
    countryCallingCode: i,
    countryCallingCodeSource: a,
    nationalNumber: B,
    carrierCode: C
  };
}
function wr(s, e) {
  var p = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(s);
    e && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(s, o).enumerable;
    })), p.push.apply(p, c);
  }
  return p;
}
function Er(s) {
  for (var e = 1; e < arguments.length; e++) {
    var p = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wr(Object(p), !0).forEach(function(c) {
      Qs(s, c, p[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(p)) : wr(Object(p)).forEach(function(c) {
      Object.defineProperty(s, c, Object.getOwnPropertyDescriptor(p, c));
    });
  }
  return s;
}
function Qs(s, e, p) {
  return e in s ? Object.defineProperty(s, e, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : s[e] = p, s;
}
function el(s, e, p) {
  return Js(s, Er(Er({}, e), {}, {
    v2: !0
  }), p);
}
function Pr(s, e) {
  var p = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(s);
    e && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(s, o).enumerable;
    })), p.push.apply(p, c);
  }
  return p;
}
function tl(s) {
  for (var e = 1; e < arguments.length; e++) {
    var p = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pr(Object(p), !0).forEach(function(c) {
      ol(s, c, p[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(p)) : Pr(Object(p)).forEach(function(c) {
      Object.defineProperty(s, c, Object.getOwnPropertyDescriptor(p, c));
    });
  }
  return s;
}
function ol(s, e, p) {
  return e in s ? Object.defineProperty(s, e, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : s[e] = p, s;
}
function il(s, e) {
  return pl(s) || al(s, e) || nl(s, e) || rl();
}
function rl() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nl(s, e) {
  if (s) {
    if (typeof s == "string")
      return Sr(s, e);
    var p = Object.prototype.toString.call(s).slice(8, -1);
    if (p === "Object" && s.constructor && (p = s.constructor.name), p === "Map" || p === "Set")
      return Array.from(s);
    if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
      return Sr(s, e);
  }
}
function Sr(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var p = 0, c = new Array(e); p < e; p++)
    c[p] = s[p];
  return c;
}
function al(s, e) {
  var p = s == null ? null : typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (p != null) {
    var c = [], o = !0, a = !1, i, u;
    try {
      for (p = p.call(s); !(o = (i = p.next()).done) && (c.push(i.value), !(e && c.length === e)); o = !0)
        ;
    } catch (y) {
      a = !0, u = y;
    } finally {
      try {
        !o && p.return != null && p.return();
      } finally {
        if (a)
          throw u;
      }
    }
    return c;
  }
}
function pl(s) {
  if (Array.isArray(s))
    return s;
}
function sl(s) {
  var e = Array.prototype.slice.call(s), p = il(e, 4), c = p[0], o = p[1], a = p[2], i = p[3], u, y, h;
  if (typeof c == "string")
    u = c;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    i ? (y = a, h = i) : (y = void 0, h = a), o && (y = tl({
      defaultCountry: o
    }, y));
  else if (qe(o))
    a ? (y = o, h = a) : h = o;
  else
    throw new Error("Invalid second argument: ".concat(o));
  return {
    text: u,
    options: y,
    metadata: h
  };
}
function Or(s, e) {
  var p = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(s);
    e && (c = c.filter(function(o) {
      return Object.getOwnPropertyDescriptor(s, o).enumerable;
    })), p.push.apply(p, c);
  }
  return p;
}
function kr(s) {
  for (var e = 1; e < arguments.length; e++) {
    var p = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Or(Object(p), !0).forEach(function(c) {
      ll(s, c, p[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(p)) : Or(Object(p)).forEach(function(c) {
      Object.defineProperty(s, c, Object.getOwnPropertyDescriptor(p, c));
    });
  }
  return s;
}
function ll(s, e, p) {
  return e in s ? Object.defineProperty(s, e, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : s[e] = p, s;
}
function ul(s, e, p) {
  e && e.defaultCountry && !Fp(e.defaultCountry, p) && (e = kr(kr({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return el(s, e, p);
  } catch (c) {
    if (!(c instanceof Fe))
      throw c;
  }
}
function gl() {
  var s = sl(arguments), e = s.text, p = s.options, c = s.metadata;
  return ul(e, p, c);
}
function dl() {
  return lp(gl, arguments);
}
const cl = "Europe/Stockholm";
function fl(s = 0, e = "SEK", p = 0) {
  const c = new jn.Money();
  return c.setUnits(s), c.setCurrencyCode(e), c.setNanos(p), c;
}
function yl(s) {
  const e = new qn.LatLng();
  return e.setLatitude(s.latitude), e.setLongitude(s.longitude), e;
}
function Se(s) {
  const e = new Po.DateTime(), p = new Po.TimeZone();
  return e.setYear(s.getFullYear()), e.setMonth(s.getMonth() + 1), e.setDay(s.getDate()), e.setHours(s.getHours()), e.setMinutes(s.getMinutes()), e.setSeconds(s.getSeconds()), e.setNanos(s.getMilliseconds() * 10 ** 6), p.setId(cl), e.setTimeZone(p), e;
}
function gi(s) {
  const e = new Vn.PhoneNumber(), p = dl(s, "SE");
  return e.setE164Number((p == null ? void 0 : p.number) || ""), e;
}
function ta(s) {
  const e = new D.SwedishPersonalIdentityNumber();
  return e.setTwelveDigitNumber(s), e;
}
const hl = (s, e, p, c, o, a, i) => {
  const u = new D.FindAppointmentsRequest();
  return u.setStartTime(Se(s)), u.setEndTime(Se(e)), u.setTreatmentIdsList(p), u.setClinicIdsList(c), u.setPageToken(se(o)), u.setPageSize(Jt(a)), u.setSorting(i), u;
}, vl = {
  unspecified: D.FindAppointmentsRequest.Sorting.SORTING_UNSPECIFIED,
  time: D.FindAppointmentsRequest.Sorting.SORTING_TIME,
  price: D.FindAppointmentsRequest.Sorting.SORTING_PRICE,
  preserveClinicIdsOrder: D.FindAppointmentsRequest.Sorting.SORTING_PRESERVE_CLINIC_IDS_ORDER
}, jl = async (s, e, p = [], c = [], o = "1", a = 20, i = vl.time) => {
  const { patientApiClient: u, grpcMetadata: y } = Y();
  return await new Promise((h, B) => {
    u.findAppointments(
      hl(
        s,
        e,
        p,
        c,
        o,
        a,
        i
      ),
      y,
      (C, M) => {
        C ? B(C) : h(M);
      }
    );
  });
}, Fl = (s, e, p, c, o) => {
  const a = new Ht.FindExternalBookingsRequest();
  return a.setClinicIdsList(s), e && a.setDateFrom(Se(e)), p && a.setDateTo(Se(p)), c && a.setPageToken(se(c)), o && a.setPageSize(Jt(o)), a;
}, Rl = (s, e) => {
  const p = new D.GetBookingFlowTypeRequest(), c = new D.AppointmentClaim();
  return c.setClinicId(s), c.setAppointmentId(e), p.setAppointmentClaim(c), p;
}, bl = (s, e, p, c) => {
  const o = new Ht.RescheduleExternalBookingRequest();
  return o.setConnectionId(s), o.setExternalBookingId(e), o.setClinicId(p), o.setAppointmentId(c), o;
}, Bl = (s, e, p, c, o, a, i, u, y, h) => {
  const B = new D.CreateBookingRequest(), C = new D.AppointmentClaim();
  C.setAppointmentId(e), C.setClinicId(s);
  const M = new D.PatientInfo(), I = new D.SwedishPersonalIdentityNumber();
  I.setTwelveDigitNumber(i), M.setSwedishPersonalIdentityNumber(I), M.setFirstName(p), M.setLastName(c), M.setMobilePhone(gi(a)), M.setEmail(o);
  const $ = new D.DeviceMeta();
  return $.setType(y.type), $.setRequestId(y.request_id), $.setDeviceFound(y.deviceFound), $.setDeviceId(y.deviceId), $.setDeviceConfidence(y.deviceConfidence), $.setDeviceIp(y.deviceIp), B.setAppointmentClaim(C), B.setPatient(M), B.setMessage(se(u)), B.setDeviceMeta($), h && B.setPromoCode(se(h)), B;
}, Ml = (s, e, p, c, o, a, i, u, y) => {
  const h = new D.CreateBookingInquiryRequest(), B = new D.TreatmentInquiry();
  B.setClinicId(s), B.setTreatmentId(e), B.setDateTime(Se(y));
  const C = new D.PatientInfo(), M = new D.SwedishPersonalIdentityNumber();
  return M.setTwelveDigitNumber(i), C.setSwedishPersonalIdentityNumber(M), C.setFirstName(p), C.setLastName(c), C.setMobilePhone(gi(a)), C.setEmail(o), h.setTreatmentInquiry(B), h.setPatient(C), h.setMessage(se(u)), h;
}, Cl = (s, e) => {
  const p = new D.ProceedBookingRequest(), c = new D.ProceedBookingRequest.AdyenCardTokenization(), o = new D.ProceedBookingRequest.BankIDAuthentication();
  return p.setBookingId(s), e.adyen_card_tokenization && p.setAdyenCardTokenization(
    c.setReturnUrl(e.adyen_card_tokenization)
  ), e.bank_id_authentication && p.setBankIdAuthentication(
    o.setReturnUrl(e.bank_id_authentication)
  ), p;
}, oa = (s) => ({
  Authorization: `Bearer ${s}`
}), ql = async (s, e, p, c, o, a) => {
  const { grpcMetadata: i, restrictedApiClient: u } = Y();
  return await new Promise((y, h) => {
    u.findExternalBookings(
      Fl(
        e,
        p,
        c,
        o,
        a
      ),
      {
        ...i,
        ...oa(s)
      },
      (B, C) => {
        B ? h(B) : y(C);
      }
    );
  });
}, Vl = async (s, e, p, c, o) => {
  const { restrictedApiClient: a, grpcMetadata: i } = Y();
  return await new Promise(
    (u, y) => {
      a.rescheduleExternalBooking(
        bl(
          e,
          p,
          c,
          o
        ),
        {
          ...i,
          ...oa(s)
        },
        (h, B) => {
          h ? y(h) : u(B);
        }
      );
    }
  );
}, Ul = async (s, e, p, c, o, a, i, u, y, h) => {
  const { patientApiClient: B, grpcMetadata: C } = Y();
  return await new Promise((M, I) => {
    B.createBooking(
      Bl(
        s,
        e,
        p,
        c,
        o,
        a,
        i,
        u,
        y,
        h
      ),
      C,
      ($, t) => {
        $ ? I($) : M(t);
      }
    );
  });
}, Hl = async (s, e, p, c, o, a, i, u, y) => {
  const { patientApiClient: h, grpcMetadata: B } = Y();
  return await new Promise((C, M) => {
    h.createBookingInquiry(
      Ml(
        s,
        e,
        p,
        c,
        o,
        a,
        i,
        u,
        y
      ),
      B,
      (I, $) => {
        I ? M(I) : C($);
      }
    );
  });
}, Jl = async (s, e) => {
  const { patientApiClient: p, grpcMetadata: c } = Y();
  return await new Promise((o, a) => {
    p.proceedBooking(
      Cl(s, e),
      c,
      (i, u) => {
        i ? a(i) : o(u);
      }
    );
  });
}, Yl = async (s, e) => {
  const { patientApiClient: p, grpcMetadata: c } = Y();
  return await new Promise((o, a) => {
    p.getBookingFlowType(
      Rl(
        s,
        e
      ),
      c,
      (i, u) => {
        i ? a(i) : o(u);
      }
    );
  });
}, Tl = () => new ni.GetConfigRequest(), Kl = async () => {
  const { widgetApiClient: s, grpcMetadata: e } = Y();
  return await new Promise((p, c) => {
    s.getConfig(
      Tl(),
      {
        ...e
      },
      (o, a) => {
        o ? c(o) : p(a);
      }
    );
  });
}, ml = {
  unspecified: D.ClinicSubscriptionType.CLINIC_SUBSCRIPTION_TYPE_UNSPECIFIED,
  nonPremium: D.ClinicSubscriptionType.CLINIC_SUBSCRIPTION_TYPE_NON_PREMIUM,
  premium: D.ClinicSubscriptionType.CLINIC_SUBSCRIPTION_TYPE_PREMIUM
}, Zl = {
  unspecified: D.ClinicOptionType.CLINIC_OPTION_TYPE_UNSPECIFIED,
  other: D.ClinicOptionType.CLINIC_OPTION_TYPE_OTHER,
  priceReduction: D.ClinicOptionType.CLINIC_OPTION_TYPE_PRICE_REDUCTION,
  parking: D.ClinicOptionType.CLINIC_OPTION_TYPE_PARKING
}, wl = {
  unspecified: D.FindClinicsByLocationRequest.Sorting.SORTING_UNSPECIFIED,
  proximity: D.FindClinicsByLocationRequest.Sorting.SORTING_PROXIMITY,
  name: D.FindClinicsByLocationRequest.Sorting.SORTING_NAME,
  reviewScore: D.FindClinicsByLocationRequest.Sorting.SORTING_REVIEW_SCORE
}, El = (s) => {
  const e = new D.FindClinicsByIdsRequest();
  return e.setIdsList(s), e;
}, Pl = (s) => {
  const e = new D.GetClinicRequest();
  return e.setId(s), e;
}, Sl = (s) => {
  const e = new D.GetClinicRequest();
  return e.setUrl(s), e;
}, Ol = (s, e, p, c, o, a, i) => {
  const u = new D.FindClinicsByLocationRequest();
  return u.setLocation(yl(s)), u.setMaxDistanceKm(wo(e)), u.setTreatmentIdsList(p), u.setSubscription(c), u.setSorting(o), u.setPageToken(se(a)), u.setPageSize(wo(i)), u;
}, Xl = async (s) => {
  const { patientApiClient: e, grpcMetadata: p } = Y();
  return await new Promise((c, o) => {
    e.findClinicsByIds(
      El(s),
      p,
      (a, i) => {
        a ? o(a) : c(i);
      }
    );
  });
}, Ql = async (s, e, p = [], c = ml.unspecified, o = wl.unspecified, a = "1", i = 300) => {
  const { patientApiClient: u, grpcMetadata: y } = Y();
  return await new Promise((h, B) => {
    u.findClinicsByLocation(
      Ol(
        s,
        e,
        p,
        c,
        o,
        a,
        i
      ),
      y,
      (C, M) => {
        C ? B(C) : h(M);
      }
    );
  });
}, eu = async (s) => {
  const { patientApiClient: e, grpcMetadata: p } = Y();
  return new Promise((c, o) => {
    e.getClinic(
      Pl(s),
      p,
      (a, i) => {
        a ? o(a) : c(i);
      }
    );
  });
}, tu = async (s) => {
  const { patientApiClient: e, grpcMetadata: p } = Y();
  return new Promise((c, o) => {
    e.getClinic(
      Sl(s),
      p,
      (a, i) => {
        a ? o(a) : c(i);
      }
    );
  });
}, kl = (s, e, p, c) => {
  const o = new D.FindLocationsRequest();
  return o.setName(se(s)), o.setTypesList(e), o.setPageToken(se(p)), o.setPageSize(Jt(c)), o;
}, ou = async (s = "", e = [], p = 10, c = "1") => {
  const { patientApiClient: o, grpcMetadata: a } = Y();
  return await new Promise((i, u) => {
    o.findLocations(
      kl(s, e, c, p),
      a,
      (y, h) => {
        y ? u(y) : i(h);
      }
    );
  });
}, iu = {
  unspecified: D.LocationType.LOCATION_TYPE_UNSPECIFIED,
  region: D.LocationType.LOCATION_TYPE_REGION,
  district: D.LocationType.LOCATION_TYPE_DISTRICT,
  municipality: D.LocationType.LOCATION_TYPE_MUNICIPALITY,
  zipcity: D.LocationType.LOCATION_TYPE_ZIPCITY
}, Dl = (s, e, p, c) => {
  const o = new D.FindReviewsForClinicRequest();
  return Array.isArray(s) ? o.setClinicIdsList(s) : o.setClinicId(s), o.setPageToken(se(e)), o.setPageSize(wo(p)), o.setIncludeImported(Eo(c)), o;
}, Il = (s, e, p, c, o, a, i, u, y, h, B, C) => {
  const M = new D.CreateReviewForClinicRequest();
  return M.setClinicId(s), M.setAuthorEmail(se(e)), M.setAuthorPhone(gi(p)), M.setContent(c), M.setAuthorName(se(o)), M.setAuthorGender(a), M.setAuthorAge(Jt(i)), M.setScoreTreatment(u), M.setScoreDentalCare(y), M.setScoreAvailability(h), M.setRecommendation(Eo(B)), M.setAnonym(Eo(C)), M;
}, $l = (s, e, p) => {
  const c = new D.CreateReviewForClinicRequest();
  return c.setReviewRequestId(se(s)), c.setContent(e), c.setScoreTreatment(p), c.setScoreDentalCare(p), c.setScoreAvailability(p), c;
}, Ll = (s) => {
  const e = new D.GetReviewRequestInfoRequest();
  return e.setReviewRequestId(s), e;
}, ru = async (s, e = "1", p = 100, c) => {
  const { patientApiClient: o, grpcMetadata: a } = Y();
  return await new Promise((i, u) => {
    o.findReviewsForClinic(
      Dl(s, e, p, c),
      a,
      (y, h) => {
        y ? u(y) : i(h);
      }
    );
  });
}, nu = async (s, e, p, c, o, a, i, u, y, h, B = !1, C = !1) => {
  const { patientApiClient: M, grpcMetadata: I } = Y();
  return await new Promise(($, t) => {
    M.createReviewForClinic(
      Il(
        s,
        e,
        p,
        c,
        o,
        a,
        i,
        u,
        y,
        h,
        B,
        C
      ),
      I,
      (r, n) => {
        r ? t(r) : $(n);
      }
    );
  });
}, au = async (s, e, p) => {
  const { patientApiClient: c, grpcMetadata: o } = Y();
  return await new Promise((a, i) => {
    c.createReviewForClinic(
      $l(
        s,
        e,
        p
      ),
      o,
      (u, y) => {
        u ? i(u) : a(y);
      }
    );
  });
}, pu = async (s) => {
  const { patientApiClient: e, grpcMetadata: p } = Y();
  return await new Promise((c, o) => {
    e.getReviewRequestInfo(
      Ll(s),
      p,
      (a, i) => {
        a ? o(a) : c(i);
      }
    );
  });
}, Wl = (s) => {
  const e = new D.FindTreatmentsRequest();
  return e.setTreatmentIdsList(s), e;
}, zl = (s, e, p) => {
  const c = new D.FindAvailableTreatmentIdsPerClinicRequest();
  return c.setClinicIdsList(s), c.setStartTime(Se(e)), c.setEndTime(Se(p)), c;
}, su = async (s) => {
  const { patientApiClient: e, grpcMetadata: p } = Y();
  return await new Promise((c, o) => {
    e.findTreatments(
      Wl(s),
      p,
      (a, i) => {
        a ? o(a) : c(i);
      }
    );
  });
}, lu = async (s, e, p) => {
  const { patientApiClient: c, grpcMetadata: o } = Y();
  return await new Promise((a, i) => {
    c.findAvailableTreatmentIdsPerClinic(
      zl(s, e, p),
      o,
      (u, y) => {
        u ? i(u) : a(y);
      }
    );
  });
}, Nl = (s, e, p, c, o, a) => {
  const i = new D.ValidatePromoCodeRequest(), u = fl(c), y = Se(o), h = a ? ta(a) : void 0;
  return i.setPromoCode(s), i.setClinicId(e), i.setTreatmentId(p), i.setOriginalPrice(u), i.setAppointmentDatetime(y), h && i.setSwedishPersonalIdentityNumber(h), i;
}, uu = async (s, e, p, c, o, a) => {
  const { patientApiClient: i, grpcMetadata: u } = Y();
  return await new Promise((y, h) => {
    i.validatePromoCode(
      Nl(
        s,
        e,
        p,
        c,
        o,
        a
      ),
      u,
      (B, C) => {
        B ? h(B) : y(C);
      }
    );
  });
}, Al = (s, e, p) => {
  const c = new D.PatientExistsRequest(), o = new D.AppointmentClaim(), a = ta(p);
  return o.setAppointmentId(s), o.setClinicId(e), c.setAppointmentClaim(o), c.setSwedishPersonalIdentityNumber(a), c;
}, gu = async (s, e, p) => {
  const { patientApiClient: c, grpcMetadata: o } = Y();
  return await new Promise((a, i) => {
    c.patientExists(
      Al(s, e, p),
      o,
      (u, y) => {
        u ? i(u) : a(y);
      }
    );
  });
};
var xl = /* @__PURE__ */ ((s) => (s.UnspecifiedScreen = "", s.StartScreen = "start", s.TreatmentScreen = "treatment", s.CityScreen = "city", s.ClinicScreen = "clinic", s.AppointmentScreen = "appointment", s.BookingSummaryScreen = "booking-summary", s.BookingContactScreen = "booking-contact", s.ContactInformationScreen = "contact-information", s.TokenizationScreen = "tokenization", s.BookingConfirmationScreen = "booking-confirmation", s.MyBookingsScreen = "my-bookings", s.YourBookingsScreen = "my-bookings-list", s.BookingDetailsScreen = "booking-details", s.TreatmentSelectionScreen = "treatment-selection", s))(xl || {}), Gl = /* @__PURE__ */ ((s) => (s.UnspecifiedTheme = "", s.Default = "default", s.Diplomat = "diplomat", s.Aristotel = "aristotel", s))(Gl || {});
const du = Object.freeze({
  [H.BookingConfig.Screen.SCREEN_UNSPECIFIED]: "",
  [H.BookingConfig.Screen.SCREEN_START]: "start",
  [H.BookingConfig.Screen.SCREEN_TREATMENT]: "treatment",
  [H.BookingConfig.Screen.SCREEN_CITY]: "city",
  [H.BookingConfig.Screen.SCREEN_CLINIC]: "clinic",
  [H.BookingConfig.Screen.SCREEN_APPOINTMENT]: "appointment",
  [H.BookingConfig.Screen.SCREEN_BOOKING_SUMMARY]: "booking-summary",
  [H.BookingConfig.Screen.SCREEN_BOOKING_CONTACT]: "booking-contact",
  [H.BookingConfig.Screen.SCREEN_CONTACT_INFORMATION]: "contact-information",
  [H.BookingConfig.Screen.SCREEN_BOOKING_CONFIRMATION]: "booking-confirmation",
  [H.BookingConfig.Screen.SCREEN_MY_BOOKINGS]: "my-bookings",
  [H.BookingConfig.Screen.SCREEN_YOUR_BOOKINGS]: "my-bookings-list",
  [H.BookingConfig.Screen.SCREEN_BOOKING_DETAILS]: "booking-details",
  [H.BookingConfig.Screen.SCREEN_TREATMENT_SELECTION]: "treatment-selection"
  /* TreatmentSelectionScreen */
}), cu = Object.freeze({
  [H.BookingConfig.Theme.Preset.PRESET_UNSPECIFIED]: "",
  [H.BookingConfig.Theme.Preset.PRESET_DEFAULT]: "default",
  [H.BookingConfig.Theme.Preset.PRESET_ARISTOTLE]: "aristotel",
  [H.BookingConfig.Theme.Preset.PRESET_DIPLOMAT]: "diplomat"
  /* Diplomat */
}), fu = {
  unspecified: D.Gender.GENDER_UNSPECIFIED,
  male: D.Gender.GENDER_MALE,
  female: D.Gender.GENDER_FEMALE
}, yu = {
  unspecified: D.ReviewPrompt.Type.TYPE_UNSPECIFIED,
  google: D.ReviewPrompt.Type.TYPE_GOOGLE_REVIEWS,
  trustpilot: D.ReviewPrompt.Type.TYPE_TRUSTPILOT
}, hu = H.BookingConfig, vu = D.CreateBookingResponse, Fu = D.DeviceMeta, Ru = D.GetBookingFlowTypeResponse, bu = D.ValidatePromoCodeResponse;
export {
  hu as BookingConfig,
  vu as CreateBookingResponse,
  Fu as DeviceMeta,
  Ru as GetBookingFlowTypeResponse,
  du as ScreenMap,
  xl as Screens,
  Gl as Theme,
  cu as ThemeMap,
  bu as ValidatePromoCodeResponse,
  vl as appointmentsSortingTypes,
  Zl as clinicOptionTypes,
  wl as clinicSortingTypes,
  ml as clinicSubscriptionTypes,
  Ul as createBooking,
  Hl as createBookingInquiry,
  Jl as createProceedBooking,
  nu as createReviewForClinic,
  au as createReviewForClinicByRequestId,
  jl as findAppointments,
  lu as findAvailableTreatmentIdsPerClinic,
  zl as findAvailableTreatmentIdsPerClinicRequest,
  Xl as findClinicsByIds,
  Ql as findClinicsByLocation,
  ql as findExternalBookings,
  ou as findLocations,
  ru as findReviewsForClinic,
  su as findTreatments,
  fu as genderTypes,
  Yl as getBookingFlowType,
  Rl as getBookingFlowTypeRequest,
  eu as getClinicById,
  Pl as getClinicByIdRequest,
  tu as getClinicByUrl,
  Sl as getClinicByUrlRequest,
  Ml as getCreateBookingInquiryRequest,
  Bl as getCreateBookingRequest,
  bl as getCreateRescheduleExternalBookingRequest,
  $l as getCreateReviewForClinicByRequestIdRequest,
  Il as getCreateReviewForClinicRequest,
  hl as getFindAppointmentsRequest,
  El as getFindClinicsByIdsRequest,
  Ol as getFindClinicsByLocationRequest,
  kl as getFindLocationsRequest,
  Dl as getFindReviewsForClinicRequest,
  Wl as getFindTreatmentsRequest,
  Ll as getGetReviewRequestInfoRequest,
  Fl as getMyExternalBookingsRequest,
  gu as getPatientExists,
  Al as getPatientExistsRequest,
  Kl as getPatientWidget,
  Tl as getPatientWidgetRequest,
  Cl as getProceedBookingRequest,
  pu as getReviewRequestInfo,
  Nl as getValidatePromoCodeRequest,
  _l as initApiClient,
  iu as locationTypes,
  Vl as rescheduleExternalBooking,
  yu as reviewPromptTypes,
  uu as validatePromoCode
};
